/* Options:
Date: 2026-08-20 10:53:25
Version: 5.132
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:8974

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

type IReadOnlyList<T> = T[];

type IReadOnlyDictionary<K extends string | number | symbol, V> = Record<K, V>;

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IFormFile
{
    contentType: string;
    contentDisposition: string;
    headers: IHeaderDictionary;
    length: number;
    name: string;
    fileName: string;
}

export class ActivitiesUndertaken implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ActivitiesUndertaken>) { (Object as any).assign(this, init); }
}

export class MetadataContext
{

    public constructor(init?: Partial<MetadataContext>) { (Object as any).assign(this, init); }
}

export class ActivitiesUndertakenMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ActivitiesUndertakenMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FieldChange
{
    public propertyPath: string;
    public value: Object;

    public constructor(init?: Partial<FieldChange>) { (Object as any).assign(this, init); }
}

export enum SaveMode
{
    Draft = 0,
    Submit = 1,
}

export class AddressOption implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<AddressOption>) { (Object as any).assign(this, init); }
}

export class AddressOptionMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<AddressOptionMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class AllocatedWP implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<AllocatedWP>) { (Object as any).assign(this, init); }
}

export class AllocatedWPMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<AllocatedWPMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class AssignmentType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<AssignmentType>) { (Object as any).assign(this, init); }
}

export class AssignmentTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<AssignmentTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class CaseType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<CaseType>) { (Object as any).assign(this, init); }
}

export class CaseTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<CaseTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Category implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Category>) { (Object as any).assign(this, init); }
}

export class CategoryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<CategoryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Collection implements IModel
{
    public collectionItemComponents: CollectionItemComponent[];
    public collectionSections: CollectionSection[];
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public locked?: boolean;
    public modifiedBy: string;

    public constructor(init?: Partial<Collection>) { (Object as any).assign(this, init); }
}

export class CollectionMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<CollectionMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class CollectionInstance implements IModel
{
    public collectionInstanceDatas: CollectionInstanceData[];
    public collectionInstanceSections: CollectionInstanceSection[];
    public active?: boolean;
    public collectionId?: number;
    public dataEntered?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;

    public constructor(init?: Partial<CollectionInstance>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceMetadataContext extends MetadataContext
{
    public trialId?: number;
    public institutionId?: number;

    public constructor(init?: Partial<CollectionInstanceMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Country implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class CountryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<CountryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Department implements IModel
{
    public active?: boolean;
    public address1: string;
    public address2: string;
    public countryId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public fax: string;
    public id?: number;
    public institutionId?: number;
    public mailAddress1: string;
    public mailAddress2: string;
    public mailCountryId?: number;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailStateOther: string;
    public mailSuburb: string;
    public modifiedBy: string;
    public name: string;
    public phone: string;
    public postcode: string;
    public stateId?: number;
    public stateOther: string;
    public suburb: string;

    public constructor(init?: Partial<Department>) { (Object as any).assign(this, init); }
}

export class DepartmentMetadataContext extends MetadataContext
{
    public institutionId?: number;

    public constructor(init?: Partial<DepartmentMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Error implements IModel
{
    public innerException: Error;
    public data: string;
    public dateAdded?: string;
    public id?: number;
    public innerExceptionId?: number;
    public message: string;
    public stackTrace: string;
    public type?: ErrorType;
    public url: string;
    public urlReferrer: string;
    public userAddress: string;
    public userAgent: string;
    public username: string;

    public constructor(init?: Partial<Error>) { (Object as any).assign(this, init); }
}

export class ErrorMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ErrorMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FacilityAllianceMember implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FacilityAllianceMember>) { (Object as any).assign(this, init); }
}

export class FacilityAllianceMemberMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FacilityAllianceMemberMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FormNextAutoVersion implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FormNextAutoVersion>) { (Object as any).assign(this, init); }
}

export class FormNextAutoVersionMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FormNextAutoVersionMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FormTemplate implements IModel
{
    public collection: Collection;
    public active?: boolean;
    public allowVersions?: boolean;
    public auditOnSave?: boolean;
    public collectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public formTemplateCategoryId?: number;
    public id?: number;
    public itemComponentTypeId?: number;
    public modifiedBy: string;
    public name: string;
    public rank?: number;

    public constructor(init?: Partial<FormTemplate>) { (Object as any).assign(this, init); }
}

export class FormTemplateMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FormTemplateMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FormTemplateCategory implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FormTemplateCategory>) { (Object as any).assign(this, init); }
}

export class FormTemplateCategoryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FormTemplateCategoryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FormTemplateFileType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public defaultSourceDocumentStatusId?: number;
    public enteredBy: string;
    public formName: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FormTemplateFileType>) { (Object as any).assign(this, init); }
}

export class FormTemplateFileTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FormTemplateFileTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FormTemplateStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public itemComponentTypeId?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FormTemplateStatus>) { (Object as any).assign(this, init); }
}

export class FormTemplateStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FormTemplateStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class FundingStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<FundingStatus>) { (Object as any).assign(this, init); }
}

export class FundingStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<FundingStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Gender implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Gender>) { (Object as any).assign(this, init); }
}

export class GenderMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<GenderMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Group implements IModel
{
    public abn: string;
    public acn: string;
    public acceptElectronicSignature?: number;
    public active?: boolean;
    public address: string;
    public address2: string;
    public agreementAddressOptionId?: number;
    public code: string;
    public contactNotice: string;
    public contractingPartyAddress: string;
    public contractingPartyAddress2: string;
    public contractingPartyCountryId?: number;
    public contractingPartyPostcode: string;
    public contractingPartyStateId?: number;
    public contractingPartyStateOther: string;
    public contractingPartySuburb: string;
    public countryId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public emailNotice: string;
    public enteredBy: string;
    public fax: string;
    public faxNotice: string;
    public groupTypeId?: number;
    public groupTypeOther: string;
    public id?: number;
    public isDefault?: boolean;
    public legalName: string;
    public mailAddress: string;
    public mailAddress2: string;
    public mailCountryId?: number;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailStateOther: string;
    public mailSuburb: string;
    public modifiedBy: string;
    public name: string;
    public otherNames: string;
    public phone: string;
    public phoneNotice: string;
    public postcode: string;
    public rank?: number;
    public stateId?: number;
    public stateOther: string;
    public suburb: string;
    public website: string;

    public constructor(init?: Partial<Group>) { (Object as any).assign(this, init); }
}

export class GroupMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<GroupMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class GroupItem implements IModel
{
    public collection: Collection;
    public active?: boolean;
    public allowIntraVersions?: boolean;
    public allowVersionChanges?: boolean;
    public categoryId?: number;
    public collectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public groupId?: number;
    public id?: number;
    public initialVersion: string;
    public modifiedBy: string;
    public name: string;
    public pendingDelete?: boolean;
    public rank?: number;

    public constructor(init?: Partial<GroupItem>) { (Object as any).assign(this, init); }
}

export class GroupItemMetadataContext extends MetadataContext
{
    public groupId?: number;

    public constructor(init?: Partial<GroupItemMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class GroupNote implements IModel
{
    public note: Note;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public groupId?: number;
    public id?: number;
    public modifiedBy: string;
    public noteId?: number;

    public constructor(init?: Partial<GroupNote>) { (Object as any).assign(this, init); }
}

export class GroupNoteMetadataContext extends MetadataContext
{
    public groupId?: number;

    public constructor(init?: Partial<GroupNoteMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class GroupType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<GroupType>) { (Object as any).assign(this, init); }
}

export class GroupTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<GroupTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Institution implements IModel
{
    public sourceDocuments: SourceDocument[];
    public abn: string;
    public acn: string;
    public acceptElectronicSignature?: number;
    public active?: boolean;
    public address: string;
    public address2: string;
    public agreementAddressOptionId?: number;
    public code: string;
    public contractingPartyAddress: string;
    public contractingPartyAddress2: string;
    public contractingPartyCountryId?: number;
    public contractingPartyPostcode: string;
    public contractingPartyStateId?: number;
    public contractingPartyStateOther: string;
    public contractingPartySuburb: string;
    public countryId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public facilityAllianceMemberId?: number;
    public fax: string;
    public formerNames: string;
    public id?: number;
    public institutionTypeId?: number;
    public legalName: string;
    public mailAddress: string;
    public mailAddress2: string;
    public mailCountryId?: number;
    public mailPostcode: string;
    public mailStateId?: number;
    public mailStateOther: string;
    public mailSuburb: string;
    public modifiedBy: string;
    public name: string;
    public phone: string;
    public postcode: string;
    public researchGovernanceOfficeEmail: string;
    public researchGovernanceOfficeIsNMAScheme?: number;
    public researchGovernanceOfficeName: string;
    public researchGovernanceOfficePhone: string;
    public researchGovernanceOfficeWebsite: string;
    public siteLocationId?: number;
    public stateId?: number;
    public stateOther: string;
    public suburb: string;
    public website: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class InstitutionMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InstitutionMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class InstitutionCoding implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<InstitutionCoding>) { (Object as any).assign(this, init); }
}

export class InstitutionCodingMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InstitutionCodingMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class InstitutionForm implements IModel
{
    public currentVersion: InstitutionFormVersion;
    public previousVersions: InstitutionFormVersion[];
    public active?: boolean;
    public assignedRoleId?: number;
    public assignedToId?: number;
    public assignmentTypeId?: number;
    public currentVersionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public formTemplateId?: number;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;

    public constructor(init?: Partial<InstitutionForm>) { (Object as any).assign(this, init); }
}

export class InstitutionFormMetadataContext extends MetadataContext
{
    public institutionId?: number;

    public constructor(init?: Partial<InstitutionFormMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class InstitutionNote implements IModel
{
    public note: Note;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public noteId?: number;

    public constructor(init?: Partial<InstitutionNote>) { (Object as any).assign(this, init); }
}

export class InstitutionNoteMetadataContext extends MetadataContext
{
    public institutionId?: number;

    public constructor(init?: Partial<InstitutionNoteMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class InstitutionType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<InstitutionType>) { (Object as any).assign(this, init); }
}

export class InstitutionTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InstitutionTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Interest implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Interest>) { (Object as any).assign(this, init); }
}

export class InterestMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InterestMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class InternationalTrialStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<InternationalTrialStatus>) { (Object as any).assign(this, init); }
}

export class InternationalTrialStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InternationalTrialStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Involvement implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Involvement>) { (Object as any).assign(this, init); }
}

export class InvolvementMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<InvolvementMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class ItemComponent implements IModel
{
    public itemComponentPrimitives: ItemComponentPrimitive[];
    public itemComponentRules: ItemComponentRule[];
    public sourceDocuments: SourceDocument[];
    public active?: boolean;
    public customInputControlName: string;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public id?: number;
    public isSystem?: boolean;
    public itemComponentTypeId?: number;
    public modifiedBy: string;
    public name: string;
    public rank?: number;

    public constructor(init?: Partial<ItemComponent>) { (Object as any).assign(this, init); }
}

export class ItemComponentMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ItemComponentMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class ItemComponentType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ItemComponentType>) { (Object as any).assign(this, init); }
}

export class ItemComponentTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ItemComponentTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Measurement implements IModel
{
    public active?: boolean;
    public code: string;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Measurement>) { (Object as any).assign(this, init); }
}

export class MeasurementMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<MeasurementMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class MembershipType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<MembershipType>) { (Object as any).assign(this, init); }
}

export class MembershipTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<MembershipTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class NoteType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<NoteType>) { (Object as any).assign(this, init); }
}

export class NoteTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<NoteTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class OpenClinicaUserRole implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public emailSent?: boolean;
    public enteredBy: string;
    public errorMessage: string;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public ocSyncStatus?: OCSyncStatus;
    public parentStudyId?: number;
    public personnelId?: number;
    public personnelRoleId?: number;
    public role: string;
    public studyId?: number;
    public studyIdentifier: string;
    public trialId?: number;

    public constructor(init?: Partial<OpenClinicaUserRole>) { (Object as any).assign(this, init); }
}

export class OpenClinicaUserRoleMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<OpenClinicaUserRoleMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Patient implements IModel
{
    public accrualDate?: string;
    public active?: boolean;
    public caseTypeId?: number;
    public dataManagerId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public initials: string;
    public institutionId?: number;
    public investigatorId?: number;
    public modifiedBy: string;
    public opmsId?: number;
    public registrationNumber: string;
    public treatingClinicianId?: number;
    public trialId?: number;
    public trialTreatmentId?: number;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export class PatientMetadataContext extends MetadataContext
{
    public trialId?: number;
    public institutionId?: number;

    public constructor(init?: Partial<PatientMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class PermissionConfiguration implements IModel
{
    public permissionRequirements: PermissionRequirement[];
    public description: string;
    public id?: number;
    public permission?: Permission;

    public constructor(init?: Partial<PermissionConfiguration>) { (Object as any).assign(this, init); }
}

export class PermissionConfigurationMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<PermissionConfigurationMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Personnel implements IModel
{
    public personnelInterests: PersonnelInterest[];
    public personnelProfessionalDetails: PersonnelProfessionalDetails[];
    public active?: boolean;
    public activeDirectoryUser: string;
    public apiKey: string;
    public cvDate?: string;
    public comments: string;
    public dateEntered?: string;
    public dateModified?: string;
    public emailSent?: boolean;
    public enteredBy: string;
    public firstName: string;
    public genderId?: number;
    public id?: number;
    public lastName: string;
    public membershipExpiryDate?: string;
    public membershipTypeId?: number;
    public modifiedBy: string;
    public otherDisciplines: string;
    public otherInterests: string;
    public professionalDisciplineId?: number;
    public residentialPostcode: string;
    public salutationId?: number;
    public userName: string;

    public constructor(init?: Partial<Personnel>) { (Object as any).assign(this, init); }
}

export class PersonnelMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<PersonnelMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class PersonnelNote implements IModel
{
    public note: Note;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public noteId?: number;
    public personnelId?: number;

    public constructor(init?: Partial<PersonnelNote>) { (Object as any).assign(this, init); }
}

export class PersonnelNoteMetadataContext extends MetadataContext
{
    public personnelId?: number;

    public constructor(init?: Partial<PersonnelNoteMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class PersonnelRole implements IModel
{
    public active?: boolean;
    public dateCeased?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public dateStarted?: string;
    public departmentId?: number;
    public emailSent?: boolean;
    public enteredBy: string;
    public groupId?: number;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public noEmailCommunication?: boolean;
    public personnelId?: number;
    public roleId?: number;
    public trialId?: number;

    public constructor(init?: Partial<PersonnelRole>) { (Object as any).assign(this, init); }
}

export class PersonnelRoleMetadataContext extends MetadataContext
{
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public groupId?: number;
    public personnelId?: number;
    public departmentId?: number;

    public constructor(init?: Partial<PersonnelRoleMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class PersonnelRoleCreate
{
    public personnelRole: PersonnelRole;
    public createNewPersonnel: boolean;
    public newPersonnel: Personnel;
    public createNewDepartment: boolean;
    public newDepartment: Department;

    public constructor(init?: Partial<PersonnelRoleCreate>) { (Object as any).assign(this, init); }
}

export class ProfessionalDiscipline implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ProfessionalDiscipline>) { (Object as any).assign(this, init); }
}

export class ProfessionalDisciplineMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ProfessionalDisciplineMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class ReportingTag implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public reportingTagCategoryId?: number;
    public value: string;

    public constructor(init?: Partial<ReportingTag>) { (Object as any).assign(this, init); }
}

export class ReportingTagMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ReportingTagMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class ReportingTagCategory implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ReportingTagCategory>) { (Object as any).assign(this, init); }
}

export class ReportingTagCategoryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ReportingTagCategoryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class ReportingTagType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ReportingTagType>) { (Object as any).assign(this, init); }
}

export class ReportingTagTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<ReportingTagTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Role implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public drugManagementAccess?: boolean;
    public enteredBy: string;
    public id?: number;
    public isSystem?: boolean;
    public modifiedBy: string;
    public openClinciaInstitutionRoleId?: number;
    public openClinciaRoleId?: number;
    public opmsAccess?: boolean;
    public rank?: number;
    public saeRoleId?: number;
    public value: string;

    public constructor(init?: Partial<Role>) { (Object as any).assign(this, init); }
}

export class RoleMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<RoleMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Salutation implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<Salutation>) { (Object as any).assign(this, init); }
}

export class SalutationMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<SalutationMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class SiteLocation implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<SiteLocation>) { (Object as any).assign(this, init); }
}

export class SiteLocationMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<SiteLocationMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class SiteType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<SiteType>) { (Object as any).assign(this, init); }
}

export class SiteTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<SiteTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class SortOrder implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<SortOrder>) { (Object as any).assign(this, init); }
}

export class SortOrderMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<SortOrderMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class StandardEmailTemplate implements IModel
{
    public active?: boolean;
    public body: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public standardEmailTypeId?: number;
    public subject: string;
    public value: string;

    public constructor(init?: Partial<StandardEmailTemplate>) { (Object as any).assign(this, init); }
}

export class StandardEmailTemplateMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<StandardEmailTemplateMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class State implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<State>) { (Object as any).assign(this, init); }
}

export class StateMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<StateMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TaskType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TaskType>) { (Object as any).assign(this, init); }
}

export class TaskTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TaskTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TemplateTrialItem implements IModel
{
    public collection: Collection;
    public active?: boolean;
    public allowIntraVersions?: boolean;
    public allowVersionChanges?: boolean;
    public categoryId?: number;
    public collectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public id?: number;
    public initialVersion: string;
    public modifiedBy: string;
    public name: string;
    public pendingDelete?: boolean;
    public rank?: number;

    public constructor(init?: Partial<TemplateTrialItem>) { (Object as any).assign(this, init); }
}

export class TemplateTrialItemMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TemplateTrialItemMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrackerMilestone implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrackerMilestone>) { (Object as any).assign(this, init); }
}

export class TrackerMilestoneMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrackerMilestoneMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrackerStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrackerStatus>) { (Object as any).assign(this, init); }
}

export class TrackerStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrackerStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrackerType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrackerType>) { (Object as any).assign(this, init); }
}

export class TrackerTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrackerTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class Trial implements IModel
{
    public trialAllocatedWPs: TrialAllocatedWP[];
    public trialFundings: TrialFunding[];
    public trialChairs: TrialChair[];
    public trialCollaboratingGroups: TrialCollaboratingGroup[];
    public trialProjectRegistrations: TrialProjectRegistration[];
    public trialInvolvements: TrialInvolvement[];
    public trialTumourGroups: TrialTumourGroup[];
    public trialTrialPhases: TrialTrialPhase[];
    public active?: boolean;
    public allIdentifiers: string;
    public australianLeadGroupId?: number;
    public centralCoordinatingCentreGroupId?: number;
    public centralRTQACoordinatingCentreGroupId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public internationalCentralCoordinatingCentreGroupId?: number;
    public internationalLeadGroupId?: number;
    public internationalTrialStatusId?: number;
    public isLegacyUserDatabase?: boolean;
    public laySummary: string;
    public modifiedBy: string;
    public newProposalNumber: string;
    public protocolId: string;
    public sendReminderAfterDays?: number;
    public sendReminderEmail?: boolean;
    public sendReminderStandardEmailTemplateId?: number;
    public shortTitle: string;
    public studyAcronym: string;
    public title: string;
    public trialCategoryId?: number;
    public trialDevelopmentNumber: string;
    public trialStatusId?: number;
    public tumourGroupOther: string;

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

export class TrialMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialAnalysisType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialAnalysisType>) { (Object as any).assign(this, init); }
}

export class TrialAnalysisTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialAnalysisTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialApi implements IModel
{
    public active?: boolean;
    public apiKey: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public initialsCrfItemName: string;
    public modifiedBy: string;
    public openClinciaInstitutionPrefix: string;
    public openClinciaProtocolID: string;
    public patientDetailsCRF: string;
    public registrationWebsite: string;
    public treatmentCrfItemName: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialApi>) { (Object as any).assign(this, init); }
}

export class TrialApiMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialApiMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialCategory implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public validationFormat: string;
    public validationMessage: string;
    public value: string;

    public constructor(init?: Partial<TrialCategory>) { (Object as any).assign(this, init); }
}

export class TrialCategoryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialCategoryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialForm implements IModel
{
    public currentVersion: TrialFormVersion;
    public previousVersions: TrialFormVersion[];
    public active?: boolean;
    public assignedRoleId?: number;
    public assignedToId?: number;
    public assignmentTypeId?: number;
    public currentVersionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public formTemplateId?: number;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public patientId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialForm>) { (Object as any).assign(this, init); }
}

export class TrialFormMetadataContext extends MetadataContext
{
    public trialId?: number;
    public institutionId?: number;
    public patientId?: number;

    public constructor(init?: Partial<TrialFormMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialFormReport implements IModel
{
    public trialId?: number;
    public institutionId?: number;
    public patientId?: number;
    public formTemplateId?: number;
    public assignedToId?: number;
    public formStatusId?: number;
    public trialFormReportDocuments: TrialFormReportDocument[];
    public additionalImages: SourceDocument[];
    public additionalPdfs: SourceDocument[];
    public active?: boolean;
    public centreSummary: string;
    public classificationOfReviewResults: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public introduction: string;
    public majorVariations: string;
    public minorVariations: string;
    public missingInevaluableData: string;
    public modifiedBy: string;
    public qaComments: string;
    public reviewDate?: string;
    public reviewers: string;
    public trialFormId?: number;
    public trialFormVersionId?: number;

    public constructor(init?: Partial<TrialFormReport>) { (Object as any).assign(this, init); }
}

export class TrialFormReportMetadataContext extends MetadataContext
{
    public trialFormId?: number;
    public trialId?: number;
    public institutionId?: number;

    public constructor(init?: Partial<TrialFormReportMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialGroup implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public groupId?: number;
    public id?: number;
    public modifiedBy: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialGroup>) { (Object as any).assign(this, init); }
}

export class TrialGroupMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialGroupMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialGroupItem implements IModel
{
    public currentVersion: TrialGroupItemVersion;
    public previousVersions: TrialGroupItemVersion[];
    public active?: boolean;
    public currentVersionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public groupItemId?: number;
    public id?: number;
    public modifiedBy: string;
    public trialGroupId?: number;

    public constructor(init?: Partial<TrialGroupItem>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemMetadataContext extends MetadataContext
{
    public trialId?: number;
    public groupId?: number;
    public trialGroupId?: number;
    public groupItemId?: number;

    public constructor(init?: Partial<TrialGroupItemMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialInstitution implements IModel
{
    public active?: boolean;
    public activitiesUndertakenId?: number;
    public activitiesUndertakenOther: string;
    public ccOnRegistration: string;
    public closureDate?: string;
    public comments: string;
    public dateActivated?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public expectedAccrual?: number;
    public firstPatient?: string;
    public groupId?: number;
    public id?: number;
    public initationMeetingDate?: string;
    public institutionId?: number;
    public modifiedBy: string;
    public parentInstitutionDescription: string;
    public parentInstitutionId?: number;
    public rgoApprovalDate?: string;
    public rgoSubmissionDate?: string;
    public siteTypeId?: number;
    public totalAccrual?: number;
    public trialId?: number;
    public trialInstitutionStatusId?: number;

    public constructor(init?: Partial<TrialInstitution>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialInstitutionMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialInstitutionItem implements IModel
{
    public currentVersion: TrialInstitutionItemVersion;
    public previousVersions: TrialInstitutionItemVersion[];
    public active?: boolean;
    public currentVersionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public sortOrderId?: number;
    public trialInstitutionId?: number;
    public trialInstitutionItemTemplateId?: number;

    public constructor(init?: Partial<TrialInstitutionItem>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemMetadataContext extends MetadataContext
{
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;

    public constructor(init?: Partial<TrialInstitutionItemMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplate implements IModel
{
    public collection: Collection;
    public trialInstitutionItemTemplateGroups: TrialInstitutionItemTemplateGroup[];
    public trialInstitutionItemTemplateInstitutions: TrialInstitutionItemTemplateInstitution[];
    public active?: boolean;
    public allowVersionChanges?: boolean;
    public allowVersions?: boolean;
    public auditOnSave?: boolean;
    public categoryId?: number;
    public collectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public id?: number;
    public initialVersion: string;
    public modifiedBy: string;
    public name: string;
    public pendingDelete?: boolean;
    public rank?: number;
    public sortOrderId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialInstitutionItemTemplate>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplateMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialInstitutionItemTemplateMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialInstitutionNote implements IModel
{
    public note: Note;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public noteId?: number;
    public trialId?: number;
    public trialInstitutionId?: number;

    public constructor(init?: Partial<TrialInstitutionNote>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionNoteMetadataContext extends MetadataContext
{
    public trialId?: number;
    public trialInstitutionId?: number;
    public institutionId?: number;

    public constructor(init?: Partial<TrialInstitutionNoteMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialInstitutionStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialInstitutionStatus>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialInstitutionStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialItemInstance implements IModel
{
    public currentVersion: TrialItemInstanceVersion;
    public previousVersions: TrialItemInstanceVersion[];
    public active?: boolean;
    public assignedRoleId?: number;
    public assignedToId?: number;
    public assignmentTypeId?: number;
    public currentVersionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public id?: number;
    public instanceNumber?: number;
    public modifiedBy: string;
    public sortOrderId?: number;
    public templateTrialItemId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialItemInstance>) { (Object as any).assign(this, init); }
}

export class TrialItemInstanceMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialItemInstanceMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialItemInstanceStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialItemInstanceStatus>) { (Object as any).assign(this, init); }
}

export class TrialItemInstanceStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialItemInstanceStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialMilestones implements IModel
{
    public trialAnalysisResults: TrialAnalysisResult[];
    public trialPublications: TrialPublication[];
    public trialPresentations: TrialPresentation[];
    public active?: boolean;
    public actualSitesAUS?: number;
    public actualSitesNZ?: number;
    public actualSitesTotal?: number;
    public comments: string;
    public dateAccrualComplete?: string;
    public dateActivated?: string;
    public dateCompletedWithdrawn?: string;
    public dateEntered?: string;
    public dateExpectedCompletion?: string;
    public dateFirstPatient?: string;
    public dateModified?: string;
    public dateStudyClosed?: string;
    public dateTSCApprovedForDevelopment?: string;
    public dateTSCFinalProtocol?: string;
    public dateTSCHRECApprovalReveived?: string;
    public dateTSCTROGNumberAllocated?: string;
    public enteredBy: string;
    public id?: number;
    public internationalActualDateAccrualCompleted?: string;
    public internationalActualDateFollowupCompletion?: string;
    public internationalActualSites?: number;
    public internationalDateActivated?: string;
    public internationalDateCompletedWithdrawn?: string;
    public internationalTargetAccrual?: number;
    public internationalTargetDateAccrualCompleted?: string;
    public internationalTargetDateFollowupCompletion?: string;
    public internationalTargetSites?: number;
    public internationalTotalAccrual?: number;
    public modifiedBy: string;
    public targetAccrual?: number;
    public targetDateAccrualCompleted?: string;
    public targetDateFollowupCompletion?: string;
    public targetSitesAUS?: number;
    public targetSitesNZ?: number;
    public targetSitesTotal?: number;
    public totalAccrual?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialMilestones>) { (Object as any).assign(this, init); }
}

export class TrialMilestonesMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialMilestonesMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialNote implements IModel
{
    public note: Note;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public noteId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialNote>) { (Object as any).assign(this, init); }
}

export class TrialNoteMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialNoteMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialPhase implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialPhase>) { (Object as any).assign(this, init); }
}

export class TrialPhaseMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialPhaseMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialPresentationType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialPresentationType>) { (Object as any).assign(this, init); }
}

export class TrialPresentationTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialPresentationTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialPublicationStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialPublicationStatus>) { (Object as any).assign(this, init); }
}

export class TrialPublicationStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialPublicationStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialPublicationType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialPublicationType>) { (Object as any).assign(this, init); }
}

export class TrialPublicationTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialPublicationTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialRegistry implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialRegistry>) { (Object as any).assign(this, init); }
}

export class TrialRegistryMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialRegistryMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialStatus implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialStatus>) { (Object as any).assign(this, init); }
}

export class TrialStatusMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialStatusMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialTracker implements IModel
{
    public trialTrackerComments: TrialTrackerComment[];
    public sourceDocuments: SourceDocument[];
    public active?: boolean;
    public assignedToId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public dateStarted?: string;
    public dateStopped?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public subject: string;
    public trackerMilestoneId?: number;
    public trackerStatusId?: number;
    public trackerTypeId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialTracker>) { (Object as any).assign(this, init); }
}

export class TrialTrackerMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialTrackerMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialTreatment implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public duration?: number;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public name: string;
    public opmsId?: number;
    public shortName: string;
    public targetAccrual?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialTreatment>) { (Object as any).assign(this, init); }
}

export class TrialTreatmentMetadataContext extends MetadataContext
{
    public trialId?: number;

    public constructor(init?: Partial<TrialTreatmentMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TrialType implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TrialType>) { (Object as any).assign(this, init); }
}

export class TrialTypeMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TrialTypeMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class TumourGroup implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<TumourGroup>) { (Object as any).assign(this, init); }
}

export class TumourGroupMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<TumourGroupMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class YesNo implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<YesNo>) { (Object as any).assign(this, init); }
}

export class YesNoMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<YesNoMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class YesNoPending implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<YesNoPending>) { (Object as any).assign(this, init); }
}

export class YesNoPendingMetadataContext extends MetadataContext
{

    public constructor(init?: Partial<YesNoPendingMetadataContext>) { super(init); (Object as any).assign(this, init); }
}

export class CollectionInstanceEntrySubmission
{
    public model: CollectionInstanceEntry;
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<CollectionInstanceEntrySubmission>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceEntry
{
    public id?: number;
    public collectionId?: number;
    public dataEntered?: boolean;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public persistenceState: EntryPersistenceState;
    public collectionInstanceSections: CollectionInstanceSectionEntry[];
    public collectionInstanceDatas: CollectionInstanceDataEntry[];

    public constructor(init?: Partial<CollectionInstanceEntry>) { (Object as any).assign(this, init); }
}

export enum TrialInstitutionItemDeactivationPolicy
{
    LeaveActive = 1,
    DeactivateAll = 2,
    DeactivateWithoutDataEnteredOnAnyVersion = 3,
    DeactivateWithoutDataEnteredOnCurrentVersion = 4,
}

export enum TrialInstitutionItemReactivationPolicy
{
    LeaveDeactivated = 1,
    ReactivateExisting = 2,
    ReactivateAndCreateNewVersion = 3,
}

export class TrogApiPermissionQuery
{
    public permission?: Permission;
    public permissionResolutionType?: PermissionResolutionType;
    public permissionContext: TrogApiPermissionContext;

    public constructor(init?: Partial<TrogApiPermissionQuery>) { (Object as any).assign(this, init); }
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EcrfAdminister = 40,
    DrugManagementAdministerPharmacyStock = 41,
    TrialView = 100,
    TrialCreate = 101,
    TrialDetailsView = 102,
    TrialUpdate = 103,
    DashboardView = 104,
    TrialInstitutionView = 105,
    TrialInstitutionCreate = 106,
    TrialInstitutionUpdate = 107,
    TrialPersonnelRoleView = 108,
    TrialPersonnelRoleCreate = 109,
    TrialPersonnelRoleUpdate = 110,
    TrialPatientView = 111,
    TrialPatientCreate = 112,
    TrialPatientUpdate = 113,
    TrialItemView = 114,
    TrialItemCreate = 115,
    TrialItemUpdate = 116,
    TrialNoteView = 117,
    TrialNoteCreate = 118,
    TrialNoteUpdate = 119,
    TrialGroupView = 120,
    TrialGroupCreate = 121,
    TrialGroupUpdate = 122,
    TrialFormView = 123,
    TrialFormCreate = 124,
    TrialFormUpdate = 125,
    InstitutionView = 126,
    InstitutionCreate = 127,
    InstitutionDetailsView = 128,
    InstitutionUpdate = 129,
    InstitutionDepartmentView = 130,
    InstitutionDepartmentCreate = 131,
    InstitutionDepartmentUpdate = 132,
    InstitutionPersonnelView = 133,
    InstitutionPersonnelCreate = 134,
    InstitutionPersonnelUpdate = 135,
    InstitutionFormView = 136,
    InstitutionFormCreate = 137,
    InstitutionFormUpdate = 138,
    InstitutionFormDataEntryView = 139,
    InstitutionFormDataEntryCreate = 140,
    InstitutionFormDataEntryUpdate = 141,
    InstitutionNoteView = 142,
    InstitutionNoteCreate = 143,
    InstitutionNoteUpdate = 144,
    PersonnelView = 145,
    PersonnelCreate = 146,
    PersonnelUpdate = 147,
    PersonnelItemsView = 148,
    PersonnelItemsCreate = 149,
    PersonnelItemsUpdate = 150,
    PersonnelHubspotView = 151,
    PersonnelHubspotCreate = 152,
    PersonnelHubspotUpdate = 153,
    PersonnelRoleView = 154,
    PersonnelRoleCreate = 155,
    PersonnelRoleUpdate = 156,
    PersonnelNoteView = 157,
    PersonnelNoteCreate = 158,
    PersonnelNoteUpdate = 159,
    PersonnelSecurityView = 160,
    PersonnelSecurityCreate = 161,
    PersonnelSecurityUpdate = 162,
    PersonnelOpenClinicaView = 163,
    PersonnelOpenClinicaCreate = 164,
    PersonnelOpenClinicaUpdate = 165,
    GroupView = 166,
    GroupCreate = 167,
    GroupUpdate = 168,
    GroupItemsView = 169,
    GroupItemsCreate = 170,
    GroupItemsUpdate = 171,
    GroupPersonnelRoleView = 172,
    GroupPersonnelRoleCreate = 173,
    GroupPersonnelRoleUpdate = 174,
    GroupNotesView = 175,
    GroupNotesCreate = 176,
    GroupNotesUpdate = 177,
    CategoriesView = 178,
    CategoriesCreate = 179,
    CategoriesUpdate = 180,
    RolesView = 181,
    RolesCreate = 182,
    RolesUpdate = 183,
    CountriesView = 184,
    CountriesCreate = 185,
    CountriesUpdate = 186,
    StatesView = 187,
    StatesCreate = 188,
    StatesUpdate = 189,
    ItemComponentTypesView = 190,
    ItemComponentTypesCreate = 191,
    ItemComponentTypesUpdate = 192,
    NoteTypesView = 193,
    NoteTypesCreate = 194,
    NoteTypesUpdate = 195,
    GendersView = 196,
    GendersCreate = 197,
    GendersUpdate = 198,
    InterestsView = 199,
    InterestsCreate = 200,
    InterestsUpdate = 201,
    MembershipTypesView = 202,
    MembershipTypesCreate = 203,
    MembershipTypesUpdate = 204,
    ProfessionalDisciplinesView = 205,
    ProfessionalDisciplinesCreate = 206,
    ProfessionalDisciplinesUpdate = 207,
    SalutationsView = 208,
    SalutationsCreate = 209,
    SalutationsUpdate = 210,
    TrialCategoriesView = 211,
    TrialCategoriesCreate = 212,
    TrialCategoriesUpdate = 213,
    TumorGroupsView = 214,
    TumorGroupsCreate = 215,
    TumorGroupsUpdate = 216,
    AllocatedWPsView = 217,
    AllocatedWPsCreate = 218,
    AllocatedWPsUpdate = 219,
    TrialPhasesView = 220,
    TrialPhasesCreate = 221,
    TrialPhasesUpdate = 222,
    InvolvementsView = 223,
    InvolvementsCreate = 224,
    InvolvementsUpdate = 225,
    TrialCoordCentresView = 226,
    TrialCoordCentresCreate = 227,
    TrialCoordCentresUpdate = 228,
    CollaboratingGroupsView = 229,
    CollaboratingGroupsCreate = 230,
    CollaboratingGroupsUpdate = 231,
    TrialTypesView = 232,
    TrialTypesCreate = 233,
    TrialTypesUpdate = 234,
    SiteLocationsView = 235,
    SiteLocationsCreate = 236,
    SiteLocationsUpdate = 237,
    KeyContactsView = 238,
    KeyContactsCreate = 239,
    KeyContactsUpdate = 240,
    FacilityAllianceMembersView = 241,
    FacilityAllianceMembersCreate = 242,
    FacilityAllianceMembersUpdate = 243,
    InstitutionTypesView = 244,
    InstitutionTypesCreate = 245,
    InstitutionTypesUpdate = 246,
    InstitutionCodingView = 247,
    InstitutionCodingCreate = 248,
    InstitutionCodingUpdate = 249,
    FormTemplatesView = 250,
    FormTemplatesCreate = 251,
    FormTemplatesUpdate = 252,
    FormComponentsView = 253,
    FormComponentsCreate = 254,
    FormComponentsUpdate = 255,
    ReportingTagsView = 256,
    ReportingTagsCreate = 257,
    ReportingTagsUpdate = 258,
    ReportingTagCategoriesView = 259,
    ReportingTagCategoriesCreate = 260,
    ReportingTagCategoriesUpdate = 261,
    ItemComponentsView = 262,
    ItemComponentsCreate = 263,
    ItemComponentsUpdate = 264,
    OpenClinicaUserRolesView = 265,
    OpenClinicaUserRolesCreate = 266,
    OpenClinicaUserRolesUpdate = 267,
    HubspotContactExportView = 268,
    HubspotContactExportCreate = 269,
    HubspotContactExportUpdate = 270,
    TrialApisView = 271,
    TrialTreatmentsView = 272,
    TrialTreatmentsCreate = 273,
    TrialTreatmentsUpdate = 274,
    TaskTypesView = 275,
    TaskTypesCreate = 276,
    TaskTypesUpdate = 277,
    FormTemplateFileTypesView = 278,
    FormTemplateFileTypesCreate = 279,
    FormTemplateFileTypesUpdate = 280,
    TrialFormDataEntry = 281,
    TrialTrackerView = 282,
    TrialTrackerCreate = 283,
    TrialTrackerUpdate = 284,
    QAEmailTemplatesView = 285,
    QAEmailTemplatesCreate = 286,
    QAEmailTemplatesUpdate = 287,
    TemplateTrialItemsView = 288,
    TemplateTrialItemsCreate = 289,
    TemplateTrialItemsUpdate = 290,
    TrialItemInstanceView = 291,
    TrialItemInstanceCreate = 292,
    TrialItemInstanceUpdate = 293,
    TrialInstitutionItemTemplatesView = 294,
    TrialInstitutionItemTemplatesUpdate = 295,
    TrialInstitutionItemTemplatesCreate = 296,
    TrialInstitutionItemTemplateImport = 297,
    TrialInstitutionItemTemplateRestrictedUpdate = 298,
    TrialInstitutionItemInstanceView = 299,
    TrialInstitutionItemInstanceUpdate = 300,
    TrialPresentationTypesView = 301,
    TrialPresentationTypesCreate = 302,
    TrialPresentationTypesUpdate = 303,
    TrialPublicationTypesView = 304,
    TrialPublicationTypesCreate = 305,
    TrialPublicationTypesUpdate = 306,
    TrialAnalysisTypesView = 307,
    TrialAnalysisTypesCreate = 308,
    TrialAnalysisTypesUpdate = 309,
    TrialItemTemplateLock = 310,
    TrialItemTemplateUnLock = 311,
    TrialInstitutionItemTemplateLock = 312,
    TrialInstitutionItemTemplateUnLock = 313,
    CollectionLock = 314,
    CollectionUnLock = 315,
    TrialItemInstanceVersionUpdate = 316,
    TrialItemInstanceExport = 317,
    TrialInstitutionItemInstanceExport = 318,
    SourceDataVerificationAccess = 320,
    SourceDataVerificationConfigure = 321,
    ExternalApiAccess = 322,
}

export enum PermissionResolutionType
{
    DatabaseConfiguration = 1,
    ClassConfiguration = 2,
    FileConfiguration = 3,
}

export class TrogApiPermissionContext
{
    public trialId?: number;
    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionCode: string;
    public patientStudyNumber: string;

    public constructor(init?: Partial<TrogApiPermissionContext>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class ModelMetadata
{
    public modelName: string;
    public fields: IReadOnlyList<FieldMetadata>;

    public constructor(init?: Partial<ModelMetadata>) { (Object as any).assign(this, init); }
}

export interface IModelMetadataResponse
{
    metadata: ModelMetadata;
}

export class LookupUpdate
{
    public propertyPath: string;
    public options: IReadOnlyList<LookupOption>;

    public constructor(init?: Partial<LookupUpdate>) { (Object as any).assign(this, init); }
}

export interface IModelLookupUpdatesResponse
{
    updates: LookupUpdate[];
}

export class ModelValidationResult
{
    public errors: IReadOnlyList<ModelValidationError>;
    public hasErrors: boolean;
    public isSubmitAllowed: boolean;
    public hasBlockingErrors: boolean;
    public isBlocked: boolean;

    public constructor(init?: Partial<ModelValidationResult>) { (Object as any).assign(this, init); }
}

export interface IModelValidationResponse
{
    validation: ModelValidationResult;
}

export class GroupSummary implements IView
{
    public groupId?: number;
    public groupName: string;
    public groupCode: string;
    public groupIsDefault?: boolean;
    public groupTypeId?: number;
    public groupType: string;
    public groupCountryId?: number;
    public groupCountry: string;
    public groupStateId?: number;
    public groupState: string;
    public groupActive?: boolean;

    public constructor(init?: Partial<GroupSummary>) { (Object as any).assign(this, init); }
}

export class GroupItemSummary implements IView
{
    public groupItemId?: number;
    public groupId?: number;
    public collectionId?: number;
    public groupName: string;
    public groupItemCategoryId?: number;
    public groupItemCategory: string;
    public groupItemName: string;
    public groupItemDescription: string;
    public groupItemInitialVersion: string;
    public groupItemRank?: number;
    public groupItemActive?: boolean;

    public constructor(init?: Partial<GroupItemSummary>) { (Object as any).assign(this, init); }
}

export class GroupNoteSummary implements IView
{
    public groupNoteId?: number;
    public groupId?: number;
    public noteId?: number;
    public noteNoteTypeId?: number;
    public noteNoteType: string;
    public noteTitle: string;
    public noteComments: string;
    public noteDateEntered?: string;
    public groupNoteActive?: boolean;

    public constructor(init?: Partial<GroupNoteSummary>) { (Object as any).assign(this, init); }
}

export class PersonnelSummary implements IView
{
    public personnelId?: number;
    public personnelSalutationId?: number;
    public personnelSalutation: string;
    public personnelFirstName: string;
    public personnelLastName: string;
    public personnelFullName: string;
    public personnelPrimaryEmail: string;
    public personnelUserName: string;
    public personnelGenderId?: number;
    public personnelGender: string;
    public personnelMembershipTypeId?: number;
    public personnelMembershipType: string;
    public personnelProfessionalDisciplineId?: number;
    public personnelProfessionalDiscipline: string;
    public personnelActive?: boolean;

    public constructor(init?: Partial<PersonnelSummary>) { (Object as any).assign(this, init); }
}

export class PersonnelRoleSummary implements IView
{
    public personnelRoleId?: number;
    public personnelId?: number;
    public personnelFullName: string;
    public personnelRoleEmail: string;
    public personnelRolePhone: string;
    public groupId?: number;
    public groupName: string;
    public institutionId?: number;
    public institutionName: string;
    public departmentId?: number;
    public departmentName: string;
    public trialId?: number;
    public trialDisplayNumber: string;
    public trialDisplayName: string;
    public personnelRoleRoleId?: number;
    public personnelRoleRole: string;
    public personnelRoleIsGlobal: boolean;
    public personnelRoleDateStarted?: string;
    public personnelRoleDateCeased?: string;
    public personnelRoleActive?: boolean;

    public constructor(init?: Partial<PersonnelRoleSummary>) { (Object as any).assign(this, init); }
}

export class PersonnelNoteSummary implements IView
{
    public personnelNoteId?: number;
    public personnelId?: number;
    public noteId?: number;
    public noteNoteTypeId?: number;
    public noteNoteType: string;
    public noteTitle: string;
    public noteComments: string;
    public noteDateEntered?: string;
    public personnelNoteActive?: boolean;

    public constructor(init?: Partial<PersonnelNoteSummary>) { (Object as any).assign(this, init); }
}

export class InstitutionSummary implements IView
{
    public institutionId?: number;
    public institutionName: string;
    public institutionCode: string;
    public institutionTypeId?: number;
    public institutionType: string;
    public institutionSiteLocationId?: number;
    public institutionSiteLocation: string;
    public institutionCountryId?: number;
    public institutionCountry: string;
    public institutionStateId?: number;
    public institutionState: string;
    public institutionActive?: boolean;

    public constructor(init?: Partial<InstitutionSummary>) { (Object as any).assign(this, init); }
}

export class DepartmentSummary implements IView
{
    public departmentId?: number;
    public institutionId?: number;
    public institutionName: string;
    public departmentName: string;
    public departmentCountryId?: number;
    public departmentCountry: string;
    public departmentStateId?: number;
    public departmentState: string;
    public departmentActive?: boolean;

    public constructor(init?: Partial<DepartmentSummary>) { (Object as any).assign(this, init); }
}

export class InstitutionFormSummary implements IView
{
    public institutionFormId?: number;
    public institutionFormVersionId?: number;
    public institutionFormCurrentVersionId?: number;
    public institutionFormIsCurrentVersion?: boolean;
    public institutionId?: number;
    public collectionInstanceId?: number;
    public formTemplateId?: number;
    public institutionName: string;
    public formTemplateName: string;
    public formTemplateStatusId?: number;
    public formTemplateStatusValue: string;
    public institutionFormAssignedToId?: number;
    public institutionFormAssignedRoleId?: number;
    public institutionFormAssignmentTypeId?: number;
    public institutionFormAssignedRole: string;
    public institutionFormAssignedToPersonnel: string;
    public institutionFormAssignedTo: string;
    public institutionFormDateNextVersion?: string;
    public institutionFormVersion: string;
    public institutionFormVersionDateEntered?: string;
    public institutionFormActive?: boolean;

    public constructor(init?: Partial<InstitutionFormSummary>) { (Object as any).assign(this, init); }
}

export class InstitutionNoteSummary implements IView
{
    public institutionNoteId?: number;
    public institutionId?: number;
    public noteId?: number;
    public noteNoteTypeId?: number;
    public noteNoteType: string;
    public noteTitle: string;
    public noteComments: string;
    public noteDateEntered?: string;
    public institutionNoteActive?: boolean;

    public constructor(init?: Partial<InstitutionNoteSummary>) { (Object as any).assign(this, init); }
}

export class TrialFormSummary implements IView
{
    public trialFormId?: number;
    public trialFormVersionId?: number;
    public trialFormCurrentVersionId?: number;
    public trialFormIsCurrentVersion?: boolean;
    public trialId?: number;
    public trialDisplayNumber: string;
    public institutionId?: number;
    public institutionName: string;
    public patientId?: number;
    public patientRegistrationNumber: string;
    public formTemplateId?: number;
    public formTemplateName: string;
    public trialFormFormStatusId?: number;
    public trialFormFormStatus: string;
    public collectionInstanceId?: number;
    public trialFormAssignedToId?: number;
    public trialFormAssignedRoleId?: number;
    public trialFormAssignmentTypeId?: number;
    public trialFormAssignedRole: string;
    public trialFormAssignedToPersonnel: string;
    public trialFormAssignedTo: string;
    public trialFormReviewDate?: string;
    public trialFormVersion: string;
    public trialFormVersionDateEntered?: string;
    public trialFormActive?: boolean;

    public constructor(init?: Partial<TrialFormSummary>) { (Object as any).assign(this, init); }
}

export class TrialFormAdministrationCaseReport implements IView
{
    public trialFormId?: number;
    public patientId?: number;
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public formTemplateId?: number;
    public formTemplateName: string;
    public measurementId?: number;
    public trialFormAdministrationCaseReportCategory: string;
    public trialFormAdministrationCaseReportField: string;
    public trialFormAdministrationCaseReportResult: string;
    public trialFormAdministrationCaseReportClassification: string;
    public trialFormAdministrationCaseReportBenchmark: string;
    public trialFormAdministrationCaseReportMinor?: boolean;
    public trialFormAdministrationCaseReportMajor?: boolean;

    public constructor(init?: Partial<TrialFormAdministrationCaseReport>) { (Object as any).assign(this, init); }
}

export class TrialGroupSummary implements IView
{
    public trialGroupId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public groupId?: number;
    public groupName: string;
    public trialGroupActive?: boolean;

    public constructor(init?: Partial<TrialGroupSummary>) { (Object as any).assign(this, init); }
}

export class TrialNoteSummary implements IView
{
    public trialNoteId?: number;
    public trialId?: number;
    public noteId?: number;
    public noteNoteTypeId?: number;
    public noteNoteType: string;
    public noteTitle: string;
    public noteComments: string;
    public noteDateEntered?: string;
    public trialNoteActive?: boolean;

    public constructor(init?: Partial<TrialNoteSummary>) { (Object as any).assign(this, init); }
}

export class PatientSummary implements IView
{
    public patientId?: number;
    public patientOpmsId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public institutionId?: number;
    public institutionName: string;
    public institutionCode: string;
    public patientInitials: string;
    public patientRegistrationNumber: string;
    public patientCaseTypeId?: number;
    public patientCaseType: string;
    public trialTreatmentId?: number;
    public trialTreatmentName: string;
    public patientAccrualDate?: string;
    public patientActive?: boolean;

    public constructor(init?: Partial<PatientSummary>) { (Object as any).assign(this, init); }
}

export class TrialTrackerSummary implements IView
{
    public trialTrackerId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public trialTrackerTrackerTypeId?: number;
    public trialTrackerTrackerType: string;
    public trialTrackerTrackerMilestoneId?: number;
    public trialTrackerTrackerMilestone: string;
    public trialTrackerTrackerStatusId?: number;
    public trialTrackerTrackerStatus: string;
    public trialTrackerAssignedToId?: number;
    public trialTrackerAssignedTo: string;
    public trialTrackerSubject: string;
    public trialTrackerDateStarted?: string;
    public trialTrackerDateStopped?: string;
    public trialTrackerEnteredBy: string;
    public trialTrackerCommentComments: string;
    public trialTrackerActive?: boolean;

    public constructor(init?: Partial<TrialTrackerSummary>) { (Object as any).assign(this, init); }
}

export class TrialTreatmentSummary implements IView
{
    public trialTreatmentId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public trialTreatmentName: string;
    public trialTreatmentShortName: string;
    public trialTreatmentOpmsId?: number;
    public trialTreatmentDuration?: number;
    public trialTreatmentTargetAccrual?: number;
    public trialTreatmentActive?: boolean;

    public constructor(init?: Partial<TrialTreatmentSummary>) { (Object as any).assign(this, init); }
}

export class TrialItemInstanceSummary implements IView
{
    public trialItemInstanceId?: number;
    public trialItemInstanceVersionId?: number;
    public trialItemInstanceCurrentVersionId?: number;
    public trialItemInstanceIsCurrentVersion?: boolean;
    public trialId?: number;
    public trialDisplayNumber: string;
    public templateTrialItemId?: number;
    public templateTrialItemCategoryId?: number;
    public templateTrialItemCategory: string;
    public templateTrialItemName: string;
    public trialItemInstanceDescription: string;
    public collectionInstanceId?: number;
    public collectionInstanceDataEntered?: boolean;
    public trialItemInstanceAssignedRoleId?: number;
    public trialItemInstanceAssignedRole: string;
    public trialItemInstanceAssignedToId?: number;
    public trialItemInstanceAssignedToPersonnel: string;
    public trialItemInstanceAssignedTo: string;
    public trialItemInstanceAssignmentTypeId?: number;
    public trialItemInstanceAssignmentType: string;
    public trialItemInstanceSortOrderId?: number;
    public trialItemInstanceSortOrder: string;
    public trialItemInstanceStatusId?: number;
    public trialItemInstanceStatus: string;
    public trialItemInstanceInstanceNumber?: number;
    public trialItemInstanceVersion: string;
    public trialItemInstanceVersionDate?: string;
    public trialItemInstanceActive?: boolean;

    public constructor(init?: Partial<TrialItemInstanceSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemSummary implements IView
{
    public trialInstitutionItemId?: number;
    public trialInstitutionItemVersionId?: number;
    public trialInstitutionItemCurrentVersionId?: number;
    public trialInstitutionItemIsCurrentVersion?: boolean;
    public trialInstitutionId?: number;
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionItemTemplateId?: number;
    public trialInstitutionItemTemplateCategoryId?: number;
    public trialInstitutionItemTemplateCategory: string;
    public trialInstitutionItemTemplateName: string;
    public trialInstitutionItemTemplateDescription: string;
    public trialInstitutionItemTemplateAllowVersions?: boolean;
    public collectionInstanceId?: number;
    public collectionInstanceDataEntered?: boolean;
    public trialInstitutionItemSortOrderId?: number;
    public trialInstitutionItemSortOrder: string;
    public trialInstitutionItemVersion: string;
    public trialInstitutionItemVersionDate?: string;
    public trialInstitutionItemActive?: boolean;

    public constructor(init?: Partial<TrialInstitutionItemSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionNoteSummary implements IView
{
    public trialInstitutionNoteId?: number;
    public trialInstitutionId?: number;
    public trialId?: number;
    public institutionId?: number;
    public noteId?: number;
    public noteNoteTypeId?: number;
    public noteNoteType: string;
    public noteTitle: string;
    public noteComments: string;
    public noteDateEntered?: string;
    public trialInstitutionNoteActive?: boolean;

    public constructor(init?: Partial<TrialInstitutionNoteSummary>) { (Object as any).assign(this, init); }
}

export class ItemComponentSummary implements IView
{
    public itemComponentId?: number;
    public itemComponentName: string;
    public itemComponentDescription: string;
    public itemComponentTypeId?: number;
    public itemComponentType: string;
    public itemComponentCustomInputControlName: string;
    public itemComponentRank?: number;
    public itemComponentIsSystem?: boolean;
    public itemComponentActive?: boolean;

    public constructor(init?: Partial<ItemComponentSummary>) { (Object as any).assign(this, init); }
}

export class TemplateTrialItemSummary implements IView
{
    public templateTrialItemId?: number;
    public templateTrialItemCategoryId?: number;
    public templateTrialItemCategory: string;
    public collectionId?: number;
    public templateTrialItemName: string;
    public templateTrialItemDescription: string;
    public templateTrialItemInitialVersion: string;
    public templateTrialItemRank?: number;
    public templateTrialItemActive?: boolean;

    public constructor(init?: Partial<TemplateTrialItemSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplateSummary implements IView
{
    public trialInstitutionItemTemplateId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public trialInstitutionItemTemplateCategoryId?: number;
    public trialInstitutionItemTemplateCategory: string;
    public collectionId?: number;
    public trialInstitutionItemTemplateSortOrderId?: number;
    public trialInstitutionItemTemplateSortOrder: string;
    public trialInstitutionItemTemplateName: string;
    public trialInstitutionItemTemplateDescription: string;
    public trialInstitutionItemTemplateGroupOrInstitution: string;
    public trialInstitutionItemTemplateInitialVersion: string;
    public trialInstitutionItemTemplateRank?: number;
    public trialInstitutionItemTemplateIsScoped?: boolean;
    public trialInstitutionItemTemplateActive?: boolean;

    public constructor(init?: Partial<TrialInstitutionItemTemplateSummary>) { (Object as any).assign(this, init); }
}

export class OpenClinicaUserRoleSummary implements IView
{
    public openClinicaUserRoleId?: number;
    public personnelId?: number;
    public personnelFullName: string;
    public personnelRoleId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public institutionId?: number;
    public institutionName: string;
    public openClinicaUserRoleStudyId?: number;
    public openClinicaUserRoleStudyIdentifier: string;
    public openClinicaUserRoleRole: string;
    public openClinicaUserRoleSyncStatus?: OCSyncStatus;
    public openClinicaUserRoleStatus: string;
    public openClinicaUserRoleErrorMessage: string;
    public openClinicaUserRoleActive?: boolean;

    public constructor(init?: Partial<OpenClinicaUserRoleSummary>) { (Object as any).assign(this, init); }
}

export class User
{
    public username: string;
    public fullName: string;
    public firstName: string;
    public lastName: string;
    public email: string;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}

export class UserDetails extends User
{
    public permissions: PersonnelTmdPermission[];

    public constructor(init?: Partial<UserDetails>) { super(init); (Object as any).assign(this, init); }
}

export class AppSettings
{
    public environment: string;
    public sentrySettings: SentrySettings;

    public constructor(init?: Partial<AppSettings>) { (Object as any).assign(this, init); }
}

export class DashboardSummaryTrialForm implements IView
{
    public personnelId?: number;
    public trialFormId?: number;
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public patientId?: number;
    public itemComponentTypeId?: number;
    public itemComponentType: string;
    public trialDisplayNumber: string;
    public trialDisplayTitle: string;
    public institutionName: string;
    public patientRegistrationNumber: string;
    public formTemplateId?: number;
    public formTemplateName: string;
    public formStatusId?: number;
    public formStatus: string;
    public assignedToId?: number;
    public assignedRoleId?: number;
    public assignmentTypeId?: number;
    public assignedTo: string;
    public version: string;

    public constructor(init?: Partial<DashboardSummaryTrialForm>) { (Object as any).assign(this, init); }
}

export class DashboardSummaryInstitutionForm implements IView
{
    public personnelId?: number;
    public institutionFormId?: number;
    public institutionId?: number;
    public institutionName: string;
    public itemComponentTypeId?: number;
    public itemComponentType: string;
    public formTemplateId?: number;
    public formTemplateName: string;
    public formStatusId?: number;
    public formStatus: string;
    public assignedToId?: number;
    public assignedRoleId?: number;
    public assignmentTypeId?: number;
    public assignedTo: string;
    public version: string;

    public constructor(init?: Partial<DashboardSummaryInstitutionForm>) { (Object as any).assign(this, init); }
}

export class DashboardSummaryTrialItemInstance implements IView
{
    public personnelId?: number;
    public trialId?: number;
    public trialItemInstanceId?: number;
    public templateTrialItemId?: number;
    public collectionInstanceId?: number;
    public assignedToId?: number;
    public assignedRoleId?: number;
    public assignmentTypeId?: number;
    public assignedTo: string;
    public trialDisplayNumber: string;
    public trialDisplayTitle: string;
    public templateTrialItemName: string;
    public trialItemInstanceStatusId?: number;
    public trialItemInstanceStatus: string;
    public trialItemInstanceVersion: string;

    public constructor(init?: Partial<DashboardSummaryTrialItemInstance>) { (Object as any).assign(this, init); }
}

export class DashboardSummaryTrialInstitution implements IView
{
    public personnelId?: number;
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public trialDisplayNumber: string;
    public trialDisplayTitle: string;
    public institutionName: string;
    public trialInstitutionStatusId?: number;
    public trialInstitutionStatus: string;
    public trialInstitutionRolesActive?: number;
    public trialInstitutionRolesInactive?: number;
    public trialInstitutionRolesTotal?: number;
    public dateActivated?: string;

    public constructor(init?: Partial<DashboardSummaryTrialInstitution>) { (Object as any).assign(this, init); }
}

export class DashboardSummaryTrial implements IView
{
    public personnelId?: number;
    public trialId?: number;
    public trialDisplayNumber: string;
    public trialDisplayTitle: string;
    public trialStatusId?: number;
    public trialStatus: string;
    public trialRolesActive?: number;
    public trialRolesInactive?: number;
    public trialRolesTotal?: number;
    public trialInstitutionRolesActive?: number;
    public trialInstitutionRolesInactive?: number;
    public trialInstitutionRolesTotal?: number;

    public constructor(init?: Partial<DashboardSummaryTrial>) { (Object as any).assign(this, init); }
}

export class Search implements IView
{
    public searchType?: SearchType;
    public title: string;
    public description: string;
    public details: { [index: string]: string; };
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public groupId?: number;
    public personnelId?: number;
    public patientId?: number;

    public constructor(init?: Partial<Search>) { (Object as any).assign(this, init); }
}

export class TemporaryFile implements IView
{
    public id: string;
    public name: string;
    public contentType: string;
    public extension: string;
    public fileSize?: number;
    public image?: boolean;
    public dateUploaded?: string;

    public constructor(init?: Partial<TemporaryFile>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceEntrySaveResult
{
    public model: CollectionInstanceEntry;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<CollectionInstanceEntrySaveResult>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemDeactivationCandidate
{
    public trialInstitutionItemId: number;
    public hasDataEnteredOnAnyVersion: boolean;
    public hasDataEnteredOnCurrentVersion: boolean;

    public constructor(init?: Partial<TrialInstitutionItemDeactivationCandidate>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemReactivationCandidate
{
    public trialInstitutionItemId: number;
    public allowVersions: boolean;

    public constructor(init?: Partial<TrialInstitutionItemReactivationCandidate>) { (Object as any).assign(this, init); }
}

export class TrialIdentity implements IView
{
    public id?: number;
    public displayNumber: string;
    public displayTitle: string;
    public active?: boolean;

    public constructor(init?: Partial<TrialIdentity>) { (Object as any).assign(this, init); }
}

export class TrialSummary implements IView
{
    public trialId?: number;
    public trialIdentifiers: string;
    public trialDisplayNumber: string;
    public trialAcronym: string;
    public trialCategoryId?: number;
    public trialCategory: string;
    public trialStatusId?: number;
    public trialStatus: string;
    public trialActive?: boolean;
    public trialRegistrationWebsite: string;

    public constructor(init?: Partial<TrialSummary>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionIdentity implements IView
{
    public id?: number;
    public trialId?: number;
    public institutionId?: number;
    public institutionName: string;
    public active?: boolean;

    public constructor(init?: Partial<TrialInstitutionIdentity>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionSummary implements IView
{
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public trialDisplayNumber: string;
    public trialDisplayTitle: string;
    public institutionName: string;
    public institutionCode: string;
    public trialInstitutionStatusId?: number;
    public trialInstitutionStatus: string;
    public accrualActive?: number;
    public accrualInactive?: number;
    public accrualTotal?: number;
    public dateActivated?: string;
    public trialInstitutionRolesActive?: number;
    public trialInstitutionRolesInactive?: number;
    public trialInstitutionRolesTotal?: number;
    public trialActive?: boolean;
    public institutionActive?: boolean;
    public trialInstitutionActive?: boolean;

    public constructor(init?: Partial<TrialInstitutionSummary>) { (Object as any).assign(this, init); }
}

export class InstitutionIdentity implements IView
{
    public id?: number;
    public name: string;
    public active?: boolean;

    public constructor(init?: Partial<InstitutionIdentity>) { (Object as any).assign(this, init); }
}

export class DepartmentIdentity implements IView
{
    public id?: number;
    public institutionId?: number;
    public name: string;
    public active?: boolean;

    public constructor(init?: Partial<DepartmentIdentity>) { (Object as any).assign(this, init); }
}

export class PatientIdentity implements IView
{
    public id?: number;
    public trialId?: number;
    public institutionId?: number;
    public trialInstitutionId?: number;
    public initials: string;
    public registrationNumber: string;
    public active?: boolean;

    public constructor(init?: Partial<PatientIdentity>) { (Object as any).assign(this, init); }
}

export class GroupIdentity implements IView
{
    public id?: number;
    public name: string;
    public active?: boolean;

    public constructor(init?: Partial<GroupIdentity>) { (Object as any).assign(this, init); }
}

export class PersonnelIdentity implements IView
{
    public id?: number;
    public firstName: string;
    public lastName: string;
    public primaryEmail: string;
    public active?: boolean;

    public constructor(init?: Partial<PersonnelIdentity>) { (Object as any).assign(this, init); }
}

export class MeasurementReport implements IView
{
    public trialFormId?: number;
    public trialId?: number;
    public institutionId?: number;
    public summaries: MeasurementReportSummary[];
    public summaryTotals: MeasurementReportSummaryTotals;
    public classifications: MeasurementReportClassification[];
    public classificationTotals: MeasurementReportClassificationTotals;
    public values: MeasurementReportValue[];

    public constructor(init?: Partial<MeasurementReport>) { (Object as any).assign(this, init); }
}

export class TrogApiInstitution
{
    public id?: number;
    public name: string;
    public code: string;
    public trialInstitutions: TrogApiTrialInstitution[];
    public userInstitutions: TrogApiUserInstitution[];

    public constructor(init?: Partial<TrogApiInstitution>) { (Object as any).assign(this, init); }
}

export class TrogApiTrial
{
    public id: number;
    public name: string;
    public code: string;
    public userTrialInstitutions: TrogApiUserTrialInstitution[];
    public trialInstitutions: TrogApiTrialInstitution[];

    public constructor(init?: Partial<TrogApiTrial>) { (Object as any).assign(this, init); }
}

export class TrogApiUser
{
    public id?: number;
    public firstName: string;
    public lastName: string;
    public subjectId: string;
    public username: string;
    public email: string;
    public apiKey: string;
    public memberships: TrogApiMembership[];
    public userInstitutions: TrogApiUserInstitution[];
    public userGroups: TrogApiUserGroup[];

    public constructor(init?: Partial<TrogApiUser>) { (Object as any).assign(this, init); }
}

export class KeyValuePair<TKey, TValue>
{
    public key: TKey;
    public value: TValue;

    public constructor(init?: Partial<KeyValuePair<TKey, TValue>>) { (Object as any).assign(this, init); }
}

export class TrogApiPermissionConfiguration
{
    public id?: number;
    public permission?: Permission;
    public description: string;

    public constructor(init?: Partial<TrogApiPermissionConfiguration>) { (Object as any).assign(this, init); }
}

export interface IModelDeleteResponse
{
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IHeaderDictionary
{
}

export interface IModel
{
    id?: number;
}

export class CollectionItemComponent implements IModel
{
    public collectionItemComponentOverrides: CollectionItemComponentOverride[];
    public active?: boolean;
    public collectionId?: number;
    public collectionSectionId?: number;
    public column?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public itemComponentId?: number;
    public modifiedBy: string;
    public rank?: number;

    public constructor(init?: Partial<CollectionItemComponent>) { (Object as any).assign(this, init); }
}

export class CollectionSection implements IModel
{
    public collectionItemComponents: CollectionItemComponent[];
    public active?: boolean;
    public canAssign?: boolean;
    public collectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public isNaAllowed?: boolean;
    public modifiedBy: string;
    public name: string;
    public rank?: number;

    public constructor(init?: Partial<CollectionSection>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceData implements IModel
{
    public sourceDocuments: SourceDocument[];
    public active?: boolean;
    public bitValue?: boolean;
    public collectionInstanceId?: number;
    public collectionItemComponentId?: number;
    public dateEntered?: string;
    public dateJustified?: string;
    public dateModified?: string;
    public dateValue?: string;
    public enteredBy: string;
    public id?: number;
    public intValue?: number;
    public isNa?: boolean;
    public itemComponentId?: number;
    public itemComponentPrimitiveId?: number;
    public justified?: boolean;
    public justifiedBy: string;
    public modifiedBy: string;
    public numberValue?: number;
    public textValue: string;
    public version: string;

    public constructor(init?: Partial<CollectionInstanceData>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceSection implements IModel
{
    public collectionInstanceDatas: CollectionInstanceData[];
    public active?: boolean;
    public assignedRoleId?: number;
    public assignedToId?: number;
    public assignmentTypeId?: number;
    public collectionInstanceId?: number;
    public collectionSectionId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public isNa?: boolean;
    public modifiedBy: string;

    public constructor(init?: Partial<CollectionInstanceSection>) { (Object as any).assign(this, init); }
}

export enum ErrorType
{
    Server = 1,
    Client = 2,
}

export class Note implements IModel
{
    public active?: boolean;
    public comments: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public noteTypeId?: number;
    public title: string;

    public constructor(init?: Partial<Note>) { (Object as any).assign(this, init); }
}

export class SourceDocument implements IModel
{
    public image?: boolean;
    public fileInformation: TemporaryFileInformation;
    public guid: string;
    public fileSize?: number;
    public contentType: string;
    public exists?: boolean;
    public isDownloadable?: boolean;
    public base64: string;
    public count?: number;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public description: string;
    public enteredBy: string;
    public errorMessage: string;
    public extension: string;
    public fileType?: number;
    public formName: string;
    public id?: number;
    public modifiedBy: string;
    public name: string;
    public parentSourceDocumentId?: number;
    public processServerPath: string;
    public recordId?: number;
    public sourceDocumentStatusId?: number;
    public subRecordId?: number;

    public constructor(init?: Partial<SourceDocument>) { (Object as any).assign(this, init); }
}

export class InstitutionFormVersion implements IModel
{
    public active?: boolean;
    public collectionInstanceId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public dateNextVersion?: string;
    public enteredBy: string;
    public formNextAutoVersionId?: number;
    public formStatusId?: number;
    public id?: number;
    public institutionFormId?: number;
    public modifiedBy: string;
    public version: string;

    public constructor(init?: Partial<InstitutionFormVersion>) { (Object as any).assign(this, init); }
}

export class ItemComponentPrimitive implements IModel
{
    public itemComponentPrimitiveOptions: ItemComponentPrimitiveOption[];
    public active?: boolean;
    public calculationFormula?: CalculationFormula;
    public compare1ItemComponentPrimitiveId?: number;
    public compare2ItemComponentPrimitiveId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public itemComponentId?: number;
    public itemPrimitive?: ItemPrimitive;
    public label: string;
    public measure?: boolean;
    public modifiedBy: string;
    public rank?: number;

    public constructor(init?: Partial<ItemComponentPrimitive>) { (Object as any).assign(this, init); }
}

export class ItemComponentRule implements IModel
{
    public active?: boolean;
    public compareItemComponentPrimitiveId?: number;
    public compareValue: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public itemComponentId?: number;
    public itemComponentPrimitiveId?: number;
    public itemPrimitiveRule?: ItemPrimitiveRule;
    public modifiedBy: string;

    public constructor(init?: Partial<ItemComponentRule>) { (Object as any).assign(this, init); }
}

export enum OCSyncStatus
{
    Pending = 1,
    Complete = 2,
    Processing = 3,
    Failed = 4,
    UpdateRequired = 5,
    RemoveRequested = 6,
    Removed = 7,
}

export class PermissionRequirement implements IModel
{
    public roleGroup: RoleGroup;
    public configurationId?: number;
    public coordinatingGroupId?: number;
    public coordinatingGroupMatch?: boolean;
    public description: string;
    public groupCommitteeId?: number;
    public id?: number;
    public institutionCode: string;
    public institutionMatch?: boolean;
    public masterGroupId?: number;
    public masterGroupMatch?: boolean;
    public patientMatch?: boolean;
    public patientStudyNumber: string;
    public roleGroupId?: number;
    public trialId?: number;
    public trialInstitutionStatusId?: number;
    public trialMatch?: boolean;
    public trialStatusId?: number;
    public type?: PermissionRequirementType;

    public constructor(init?: Partial<PermissionRequirement>) { (Object as any).assign(this, init); }
}

export class PersonnelInterest implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public interestId?: number;
    public modifiedBy: string;
    public personnelId?: number;

    public constructor(init?: Partial<PersonnelInterest>) { (Object as any).assign(this, init); }
}

export class PersonnelProfessionalDetails implements IModel
{
    public active?: boolean;
    public addressLine1: string;
    public addressLine2: string;
    public citySuburb: string;
    public countryId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public department: string;
    public enteredBy: string;
    public id?: number;
    public institutionId?: number;
    public institutionOther: string;
    public jobTitle: string;
    public mobile: string;
    public modifiedBy: string;
    public personnelId?: number;
    public phone: string;
    public postCode: string;
    public primaryDetails?: boolean;
    public primaryEmail: string;
    public secondaryEmail: string;
    public stateOther: string;
    public stateProvinceRegionId?: number;

    public constructor(init?: Partial<PersonnelProfessionalDetails>) { (Object as any).assign(this, init); }
}

export class TrialAllocatedWP implements IModel
{
    public active?: boolean;
    public allocatedWPId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialAllocatedWP>) { (Object as any).assign(this, init); }
}

export class TrialFunding implements IModel
{
    public active?: boolean;
    public amountRecieved?: number;
    public amountRequested?: number;
    public currency: string;
    public dateEntered?: string;
    public dateModified?: string;
    public endDate?: string;
    public enteredBy: string;
    public fundingStatusId?: number;
    public id?: number;
    public modifiedBy: string;
    public name: string;
    public source: string;
    public startDate?: string;
    public submissionDate?: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialFunding>) { (Object as any).assign(this, init); }
}

export class TrialChair implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public isPrimary?: boolean;
    public modifiedBy: string;
    public personnelId?: number;
    public trialId?: number;

    public constructor(init?: Partial<TrialChair>) { (Object as any).assign(this, init); }
}

export class TrialCollaboratingGroup implements IModel
{
    public active?: boolean;
    public collaboratingGroupId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialCollaboratingGroup>) { (Object as any).assign(this, init); }
}

export class TrialProjectRegistration implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public registrationNumber: string;
    public trialId?: number;
    public trialRegistryId?: number;
    public trialRegistryOther: string;
    public url: string;

    public constructor(init?: Partial<TrialProjectRegistration>) { (Object as any).assign(this, init); }
}

export class TrialInvolvement implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public involvementId?: number;
    public modifiedBy: string;
    public trialId?: number;

    public constructor(init?: Partial<TrialInvolvement>) { (Object as any).assign(this, init); }
}

export class TrialTumourGroup implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialId?: number;
    public tumourGroupId?: number;

    public constructor(init?: Partial<TrialTumourGroup>) { (Object as any).assign(this, init); }
}

export class TrialTrialPhase implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialId?: number;
    public trialPhaseId?: number;

    public constructor(init?: Partial<TrialTrialPhase>) { (Object as any).assign(this, init); }
}

export class TrialFormVersion implements IModel
{
    public active?: boolean;
    public collectionInstanceId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public dateNextVersion?: string;
    public enteredBy: string;
    public formNextAutoVersionId?: number;
    public formStatusId?: number;
    public id?: number;
    public modifiedBy: string;
    public reminderEmailDateSend?: string;
    public trialFormId?: number;
    public version: string;

    public constructor(init?: Partial<TrialFormVersion>) { (Object as any).assign(this, init); }
}

export class TrialFormReportDocument implements IModel
{
    public included: boolean;
    public source: string;
    public name: string;
    public description: string;
    public extension: string;
    public contentType: string;
    public image: boolean;
    public pdf: boolean;
    public fileSize?: number;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public sourceDocumentId?: number;
    public trialFormReportId?: number;

    public constructor(init?: Partial<TrialFormReportDocument>) { (Object as any).assign(this, init); }
}

export class TrialGroupItemVersion implements IModel
{
    public active?: boolean;
    public collectionInstanceId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialGroupItemId?: number;
    public version: string;

    public constructor(init?: Partial<TrialGroupItemVersion>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemVersion implements IModel
{
    public active?: boolean;
    public collectionInstanceId?: number;
    public comments: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialInstitutionItemId?: number;
    public version: string;
    public versionDate?: string;

    public constructor(init?: Partial<TrialInstitutionItemVersion>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplateGroup implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public groupId?: number;
    public id?: number;
    public modifiedBy: string;
    public trialInstitutionItemTemplateId?: number;

    public constructor(init?: Partial<TrialInstitutionItemTemplateGroup>) { (Object as any).assign(this, init); }
}

export class TrialInstitutionItemTemplateInstitution implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public institutionId?: number;
    public modifiedBy: string;
    public trialInstitutionItemTemplateId?: number;

    public constructor(init?: Partial<TrialInstitutionItemTemplateInstitution>) { (Object as any).assign(this, init); }
}

export class TrialItemInstanceVersion implements IModel
{
    public active?: boolean;
    public collectionInstanceId?: number;
    public comments: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialItemInstanceId?: number;
    public trialItemInstanceStatusId?: number;
    public version: string;
    public versionDate?: string;

    public constructor(init?: Partial<TrialItemInstanceVersion>) { (Object as any).assign(this, init); }
}

export class TrialAnalysisResult implements IModel
{
    public active?: boolean;
    public actualCompletionDate?: string;
    public actualStartDate?: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public targetCompletionDate?: string;
    public targetStartDate?: string;
    public trialAnalysisTypeId?: number;
    public trialAnalysisTypeOther: string;
    public trialId?: number;
    public trialPublicationId?: number;

    public constructor(init?: Partial<TrialAnalysisResult>) { (Object as any).assign(this, init); }
}

export class TrialPublication implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public details: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public tpcReviewedId?: number;
    public trialId?: number;
    public trialPublicationStatusId?: number;
    public trialPublicationTypeId?: number;
    public trialPublicationTypeOther: string;
    public yearPublished?: number;

    public constructor(init?: Partial<TrialPublication>) { (Object as any).assign(this, init); }
}

export class TrialPresentation implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public meeting: string;
    public meetingDate?: string;
    public modifiedBy: string;
    public presenterName: string;
    public publishedAsAnAbstractId?: number;
    public title: string;
    public trialId?: number;
    public trialPresentationTypeId?: number;

    public constructor(init?: Partial<TrialPresentation>) { (Object as any).assign(this, init); }
}

export class TrialTrackerComment implements IModel
{
    public active?: boolean;
    public comments: string;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public modifiedBy: string;
    public trialTrackerId?: number;

    public constructor(init?: Partial<TrialTrackerComment>) { (Object as any).assign(this, init); }
}

export enum EntryPersistenceState
{
    Unchanged = 1,
    Added = 2,
    Modified = 3,
    Deleted = 4,
}

export class CollectionInstanceSectionEntry
{
    public id?: number;
    public collectionInstanceId?: number;
    public collectionSectionId?: number;
    public isNa?: boolean;
    public assignedToId?: number;
    public assignedRoleId?: number;
    public assignmentTypeId?: number;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public persistenceState: EntryPersistenceState;
    public collectionInstanceDatas: CollectionInstanceDataEntry[];

    public constructor(init?: Partial<CollectionInstanceSectionEntry>) { (Object as any).assign(this, init); }
}

export class CollectionInstanceDataEntry
{
    public id?: number;
    public collectionInstanceId?: number;
    public collectionItemComponentId?: number;
    public itemComponentId?: number;
    public itemComponentPrimitiveId?: number;
    public textValue: string;
    public bitValue?: boolean;
    public numberValue?: number;
    public intValue?: number;
    public dateValue?: string;
    public isNa?: boolean;
    public version: string;
    public justified?: boolean;
    public dateJustified?: string;
    public justifiedBy: string;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public persistenceState: EntryPersistenceState;
    public sourceDocuments: SourceDocumentEntry[];

    public constructor(init?: Partial<CollectionInstanceDataEntry>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

export class FieldMetadata
{
    public propertyPath: string;
    public fieldName: string;
    public label: FieldLabel;
    public lookupOptions: IReadOnlyList<LookupOption>;
    public dependsOn: IReadOnlyList<string>;

    public constructor(init?: Partial<FieldMetadata>) { (Object as any).assign(this, init); }
}

export class LookupOption
{
    public value: Object;
    public label: string;
    public metadata: Object;
    public active: boolean;

    public constructor(init?: Partial<LookupOption>) { (Object as any).assign(this, init); }
}

export class ModelValidationError
{
    public propertyPath: string;
    public message: string;
    public code: string;
    public type: ValidationErrorType;

    public constructor(init?: Partial<ModelValidationError>) { (Object as any).assign(this, init); }
}

export interface IView
{
}

export class PersonnelTmdPermission implements IView
{
    public personnelId?: number;
    public personnelUserName: string;
    public personnelFullName: string;
    public trialId?: number;
    public trialProtocolID: string;
    public institutionId?: number;
    public institutionCode: string;
    public roleGroupId?: number;
    public trialMatch?: boolean;
    public institutionMatch?: boolean;
    public permissionRequirementDescription: string;
    public permissionConfigurationDescription: string;
    public moduleName: string;
    public moduleDescription: string;
    public roleId?: number;
    public roleName: string;
    public roleRank?: number;
    public permission?: Permission;
    public permissionName: string;
    public permissionDescription: string;

    public constructor(init?: Partial<PersonnelTmdPermission>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    public dsn: string;
    public application: string;
    public release: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export enum SearchType
{
    Trial = 1,
    Institution = 2,
    Group = 3,
    Personnel = 4,
    Patient = 5,
}

export class MeasurementReportSummary implements IView
{
    public reportingTagCategory: string;
    public variables?: number;
    public acceptable?: number;
    public minorVariations?: number;
    public majorVariations?: number;
    public missingOrNa?: number;

    public constructor(init?: Partial<MeasurementReportSummary>) { (Object as any).assign(this, init); }
}

export class MeasurementReportSummaryTotals implements IView
{
    public variables?: number;
    public acceptable?: number;
    public acceptableDisplay: string;
    public minorVariations?: number;
    public minorVariationsDisplay: string;
    public majorVariations?: number;
    public majorVariationsDisplay: string;
    public missingOrNa?: number;
    public missingOrNaDisplay: string;
    public total?: number;

    public constructor(init?: Partial<MeasurementReportSummaryTotals>) { (Object as any).assign(this, init); }
}

export class MeasurementReportClassification implements IView
{
    public trialFormId?: number;
    public version: string;
    public sectionName: string;
    public label: string;
    public reportingTagCategory: string;
    public reportingTagCategoryRank?: number;
    public collectionInstanceDataId?: number;
    public acceptable?: number;
    public minorVariations?: number;
    public majorVariations?: number;
    public missing?: number;
    public na?: number;
    public justified?: number;

    public constructor(init?: Partial<MeasurementReportClassification>) { (Object as any).assign(this, init); }
}

export class MeasurementReportClassificationTotals implements IView
{
    public acceptable?: number;
    public acceptableDisplay: string;
    public minorVariations?: number;
    public minorVariationsDisplay: string;
    public majorVariations?: number;
    public majorVariationsDisplay: string;
    public justified?: number;
    public justifiedDisplay: string;
    public missing?: number;
    public missingDisplay: string;
    public na?: number;
    public naDisplay: string;
    public total?: number;

    public constructor(init?: Partial<MeasurementReportClassificationTotals>) { (Object as any).assign(this, init); }
}

export class MeasurementReportValue implements IView
{
    public trialFormId?: number;
    public version: string;
    public sectionName: string;
    public label: string;
    public reportingTagCategory: string;
    public reportingTagCategoryRank?: number;
    public collectionInstanceDataId?: number;
    public itemPrimitive?: ItemPrimitive;
    public textValue: string;
    public bitValue?: boolean;
    public numberValue?: number;
    public intValue?: number;
    public dateValue?: string;
    public isNa?: boolean;
    public option: string;
    public displayValue: string;

    public constructor(init?: Partial<MeasurementReportValue>) { (Object as any).assign(this, init); }
}

export class TrogApiTrialInstitution
{
    public id: number;
    public name: string;
    public code: string;

    public constructor(init?: Partial<TrogApiTrialInstitution>) { (Object as any).assign(this, init); }
}

export class TrogApiUserInstitution
{
    public id: number;
    public name: string;
    public code: string;
    public userTrialInstitutions: TrogApiUserTrialInstitution[];

    public constructor(init?: Partial<TrogApiUserInstitution>) { (Object as any).assign(this, init); }
}

export class TrogApiUserTrialInstitution
{
    public id: number;
    public name: string;
    public code: string;
    public trialInstitutionStatusId?: number;

    public constructor(init?: Partial<TrogApiUserTrialInstitution>) { (Object as any).assign(this, init); }
}

export class TrogApiMembership
{
    public id: number;
    public userId: number;
    public groupId: number;
    public group: TrogApiGroup;
    public user: TrogApiUser;

    public constructor(init?: Partial<TrogApiMembership>) { (Object as any).assign(this, init); }
}

export class TrogApiUserGroup
{
    public id?: number;
    public name: string;
    public displayName: string;
    public description: string;

    public constructor(init?: Partial<TrogApiUserGroup>) { (Object as any).assign(this, init); }
}

export class CollectionItemComponentOverride implements IModel
{
    public active?: boolean;
    public baselineAmount?: number;
    public bulkSetValue: string;
    public calculationMethod?: CalculationMethod;
    public collectionId?: number;
    public collectionItemComponentId?: number;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public instructions: string;
    public isNaAllowed?: boolean;
    public itemComponentPrimitiveId?: number;
    public label: string;
    public maxValue?: number;
    public minValue?: number;
    public modifiedBy: string;
    public readonly?: boolean;
    public reportingTagId?: number;
    public reportingTagTypeId?: number;
    public required?: boolean;

    public constructor(init?: Partial<CollectionItemComponentOverride>) { (Object as any).assign(this, init); }
}

export class TemporaryFileInformation implements IView
{
    public state?: FileState;
    public progress: string;
    public guid: string;
    public temporaryFile: TemporaryFile;

    public constructor(init?: Partial<TemporaryFileInformation>) { (Object as any).assign(this, init); }
}

export class ItemComponentPrimitiveOption implements IModel
{
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public id?: number;
    public itemComponentPrimitiveId?: number;
    public measurementId?: number;
    public modifiedBy: string;
    public rank?: number;
    public value: string;

    public constructor(init?: Partial<ItemComponentPrimitiveOption>) { (Object as any).assign(this, init); }
}

export enum CalculationFormula
{
    None = 0,
    Difference = 1,
}

export enum ItemPrimitive
{
    Label = 1,
    Text = 2,
    Comments = 3,
    Date = 4,
    Checkbox = 5,
    Documents = 6,
    Numeric = 7,
    Select = 8,
}

export enum ItemPrimitiveRule
{
    IsEnabledIf = 1,
    IsDisabledIf = 2,
    RequiredIf = 3,
    Required = 4,
}

export class RoleGroup implements IModel
{
    public roleRoleGroups: RoleRoleGroup[];
    public description: string;
    public id?: number;
    public name: string;

    public constructor(init?: Partial<RoleGroup>) { (Object as any).assign(this, init); }
}

export enum PermissionRequirementType
{
    Allow = 1,
    Deny = 2,
}

export class SourceDocumentEntry
{
    public id?: number;
    public fileType?: number;
    public sourceDocumentStatusId?: number;
    public parentSourceDocumentId?: number;
    public name: string;
    public extension: string;
    public description: string;
    public processServerPath: string;
    public errorMessage: string;
    public active?: boolean;
    public dateEntered?: string;
    public dateModified?: string;
    public enteredBy: string;
    public modifiedBy: string;
    public image?: boolean;
    public fileInformation: TemporaryFileInformation;
    public guid: string;
    public fileSize?: number;
    public contentType: string;
    public exists?: boolean;
    public isDownloadable?: boolean;
    public base64: string;
    public count?: number;
    public persistenceState: EntryPersistenceState;

    public constructor(init?: Partial<SourceDocumentEntry>) { (Object as any).assign(this, init); }
}

export class FieldLabel
{
    public label: string;
    public propertyPath: string;
    public isDeindexed: boolean;

    public constructor(init?: Partial<FieldLabel>) { (Object as any).assign(this, init); }
}

export enum ValidationErrorType
{
    Description = 1,
    Information = 2,
    Warning = 3,
    Low = 4,
    Medium = 5,
    High = 6,
    Critical = 7,
}

export class TrogApiGroup
{
    public id?: number;
    public name: string;
    public displayName: string;
    public description: string;
    public canImpersonate: boolean;
    public trialId?: number;
    public trialStatusId?: number;

    public constructor(init?: Partial<TrogApiGroup>) { (Object as any).assign(this, init); }
}

export enum CalculationMethod
{
    EitherSideOfBaseline = 1,
    AbsoluteValues = 2,
}

export enum FileState
{
    Uploading = 1,
    Success = 2,
    Failure = 3,
    Cancelled = 4,
    Empty = 5,
}

export class RoleRoleGroup implements IModel
{
    public id?: number;
    public roleGroupId?: number;
    public roleId?: number;

    public constructor(init?: Partial<RoleRoleGroup>) { (Object as any).assign(this, init); }
}

export class GetActivitiesUndertakenMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetActivitiesUndertakenMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetActivitiesUndertakenLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetActivitiesUndertakenLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateActivitiesUndertakenResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateActivitiesUndertakenResponse>) { (Object as any).assign(this, init); }
}

export class SubmitActivitiesUndertakenFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ActivitiesUndertaken;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitActivitiesUndertakenFormResponse>) { (Object as any).assign(this, init); }
}

export class GetAddressOptionMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetAddressOptionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetAddressOptionLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetAddressOptionLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateAddressOptionResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateAddressOptionResponse>) { (Object as any).assign(this, init); }
}

export class SubmitAddressOptionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: AddressOption;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitAddressOptionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetAllocatedWPMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetAllocatedWPMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetAllocatedWPLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetAllocatedWPLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateAllocatedWPResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateAllocatedWPResponse>) { (Object as any).assign(this, init); }
}

export class SubmitAllocatedWPFormResponse
{
    public responseStatus: ResponseStatus;
    public model: AllocatedWP;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitAllocatedWPFormResponse>) { (Object as any).assign(this, init); }
}

export class GetAssignmentTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetAssignmentTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetAssignmentTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetAssignmentTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateAssignmentTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateAssignmentTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitAssignmentTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: AssignmentType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitAssignmentTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetCaseTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetCaseTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetCaseTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetCaseTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCaseTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateCaseTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCaseTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: CaseType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitCaseTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetCategoryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetCategoryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCategoryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCategoryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Category;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitCategoryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetCollectionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetCollectionLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCollectionResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCollectionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Collection;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitCollectionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetCollectionInstanceMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetCollectionInstanceLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCollectionInstanceResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateCollectionInstanceResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCollectionInstanceFormResponse
{
    public responseStatus: ResponseStatus;
    public model: CollectionInstance;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitCollectionInstanceFormResponse>) { (Object as any).assign(this, init); }
}

export class GetCountryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetCountryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetCountryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetCountryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCountryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateCountryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCountryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Country;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitCountryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetDepartmentMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetDepartmentLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDepartmentResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class SubmitDepartmentFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Department;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitDepartmentFormResponse>) { (Object as any).assign(this, init); }
}

export class GetErrorMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetErrorMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetErrorLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetErrorLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateErrorResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateErrorResponse>) { (Object as any).assign(this, init); }
}

export class SubmitErrorFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Error;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitErrorFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFacilityAllianceMemberMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFacilityAllianceMemberMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFacilityAllianceMemberLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFacilityAllianceMemberLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFacilityAllianceMemberResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFacilityAllianceMemberResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFacilityAllianceMemberFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FacilityAllianceMember;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFacilityAllianceMemberFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFormNextAutoVersionMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFormNextAutoVersionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormNextAutoVersionLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFormNextAutoVersionLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormNextAutoVersionResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFormNextAutoVersionResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFormNextAutoVersionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FormNextAutoVersion;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFormNextAutoVersionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFormTemplateMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFormTemplateLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFormTemplateFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplate;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFormTemplateFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateCategoryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFormTemplateCategoryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateCategoryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFormTemplateCategoryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateCategoryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFormTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFormTemplateCategoryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateCategory;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFormTemplateCategoryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFormTemplateFileTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFormTemplateFileTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateFileTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFormTemplateFileTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateFileType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFormTemplateFileTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFormTemplateStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFormTemplateStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFormTemplateStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFormTemplateStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFormTemplateStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFormTemplateStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetFundingStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetFundingStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetFundingStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetFundingStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateFundingStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateFundingStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitFundingStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: FundingStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitFundingStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGenderMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetGenderMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetGenderLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetGenderLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGenderResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateGenderResponse>) { (Object as any).assign(this, init); }
}

export class SubmitGenderFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Gender;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitGenderFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetGroupMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetGroupLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateGroupResponse>) { (Object as any).assign(this, init); }
}

export class SubmitGroupFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Group;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitGroupFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetGroupItemMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetGroupItemLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupItemResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class SubmitGroupItemFormResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupItem;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitGroupItemFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupNoteMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetGroupNoteMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupNoteLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetGroupNoteLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupNoteResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateGroupNoteResponse>) { (Object as any).assign(this, init); }
}

export class SubmitGroupNoteFormResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupNote;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitGroupNoteFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetGroupTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetGroupTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateGroupTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateGroupTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitGroupTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitGroupTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInstitutionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInstitutionLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInstitutionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Institution;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInstitutionCodingMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInstitutionCodingLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionCodingResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInstitutionCodingFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionCoding;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInstitutionCodingFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInstitutionFormMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInstitutionFormLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionFormResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInstitutionFormFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionForm;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInstitutionFormFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionNoteMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInstitutionNoteMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionNoteLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInstitutionNoteLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionNoteResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInstitutionNoteFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionNote;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInstitutionNoteFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInstitutionTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInstitutionTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInstitutionTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInstitutionTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInstitutionTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInterestMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInterestLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInterestResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInterestResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInterestFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Interest;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInterestFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInternationalTrialStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInternationalTrialStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInternationalTrialStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInternationalTrialStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInternationalTrialStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInternationalTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInternationalTrialStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InternationalTrialStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInternationalTrialStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInvolvementMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetInvolvementMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetInvolvementLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetInvolvementLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateInvolvementResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateInvolvementResponse>) { (Object as any).assign(this, init); }
}

export class SubmitInvolvementFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Involvement;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitInvolvementFormResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetItemComponentMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetItemComponentLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateItemComponentResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class SubmitItemComponentFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponent;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitItemComponentFormResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetItemComponentTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetItemComponentTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateItemComponentTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitItemComponentTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponentType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitItemComponentTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetMeasurementMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetMeasurementMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetMeasurementLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetMeasurementLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMeasurementResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateMeasurementResponse>) { (Object as any).assign(this, init); }
}

export class SubmitMeasurementFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Measurement;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitMeasurementFormResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetMembershipTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetMembershipTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateMembershipTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitMembershipTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: MembershipType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitMembershipTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetNoteTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetNoteTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateNoteTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitNoteTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: NoteType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitNoteTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRoleMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetOpenClinicaUserRoleMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRoleLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetOpenClinicaUserRoleLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateOpenClinicaUserRoleResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateOpenClinicaUserRoleResponse>) { (Object as any).assign(this, init); }
}

export class SubmitOpenClinicaUserRoleFormResponse
{
    public responseStatus: ResponseStatus;
    public model: OpenClinicaUserRole;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitOpenClinicaUserRoleFormResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetPatientMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetPatientLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePatientResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidatePatientResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPatientFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Patient;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitPatientFormResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetPermissionConfigurationMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetPermissionConfigurationLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePermissionConfigurationResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidatePermissionConfigurationResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPermissionConfigurationFormResponse
{
    public responseStatus: ResponseStatus;
    public model: PermissionConfiguration;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitPermissionConfigurationFormResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetPersonnelMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetPersonnelLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidatePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPersonnelFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Personnel;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitPersonnelFormResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelNoteMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetPersonnelNoteMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelNoteLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetPersonnelNoteLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelNoteResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidatePersonnelNoteResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPersonnelNoteFormResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelNote;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitPersonnelNoteFormResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetPersonnelRoleMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetPersonnelRoleLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelRoleResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidatePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPersonnelRoleFormResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelRole;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitPersonnelRoleFormResponse>) { (Object as any).assign(this, init); }
}

export class InitializePersonnelRoleCreateResponse
{
    public model: PersonnelRoleCreate;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<InitializePersonnelRoleCreateResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleCreateMetadataResponse implements IModelMetadataResponse
{
    public metadata: ModelMetadata;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetPersonnelRoleCreateMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleCreateLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public updates: LookupUpdate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetPersonnelRoleCreateLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidatePersonnelRoleCreateResponse implements IModelValidationResponse
{
    public validation: ModelValidationResult;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ValidatePersonnelRoleCreateResponse>) { (Object as any).assign(this, init); }
}

export class SubmitPersonnelRoleCreateFormResponse
{
    public model: PersonnelRoleCreate;
    public validation: ModelValidationResult;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SubmitPersonnelRoleCreateFormResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplineMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetProfessionalDisciplineMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplineLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetProfessionalDisciplineLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateProfessionalDisciplineResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class SubmitProfessionalDisciplineFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ProfessionalDiscipline;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitProfessionalDisciplineFormResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetReportingTagMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetReportingTagLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateReportingTagResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class SubmitReportingTagFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTag;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitReportingTagFormResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetReportingTagCategoryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetReportingTagCategoryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateReportingTagCategoryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitReportingTagCategoryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagCategory;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitReportingTagCategoryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetReportingTagTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetReportingTagTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateReportingTagTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateReportingTagTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitReportingTagTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitReportingTagTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetRoleMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetRoleMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetRoleLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetRoleLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateRoleResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateRoleResponse>) { (Object as any).assign(this, init); }
}

export class SubmitRoleFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Role;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitRoleFormResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetSalutationMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetSalutationLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSalutationResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateSalutationResponse>) { (Object as any).assign(this, init); }
}

export class SubmitSalutationFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Salutation;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitSalutationFormResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetSiteLocationMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetSiteLocationLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSiteLocationResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class SubmitSiteLocationFormResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteLocation;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitSiteLocationFormResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetSiteTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetSiteTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSiteTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateSiteTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitSiteTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitSiteTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetSortOrderMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetSortOrderMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetSortOrderLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetSortOrderLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateSortOrderResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateSortOrderResponse>) { (Object as any).assign(this, init); }
}

export class SubmitSortOrderFormResponse
{
    public responseStatus: ResponseStatus;
    public model: SortOrder;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitSortOrderFormResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplateMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetStandardEmailTemplateMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplateLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetStandardEmailTemplateLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateStandardEmailTemplateResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SubmitStandardEmailTemplateFormResponse
{
    public responseStatus: ResponseStatus;
    public model: StandardEmailTemplate;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitStandardEmailTemplateFormResponse>) { (Object as any).assign(this, init); }
}

export class GetStateMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetStateMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetStateLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetStateLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateStateResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateStateResponse>) { (Object as any).assign(this, init); }
}

export class SubmitStateFormResponse
{
    public responseStatus: ResponseStatus;
    public model: State;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitStateFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTaskTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTaskTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTaskTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTaskTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TaskType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTaskTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTemplateTrialItemMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTemplateTrialItemMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTemplateTrialItemLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTemplateTrialItemLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTemplateTrialItemResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTemplateTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTemplateTrialItemFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TemplateTrialItem;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTemplateTrialItemFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestoneMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrackerMilestoneMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestoneLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrackerMilestoneLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrackerMilestoneResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrackerMilestoneFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerMilestone;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrackerMilestoneFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrackerStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrackerStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrackerStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrackerStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrackerStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrackerStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrackerTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrackerTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrackerTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrackerTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrackerTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialFormResponse
{
    public responseStatus: ResponseStatus;
    public model: Trial;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialAnalysisTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialAnalysisTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialAnalysisTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialAnalysisTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialAnalysisTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialAnalysisTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialAnalysisTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialAnalysisType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialAnalysisTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialApiMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialApiMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialApiLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialApiLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialApiResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialApiResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialApiFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialApi;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialApiFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialCategoryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialCategoryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialCategoryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialCategoryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialCategoryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialCategoryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialCategory;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialCategoryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialFormMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialFormLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialFormResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialFormResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialFormFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialForm;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialFormFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormReportMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialFormReportMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormReportLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialFormReportLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialFormReportResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialFormReportResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialFormReportFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialFormReport;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialFormReportFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialGroupMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialGroupLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialGroupResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialGroupFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroup;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialGroupFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialGroupItemMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialGroupItemLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialGroupItemResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialGroupItemFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroupItem;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialGroupItemFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialInstitutionMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialInstitutionLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialInstitutionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitution;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialInstitutionItemMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialInstitutionItemLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionItemResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialInstitutionItemFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItem;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialInstitutionItemFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionItemTemplateResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialInstitutionItemTemplateFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItemTemplate;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialInstitutionItemTemplateFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionNoteMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialInstitutionNoteMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionNoteLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialInstitutionNoteLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionNoteResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialInstitutionNoteFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionNote;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialInstitutionNoteFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialInstitutionStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialInstitutionStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialInstitutionStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialInstitutionStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialInstitutionStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialInstitutionStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialItemInstanceMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialItemInstanceLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialItemInstanceResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialItemInstanceResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialItemInstanceFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstance;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialItemInstanceFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialItemInstanceStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialItemInstanceStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialItemInstanceStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialItemInstanceStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialItemInstanceStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstanceStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialItemInstanceStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMilestonesMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialMilestonesMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMilestonesLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialMilestonesLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialMilestonesResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialMilestonesFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialMilestones;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialMilestonesFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialNoteMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialNoteMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialNoteLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialNoteLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialNoteResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialNoteResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialNoteFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialNote;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialNoteFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPhaseMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialPhaseMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPhaseLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialPhaseLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialPhaseResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialPhaseResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialPhaseFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPhase;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialPhaseFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPresentationTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialPresentationTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPresentationTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialPresentationTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialPresentationTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialPresentationTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialPresentationTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPresentationType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialPresentationTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialPublicationStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialPublicationStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialPublicationStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialPublicationStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialPublicationStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialPublicationStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialPublicationTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialPublicationTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialPublicationTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialPublicationTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialPublicationTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialPublicationTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialRegistryMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialRegistryMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialRegistryLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialRegistryLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialRegistryResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialRegistryResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialRegistryFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialRegistry;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialRegistryFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialStatusMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialStatusMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialStatusLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialStatusLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialStatusResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialStatusFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialStatusFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTrackerMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialTrackerMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTrackerLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialTrackerLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialTrackerResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialTrackerResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialTrackerFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTracker;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialTrackerFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTreatmentMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialTreatmentMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTreatmentLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialTreatmentLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialTreatmentResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialTreatmentFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTreatment;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialTreatmentFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypeMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTrialTypeMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypeLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTrialTypeLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTrialTypeResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTrialTypeFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialType;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTrialTypeFormResponse>) { (Object as any).assign(this, init); }
}

export class GetTumourGroupMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetTumourGroupMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetTumourGroupLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetTumourGroupLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateTumourGroupResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateTumourGroupResponse>) { (Object as any).assign(this, init); }
}

export class SubmitTumourGroupFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TumourGroup;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitTumourGroupFormResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetYesNoMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetYesNoLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateYesNoResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateYesNoResponse>) { (Object as any).assign(this, init); }
}

export class SubmitYesNoFormResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNo;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitYesNoFormResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoPendingMetadataResponse implements IModelMetadataResponse
{
    public responseStatus: ResponseStatus;
    public metadata: ModelMetadata;

    public constructor(init?: Partial<GetYesNoPendingMetadataResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoPendingLookupUpdatesResponse implements IModelLookupUpdatesResponse
{
    public responseStatus: ResponseStatus;
    public updates: LookupUpdate[];

    public constructor(init?: Partial<GetYesNoPendingLookupUpdatesResponse>) { (Object as any).assign(this, init); }
}

export class ValidateYesNoPendingResponse implements IModelValidationResponse
{
    public responseStatus: ResponseStatus;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<ValidateYesNoPendingResponse>) { (Object as any).assign(this, init); }
}

export class SubmitYesNoPendingFormResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNoPending;
    public validation: ModelValidationResult;

    public constructor(init?: Partial<SubmitYesNoPendingFormResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupSummariesResponse
{
    public responseStatus: ResponseStatus;
    public groupSummaries: GroupSummary[];

    public constructor(init?: Partial<GetGroupSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemSummariesResponse
{
    public responseStatus: ResponseStatus;
    public groupItemSummaries: GroupItemSummary[];

    public constructor(init?: Partial<GetGroupItemSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupNoteSummariesResponse
{
    public responseStatus: ResponseStatus;
    public groupNoteSummaries: GroupNoteSummary[];

    public constructor(init?: Partial<GetGroupNoteSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelSummariesResponse
{
    public responseStatus: ResponseStatus;
    public personnelSummaries: PersonnelSummary[];

    public constructor(init?: Partial<GetPersonnelSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleSummariesResponse
{
    public responseStatus: ResponseStatus;
    public personnelRoleSummaries: PersonnelRoleSummary[];

    public constructor(init?: Partial<GetPersonnelRoleSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelNoteSummariesResponse
{
    public responseStatus: ResponseStatus;
    public personnelNoteSummaries: PersonnelNoteSummary[];

    public constructor(init?: Partial<GetPersonnelNoteSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionSummariesResponse
{
    public responseStatus: ResponseStatus;
    public institutionSummaries: InstitutionSummary[];

    public constructor(init?: Partial<GetInstitutionSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentSummariesResponse
{
    public responseStatus: ResponseStatus;
    public departmentSummaries: DepartmentSummary[];

    public constructor(init?: Partial<GetDepartmentSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormSummaryByInstitutionFormIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionFormSummary: InstitutionFormSummary;

    public constructor(init?: Partial<GetInstitutionFormSummaryByInstitutionFormIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormSummariesResponse
{
    public responseStatus: ResponseStatus;
    public institutionFormSummaries: InstitutionFormSummary[];

    public constructor(init?: Partial<GetInstitutionFormSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionNoteSummariesResponse
{
    public responseStatus: ResponseStatus;
    public institutionNoteSummaries: InstitutionNoteSummary[];

    public constructor(init?: Partial<GetInstitutionNoteSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormSummaryByTrialFormIdResponse
{
    public responseStatus: ResponseStatus;
    public trialFormSummary: TrialFormSummary;

    public constructor(init?: Partial<GetTrialFormSummaryByTrialFormIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialFormSummaries: TrialFormSummary[];

    public constructor(init?: Partial<GetTrialFormSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormAdministrationCaseReportsResponse
{
    public responseStatus: ResponseStatus;
    public trialFormAdministrationCaseReports: TrialFormAdministrationCaseReport[];

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialGroupSummaries: TrialGroupSummary[];

    public constructor(init?: Partial<GetTrialGroupSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialNoteSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialNoteSummaries: TrialNoteSummary[];

    public constructor(init?: Partial<GetTrialNoteSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientSummariesResponse
{
    public responseStatus: ResponseStatus;
    public patientSummaries: PatientSummary[];

    public constructor(init?: Partial<GetPatientSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTrackerSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialTrackerSummaries: TrialTrackerSummary[];

    public constructor(init?: Partial<GetTrialTrackerSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTreatmentSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialTreatmentSummaries: TrialTreatmentSummary[];

    public constructor(init?: Partial<GetTrialTreatmentSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialItemInstanceSummaries: TrialItemInstanceSummary[];

    public constructor(init?: Partial<GetTrialItemInstanceSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemSummaries: TrialInstitutionItemSummary[];

    public constructor(init?: Partial<GetTrialInstitutionItemSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionNoteSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionNoteSummaries: TrialInstitutionNoteSummary[];

    public constructor(init?: Partial<GetTrialInstitutionNoteSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentSummariesResponse
{
    public responseStatus: ResponseStatus;
    public itemComponentSummaries: ItemComponentSummary[];

    public constructor(init?: Partial<GetItemComponentSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTemplateTrialItemSummariesResponse
{
    public responseStatus: ResponseStatus;
    public templateTrialItemSummaries: TemplateTrialItemSummary[];

    public constructor(init?: Partial<GetTemplateTrialItemSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionItemTemplateSummaries: TrialInstitutionItemTemplateSummary[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRoleSummariesResponse
{
    public responseStatus: ResponseStatus;
    public openClinicaUserRoleSummaries: OpenClinicaUserRoleSummary[];

    public constructor(init?: Partial<GetOpenClinicaUserRoleSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    public responseStatus: ResponseStatus;
    public userDetails: UserDetails;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

export class GetAppSettingsResponse
{
    public responseStatus: ResponseStatus;
    public appSettings: AppSettings;

    public constructor(init?: Partial<GetAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetDashboardSummaryTrialFormsByCurrentUserResponse
{
    public responseStatus: ResponseStatus;
    public dashboardSummaryTrialForms: DashboardSummaryTrialForm[];

    public constructor(init?: Partial<GetDashboardSummaryTrialFormsByCurrentUserResponse>) { (Object as any).assign(this, init); }
}

export class GetDashboardSummaryInstitutionFormsByCurrentUserResponse
{
    public responseStatus: ResponseStatus;
    public dashboardSummaryInstitutionForms: DashboardSummaryInstitutionForm[];

    public constructor(init?: Partial<GetDashboardSummaryInstitutionFormsByCurrentUserResponse>) { (Object as any).assign(this, init); }
}

export class GetDashboardSummaryTrialItemInstancesByCurrentUserResponse
{
    public responseStatus: ResponseStatus;
    public dashboardSummaryTrialItemInstances: DashboardSummaryTrialItemInstance[];

    public constructor(init?: Partial<GetDashboardSummaryTrialItemInstancesByCurrentUserResponse>) { (Object as any).assign(this, init); }
}

export class GetDashboardSummaryTrialInstitutionsByCurrentUserResponse
{
    public responseStatus: ResponseStatus;
    public dashboardSummaryTrialInstitutions: DashboardSummaryTrialInstitution[];

    public constructor(init?: Partial<GetDashboardSummaryTrialInstitutionsByCurrentUserResponse>) { (Object as any).assign(this, init); }
}

export class GetDashboardSummaryTrialsByCurrentUserResponse
{
    public responseStatus: ResponseStatus;
    public dashboardSummaryTrials: DashboardSummaryTrial[];

    public constructor(init?: Partial<GetDashboardSummaryTrialsByCurrentUserResponse>) { (Object as any).assign(this, init); }
}

export class GetSearchResultsResponse
{
    public responseStatus: ResponseStatus;
    public results: Search[];

    public constructor(init?: Partial<GetSearchResultsResponse>) { (Object as any).assign(this, init); }
}

export class UploadTemporaryFileResponse
{
    public responseStatus: ResponseStatus;
    public guid: string;

    public constructor(init?: Partial<UploadTemporaryFileResponse>) { (Object as any).assign(this, init); }
}

export class UploadTemporaryFileChunkResponse
{
    public responseStatus: ResponseStatus;
    public complete: boolean;
    public fileName: string;
    public guid: string;

    public constructor(init?: Partial<UploadTemporaryFileChunkResponse>) { (Object as any).assign(this, init); }
}

export class GetTemporaryFileInfoResponse
{
    public responseStatus: ResponseStatus;
    public temporaryFile: TemporaryFile;

    public constructor(init?: Partial<GetTemporaryFileInfoResponse>) { (Object as any).assign(this, init); }
}

export class RemoveTemporaryFileResponse
{
    public responseStatus: ResponseStatus;
    public removed: boolean;

    public constructor(init?: Partial<RemoveTemporaryFileResponse>) { (Object as any).assign(this, init); }
}

export class BeginTemporaryFileParallelChunkResponse
{
    public responseStatus: ResponseStatus;
    public uploadId: string;

    public constructor(init?: Partial<BeginTemporaryFileParallelChunkResponse>) { (Object as any).assign(this, init); }
}

export class GetTemporaryFileParallelChunkStatusResponse
{
    public responseStatus: ResponseStatus;
    public totalChunks: number;
    public completedChunks: number[];
    public isComplete: boolean;

    public constructor(init?: Partial<GetTemporaryFileParallelChunkStatusResponse>) { (Object as any).assign(this, init); }
}

export class RemoveTemporaryFileParallelChunkResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RemoveTemporaryFileParallelChunkResponse>) { (Object as any).assign(this, init); }
}

export class UploadTemporaryFileParallelChunkResponse
{
    public responseStatus: ResponseStatus;
    public complete: boolean;

    public constructor(init?: Partial<UploadTemporaryFileParallelChunkResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceEntryResponse
{
    public model: CollectionInstanceEntry;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetCollectionInstanceEntryResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceEntriesResponse
{
    public models: CollectionInstanceEntry[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetCollectionInstanceEntriesResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCollectionInstanceEntriesResponse
{
    public results: CollectionInstanceEntrySaveResult[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SubmitCollectionInstanceEntriesResponse>) { (Object as any).assign(this, init); }
}

export class SubmitCollectionInstanceEntryResponse
{
    public model: CollectionInstanceEntry;
    public validation: ModelValidationResult;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SubmitCollectionInstanceEntryResponse>) { (Object as any).assign(this, init); }
}

export class ValidateCollectionInstanceEntryResponse
{
    public validation: ModelValidationResult;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ValidateCollectionInstanceEntryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateOutOfScopeItemsResponse
{
    public candidates: TrialInstitutionItemDeactivationCandidate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateOutOfScopeItemsResponse>) { (Object as any).assign(this, init); }
}

export class ApplyTrialInstitutionItemTemplateDeactivationPolicyResponse
{
    public deactivatedCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ApplyTrialInstitutionItemTemplateDeactivationPolicyResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionOutOfScopeItemsResponse
{
    public candidates: TrialInstitutionItemDeactivationCandidate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialInstitutionOutOfScopeItemsResponse>) { (Object as any).assign(this, init); }
}

export class ApplyTrialInstitutionDeactivationPolicyResponse
{
    public deactivatedCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ApplyTrialInstitutionDeactivationPolicyResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateReactivationCandidatesResponse
{
    public candidates: TrialInstitutionItemReactivationCandidate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateReactivationCandidatesResponse>) { (Object as any).assign(this, init); }
}

export class ApplyTrialInstitutionItemTemplateReactivationPolicyResponse
{
    public affectedCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ApplyTrialInstitutionItemTemplateReactivationPolicyResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionReactivationCandidatesResponse
{
    public candidates: TrialInstitutionItemReactivationCandidate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialInstitutionReactivationCandidatesResponse>) { (Object as any).assign(this, init); }
}

export class ApplyTrialInstitutionReactivationPolicyResponse
{
    public affectedCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ApplyTrialInstitutionReactivationPolicyResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public trialIdentities: TrialIdentity[];

    public constructor(init?: Partial<GetTrialIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialIdentity: TrialIdentity;

    public constructor(init?: Partial<GetTrialIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialSummaries: TrialSummary[];

    public constructor(init?: Partial<GetTrialSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionIdentities: TrialInstitutionIdentity[];

    public constructor(init?: Partial<GetTrialInstitutionIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionIdentity: TrialInstitutionIdentity;

    public constructor(init?: Partial<GetTrialInstitutionIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionSummariesResponse
{
    public responseStatus: ResponseStatus;
    public trialInstitutionSummaries: TrialInstitutionSummary[];

    public constructor(init?: Partial<GetTrialInstitutionSummariesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public institutionIdentities: InstitutionIdentity[];

    public constructor(init?: Partial<GetInstitutionIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public institutionIdentity: InstitutionIdentity;

    public constructor(init?: Partial<GetInstitutionIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public departmentIdentities: DepartmentIdentity[];

    public constructor(init?: Partial<GetDepartmentIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public departmentIdentity: DepartmentIdentity;

    public constructor(init?: Partial<GetDepartmentIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public patientIdentities: PatientIdentity[];

    public constructor(init?: Partial<GetPatientIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public patientIdentity: PatientIdentity;

    public constructor(init?: Partial<GetPatientIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public groupIdentities: GroupIdentity[];

    public constructor(init?: Partial<GetGroupIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public groupIdentity: GroupIdentity;

    public constructor(init?: Partial<GetGroupIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelIdentitiesResponse
{
    public responseStatus: ResponseStatus;
    public personnelIdentities: PersonnelIdentity[];

    public constructor(init?: Partial<GetPersonnelIdentitiesResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelIdentityByIdResponse
{
    public responseStatus: ResponseStatus;
    public personnelIdentity: PersonnelIdentity;

    public constructor(init?: Partial<GetPersonnelIdentityByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMeasurementReportByTrialFormIdResponse
{
    public responseStatus: ResponseStatus;
    public measurementReport: MeasurementReport;

    public constructor(init?: Partial<GetMeasurementReportByTrialFormIdResponse>) { (Object as any).assign(this, init); }
}

export class SetMeasurementReportClassificationJustifiedResponse
{
    public responseStatus: ResponseStatus;
    public measurementReport: MeasurementReport;

    public constructor(init?: Partial<SetMeasurementReportClassificationJustifiedResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormReportByTrialFormIdResponse
{
    public responseStatus: ResponseStatus;
    public trialFormReport: TrialFormReport;

    public constructor(init?: Partial<GetTrialFormReportByTrialFormIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialApiByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialApi: TrialApi;

    public constructor(init?: Partial<GetTrialApiByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMilestonesByTrialIdResponse
{
    public responseStatus: ResponseStatus;
    public trialMilestones: TrialMilestones;

    public constructor(init?: Partial<GetTrialMilestonesByTrialIdResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public institution: TrogApiInstitution;

    public constructor(init?: Partial<TrogApiGetInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetTrialInstitutionsResponse
{
    public responseStatus: ResponseStatus;
    public trial: TrogApiTrial;

    public constructor(init?: Partial<TrogApiGetTrialInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetUsersResponse
{
    public responseStatus: ResponseStatus;
    public users: TrogApiUser[];

    public constructor(init?: Partial<TrogApiGetUsersResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetUserApiKeyResponse
{
    public responseStatus: ResponseStatus;
    public user: TrogApiUser;

    public constructor(init?: Partial<TrogApiGetUserApiKeyResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetUserByUserNameResponse
{
    public responseStatus: ResponseStatus;
    public apiUser: TrogApiUser;

    public constructor(init?: Partial<TrogApiGetUserByUserNameResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiHasPermissionResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<TrogApiHasPermissionResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiHasPermissionsResponse
{
    public responseStatus: ResponseStatus;
    public permissionResults: { [index: number]: boolean; };

    public constructor(init?: Partial<TrogApiHasPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiHasPermissionsAnyResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<TrogApiHasPermissionsAnyResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiHasPermissionsAllResponse
{
    public responseStatus: ResponseStatus;
    public hasPermission: boolean;

    public constructor(init?: Partial<TrogApiHasPermissionsAllResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiEvaluateAllPermissionsResponse
{
    public responseStatus: ResponseStatus;
    public permissionResults: KeyValuePair<TrogApiPermissionQuery,boolean>[];

    public constructor(init?: Partial<TrogApiEvaluateAllPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetPermissionConfigurationsResponse
{
    public responseStatus: ResponseStatus;
    public permissionConfigurations: TrogApiPermissionConfiguration[];

    public constructor(init?: Partial<TrogApiGetPermissionConfigurationsResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetPermissionConfigurationByPermissionIdResponse
{
    public responseStatus: ResponseStatus;
    public permissionConfigurations: TrogApiPermissionConfiguration[];

    public constructor(init?: Partial<TrogApiGetPermissionConfigurationByPermissionIdResponse>) { (Object as any).assign(this, init); }
}

export class TrogApiGetPermissionsForUserAndContextResponse
{
    public responseStatus: ResponseStatus;
    public permissions: Permission[];

    public constructor(init?: Partial<TrogApiGetPermissionsForUserAndContextResponse>) { (Object as any).assign(this, init); }
}

export class GetActivitiesUndertakenByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ActivitiesUndertaken;

    public constructor(init?: Partial<GetActivitiesUndertakenByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetActivitiesUndertakenListResponse
{
    public responseStatus: ResponseStatus;
    public models: ActivitiesUndertaken[];

    public constructor(init?: Partial<GetActivitiesUndertakenListResponse>) { (Object as any).assign(this, init); }
}

export class InitializeActivitiesUndertakenResponse
{
    public responseStatus: ResponseStatus;
    public model: ActivitiesUndertaken;

    public constructor(init?: Partial<InitializeActivitiesUndertakenResponse>) { (Object as any).assign(this, init); }
}

export class SaveActivitiesUndertakenResponse
{
    public responseStatus: ResponseStatus;
    public model: ActivitiesUndertaken;

    public constructor(init?: Partial<SaveActivitiesUndertakenResponse>) { (Object as any).assign(this, init); }
}

export class DeleteActivitiesUndertakenResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteActivitiesUndertakenResponse>) { (Object as any).assign(this, init); }
}

export class GetAddressOptionByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: AddressOption;

    public constructor(init?: Partial<GetAddressOptionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetAddressOptionsResponse
{
    public responseStatus: ResponseStatus;
    public models: AddressOption[];

    public constructor(init?: Partial<GetAddressOptionsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeAddressOptionResponse
{
    public responseStatus: ResponseStatus;
    public model: AddressOption;

    public constructor(init?: Partial<InitializeAddressOptionResponse>) { (Object as any).assign(this, init); }
}

export class SaveAddressOptionResponse
{
    public responseStatus: ResponseStatus;
    public model: AddressOption;

    public constructor(init?: Partial<SaveAddressOptionResponse>) { (Object as any).assign(this, init); }
}

export class DeleteAddressOptionResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteAddressOptionResponse>) { (Object as any).assign(this, init); }
}

export class GetAllocatedWPByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: AllocatedWP;

    public constructor(init?: Partial<GetAllocatedWPByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetAllocatedWPsResponse
{
    public responseStatus: ResponseStatus;
    public models: AllocatedWP[];

    public constructor(init?: Partial<GetAllocatedWPsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeAllocatedWPResponse
{
    public responseStatus: ResponseStatus;
    public model: AllocatedWP;

    public constructor(init?: Partial<InitializeAllocatedWPResponse>) { (Object as any).assign(this, init); }
}

export class SaveAllocatedWPResponse
{
    public responseStatus: ResponseStatus;
    public model: AllocatedWP;

    public constructor(init?: Partial<SaveAllocatedWPResponse>) { (Object as any).assign(this, init); }
}

export class DeleteAllocatedWPResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteAllocatedWPResponse>) { (Object as any).assign(this, init); }
}

export class GetAssignmentTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: AssignmentType;

    public constructor(init?: Partial<GetAssignmentTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetAssignmentTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: AssignmentType[];

    public constructor(init?: Partial<GetAssignmentTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeAssignmentTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: AssignmentType;

    public constructor(init?: Partial<InitializeAssignmentTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveAssignmentTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: AssignmentType;

    public constructor(init?: Partial<SaveAssignmentTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteAssignmentTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteAssignmentTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetCaseTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: CaseType;

    public constructor(init?: Partial<GetCaseTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCaseTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: CaseType[];

    public constructor(init?: Partial<GetCaseTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeCaseTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: CaseType;

    public constructor(init?: Partial<InitializeCaseTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveCaseTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: CaseType;

    public constructor(init?: Partial<SaveCaseTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteCaseTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteCaseTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Category;

    public constructor(init?: Partial<GetCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public models: Category[];

    public constructor(init?: Partial<GetCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: Category;

    public constructor(init?: Partial<InitializeCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SaveCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: Category;

    public constructor(init?: Partial<SaveCategoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteCategoryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: CollectionInstance;

    public constructor(init?: Partial<GetCollectionInstanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionInstancesResponse
{
    public responseStatus: ResponseStatus;
    public models: CollectionInstance[];

    public constructor(init?: Partial<GetCollectionInstancesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeCollectionInstanceResponse
{
    public responseStatus: ResponseStatus;
    public model: CollectionInstance;

    public constructor(init?: Partial<InitializeCollectionInstanceResponse>) { (Object as any).assign(this, init); }
}

export class SaveCollectionInstanceResponse
{
    public responseStatus: ResponseStatus;
    public model: CollectionInstance;

    public constructor(init?: Partial<SaveCollectionInstanceResponse>) { (Object as any).assign(this, init); }
}

export class DeleteCollectionInstanceResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteCollectionInstanceResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Collection;

    public constructor(init?: Partial<GetCollectionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCollectionsResponse
{
    public responseStatus: ResponseStatus;
    public models: Collection[];

    public constructor(init?: Partial<GetCollectionsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeCollectionResponse
{
    public responseStatus: ResponseStatus;
    public model: Collection;

    public constructor(init?: Partial<InitializeCollectionResponse>) { (Object as any).assign(this, init); }
}

export class SaveCollectionResponse
{
    public responseStatus: ResponseStatus;
    public model: Collection;

    public constructor(init?: Partial<SaveCollectionResponse>) { (Object as any).assign(this, init); }
}

export class DeleteCollectionResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetCountryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Country;

    public constructor(init?: Partial<GetCountryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetCountriesResponse
{
    public responseStatus: ResponseStatus;
    public models: Country[];

    public constructor(init?: Partial<GetCountriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeCountryResponse
{
    public responseStatus: ResponseStatus;
    public model: Country;

    public constructor(init?: Partial<InitializeCountryResponse>) { (Object as any).assign(this, init); }
}

export class SaveCountryResponse
{
    public responseStatus: ResponseStatus;
    public model: Country;

    public constructor(init?: Partial<SaveCountryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteCountryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteCountryResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Department;

    public constructor(init?: Partial<GetDepartmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepartmentsResponse
{
    public responseStatus: ResponseStatus;
    public models: Department[];

    public constructor(init?: Partial<GetDepartmentsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public model: Department;

    public constructor(init?: Partial<InitializeDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class SaveDepartmentResponse
{
    public responseStatus: ResponseStatus;
    public model: Department;

    public constructor(init?: Partial<SaveDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDepartmentResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDepartmentResponse>) { (Object as any).assign(this, init); }
}

export class GetErrorByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Error;

    public constructor(init?: Partial<GetErrorByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetErrorsResponse
{
    public responseStatus: ResponseStatus;
    public models: Error[];

    public constructor(init?: Partial<GetErrorsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeErrorResponse
{
    public responseStatus: ResponseStatus;
    public model: Error;

    public constructor(init?: Partial<InitializeErrorResponse>) { (Object as any).assign(this, init); }
}

export class SaveErrorResponse
{
    public responseStatus: ResponseStatus;
    public model: Error;

    public constructor(init?: Partial<SaveErrorResponse>) { (Object as any).assign(this, init); }
}

export class DeleteErrorResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteErrorResponse>) { (Object as any).assign(this, init); }
}

export class GetFacilityAllianceMemberByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FacilityAllianceMember;

    public constructor(init?: Partial<GetFacilityAllianceMemberByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFacilityAllianceMembersResponse
{
    public responseStatus: ResponseStatus;
    public models: FacilityAllianceMember[];

    public constructor(init?: Partial<GetFacilityAllianceMembersResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFacilityAllianceMemberResponse
{
    public responseStatus: ResponseStatus;
    public model: FacilityAllianceMember;

    public constructor(init?: Partial<InitializeFacilityAllianceMemberResponse>) { (Object as any).assign(this, init); }
}

export class SaveFacilityAllianceMemberResponse
{
    public responseStatus: ResponseStatus;
    public model: FacilityAllianceMember;

    public constructor(init?: Partial<SaveFacilityAllianceMemberResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFacilityAllianceMemberResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFacilityAllianceMemberResponse>) { (Object as any).assign(this, init); }
}

export class GetFormNextAutoVersionByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FormNextAutoVersion;

    public constructor(init?: Partial<GetFormNextAutoVersionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFormNextAutoVersionsResponse
{
    public responseStatus: ResponseStatus;
    public models: FormNextAutoVersion[];

    public constructor(init?: Partial<GetFormNextAutoVersionsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFormNextAutoVersionResponse
{
    public responseStatus: ResponseStatus;
    public model: FormNextAutoVersion;

    public constructor(init?: Partial<InitializeFormNextAutoVersionResponse>) { (Object as any).assign(this, init); }
}

export class SaveFormNextAutoVersionResponse
{
    public responseStatus: ResponseStatus;
    public model: FormNextAutoVersion;

    public constructor(init?: Partial<SaveFormNextAutoVersionResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFormNextAutoVersionResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFormNextAutoVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateCategory;

    public constructor(init?: Partial<GetFormTemplateCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public models: FormTemplateCategory[];

    public constructor(init?: Partial<GetFormTemplateCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFormTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateCategory;

    public constructor(init?: Partial<InitializeFormTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SaveFormTemplateCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateCategory;

    public constructor(init?: Partial<SaveFormTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFormTemplateCategoryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFormTemplateCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateFileType;

    public constructor(init?: Partial<GetFormTemplateFileTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateFileTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: FormTemplateFileType[];

    public constructor(init?: Partial<GetFormTemplateFileTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFormTemplateFileTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateFileType;

    public constructor(init?: Partial<InitializeFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveFormTemplateFileTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateFileType;

    public constructor(init?: Partial<SaveFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFormTemplateFileTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFormTemplateFileTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateStatus;

    public constructor(init?: Partial<GetFormTemplateStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: FormTemplateStatus[];

    public constructor(init?: Partial<GetFormTemplateStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFormTemplateStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateStatus;

    public constructor(init?: Partial<InitializeFormTemplateStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveFormTemplateStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplateStatus;

    public constructor(init?: Partial<SaveFormTemplateStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFormTemplateStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFormTemplateStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplate;

    public constructor(init?: Partial<GetFormTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFormTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public models: FormTemplate[];

    public constructor(init?: Partial<GetFormTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFormTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplate;

    public constructor(init?: Partial<InitializeFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SaveFormTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: FormTemplate;

    public constructor(init?: Partial<SaveFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFormTemplateResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFormTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetFundingStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: FundingStatus;

    public constructor(init?: Partial<GetFundingStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetFundingStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: FundingStatus[];

    public constructor(init?: Partial<GetFundingStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeFundingStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: FundingStatus;

    public constructor(init?: Partial<InitializeFundingStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveFundingStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: FundingStatus;

    public constructor(init?: Partial<SaveFundingStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteFundingStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteFundingStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetGenderByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Gender;

    public constructor(init?: Partial<GetGenderByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGendersResponse
{
    public responseStatus: ResponseStatus;
    public models: Gender[];

    public constructor(init?: Partial<GetGendersResponse>) { (Object as any).assign(this, init); }
}

export class InitializeGenderResponse
{
    public responseStatus: ResponseStatus;
    public model: Gender;

    public constructor(init?: Partial<InitializeGenderResponse>) { (Object as any).assign(this, init); }
}

export class SaveGenderResponse
{
    public responseStatus: ResponseStatus;
    public model: Gender;

    public constructor(init?: Partial<SaveGenderResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGenderResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGenderResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupItem;

    public constructor(init?: Partial<GetGroupItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupItemsResponse
{
    public responseStatus: ResponseStatus;
    public models: GroupItem[];

    public constructor(init?: Partial<GetGroupItemsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupItem;

    public constructor(init?: Partial<InitializeGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class SaveGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupItem;

    public constructor(init?: Partial<SaveGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGroupItemResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupNote;

    public constructor(init?: Partial<GetGroupNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupNotesResponse
{
    public responseStatus: ResponseStatus;
    public models: GroupNote[];

    public constructor(init?: Partial<GetGroupNotesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeGroupNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupNote;

    public constructor(init?: Partial<InitializeGroupNoteResponse>) { (Object as any).assign(this, init); }
}

export class SaveGroupNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupNote;

    public constructor(init?: Partial<SaveGroupNoteResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGroupNoteResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGroupNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupType;

    public constructor(init?: Partial<GetGroupTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: GroupType[];

    public constructor(init?: Partial<GetGroupTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeGroupTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupType;

    public constructor(init?: Partial<InitializeGroupTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveGroupTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: GroupType;

    public constructor(init?: Partial<SaveGroupTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGroupTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGroupTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Group;

    public constructor(init?: Partial<GetGroupByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetGroupsResponse
{
    public responseStatus: ResponseStatus;
    public models: Group[];

    public constructor(init?: Partial<GetGroupsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: Group;

    public constructor(init?: Partial<InitializeGroupResponse>) { (Object as any).assign(this, init); }
}

export class SaveGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: Group;

    public constructor(init?: Partial<SaveGroupResponse>) { (Object as any).assign(this, init); }
}

export class DeleteGroupResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteGroupResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionCoding;

    public constructor(init?: Partial<GetInstitutionCodingByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionCodingsResponse
{
    public responseStatus: ResponseStatus;
    public models: InstitutionCoding[];

    public constructor(init?: Partial<GetInstitutionCodingsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInstitutionCodingResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionCoding;

    public constructor(init?: Partial<InitializeInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class SaveInstitutionCodingResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionCoding;

    public constructor(init?: Partial<SaveInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionCodingResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionCodingResponse>) { (Object as any).assign(this, init); }
}

export class CreateInstitutionFormVersionResponse
{
    public model: InstitutionForm;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateInstitutionFormVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionForm;

    public constructor(init?: Partial<GetInstitutionFormByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionFormsResponse
{
    public responseStatus: ResponseStatus;
    public models: InstitutionForm[];

    public constructor(init?: Partial<GetInstitutionFormsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInstitutionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionForm;

    public constructor(init?: Partial<InitializeInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class SaveInstitutionFormResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionForm;

    public constructor(init?: Partial<SaveInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionFormResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionFormResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionNote;

    public constructor(init?: Partial<GetInstitutionNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionNotesResponse
{
    public responseStatus: ResponseStatus;
    public models: InstitutionNote[];

    public constructor(init?: Partial<GetInstitutionNotesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInstitutionNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionNote;

    public constructor(init?: Partial<InitializeInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class SaveInstitutionNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionNote;

    public constructor(init?: Partial<SaveInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionNoteResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionType;

    public constructor(init?: Partial<GetInstitutionTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: InstitutionType[];

    public constructor(init?: Partial<GetInstitutionTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInstitutionTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionType;

    public constructor(init?: Partial<InitializeInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveInstitutionTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: InstitutionType;

    public constructor(init?: Partial<SaveInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Institution;

    public constructor(init?: Partial<GetInstitutionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionsResponse
{
    public responseStatus: ResponseStatus;
    public models: Institution[];

    public constructor(init?: Partial<GetInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public model: Institution;

    public constructor(init?: Partial<InitializeInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class SaveInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public model: Institution;

    public constructor(init?: Partial<SaveInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInstitutionResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Interest;

    public constructor(init?: Partial<GetInterestByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInterestsResponse
{
    public responseStatus: ResponseStatus;
    public models: Interest[];

    public constructor(init?: Partial<GetInterestsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInterestResponse
{
    public responseStatus: ResponseStatus;
    public model: Interest;

    public constructor(init?: Partial<InitializeInterestResponse>) { (Object as any).assign(this, init); }
}

export class SaveInterestResponse
{
    public responseStatus: ResponseStatus;
    public model: Interest;

    public constructor(init?: Partial<SaveInterestResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInterestResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInterestResponse>) { (Object as any).assign(this, init); }
}

export class GetInternationalTrialStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: InternationalTrialStatus;

    public constructor(init?: Partial<GetInternationalTrialStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInternationalTrialStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: InternationalTrialStatus[];

    public constructor(init?: Partial<GetInternationalTrialStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInternationalTrialStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: InternationalTrialStatus;

    public constructor(init?: Partial<InitializeInternationalTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveInternationalTrialStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: InternationalTrialStatus;

    public constructor(init?: Partial<SaveInternationalTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInternationalTrialStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInternationalTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetInvolvementByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Involvement;

    public constructor(init?: Partial<GetInvolvementByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetInvolvementsResponse
{
    public responseStatus: ResponseStatus;
    public models: Involvement[];

    public constructor(init?: Partial<GetInvolvementsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeInvolvementResponse
{
    public responseStatus: ResponseStatus;
    public model: Involvement;

    public constructor(init?: Partial<InitializeInvolvementResponse>) { (Object as any).assign(this, init); }
}

export class SaveInvolvementResponse
{
    public responseStatus: ResponseStatus;
    public model: Involvement;

    public constructor(init?: Partial<SaveInvolvementResponse>) { (Object as any).assign(this, init); }
}

export class DeleteInvolvementResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteInvolvementResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponentType;

    public constructor(init?: Partial<GetItemComponentTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: ItemComponentType[];

    public constructor(init?: Partial<GetItemComponentTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeItemComponentTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponentType;

    public constructor(init?: Partial<InitializeItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveItemComponentTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponentType;

    public constructor(init?: Partial<SaveItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteItemComponentTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteItemComponentTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentsByCollectionIdResponse
{
    public responseStatus: ResponseStatus;
    public models: ItemComponent[];

    public constructor(init?: Partial<GetItemComponentsByCollectionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponent;

    public constructor(init?: Partial<GetItemComponentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetItemComponentsResponse
{
    public responseStatus: ResponseStatus;
    public models: ItemComponent[];

    public constructor(init?: Partial<GetItemComponentsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeItemComponentResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponent;

    public constructor(init?: Partial<InitializeItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class SaveItemComponentResponse
{
    public responseStatus: ResponseStatus;
    public model: ItemComponent;

    public constructor(init?: Partial<SaveItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class DeleteItemComponentResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteItemComponentResponse>) { (Object as any).assign(this, init); }
}

export class GetMeasurementByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Measurement;

    public constructor(init?: Partial<GetMeasurementByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMeasurementsResponse
{
    public responseStatus: ResponseStatus;
    public models: Measurement[];

    public constructor(init?: Partial<GetMeasurementsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeMeasurementResponse
{
    public responseStatus: ResponseStatus;
    public model: Measurement;

    public constructor(init?: Partial<InitializeMeasurementResponse>) { (Object as any).assign(this, init); }
}

export class SaveMeasurementResponse
{
    public responseStatus: ResponseStatus;
    public model: Measurement;

    public constructor(init?: Partial<SaveMeasurementResponse>) { (Object as any).assign(this, init); }
}

export class DeleteMeasurementResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteMeasurementResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: MembershipType;

    public constructor(init?: Partial<GetMembershipTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: MembershipType[];

    public constructor(init?: Partial<GetMembershipTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeMembershipTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: MembershipType;

    public constructor(init?: Partial<InitializeMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveMembershipTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: MembershipType;

    public constructor(init?: Partial<SaveMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteMembershipTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: NoteType;

    public constructor(init?: Partial<GetNoteTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetNoteTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: NoteType[];

    public constructor(init?: Partial<GetNoteTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeNoteTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: NoteType;

    public constructor(init?: Partial<InitializeNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveNoteTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: NoteType;

    public constructor(init?: Partial<SaveNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteNoteTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteNoteTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: OpenClinicaUserRole;

    public constructor(init?: Partial<GetOpenClinicaUserRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetOpenClinicaUserRolesResponse
{
    public responseStatus: ResponseStatus;
    public models: OpenClinicaUserRole[];

    public constructor(init?: Partial<GetOpenClinicaUserRolesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeOpenClinicaUserRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: OpenClinicaUserRole;

    public constructor(init?: Partial<InitializeOpenClinicaUserRoleResponse>) { (Object as any).assign(this, init); }
}

export class SaveOpenClinicaUserRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: OpenClinicaUserRole;

    public constructor(init?: Partial<SaveOpenClinicaUserRoleResponse>) { (Object as any).assign(this, init); }
}

export class DeleteOpenClinicaUserRoleResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteOpenClinicaUserRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Patient;

    public constructor(init?: Partial<GetPatientByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsResponse
{
    public responseStatus: ResponseStatus;
    public models: Patient[];

    public constructor(init?: Partial<GetPatientsResponse>) { (Object as any).assign(this, init); }
}

export class InitializePatientResponse
{
    public responseStatus: ResponseStatus;
    public model: Patient;

    public constructor(init?: Partial<InitializePatientResponse>) { (Object as any).assign(this, init); }
}

export class SavePatientResponse
{
    public responseStatus: ResponseStatus;
    public model: Patient;

    public constructor(init?: Partial<SavePatientResponse>) { (Object as any).assign(this, init); }
}

export class DeletePatientResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletePatientResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: PermissionConfiguration;

    public constructor(init?: Partial<GetPermissionConfigurationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPermissionConfigurationsResponse
{
    public responseStatus: ResponseStatus;
    public models: PermissionConfiguration[];

    public constructor(init?: Partial<GetPermissionConfigurationsResponse>) { (Object as any).assign(this, init); }
}

export class InitializePermissionConfigurationResponse
{
    public responseStatus: ResponseStatus;
    public model: PermissionConfiguration;

    public constructor(init?: Partial<InitializePermissionConfigurationResponse>) { (Object as any).assign(this, init); }
}

export class SavePermissionConfigurationResponse
{
    public responseStatus: ResponseStatus;
    public model: PermissionConfiguration;

    public constructor(init?: Partial<SavePermissionConfigurationResponse>) { (Object as any).assign(this, init); }
}

export class DeletePermissionConfigurationResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletePermissionConfigurationResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelNote;

    public constructor(init?: Partial<GetPersonnelNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelNotesResponse
{
    public responseStatus: ResponseStatus;
    public models: PersonnelNote[];

    public constructor(init?: Partial<GetPersonnelNotesResponse>) { (Object as any).assign(this, init); }
}

export class InitializePersonnelNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelNote;

    public constructor(init?: Partial<InitializePersonnelNoteResponse>) { (Object as any).assign(this, init); }
}

export class SavePersonnelNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelNote;

    public constructor(init?: Partial<SavePersonnelNoteResponse>) { (Object as any).assign(this, init); }
}

export class DeletePersonnelNoteResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletePersonnelNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelRole;

    public constructor(init?: Partial<GetPersonnelRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelRolesResponse
{
    public responseStatus: ResponseStatus;
    public models: PersonnelRole[];

    public constructor(init?: Partial<GetPersonnelRolesResponse>) { (Object as any).assign(this, init); }
}

export class InitializePersonnelRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelRole;

    public constructor(init?: Partial<InitializePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class SavePersonnelRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: PersonnelRole;

    public constructor(init?: Partial<SavePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class DeletePersonnelRoleResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletePersonnelRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Personnel;

    public constructor(init?: Partial<GetPersonnelByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPersonnelsResponse
{
    public responseStatus: ResponseStatus;
    public models: Personnel[];

    public constructor(init?: Partial<GetPersonnelsResponse>) { (Object as any).assign(this, init); }
}

export class InitializePersonnelResponse
{
    public responseStatus: ResponseStatus;
    public model: Personnel;

    public constructor(init?: Partial<InitializePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class SavePersonnelResponse
{
    public responseStatus: ResponseStatus;
    public model: Personnel;

    public constructor(init?: Partial<SavePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class DeletePersonnelResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletePersonnelResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplineByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ProfessionalDiscipline;

    public constructor(init?: Partial<GetProfessionalDisciplineByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetProfessionalDisciplinesResponse
{
    public responseStatus: ResponseStatus;
    public models: ProfessionalDiscipline[];

    public constructor(init?: Partial<GetProfessionalDisciplinesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeProfessionalDisciplineResponse
{
    public responseStatus: ResponseStatus;
    public model: ProfessionalDiscipline;

    public constructor(init?: Partial<InitializeProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class SaveProfessionalDisciplineResponse
{
    public responseStatus: ResponseStatus;
    public model: ProfessionalDiscipline;

    public constructor(init?: Partial<SaveProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class DeleteProfessionalDisciplineResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteProfessionalDisciplineResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagCategory;

    public constructor(init?: Partial<GetReportingTagCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public models: ReportingTagCategory[];

    public constructor(init?: Partial<GetReportingTagCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeReportingTagCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagCategory;

    public constructor(init?: Partial<InitializeReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SaveReportingTagCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagCategory;

    public constructor(init?: Partial<SaveReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteReportingTagCategoryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteReportingTagCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagType;

    public constructor(init?: Partial<GetReportingTagTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: ReportingTagType[];

    public constructor(init?: Partial<GetReportingTagTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeReportingTagTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagType;

    public constructor(init?: Partial<InitializeReportingTagTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveReportingTagTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTagType;

    public constructor(init?: Partial<SaveReportingTagTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteReportingTagTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteReportingTagTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTag;

    public constructor(init?: Partial<GetReportingTagByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetReportingTagsResponse
{
    public responseStatus: ResponseStatus;
    public models: ReportingTag[];

    public constructor(init?: Partial<GetReportingTagsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeReportingTagResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTag;

    public constructor(init?: Partial<InitializeReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class SaveReportingTagResponse
{
    public responseStatus: ResponseStatus;
    public model: ReportingTag;

    public constructor(init?: Partial<SaveReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class DeleteReportingTagResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteReportingTagResponse>) { (Object as any).assign(this, init); }
}

export class GetRoleByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Role;

    public constructor(init?: Partial<GetRoleByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetRolesResponse
{
    public responseStatus: ResponseStatus;
    public models: Role[];

    public constructor(init?: Partial<GetRolesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: Role;

    public constructor(init?: Partial<InitializeRoleResponse>) { (Object as any).assign(this, init); }
}

export class SaveRoleResponse
{
    public responseStatus: ResponseStatus;
    public model: Role;

    public constructor(init?: Partial<SaveRoleResponse>) { (Object as any).assign(this, init); }
}

export class DeleteRoleResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Salutation;

    public constructor(init?: Partial<GetSalutationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSalutationsResponse
{
    public responseStatus: ResponseStatus;
    public models: Salutation[];

    public constructor(init?: Partial<GetSalutationsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeSalutationResponse
{
    public responseStatus: ResponseStatus;
    public model: Salutation;

    public constructor(init?: Partial<InitializeSalutationResponse>) { (Object as any).assign(this, init); }
}

export class SaveSalutationResponse
{
    public responseStatus: ResponseStatus;
    public model: Salutation;

    public constructor(init?: Partial<SaveSalutationResponse>) { (Object as any).assign(this, init); }
}

export class DeleteSalutationResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteSalutationResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteLocation;

    public constructor(init?: Partial<GetSiteLocationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteLocationsResponse
{
    public responseStatus: ResponseStatus;
    public models: SiteLocation[];

    public constructor(init?: Partial<GetSiteLocationsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeSiteLocationResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteLocation;

    public constructor(init?: Partial<InitializeSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class SaveSiteLocationResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteLocation;

    public constructor(init?: Partial<SaveSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class DeleteSiteLocationResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteSiteLocationResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteType;

    public constructor(init?: Partial<GetSiteTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: SiteType[];

    public constructor(init?: Partial<GetSiteTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeSiteTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteType;

    public constructor(init?: Partial<InitializeSiteTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveSiteTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: SiteType;

    public constructor(init?: Partial<SaveSiteTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteSiteTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteSiteTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetSortOrderByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: SortOrder;

    public constructor(init?: Partial<GetSortOrderByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSortOrdersResponse
{
    public responseStatus: ResponseStatus;
    public models: SortOrder[];

    public constructor(init?: Partial<GetSortOrdersResponse>) { (Object as any).assign(this, init); }
}

export class InitializeSortOrderResponse
{
    public responseStatus: ResponseStatus;
    public model: SortOrder;

    public constructor(init?: Partial<InitializeSortOrderResponse>) { (Object as any).assign(this, init); }
}

export class SaveSortOrderResponse
{
    public responseStatus: ResponseStatus;
    public model: SortOrder;

    public constructor(init?: Partial<SaveSortOrderResponse>) { (Object as any).assign(this, init); }
}

export class DeleteSortOrderResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteSortOrderResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: StandardEmailTemplate;

    public constructor(init?: Partial<GetStandardEmailTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetStandardEmailTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public models: StandardEmailTemplate[];

    public constructor(init?: Partial<GetStandardEmailTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeStandardEmailTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: StandardEmailTemplate;

    public constructor(init?: Partial<InitializeStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SaveStandardEmailTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: StandardEmailTemplate;

    public constructor(init?: Partial<SaveStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class DeleteStandardEmailTemplateResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteStandardEmailTemplateResponse>) { (Object as any).assign(this, init); }
}

export class GetStateByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: State;

    public constructor(init?: Partial<GetStateByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetStatesResponse
{
    public responseStatus: ResponseStatus;
    public models: State[];

    public constructor(init?: Partial<GetStatesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeStateResponse
{
    public responseStatus: ResponseStatus;
    public model: State;

    public constructor(init?: Partial<InitializeStateResponse>) { (Object as any).assign(this, init); }
}

export class SaveStateResponse
{
    public responseStatus: ResponseStatus;
    public model: State;

    public constructor(init?: Partial<SaveStateResponse>) { (Object as any).assign(this, init); }
}

export class DeleteStateResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteStateResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TaskType;

    public constructor(init?: Partial<GetTaskTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTaskTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TaskType[];

    public constructor(init?: Partial<GetTaskTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTaskTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TaskType;

    public constructor(init?: Partial<InitializeTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTaskTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TaskType;

    public constructor(init?: Partial<SaveTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTaskTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTaskTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTemplateTrialItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TemplateTrialItem;

    public constructor(init?: Partial<GetTemplateTrialItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTemplateTrialItemsResponse
{
    public responseStatus: ResponseStatus;
    public models: TemplateTrialItem[];

    public constructor(init?: Partial<GetTemplateTrialItemsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTemplateTrialItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TemplateTrialItem;

    public constructor(init?: Partial<InitializeTemplateTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class SaveTemplateTrialItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TemplateTrialItem;

    public constructor(init?: Partial<SaveTemplateTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTemplateTrialItemResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTemplateTrialItemResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestoneByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerMilestone;

    public constructor(init?: Partial<GetTrackerMilestoneByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerMilestonesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrackerMilestone[];

    public constructor(init?: Partial<GetTrackerMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrackerMilestoneResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerMilestone;

    public constructor(init?: Partial<InitializeTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrackerMilestoneResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerMilestone;

    public constructor(init?: Partial<SaveTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrackerMilestoneResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrackerMilestoneResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerStatus;

    public constructor(init?: Partial<GetTrackerStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrackerStatus[];

    public constructor(init?: Partial<GetTrackerStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrackerStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerStatus;

    public constructor(init?: Partial<InitializeTrackerStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrackerStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerStatus;

    public constructor(init?: Partial<SaveTrackerStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrackerStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrackerStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerType;

    public constructor(init?: Partial<GetTrackerTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrackerTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrackerType[];

    public constructor(init?: Partial<GetTrackerTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrackerTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerType;

    public constructor(init?: Partial<InitializeTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrackerTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrackerType;

    public constructor(init?: Partial<SaveTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrackerTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrackerTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialAnalysisTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialAnalysisType;

    public constructor(init?: Partial<GetTrialAnalysisTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialAnalysisTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialAnalysisType[];

    public constructor(init?: Partial<GetTrialAnalysisTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialAnalysisTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialAnalysisType;

    public constructor(init?: Partial<InitializeTrialAnalysisTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialAnalysisTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialAnalysisType;

    public constructor(init?: Partial<SaveTrialAnalysisTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialAnalysisTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialAnalysisTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialApiByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialApi;

    public constructor(init?: Partial<GetTrialApiByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialApisResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialApi[];

    public constructor(init?: Partial<GetTrialApisResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialApiResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialApi;

    public constructor(init?: Partial<InitializeTrialApiResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialApiResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialApi;

    public constructor(init?: Partial<SaveTrialApiResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialApiResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialApiResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialCategoryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialCategory;

    public constructor(init?: Partial<GetTrialCategoryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialCategoriesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialCategory[];

    public constructor(init?: Partial<GetTrialCategoriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialCategory;

    public constructor(init?: Partial<InitializeTrialCategoryResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialCategoryResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialCategory;

    public constructor(init?: Partial<SaveTrialCategoryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialCategoryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormReportByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialFormReport;

    public constructor(init?: Partial<GetTrialFormReportByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormReportsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialFormReport[];

    public constructor(init?: Partial<GetTrialFormReportsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialFormReportResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialFormReport;

    public constructor(init?: Partial<InitializeTrialFormReportResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialFormReportResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialFormReport;

    public constructor(init?: Partial<SaveTrialFormReportResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialFormReportResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialFormReportResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialFormVersionResponse
{
    public model: TrialForm;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateTrialFormVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialForm;

    public constructor(init?: Partial<GetTrialFormByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialFormsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialForm[];

    public constructor(init?: Partial<GetTrialFormsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialForm;

    public constructor(init?: Partial<InitializeTrialFormResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialFormResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialForm;

    public constructor(init?: Partial<SaveTrialFormResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialFormResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialFormResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialGroupItemVersionResponse
{
    public model: TrialGroupItem;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateTrialGroupItemVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroupItem;

    public constructor(init?: Partial<GetTrialGroupItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupItemsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialGroupItem[];

    public constructor(init?: Partial<GetTrialGroupItemsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroupItem;

    public constructor(init?: Partial<InitializeTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialGroupItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroupItem;

    public constructor(init?: Partial<SaveTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialGroupItemResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialGroupItemResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroup;

    public constructor(init?: Partial<GetTrialGroupByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialGroupsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialGroup[];

    public constructor(init?: Partial<GetTrialGroupsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroup;

    public constructor(init?: Partial<InitializeTrialGroupResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialGroup;

    public constructor(init?: Partial<SaveTrialGroupResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialGroupResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialGroupResponse>) { (Object as any).assign(this, init); }
}

export class ImportTrialInstitutionItemTemplatesResponse
{
    public createdItems: TrialInstitutionItemTemplate[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ImportTrialInstitutionItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplateByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItemTemplate;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemTemplatesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialInstitutionItemTemplate[];

    public constructor(init?: Partial<GetTrialInstitutionItemTemplatesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItemTemplate;

    public constructor(init?: Partial<InitializeTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialInstitutionItemTemplateResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItemTemplate;

    public constructor(init?: Partial<SaveTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionItemTemplateResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionItemTemplateResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialInstitutionItemVersionResponse
{
    public model: TrialInstitutionItem;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateTrialInstitutionItemVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItem;

    public constructor(init?: Partial<GetTrialInstitutionItemByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionItemsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialInstitutionItem[];

    public constructor(init?: Partial<GetTrialInstitutionItemsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItem;

    public constructor(init?: Partial<InitializeTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialInstitutionItemResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionItem;

    public constructor(init?: Partial<SaveTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionItemResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionItemResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionNote;

    public constructor(init?: Partial<GetTrialInstitutionNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionNotesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialInstitutionNote[];

    public constructor(init?: Partial<GetTrialInstitutionNotesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialInstitutionNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionNote;

    public constructor(init?: Partial<InitializeTrialInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialInstitutionNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionNote;

    public constructor(init?: Partial<SaveTrialInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionNoteResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionStatus;

    public constructor(init?: Partial<GetTrialInstitutionStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialInstitutionStatus[];

    public constructor(init?: Partial<GetTrialInstitutionStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialInstitutionStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionStatus;

    public constructor(init?: Partial<InitializeTrialInstitutionStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialInstitutionStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitutionStatus;

    public constructor(init?: Partial<SaveTrialInstitutionStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitution;

    public constructor(init?: Partial<GetTrialInstitutionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialInstitutionsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialInstitution[];

    public constructor(init?: Partial<GetTrialInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitution;

    public constructor(init?: Partial<InitializeTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialInstitutionResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialInstitution;

    public constructor(init?: Partial<SaveTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialInstitutionResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstanceStatus;

    public constructor(init?: Partial<GetTrialItemInstanceStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialItemInstanceStatus[];

    public constructor(init?: Partial<GetTrialItemInstanceStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialItemInstanceStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstanceStatus;

    public constructor(init?: Partial<InitializeTrialItemInstanceStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialItemInstanceStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstanceStatus;

    public constructor(init?: Partial<SaveTrialItemInstanceStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialItemInstanceStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialItemInstanceStatusResponse>) { (Object as any).assign(this, init); }
}

export class ImportTrialItemInstancesResponse
{
    public createdItems: TrialItemInstance[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ImportTrialItemInstancesResponse>) { (Object as any).assign(this, init); }
}

export class CreateTrialItemInstanceVersionResponse
{
    public model: TrialItemInstance;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateTrialItemInstanceVersionResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstanceByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstance;

    public constructor(init?: Partial<GetTrialItemInstanceByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialItemInstancesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialItemInstance[];

    public constructor(init?: Partial<GetTrialItemInstancesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialItemInstanceResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstance;

    public constructor(init?: Partial<InitializeTrialItemInstanceResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialItemInstanceResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialItemInstance;

    public constructor(init?: Partial<SaveTrialItemInstanceResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialItemInstanceResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialItemInstanceResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMilestonesByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialMilestones;

    public constructor(init?: Partial<GetTrialMilestonesByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialMilestonesListResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialMilestones[];

    public constructor(init?: Partial<GetTrialMilestonesListResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialMilestonesResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialMilestones;

    public constructor(init?: Partial<InitializeTrialMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialMilestonesResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialMilestones;

    public constructor(init?: Partial<SaveTrialMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialMilestonesResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialMilestonesResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialNoteByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialNote;

    public constructor(init?: Partial<GetTrialNoteByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialNotesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialNote[];

    public constructor(init?: Partial<GetTrialNotesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialNote;

    public constructor(init?: Partial<InitializeTrialNoteResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialNoteResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialNote;

    public constructor(init?: Partial<SaveTrialNoteResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialNoteResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialNoteResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPhaseByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPhase;

    public constructor(init?: Partial<GetTrialPhaseByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPhasesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialPhase[];

    public constructor(init?: Partial<GetTrialPhasesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialPhaseResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPhase;

    public constructor(init?: Partial<InitializeTrialPhaseResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialPhaseResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPhase;

    public constructor(init?: Partial<SaveTrialPhaseResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialPhaseResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialPhaseResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPresentationTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPresentationType;

    public constructor(init?: Partial<GetTrialPresentationTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPresentationTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialPresentationType[];

    public constructor(init?: Partial<GetTrialPresentationTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialPresentationTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPresentationType;

    public constructor(init?: Partial<InitializeTrialPresentationTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialPresentationTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPresentationType;

    public constructor(init?: Partial<SaveTrialPresentationTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialPresentationTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialPresentationTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationStatus;

    public constructor(init?: Partial<GetTrialPublicationStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialPublicationStatus[];

    public constructor(init?: Partial<GetTrialPublicationStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialPublicationStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationStatus;

    public constructor(init?: Partial<InitializeTrialPublicationStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialPublicationStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationStatus;

    public constructor(init?: Partial<SaveTrialPublicationStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialPublicationStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialPublicationStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationType;

    public constructor(init?: Partial<GetTrialPublicationTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialPublicationTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialPublicationType[];

    public constructor(init?: Partial<GetTrialPublicationTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialPublicationTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationType;

    public constructor(init?: Partial<InitializeTrialPublicationTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialPublicationTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialPublicationType;

    public constructor(init?: Partial<SaveTrialPublicationTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialPublicationTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialPublicationTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialRegistryByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialRegistry;

    public constructor(init?: Partial<GetTrialRegistryByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialRegistriesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialRegistry[];

    public constructor(init?: Partial<GetTrialRegistriesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialRegistryResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialRegistry;

    public constructor(init?: Partial<InitializeTrialRegistryResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialRegistryResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialRegistry;

    public constructor(init?: Partial<SaveTrialRegistryResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialRegistryResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialRegistryResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialStatusByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialStatus;

    public constructor(init?: Partial<GetTrialStatusByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialStatusesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialStatus[];

    public constructor(init?: Partial<GetTrialStatusesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialStatus;

    public constructor(init?: Partial<InitializeTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialStatusResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialStatus;

    public constructor(init?: Partial<SaveTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialStatusResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTrackerByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTracker;

    public constructor(init?: Partial<GetTrialTrackerByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTrackersResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialTracker[];

    public constructor(init?: Partial<GetTrialTrackersResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialTrackerResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTracker;

    public constructor(init?: Partial<InitializeTrialTrackerResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialTrackerResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTracker;

    public constructor(init?: Partial<SaveTrialTrackerResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialTrackerResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialTrackerResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTreatmentByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTreatment;

    public constructor(init?: Partial<GetTrialTreatmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTreatmentsResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialTreatment[];

    public constructor(init?: Partial<GetTrialTreatmentsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialTreatmentResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTreatment;

    public constructor(init?: Partial<InitializeTrialTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialTreatmentResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialTreatment;

    public constructor(init?: Partial<SaveTrialTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialTreatmentResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypeByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialType;

    public constructor(init?: Partial<GetTrialTypeByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialTypesResponse
{
    public responseStatus: ResponseStatus;
    public models: TrialType[];

    public constructor(init?: Partial<GetTrialTypesResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialType;

    public constructor(init?: Partial<InitializeTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialTypeResponse
{
    public responseStatus: ResponseStatus;
    public model: TrialType;

    public constructor(init?: Partial<SaveTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialTypeResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: Trial;

    public constructor(init?: Partial<GetTrialByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialsResponse
{
    public responseStatus: ResponseStatus;
    public models: Trial[];

    public constructor(init?: Partial<GetTrialsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTrialResponse
{
    public responseStatus: ResponseStatus;
    public model: Trial;

    public constructor(init?: Partial<InitializeTrialResponse>) { (Object as any).assign(this, init); }
}

export class SaveTrialResponse
{
    public responseStatus: ResponseStatus;
    public model: Trial;

    public constructor(init?: Partial<SaveTrialResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTrialResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTrialResponse>) { (Object as any).assign(this, init); }
}

export class GetTumourGroupByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: TumourGroup;

    public constructor(init?: Partial<GetTumourGroupByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTumourGroupsResponse
{
    public responseStatus: ResponseStatus;
    public models: TumourGroup[];

    public constructor(init?: Partial<GetTumourGroupsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeTumourGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: TumourGroup;

    public constructor(init?: Partial<InitializeTumourGroupResponse>) { (Object as any).assign(this, init); }
}

export class SaveTumourGroupResponse
{
    public responseStatus: ResponseStatus;
    public model: TumourGroup;

    public constructor(init?: Partial<SaveTumourGroupResponse>) { (Object as any).assign(this, init); }
}

export class DeleteTumourGroupResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteTumourGroupResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoPendingByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNoPending;

    public constructor(init?: Partial<GetYesNoPendingByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoPendingsResponse
{
    public responseStatus: ResponseStatus;
    public models: YesNoPending[];

    public constructor(init?: Partial<GetYesNoPendingsResponse>) { (Object as any).assign(this, init); }
}

export class InitializeYesNoPendingResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNoPending;

    public constructor(init?: Partial<InitializeYesNoPendingResponse>) { (Object as any).assign(this, init); }
}

export class SaveYesNoPendingResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNoPending;

    public constructor(init?: Partial<SaveYesNoPendingResponse>) { (Object as any).assign(this, init); }
}

export class DeleteYesNoPendingResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteYesNoPendingResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNoByIdResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNo;

    public constructor(init?: Partial<GetYesNoByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetYesNosResponse
{
    public responseStatus: ResponseStatus;
    public models: YesNo[];

    public constructor(init?: Partial<GetYesNosResponse>) { (Object as any).assign(this, init); }
}

export class InitializeYesNoResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNo;

    public constructor(init?: Partial<InitializeYesNoResponse>) { (Object as any).assign(this, init); }
}

export class SaveYesNoResponse
{
    public responseStatus: ResponseStatus;
    public model: YesNo;

    public constructor(init?: Partial<SaveYesNoResponse>) { (Object as any).assign(this, init); }
}

export class DeleteYesNoResponse implements IModelDeleteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteYesNoResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/api/v2/activities-undertaken/metadata", "POST")
export class GetActivitiesUndertakenMetadataRequest implements IReturn<GetActivitiesUndertakenMetadataResponse>
{
    public model: ActivitiesUndertaken;
    public context: ActivitiesUndertakenMetadataContext;

    public constructor(init?: Partial<GetActivitiesUndertakenMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetActivitiesUndertakenMetadataResponse(); }
    public getTypeName() { return 'GetActivitiesUndertakenMetadataRequest'; }
}

// @Route("/api/v2/activities-undertaken/lookup-updates", "POST")
export class GetActivitiesUndertakenLookupUpdatesRequest implements IReturn<GetActivitiesUndertakenLookupUpdatesResponse>
{
    public model: ActivitiesUndertaken;
    public changes: FieldChange[];
    public context: ActivitiesUndertakenMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetActivitiesUndertakenLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetActivitiesUndertakenLookupUpdatesResponse(); }
    public getTypeName() { return 'GetActivitiesUndertakenLookupUpdatesRequest'; }
}

// @Route("/api/v2/activities-undertaken/validate", "POST")
export class ValidateActivitiesUndertakenRequest implements IReturn<ValidateActivitiesUndertakenResponse>
{
    public model: ActivitiesUndertaken;
    public context: ActivitiesUndertakenMetadataContext;

    public constructor(init?: Partial<ValidateActivitiesUndertakenRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateActivitiesUndertakenResponse(); }
    public getTypeName() { return 'ValidateActivitiesUndertakenRequest'; }
}

// @Route("/api/v2/activities-undertaken/form", "POST")
export class SubmitActivitiesUndertakenFormRequest implements IReturn<SubmitActivitiesUndertakenFormResponse>
{
    public model: ActivitiesUndertaken;
    public mode: SaveMode;
    public context: ActivitiesUndertakenMetadataContext;

    public constructor(init?: Partial<SubmitActivitiesUndertakenFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitActivitiesUndertakenFormResponse(); }
    public getTypeName() { return 'SubmitActivitiesUndertakenFormRequest'; }
}

// @Route("/api/v2/address-options/metadata", "POST")
export class GetAddressOptionMetadataRequest implements IReturn<GetAddressOptionMetadataResponse>
{
    public model: AddressOption;
    public context: AddressOptionMetadataContext;

    public constructor(init?: Partial<GetAddressOptionMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAddressOptionMetadataResponse(); }
    public getTypeName() { return 'GetAddressOptionMetadataRequest'; }
}

// @Route("/api/v2/address-options/lookup-updates", "POST")
export class GetAddressOptionLookupUpdatesRequest implements IReturn<GetAddressOptionLookupUpdatesResponse>
{
    public model: AddressOption;
    public changes: FieldChange[];
    public context: AddressOptionMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetAddressOptionLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAddressOptionLookupUpdatesResponse(); }
    public getTypeName() { return 'GetAddressOptionLookupUpdatesRequest'; }
}

// @Route("/api/v2/address-options/validate", "POST")
export class ValidateAddressOptionRequest implements IReturn<ValidateAddressOptionResponse>
{
    public model: AddressOption;
    public context: AddressOptionMetadataContext;

    public constructor(init?: Partial<ValidateAddressOptionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateAddressOptionResponse(); }
    public getTypeName() { return 'ValidateAddressOptionRequest'; }
}

// @Route("/api/v2/address-options/form", "POST")
export class SubmitAddressOptionFormRequest implements IReturn<SubmitAddressOptionFormResponse>
{
    public model: AddressOption;
    public mode: SaveMode;
    public context: AddressOptionMetadataContext;

    public constructor(init?: Partial<SubmitAddressOptionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitAddressOptionFormResponse(); }
    public getTypeName() { return 'SubmitAddressOptionFormRequest'; }
}

// @Route("/api/v2/allocated-wps/metadata", "POST")
export class GetAllocatedWPMetadataRequest implements IReturn<GetAllocatedWPMetadataResponse>
{
    public model: AllocatedWP;
    public context: AllocatedWPMetadataContext;

    public constructor(init?: Partial<GetAllocatedWPMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAllocatedWPMetadataResponse(); }
    public getTypeName() { return 'GetAllocatedWPMetadataRequest'; }
}

// @Route("/api/v2/allocated-wps/lookup-updates", "POST")
export class GetAllocatedWPLookupUpdatesRequest implements IReturn<GetAllocatedWPLookupUpdatesResponse>
{
    public model: AllocatedWP;
    public changes: FieldChange[];
    public context: AllocatedWPMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetAllocatedWPLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAllocatedWPLookupUpdatesResponse(); }
    public getTypeName() { return 'GetAllocatedWPLookupUpdatesRequest'; }
}

// @Route("/api/v2/allocated-wps/validate", "POST")
export class ValidateAllocatedWPRequest implements IReturn<ValidateAllocatedWPResponse>
{
    public model: AllocatedWP;
    public context: AllocatedWPMetadataContext;

    public constructor(init?: Partial<ValidateAllocatedWPRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateAllocatedWPResponse(); }
    public getTypeName() { return 'ValidateAllocatedWPRequest'; }
}

// @Route("/api/v2/allocated-wps/form", "POST")
export class SubmitAllocatedWPFormRequest implements IReturn<SubmitAllocatedWPFormResponse>
{
    public model: AllocatedWP;
    public mode: SaveMode;
    public context: AllocatedWPMetadataContext;

    public constructor(init?: Partial<SubmitAllocatedWPFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitAllocatedWPFormResponse(); }
    public getTypeName() { return 'SubmitAllocatedWPFormRequest'; }
}

// @Route("/api/v2/assignment-types/metadata", "POST")
export class GetAssignmentTypeMetadataRequest implements IReturn<GetAssignmentTypeMetadataResponse>
{
    public model: AssignmentType;
    public context: AssignmentTypeMetadataContext;

    public constructor(init?: Partial<GetAssignmentTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAssignmentTypeMetadataResponse(); }
    public getTypeName() { return 'GetAssignmentTypeMetadataRequest'; }
}

// @Route("/api/v2/assignment-types/lookup-updates", "POST")
export class GetAssignmentTypeLookupUpdatesRequest implements IReturn<GetAssignmentTypeLookupUpdatesResponse>
{
    public model: AssignmentType;
    public changes: FieldChange[];
    public context: AssignmentTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetAssignmentTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAssignmentTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetAssignmentTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/assignment-types/validate", "POST")
export class ValidateAssignmentTypeRequest implements IReturn<ValidateAssignmentTypeResponse>
{
    public model: AssignmentType;
    public context: AssignmentTypeMetadataContext;

    public constructor(init?: Partial<ValidateAssignmentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateAssignmentTypeResponse(); }
    public getTypeName() { return 'ValidateAssignmentTypeRequest'; }
}

// @Route("/api/v2/assignment-types/form", "POST")
export class SubmitAssignmentTypeFormRequest implements IReturn<SubmitAssignmentTypeFormResponse>
{
    public model: AssignmentType;
    public mode: SaveMode;
    public context: AssignmentTypeMetadataContext;

    public constructor(init?: Partial<SubmitAssignmentTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitAssignmentTypeFormResponse(); }
    public getTypeName() { return 'SubmitAssignmentTypeFormRequest'; }
}

// @Route("/api/v2/case-types/metadata", "POST")
export class GetCaseTypeMetadataRequest implements IReturn<GetCaseTypeMetadataResponse>
{
    public model: CaseType;
    public context: CaseTypeMetadataContext;

    public constructor(init?: Partial<GetCaseTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCaseTypeMetadataResponse(); }
    public getTypeName() { return 'GetCaseTypeMetadataRequest'; }
}

// @Route("/api/v2/case-types/lookup-updates", "POST")
export class GetCaseTypeLookupUpdatesRequest implements IReturn<GetCaseTypeLookupUpdatesResponse>
{
    public model: CaseType;
    public changes: FieldChange[];
    public context: CaseTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetCaseTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCaseTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetCaseTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/case-types/validate", "POST")
export class ValidateCaseTypeRequest implements IReturn<ValidateCaseTypeResponse>
{
    public model: CaseType;
    public context: CaseTypeMetadataContext;

    public constructor(init?: Partial<ValidateCaseTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCaseTypeResponse(); }
    public getTypeName() { return 'ValidateCaseTypeRequest'; }
}

// @Route("/api/v2/case-types/form", "POST")
export class SubmitCaseTypeFormRequest implements IReturn<SubmitCaseTypeFormResponse>
{
    public model: CaseType;
    public mode: SaveMode;
    public context: CaseTypeMetadataContext;

    public constructor(init?: Partial<SubmitCaseTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCaseTypeFormResponse(); }
    public getTypeName() { return 'SubmitCaseTypeFormRequest'; }
}

// @Route("/api/v2/categories/metadata", "POST")
export class GetCategoryMetadataRequest implements IReturn<GetCategoryMetadataResponse>
{
    public model: Category;
    public context: CategoryMetadataContext;

    public constructor(init?: Partial<GetCategoryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCategoryMetadataResponse(); }
    public getTypeName() { return 'GetCategoryMetadataRequest'; }
}

// @Route("/api/v2/categories/lookup-updates", "POST")
export class GetCategoryLookupUpdatesRequest implements IReturn<GetCategoryLookupUpdatesResponse>
{
    public model: Category;
    public changes: FieldChange[];
    public context: CategoryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetCategoryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCategoryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetCategoryLookupUpdatesRequest'; }
}

// @Route("/api/v2/categories/validate", "POST")
export class ValidateCategoryRequest implements IReturn<ValidateCategoryResponse>
{
    public model: Category;
    public context: CategoryMetadataContext;

    public constructor(init?: Partial<ValidateCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCategoryResponse(); }
    public getTypeName() { return 'ValidateCategoryRequest'; }
}

// @Route("/api/v2/categories/form", "POST")
export class SubmitCategoryFormRequest implements IReturn<SubmitCategoryFormResponse>
{
    public model: Category;
    public mode: SaveMode;
    public context: CategoryMetadataContext;

    public constructor(init?: Partial<SubmitCategoryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCategoryFormResponse(); }
    public getTypeName() { return 'SubmitCategoryFormRequest'; }
}

// @Route("/api/v2/collections/metadata", "POST")
export class GetCollectionMetadataRequest implements IReturn<GetCollectionMetadataResponse>
{
    public model: Collection;
    public context: CollectionMetadataContext;

    public constructor(init?: Partial<GetCollectionMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionMetadataResponse(); }
    public getTypeName() { return 'GetCollectionMetadataRequest'; }
}

// @Route("/api/v2/collections/lookup-updates", "POST")
export class GetCollectionLookupUpdatesRequest implements IReturn<GetCollectionLookupUpdatesResponse>
{
    public model: Collection;
    public changes: FieldChange[];
    public context: CollectionMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetCollectionLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionLookupUpdatesResponse(); }
    public getTypeName() { return 'GetCollectionLookupUpdatesRequest'; }
}

// @Route("/api/v2/collections/validate", "POST")
export class ValidateCollectionRequest implements IReturn<ValidateCollectionResponse>
{
    public model: Collection;
    public context: CollectionMetadataContext;

    public constructor(init?: Partial<ValidateCollectionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCollectionResponse(); }
    public getTypeName() { return 'ValidateCollectionRequest'; }
}

// @Route("/api/v2/collections/form", "POST")
export class SubmitCollectionFormRequest implements IReturn<SubmitCollectionFormResponse>
{
    public model: Collection;
    public mode: SaveMode;
    public context: CollectionMetadataContext;

    public constructor(init?: Partial<SubmitCollectionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCollectionFormResponse(); }
    public getTypeName() { return 'SubmitCollectionFormRequest'; }
}

// @Route("/api/v2/collection-instances/metadata", "POST")
export class GetCollectionInstanceMetadataRequest implements IReturn<GetCollectionInstanceMetadataResponse>
{
    public model: CollectionInstance;
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<GetCollectionInstanceMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstanceMetadataResponse(); }
    public getTypeName() { return 'GetCollectionInstanceMetadataRequest'; }
}

// @Route("/api/v2/collection-instances/lookup-updates", "POST")
export class GetCollectionInstanceLookupUpdatesRequest implements IReturn<GetCollectionInstanceLookupUpdatesResponse>
{
    public model: CollectionInstance;
    public changes: FieldChange[];
    public context: CollectionInstanceMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetCollectionInstanceLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstanceLookupUpdatesResponse(); }
    public getTypeName() { return 'GetCollectionInstanceLookupUpdatesRequest'; }
}

// @Route("/api/v2/collection-instances/validate", "POST")
export class ValidateCollectionInstanceRequest implements IReturn<ValidateCollectionInstanceResponse>
{
    public model: CollectionInstance;
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<ValidateCollectionInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCollectionInstanceResponse(); }
    public getTypeName() { return 'ValidateCollectionInstanceRequest'; }
}

// @Route("/api/v2/collection-instances/form", "POST")
export class SubmitCollectionInstanceFormRequest implements IReturn<SubmitCollectionInstanceFormResponse>
{
    public model: CollectionInstance;
    public mode: SaveMode;
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<SubmitCollectionInstanceFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCollectionInstanceFormResponse(); }
    public getTypeName() { return 'SubmitCollectionInstanceFormRequest'; }
}

// @Route("/api/v2/countries/metadata", "POST")
export class GetCountryMetadataRequest implements IReturn<GetCountryMetadataResponse>
{
    public model: Country;
    public context: CountryMetadataContext;

    public constructor(init?: Partial<GetCountryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountryMetadataResponse(); }
    public getTypeName() { return 'GetCountryMetadataRequest'; }
}

// @Route("/api/v2/countries/lookup-updates", "POST")
export class GetCountryLookupUpdatesRequest implements IReturn<GetCountryLookupUpdatesResponse>
{
    public model: Country;
    public changes: FieldChange[];
    public context: CountryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetCountryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetCountryLookupUpdatesRequest'; }
}

// @Route("/api/v2/countries/validate", "POST")
export class ValidateCountryRequest implements IReturn<ValidateCountryResponse>
{
    public model: Country;
    public context: CountryMetadataContext;

    public constructor(init?: Partial<ValidateCountryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCountryResponse(); }
    public getTypeName() { return 'ValidateCountryRequest'; }
}

// @Route("/api/v2/countries/form", "POST")
export class SubmitCountryFormRequest implements IReturn<SubmitCountryFormResponse>
{
    public model: Country;
    public mode: SaveMode;
    public context: CountryMetadataContext;

    public constructor(init?: Partial<SubmitCountryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCountryFormResponse(); }
    public getTypeName() { return 'SubmitCountryFormRequest'; }
}

// @Route("/api/v2/departments/metadata", "POST")
export class GetDepartmentMetadataRequest implements IReturn<GetDepartmentMetadataResponse>
{
    public model: Department;
    public context: DepartmentMetadataContext;

    public constructor(init?: Partial<GetDepartmentMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentMetadataResponse(); }
    public getTypeName() { return 'GetDepartmentMetadataRequest'; }
}

// @Route("/api/v2/departments/lookup-updates", "POST")
export class GetDepartmentLookupUpdatesRequest implements IReturn<GetDepartmentLookupUpdatesResponse>
{
    public model: Department;
    public changes: FieldChange[];
    public context: DepartmentMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetDepartmentLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentLookupUpdatesResponse(); }
    public getTypeName() { return 'GetDepartmentLookupUpdatesRequest'; }
}

// @Route("/api/v2/departments/validate", "POST")
export class ValidateDepartmentRequest implements IReturn<ValidateDepartmentResponse>
{
    public model: Department;
    public context: DepartmentMetadataContext;

    public constructor(init?: Partial<ValidateDepartmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateDepartmentResponse(); }
    public getTypeName() { return 'ValidateDepartmentRequest'; }
}

// @Route("/api/v2/departments/form", "POST")
export class SubmitDepartmentFormRequest implements IReturn<SubmitDepartmentFormResponse>
{
    public model: Department;
    public mode: SaveMode;
    public context: DepartmentMetadataContext;

    public constructor(init?: Partial<SubmitDepartmentFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitDepartmentFormResponse(); }
    public getTypeName() { return 'SubmitDepartmentFormRequest'; }
}

// @Route("/api/v2/errors/metadata", "POST")
export class GetErrorMetadataRequest implements IReturn<GetErrorMetadataResponse>
{
    public model: Error;
    public context: ErrorMetadataContext;

    public constructor(init?: Partial<GetErrorMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetErrorMetadataResponse(); }
    public getTypeName() { return 'GetErrorMetadataRequest'; }
}

// @Route("/api/v2/errors/lookup-updates", "POST")
export class GetErrorLookupUpdatesRequest implements IReturn<GetErrorLookupUpdatesResponse>
{
    public model: Error;
    public changes: FieldChange[];
    public context: ErrorMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetErrorLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetErrorLookupUpdatesResponse(); }
    public getTypeName() { return 'GetErrorLookupUpdatesRequest'; }
}

// @Route("/api/v2/errors/validate", "POST")
export class ValidateErrorRequest implements IReturn<ValidateErrorResponse>
{
    public model: Error;
    public context: ErrorMetadataContext;

    public constructor(init?: Partial<ValidateErrorRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateErrorResponse(); }
    public getTypeName() { return 'ValidateErrorRequest'; }
}

// @Route("/api/v2/errors/form", "POST")
export class SubmitErrorFormRequest implements IReturn<SubmitErrorFormResponse>
{
    public model: Error;
    public mode: SaveMode;
    public context: ErrorMetadataContext;

    public constructor(init?: Partial<SubmitErrorFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitErrorFormResponse(); }
    public getTypeName() { return 'SubmitErrorFormRequest'; }
}

// @Route("/api/v2/facility-alliance-members/metadata", "POST")
export class GetFacilityAllianceMemberMetadataRequest implements IReturn<GetFacilityAllianceMemberMetadataResponse>
{
    public model: FacilityAllianceMember;
    public context: FacilityAllianceMemberMetadataContext;

    public constructor(init?: Partial<GetFacilityAllianceMemberMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFacilityAllianceMemberMetadataResponse(); }
    public getTypeName() { return 'GetFacilityAllianceMemberMetadataRequest'; }
}

// @Route("/api/v2/facility-alliance-members/lookup-updates", "POST")
export class GetFacilityAllianceMemberLookupUpdatesRequest implements IReturn<GetFacilityAllianceMemberLookupUpdatesResponse>
{
    public model: FacilityAllianceMember;
    public changes: FieldChange[];
    public context: FacilityAllianceMemberMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFacilityAllianceMemberLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFacilityAllianceMemberLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFacilityAllianceMemberLookupUpdatesRequest'; }
}

// @Route("/api/v2/facility-alliance-members/validate", "POST")
export class ValidateFacilityAllianceMemberRequest implements IReturn<ValidateFacilityAllianceMemberResponse>
{
    public model: FacilityAllianceMember;
    public context: FacilityAllianceMemberMetadataContext;

    public constructor(init?: Partial<ValidateFacilityAllianceMemberRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFacilityAllianceMemberResponse(); }
    public getTypeName() { return 'ValidateFacilityAllianceMemberRequest'; }
}

// @Route("/api/v2/facility-alliance-members/form", "POST")
export class SubmitFacilityAllianceMemberFormRequest implements IReturn<SubmitFacilityAllianceMemberFormResponse>
{
    public model: FacilityAllianceMember;
    public mode: SaveMode;
    public context: FacilityAllianceMemberMetadataContext;

    public constructor(init?: Partial<SubmitFacilityAllianceMemberFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFacilityAllianceMemberFormResponse(); }
    public getTypeName() { return 'SubmitFacilityAllianceMemberFormRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/metadata", "POST")
export class GetFormNextAutoVersionMetadataRequest implements IReturn<GetFormNextAutoVersionMetadataResponse>
{
    public model: FormNextAutoVersion;
    public context: FormNextAutoVersionMetadataContext;

    public constructor(init?: Partial<GetFormNextAutoVersionMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormNextAutoVersionMetadataResponse(); }
    public getTypeName() { return 'GetFormNextAutoVersionMetadataRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/lookup-updates", "POST")
export class GetFormNextAutoVersionLookupUpdatesRequest implements IReturn<GetFormNextAutoVersionLookupUpdatesResponse>
{
    public model: FormNextAutoVersion;
    public changes: FieldChange[];
    public context: FormNextAutoVersionMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFormNextAutoVersionLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormNextAutoVersionLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFormNextAutoVersionLookupUpdatesRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/validate", "POST")
export class ValidateFormNextAutoVersionRequest implements IReturn<ValidateFormNextAutoVersionResponse>
{
    public model: FormNextAutoVersion;
    public context: FormNextAutoVersionMetadataContext;

    public constructor(init?: Partial<ValidateFormNextAutoVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFormNextAutoVersionResponse(); }
    public getTypeName() { return 'ValidateFormNextAutoVersionRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/form", "POST")
export class SubmitFormNextAutoVersionFormRequest implements IReturn<SubmitFormNextAutoVersionFormResponse>
{
    public model: FormNextAutoVersion;
    public mode: SaveMode;
    public context: FormNextAutoVersionMetadataContext;

    public constructor(init?: Partial<SubmitFormNextAutoVersionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFormNextAutoVersionFormResponse(); }
    public getTypeName() { return 'SubmitFormNextAutoVersionFormRequest'; }
}

// @Route("/api/v2/form-templates/metadata", "POST")
export class GetFormTemplateMetadataRequest implements IReturn<GetFormTemplateMetadataResponse>
{
    public model: FormTemplate;
    public context: FormTemplateMetadataContext;

    public constructor(init?: Partial<GetFormTemplateMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateMetadataResponse(); }
    public getTypeName() { return 'GetFormTemplateMetadataRequest'; }
}

// @Route("/api/v2/form-templates/lookup-updates", "POST")
export class GetFormTemplateLookupUpdatesRequest implements IReturn<GetFormTemplateLookupUpdatesResponse>
{
    public model: FormTemplate;
    public changes: FieldChange[];
    public context: FormTemplateMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFormTemplateLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFormTemplateLookupUpdatesRequest'; }
}

// @Route("/api/v2/form-templates/validate", "POST")
export class ValidateFormTemplateRequest implements IReturn<ValidateFormTemplateResponse>
{
    public model: FormTemplate;
    public context: FormTemplateMetadataContext;

    public constructor(init?: Partial<ValidateFormTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFormTemplateResponse(); }
    public getTypeName() { return 'ValidateFormTemplateRequest'; }
}

// @Route("/api/v2/form-templates/form", "POST")
export class SubmitFormTemplateFormRequest implements IReturn<SubmitFormTemplateFormResponse>
{
    public model: FormTemplate;
    public mode: SaveMode;
    public context: FormTemplateMetadataContext;

    public constructor(init?: Partial<SubmitFormTemplateFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFormTemplateFormResponse(); }
    public getTypeName() { return 'SubmitFormTemplateFormRequest'; }
}

// @Route("/api/v2/form-template-categories/metadata", "POST")
export class GetFormTemplateCategoryMetadataRequest implements IReturn<GetFormTemplateCategoryMetadataResponse>
{
    public model: FormTemplateCategory;
    public context: FormTemplateCategoryMetadataContext;

    public constructor(init?: Partial<GetFormTemplateCategoryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateCategoryMetadataResponse(); }
    public getTypeName() { return 'GetFormTemplateCategoryMetadataRequest'; }
}

// @Route("/api/v2/form-template-categories/lookup-updates", "POST")
export class GetFormTemplateCategoryLookupUpdatesRequest implements IReturn<GetFormTemplateCategoryLookupUpdatesResponse>
{
    public model: FormTemplateCategory;
    public changes: FieldChange[];
    public context: FormTemplateCategoryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFormTemplateCategoryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateCategoryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFormTemplateCategoryLookupUpdatesRequest'; }
}

// @Route("/api/v2/form-template-categories/validate", "POST")
export class ValidateFormTemplateCategoryRequest implements IReturn<ValidateFormTemplateCategoryResponse>
{
    public model: FormTemplateCategory;
    public context: FormTemplateCategoryMetadataContext;

    public constructor(init?: Partial<ValidateFormTemplateCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFormTemplateCategoryResponse(); }
    public getTypeName() { return 'ValidateFormTemplateCategoryRequest'; }
}

// @Route("/api/v2/form-template-categories/form", "POST")
export class SubmitFormTemplateCategoryFormRequest implements IReturn<SubmitFormTemplateCategoryFormResponse>
{
    public model: FormTemplateCategory;
    public mode: SaveMode;
    public context: FormTemplateCategoryMetadataContext;

    public constructor(init?: Partial<SubmitFormTemplateCategoryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFormTemplateCategoryFormResponse(); }
    public getTypeName() { return 'SubmitFormTemplateCategoryFormRequest'; }
}

// @Route("/api/v2/form-template-file-types/metadata", "POST")
export class GetFormTemplateFileTypeMetadataRequest implements IReturn<GetFormTemplateFileTypeMetadataResponse>
{
    public model: FormTemplateFileType;
    public context: FormTemplateFileTypeMetadataContext;

    public constructor(init?: Partial<GetFormTemplateFileTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateFileTypeMetadataResponse(); }
    public getTypeName() { return 'GetFormTemplateFileTypeMetadataRequest'; }
}

// @Route("/api/v2/form-template-file-types/lookup-updates", "POST")
export class GetFormTemplateFileTypeLookupUpdatesRequest implements IReturn<GetFormTemplateFileTypeLookupUpdatesResponse>
{
    public model: FormTemplateFileType;
    public changes: FieldChange[];
    public context: FormTemplateFileTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFormTemplateFileTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateFileTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFormTemplateFileTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/form-template-file-types/validate", "POST")
export class ValidateFormTemplateFileTypeRequest implements IReturn<ValidateFormTemplateFileTypeResponse>
{
    public model: FormTemplateFileType;
    public context: FormTemplateFileTypeMetadataContext;

    public constructor(init?: Partial<ValidateFormTemplateFileTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFormTemplateFileTypeResponse(); }
    public getTypeName() { return 'ValidateFormTemplateFileTypeRequest'; }
}

// @Route("/api/v2/form-template-file-types/form", "POST")
export class SubmitFormTemplateFileTypeFormRequest implements IReturn<SubmitFormTemplateFileTypeFormResponse>
{
    public model: FormTemplateFileType;
    public mode: SaveMode;
    public context: FormTemplateFileTypeMetadataContext;

    public constructor(init?: Partial<SubmitFormTemplateFileTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFormTemplateFileTypeFormResponse(); }
    public getTypeName() { return 'SubmitFormTemplateFileTypeFormRequest'; }
}

// @Route("/api/v2/form-template-statuses/metadata", "POST")
export class GetFormTemplateStatusMetadataRequest implements IReturn<GetFormTemplateStatusMetadataResponse>
{
    public model: FormTemplateStatus;
    public context: FormTemplateStatusMetadataContext;

    public constructor(init?: Partial<GetFormTemplateStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateStatusMetadataResponse(); }
    public getTypeName() { return 'GetFormTemplateStatusMetadataRequest'; }
}

// @Route("/api/v2/form-template-statuses/lookup-updates", "POST")
export class GetFormTemplateStatusLookupUpdatesRequest implements IReturn<GetFormTemplateStatusLookupUpdatesResponse>
{
    public model: FormTemplateStatus;
    public changes: FieldChange[];
    public context: FormTemplateStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFormTemplateStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFormTemplateStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/form-template-statuses/validate", "POST")
export class ValidateFormTemplateStatusRequest implements IReturn<ValidateFormTemplateStatusResponse>
{
    public model: FormTemplateStatus;
    public context: FormTemplateStatusMetadataContext;

    public constructor(init?: Partial<ValidateFormTemplateStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFormTemplateStatusResponse(); }
    public getTypeName() { return 'ValidateFormTemplateStatusRequest'; }
}

// @Route("/api/v2/form-template-statuses/form", "POST")
export class SubmitFormTemplateStatusFormRequest implements IReturn<SubmitFormTemplateStatusFormResponse>
{
    public model: FormTemplateStatus;
    public mode: SaveMode;
    public context: FormTemplateStatusMetadataContext;

    public constructor(init?: Partial<SubmitFormTemplateStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFormTemplateStatusFormResponse(); }
    public getTypeName() { return 'SubmitFormTemplateStatusFormRequest'; }
}

// @Route("/api/v2/funding-statuses/metadata", "POST")
export class GetFundingStatusMetadataRequest implements IReturn<GetFundingStatusMetadataResponse>
{
    public model: FundingStatus;
    public context: FundingStatusMetadataContext;

    public constructor(init?: Partial<GetFundingStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFundingStatusMetadataResponse(); }
    public getTypeName() { return 'GetFundingStatusMetadataRequest'; }
}

// @Route("/api/v2/funding-statuses/lookup-updates", "POST")
export class GetFundingStatusLookupUpdatesRequest implements IReturn<GetFundingStatusLookupUpdatesResponse>
{
    public model: FundingStatus;
    public changes: FieldChange[];
    public context: FundingStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetFundingStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFundingStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetFundingStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/funding-statuses/validate", "POST")
export class ValidateFundingStatusRequest implements IReturn<ValidateFundingStatusResponse>
{
    public model: FundingStatus;
    public context: FundingStatusMetadataContext;

    public constructor(init?: Partial<ValidateFundingStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateFundingStatusResponse(); }
    public getTypeName() { return 'ValidateFundingStatusRequest'; }
}

// @Route("/api/v2/funding-statuses/form", "POST")
export class SubmitFundingStatusFormRequest implements IReturn<SubmitFundingStatusFormResponse>
{
    public model: FundingStatus;
    public mode: SaveMode;
    public context: FundingStatusMetadataContext;

    public constructor(init?: Partial<SubmitFundingStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitFundingStatusFormResponse(); }
    public getTypeName() { return 'SubmitFundingStatusFormRequest'; }
}

// @Route("/api/v2/genders/metadata", "POST")
export class GetGenderMetadataRequest implements IReturn<GetGenderMetadataResponse>
{
    public model: Gender;
    public context: GenderMetadataContext;

    public constructor(init?: Partial<GetGenderMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGenderMetadataResponse(); }
    public getTypeName() { return 'GetGenderMetadataRequest'; }
}

// @Route("/api/v2/genders/lookup-updates", "POST")
export class GetGenderLookupUpdatesRequest implements IReturn<GetGenderLookupUpdatesResponse>
{
    public model: Gender;
    public changes: FieldChange[];
    public context: GenderMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetGenderLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGenderLookupUpdatesResponse(); }
    public getTypeName() { return 'GetGenderLookupUpdatesRequest'; }
}

// @Route("/api/v2/genders/validate", "POST")
export class ValidateGenderRequest implements IReturn<ValidateGenderResponse>
{
    public model: Gender;
    public context: GenderMetadataContext;

    public constructor(init?: Partial<ValidateGenderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateGenderResponse(); }
    public getTypeName() { return 'ValidateGenderRequest'; }
}

// @Route("/api/v2/genders/form", "POST")
export class SubmitGenderFormRequest implements IReturn<SubmitGenderFormResponse>
{
    public model: Gender;
    public mode: SaveMode;
    public context: GenderMetadataContext;

    public constructor(init?: Partial<SubmitGenderFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitGenderFormResponse(); }
    public getTypeName() { return 'SubmitGenderFormRequest'; }
}

// @Route("/api/v2/groups/metadata", "POST")
export class GetGroupMetadataRequest implements IReturn<GetGroupMetadataResponse>
{
    public model: Group;
    public context: GroupMetadataContext;

    public constructor(init?: Partial<GetGroupMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupMetadataResponse(); }
    public getTypeName() { return 'GetGroupMetadataRequest'; }
}

// @Route("/api/v2/groups/lookup-updates", "POST")
export class GetGroupLookupUpdatesRequest implements IReturn<GetGroupLookupUpdatesResponse>
{
    public model: Group;
    public changes: FieldChange[];
    public context: GroupMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetGroupLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupLookupUpdatesResponse(); }
    public getTypeName() { return 'GetGroupLookupUpdatesRequest'; }
}

// @Route("/api/v2/groups/validate", "POST")
export class ValidateGroupRequest implements IReturn<ValidateGroupResponse>
{
    public model: Group;
    public context: GroupMetadataContext;

    public constructor(init?: Partial<ValidateGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateGroupResponse(); }
    public getTypeName() { return 'ValidateGroupRequest'; }
}

// @Route("/api/v2/groups/form", "POST")
export class SubmitGroupFormRequest implements IReturn<SubmitGroupFormResponse>
{
    public model: Group;
    public mode: SaveMode;
    public context: GroupMetadataContext;

    public constructor(init?: Partial<SubmitGroupFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitGroupFormResponse(); }
    public getTypeName() { return 'SubmitGroupFormRequest'; }
}

// @Route("/api/v2/group-items/metadata", "POST")
export class GetGroupItemMetadataRequest implements IReturn<GetGroupItemMetadataResponse>
{
    public model: GroupItem;
    public context: GroupItemMetadataContext;

    public constructor(init?: Partial<GetGroupItemMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemMetadataResponse(); }
    public getTypeName() { return 'GetGroupItemMetadataRequest'; }
}

// @Route("/api/v2/group-items/lookup-updates", "POST")
export class GetGroupItemLookupUpdatesRequest implements IReturn<GetGroupItemLookupUpdatesResponse>
{
    public model: GroupItem;
    public changes: FieldChange[];
    public context: GroupItemMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetGroupItemLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemLookupUpdatesResponse(); }
    public getTypeName() { return 'GetGroupItemLookupUpdatesRequest'; }
}

// @Route("/api/v2/group-items/validate", "POST")
export class ValidateGroupItemRequest implements IReturn<ValidateGroupItemResponse>
{
    public model: GroupItem;
    public context: GroupItemMetadataContext;

    public constructor(init?: Partial<ValidateGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateGroupItemResponse(); }
    public getTypeName() { return 'ValidateGroupItemRequest'; }
}

// @Route("/api/v2/group-items/form", "POST")
export class SubmitGroupItemFormRequest implements IReturn<SubmitGroupItemFormResponse>
{
    public model: GroupItem;
    public mode: SaveMode;
    public context: GroupItemMetadataContext;

    public constructor(init?: Partial<SubmitGroupItemFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitGroupItemFormResponse(); }
    public getTypeName() { return 'SubmitGroupItemFormRequest'; }
}

// @Route("/api/v2/group-notes/metadata", "POST")
export class GetGroupNoteMetadataRequest implements IReturn<GetGroupNoteMetadataResponse>
{
    public model: GroupNote;
    public context: GroupNoteMetadataContext;

    public constructor(init?: Partial<GetGroupNoteMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNoteMetadataResponse(); }
    public getTypeName() { return 'GetGroupNoteMetadataRequest'; }
}

// @Route("/api/v2/group-notes/lookup-updates", "POST")
export class GetGroupNoteLookupUpdatesRequest implements IReturn<GetGroupNoteLookupUpdatesResponse>
{
    public model: GroupNote;
    public changes: FieldChange[];
    public context: GroupNoteMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetGroupNoteLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNoteLookupUpdatesResponse(); }
    public getTypeName() { return 'GetGroupNoteLookupUpdatesRequest'; }
}

// @Route("/api/v2/group-notes/validate", "POST")
export class ValidateGroupNoteRequest implements IReturn<ValidateGroupNoteResponse>
{
    public model: GroupNote;
    public context: GroupNoteMetadataContext;

    public constructor(init?: Partial<ValidateGroupNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateGroupNoteResponse(); }
    public getTypeName() { return 'ValidateGroupNoteRequest'; }
}

// @Route("/api/v2/group-notes/form", "POST")
export class SubmitGroupNoteFormRequest implements IReturn<SubmitGroupNoteFormResponse>
{
    public model: GroupNote;
    public mode: SaveMode;
    public context: GroupNoteMetadataContext;

    public constructor(init?: Partial<SubmitGroupNoteFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitGroupNoteFormResponse(); }
    public getTypeName() { return 'SubmitGroupNoteFormRequest'; }
}

// @Route("/api/v2/group-types/metadata", "POST")
export class GetGroupTypeMetadataRequest implements IReturn<GetGroupTypeMetadataResponse>
{
    public model: GroupType;
    public context: GroupTypeMetadataContext;

    public constructor(init?: Partial<GetGroupTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupTypeMetadataResponse(); }
    public getTypeName() { return 'GetGroupTypeMetadataRequest'; }
}

// @Route("/api/v2/group-types/lookup-updates", "POST")
export class GetGroupTypeLookupUpdatesRequest implements IReturn<GetGroupTypeLookupUpdatesResponse>
{
    public model: GroupType;
    public changes: FieldChange[];
    public context: GroupTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetGroupTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetGroupTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/group-types/validate", "POST")
export class ValidateGroupTypeRequest implements IReturn<ValidateGroupTypeResponse>
{
    public model: GroupType;
    public context: GroupTypeMetadataContext;

    public constructor(init?: Partial<ValidateGroupTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateGroupTypeResponse(); }
    public getTypeName() { return 'ValidateGroupTypeRequest'; }
}

// @Route("/api/v2/group-types/form", "POST")
export class SubmitGroupTypeFormRequest implements IReturn<SubmitGroupTypeFormResponse>
{
    public model: GroupType;
    public mode: SaveMode;
    public context: GroupTypeMetadataContext;

    public constructor(init?: Partial<SubmitGroupTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitGroupTypeFormResponse(); }
    public getTypeName() { return 'SubmitGroupTypeFormRequest'; }
}

// @Route("/api/v2/institutions/metadata", "POST")
export class GetInstitutionMetadataRequest implements IReturn<GetInstitutionMetadataResponse>
{
    public model: Institution;
    public context: InstitutionMetadataContext;

    public constructor(init?: Partial<GetInstitutionMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionMetadataResponse(); }
    public getTypeName() { return 'GetInstitutionMetadataRequest'; }
}

// @Route("/api/v2/institutions/lookup-updates", "POST")
export class GetInstitutionLookupUpdatesRequest implements IReturn<GetInstitutionLookupUpdatesResponse>
{
    public model: Institution;
    public changes: FieldChange[];
    public context: InstitutionMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInstitutionLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInstitutionLookupUpdatesRequest'; }
}

// @Route("/api/v2/institutions/validate", "POST")
export class ValidateInstitutionRequest implements IReturn<ValidateInstitutionResponse>
{
    public model: Institution;
    public context: InstitutionMetadataContext;

    public constructor(init?: Partial<ValidateInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInstitutionResponse(); }
    public getTypeName() { return 'ValidateInstitutionRequest'; }
}

// @Route("/api/v2/institutions/form", "POST")
export class SubmitInstitutionFormRequest implements IReturn<SubmitInstitutionFormResponse>
{
    public model: Institution;
    public mode: SaveMode;
    public context: InstitutionMetadataContext;

    public constructor(init?: Partial<SubmitInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInstitutionFormResponse(); }
    public getTypeName() { return 'SubmitInstitutionFormRequest'; }
}

// @Route("/api/v2/institution-codings/metadata", "POST")
export class GetInstitutionCodingMetadataRequest implements IReturn<GetInstitutionCodingMetadataResponse>
{
    public model: InstitutionCoding;
    public context: InstitutionCodingMetadataContext;

    public constructor(init?: Partial<GetInstitutionCodingMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionCodingMetadataResponse(); }
    public getTypeName() { return 'GetInstitutionCodingMetadataRequest'; }
}

// @Route("/api/v2/institution-codings/lookup-updates", "POST")
export class GetInstitutionCodingLookupUpdatesRequest implements IReturn<GetInstitutionCodingLookupUpdatesResponse>
{
    public model: InstitutionCoding;
    public changes: FieldChange[];
    public context: InstitutionCodingMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInstitutionCodingLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionCodingLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInstitutionCodingLookupUpdatesRequest'; }
}

// @Route("/api/v2/institution-codings/validate", "POST")
export class ValidateInstitutionCodingRequest implements IReturn<ValidateInstitutionCodingResponse>
{
    public model: InstitutionCoding;
    public context: InstitutionCodingMetadataContext;

    public constructor(init?: Partial<ValidateInstitutionCodingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInstitutionCodingResponse(); }
    public getTypeName() { return 'ValidateInstitutionCodingRequest'; }
}

// @Route("/api/v2/institution-codings/form", "POST")
export class SubmitInstitutionCodingFormRequest implements IReturn<SubmitInstitutionCodingFormResponse>
{
    public model: InstitutionCoding;
    public mode: SaveMode;
    public context: InstitutionCodingMetadataContext;

    public constructor(init?: Partial<SubmitInstitutionCodingFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInstitutionCodingFormResponse(); }
    public getTypeName() { return 'SubmitInstitutionCodingFormRequest'; }
}

// @Route("/api/v2/institution-forms/metadata", "POST")
export class GetInstitutionFormMetadataRequest implements IReturn<GetInstitutionFormMetadataResponse>
{
    public model: InstitutionForm;
    public context: InstitutionFormMetadataContext;

    public constructor(init?: Partial<GetInstitutionFormMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormMetadataResponse(); }
    public getTypeName() { return 'GetInstitutionFormMetadataRequest'; }
}

// @Route("/api/v2/institution-forms/lookup-updates", "POST")
export class GetInstitutionFormLookupUpdatesRequest implements IReturn<GetInstitutionFormLookupUpdatesResponse>
{
    public model: InstitutionForm;
    public changes: FieldChange[];
    public context: InstitutionFormMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInstitutionFormLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInstitutionFormLookupUpdatesRequest'; }
}

// @Route("/api/v2/institution-forms/validate", "POST")
export class ValidateInstitutionFormRequest implements IReturn<ValidateInstitutionFormResponse>
{
    public model: InstitutionForm;
    public context: InstitutionFormMetadataContext;

    public constructor(init?: Partial<ValidateInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInstitutionFormResponse(); }
    public getTypeName() { return 'ValidateInstitutionFormRequest'; }
}

// @Route("/api/v2/institution-forms/form", "POST")
export class SubmitInstitutionFormFormRequest implements IReturn<SubmitInstitutionFormFormResponse>
{
    public model: InstitutionForm;
    public mode: SaveMode;
    public context: InstitutionFormMetadataContext;

    public constructor(init?: Partial<SubmitInstitutionFormFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInstitutionFormFormResponse(); }
    public getTypeName() { return 'SubmitInstitutionFormFormRequest'; }
}

// @Route("/api/v2/institution-notes/metadata", "POST")
export class GetInstitutionNoteMetadataRequest implements IReturn<GetInstitutionNoteMetadataResponse>
{
    public model: InstitutionNote;
    public context: InstitutionNoteMetadataContext;

    public constructor(init?: Partial<GetInstitutionNoteMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNoteMetadataResponse(); }
    public getTypeName() { return 'GetInstitutionNoteMetadataRequest'; }
}

// @Route("/api/v2/institution-notes/lookup-updates", "POST")
export class GetInstitutionNoteLookupUpdatesRequest implements IReturn<GetInstitutionNoteLookupUpdatesResponse>
{
    public model: InstitutionNote;
    public changes: FieldChange[];
    public context: InstitutionNoteMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInstitutionNoteLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNoteLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInstitutionNoteLookupUpdatesRequest'; }
}

// @Route("/api/v2/institution-notes/validate", "POST")
export class ValidateInstitutionNoteRequest implements IReturn<ValidateInstitutionNoteResponse>
{
    public model: InstitutionNote;
    public context: InstitutionNoteMetadataContext;

    public constructor(init?: Partial<ValidateInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInstitutionNoteResponse(); }
    public getTypeName() { return 'ValidateInstitutionNoteRequest'; }
}

// @Route("/api/v2/institution-notes/form", "POST")
export class SubmitInstitutionNoteFormRequest implements IReturn<SubmitInstitutionNoteFormResponse>
{
    public model: InstitutionNote;
    public mode: SaveMode;
    public context: InstitutionNoteMetadataContext;

    public constructor(init?: Partial<SubmitInstitutionNoteFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInstitutionNoteFormResponse(); }
    public getTypeName() { return 'SubmitInstitutionNoteFormRequest'; }
}

// @Route("/api/v2/institution-types/metadata", "POST")
export class GetInstitutionTypeMetadataRequest implements IReturn<GetInstitutionTypeMetadataResponse>
{
    public model: InstitutionType;
    public context: InstitutionTypeMetadataContext;

    public constructor(init?: Partial<GetInstitutionTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionTypeMetadataResponse(); }
    public getTypeName() { return 'GetInstitutionTypeMetadataRequest'; }
}

// @Route("/api/v2/institution-types/lookup-updates", "POST")
export class GetInstitutionTypeLookupUpdatesRequest implements IReturn<GetInstitutionTypeLookupUpdatesResponse>
{
    public model: InstitutionType;
    public changes: FieldChange[];
    public context: InstitutionTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInstitutionTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInstitutionTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/institution-types/validate", "POST")
export class ValidateInstitutionTypeRequest implements IReturn<ValidateInstitutionTypeResponse>
{
    public model: InstitutionType;
    public context: InstitutionTypeMetadataContext;

    public constructor(init?: Partial<ValidateInstitutionTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInstitutionTypeResponse(); }
    public getTypeName() { return 'ValidateInstitutionTypeRequest'; }
}

// @Route("/api/v2/institution-types/form", "POST")
export class SubmitInstitutionTypeFormRequest implements IReturn<SubmitInstitutionTypeFormResponse>
{
    public model: InstitutionType;
    public mode: SaveMode;
    public context: InstitutionTypeMetadataContext;

    public constructor(init?: Partial<SubmitInstitutionTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInstitutionTypeFormResponse(); }
    public getTypeName() { return 'SubmitInstitutionTypeFormRequest'; }
}

// @Route("/api/v2/interests/metadata", "POST")
export class GetInterestMetadataRequest implements IReturn<GetInterestMetadataResponse>
{
    public model: Interest;
    public context: InterestMetadataContext;

    public constructor(init?: Partial<GetInterestMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInterestMetadataResponse(); }
    public getTypeName() { return 'GetInterestMetadataRequest'; }
}

// @Route("/api/v2/interests/lookup-updates", "POST")
export class GetInterestLookupUpdatesRequest implements IReturn<GetInterestLookupUpdatesResponse>
{
    public model: Interest;
    public changes: FieldChange[];
    public context: InterestMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInterestLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInterestLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInterestLookupUpdatesRequest'; }
}

// @Route("/api/v2/interests/validate", "POST")
export class ValidateInterestRequest implements IReturn<ValidateInterestResponse>
{
    public model: Interest;
    public context: InterestMetadataContext;

    public constructor(init?: Partial<ValidateInterestRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInterestResponse(); }
    public getTypeName() { return 'ValidateInterestRequest'; }
}

// @Route("/api/v2/interests/form", "POST")
export class SubmitInterestFormRequest implements IReturn<SubmitInterestFormResponse>
{
    public model: Interest;
    public mode: SaveMode;
    public context: InterestMetadataContext;

    public constructor(init?: Partial<SubmitInterestFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInterestFormResponse(); }
    public getTypeName() { return 'SubmitInterestFormRequest'; }
}

// @Route("/api/v2/international-trial-statuses/metadata", "POST")
export class GetInternationalTrialStatusMetadataRequest implements IReturn<GetInternationalTrialStatusMetadataResponse>
{
    public model: InternationalTrialStatus;
    public context: InternationalTrialStatusMetadataContext;

    public constructor(init?: Partial<GetInternationalTrialStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInternationalTrialStatusMetadataResponse(); }
    public getTypeName() { return 'GetInternationalTrialStatusMetadataRequest'; }
}

// @Route("/api/v2/international-trial-statuses/lookup-updates", "POST")
export class GetInternationalTrialStatusLookupUpdatesRequest implements IReturn<GetInternationalTrialStatusLookupUpdatesResponse>
{
    public model: InternationalTrialStatus;
    public changes: FieldChange[];
    public context: InternationalTrialStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInternationalTrialStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInternationalTrialStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInternationalTrialStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/international-trial-statuses/validate", "POST")
export class ValidateInternationalTrialStatusRequest implements IReturn<ValidateInternationalTrialStatusResponse>
{
    public model: InternationalTrialStatus;
    public context: InternationalTrialStatusMetadataContext;

    public constructor(init?: Partial<ValidateInternationalTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInternationalTrialStatusResponse(); }
    public getTypeName() { return 'ValidateInternationalTrialStatusRequest'; }
}

// @Route("/api/v2/international-trial-statuses/form", "POST")
export class SubmitInternationalTrialStatusFormRequest implements IReturn<SubmitInternationalTrialStatusFormResponse>
{
    public model: InternationalTrialStatus;
    public mode: SaveMode;
    public context: InternationalTrialStatusMetadataContext;

    public constructor(init?: Partial<SubmitInternationalTrialStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInternationalTrialStatusFormResponse(); }
    public getTypeName() { return 'SubmitInternationalTrialStatusFormRequest'; }
}

// @Route("/api/v2/involvements/metadata", "POST")
export class GetInvolvementMetadataRequest implements IReturn<GetInvolvementMetadataResponse>
{
    public model: Involvement;
    public context: InvolvementMetadataContext;

    public constructor(init?: Partial<GetInvolvementMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInvolvementMetadataResponse(); }
    public getTypeName() { return 'GetInvolvementMetadataRequest'; }
}

// @Route("/api/v2/involvements/lookup-updates", "POST")
export class GetInvolvementLookupUpdatesRequest implements IReturn<GetInvolvementLookupUpdatesResponse>
{
    public model: Involvement;
    public changes: FieldChange[];
    public context: InvolvementMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetInvolvementLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInvolvementLookupUpdatesResponse(); }
    public getTypeName() { return 'GetInvolvementLookupUpdatesRequest'; }
}

// @Route("/api/v2/involvements/validate", "POST")
export class ValidateInvolvementRequest implements IReturn<ValidateInvolvementResponse>
{
    public model: Involvement;
    public context: InvolvementMetadataContext;

    public constructor(init?: Partial<ValidateInvolvementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateInvolvementResponse(); }
    public getTypeName() { return 'ValidateInvolvementRequest'; }
}

// @Route("/api/v2/involvements/form", "POST")
export class SubmitInvolvementFormRequest implements IReturn<SubmitInvolvementFormResponse>
{
    public model: Involvement;
    public mode: SaveMode;
    public context: InvolvementMetadataContext;

    public constructor(init?: Partial<SubmitInvolvementFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitInvolvementFormResponse(); }
    public getTypeName() { return 'SubmitInvolvementFormRequest'; }
}

// @Route("/api/v2/item-components/metadata", "POST")
export class GetItemComponentMetadataRequest implements IReturn<GetItemComponentMetadataResponse>
{
    public model: ItemComponent;
    public context: ItemComponentMetadataContext;

    public constructor(init?: Partial<GetItemComponentMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentMetadataResponse(); }
    public getTypeName() { return 'GetItemComponentMetadataRequest'; }
}

// @Route("/api/v2/item-components/lookup-updates", "POST")
export class GetItemComponentLookupUpdatesRequest implements IReturn<GetItemComponentLookupUpdatesResponse>
{
    public model: ItemComponent;
    public changes: FieldChange[];
    public context: ItemComponentMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetItemComponentLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentLookupUpdatesResponse(); }
    public getTypeName() { return 'GetItemComponentLookupUpdatesRequest'; }
}

// @Route("/api/v2/item-components/validate", "POST")
export class ValidateItemComponentRequest implements IReturn<ValidateItemComponentResponse>
{
    public model: ItemComponent;
    public context: ItemComponentMetadataContext;

    public constructor(init?: Partial<ValidateItemComponentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateItemComponentResponse(); }
    public getTypeName() { return 'ValidateItemComponentRequest'; }
}

// @Route("/api/v2/item-components/form", "POST")
export class SubmitItemComponentFormRequest implements IReturn<SubmitItemComponentFormResponse>
{
    public model: ItemComponent;
    public mode: SaveMode;
    public context: ItemComponentMetadataContext;

    public constructor(init?: Partial<SubmitItemComponentFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitItemComponentFormResponse(); }
    public getTypeName() { return 'SubmitItemComponentFormRequest'; }
}

// @Route("/api/v2/item-component-types/metadata", "POST")
export class GetItemComponentTypeMetadataRequest implements IReturn<GetItemComponentTypeMetadataResponse>
{
    public model: ItemComponentType;
    public context: ItemComponentTypeMetadataContext;

    public constructor(init?: Partial<GetItemComponentTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentTypeMetadataResponse(); }
    public getTypeName() { return 'GetItemComponentTypeMetadataRequest'; }
}

// @Route("/api/v2/item-component-types/lookup-updates", "POST")
export class GetItemComponentTypeLookupUpdatesRequest implements IReturn<GetItemComponentTypeLookupUpdatesResponse>
{
    public model: ItemComponentType;
    public changes: FieldChange[];
    public context: ItemComponentTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetItemComponentTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetItemComponentTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/item-component-types/validate", "POST")
export class ValidateItemComponentTypeRequest implements IReturn<ValidateItemComponentTypeResponse>
{
    public model: ItemComponentType;
    public context: ItemComponentTypeMetadataContext;

    public constructor(init?: Partial<ValidateItemComponentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateItemComponentTypeResponse(); }
    public getTypeName() { return 'ValidateItemComponentTypeRequest'; }
}

// @Route("/api/v2/item-component-types/form", "POST")
export class SubmitItemComponentTypeFormRequest implements IReturn<SubmitItemComponentTypeFormResponse>
{
    public model: ItemComponentType;
    public mode: SaveMode;
    public context: ItemComponentTypeMetadataContext;

    public constructor(init?: Partial<SubmitItemComponentTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitItemComponentTypeFormResponse(); }
    public getTypeName() { return 'SubmitItemComponentTypeFormRequest'; }
}

// @Route("/api/v2/measurements/metadata", "POST")
export class GetMeasurementMetadataRequest implements IReturn<GetMeasurementMetadataResponse>
{
    public model: Measurement;
    public context: MeasurementMetadataContext;

    public constructor(init?: Partial<GetMeasurementMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMeasurementMetadataResponse(); }
    public getTypeName() { return 'GetMeasurementMetadataRequest'; }
}

// @Route("/api/v2/measurements/lookup-updates", "POST")
export class GetMeasurementLookupUpdatesRequest implements IReturn<GetMeasurementLookupUpdatesResponse>
{
    public model: Measurement;
    public changes: FieldChange[];
    public context: MeasurementMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetMeasurementLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMeasurementLookupUpdatesResponse(); }
    public getTypeName() { return 'GetMeasurementLookupUpdatesRequest'; }
}

// @Route("/api/v2/measurements/validate", "POST")
export class ValidateMeasurementRequest implements IReturn<ValidateMeasurementResponse>
{
    public model: Measurement;
    public context: MeasurementMetadataContext;

    public constructor(init?: Partial<ValidateMeasurementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateMeasurementResponse(); }
    public getTypeName() { return 'ValidateMeasurementRequest'; }
}

// @Route("/api/v2/measurements/form", "POST")
export class SubmitMeasurementFormRequest implements IReturn<SubmitMeasurementFormResponse>
{
    public model: Measurement;
    public mode: SaveMode;
    public context: MeasurementMetadataContext;

    public constructor(init?: Partial<SubmitMeasurementFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitMeasurementFormResponse(); }
    public getTypeName() { return 'SubmitMeasurementFormRequest'; }
}

// @Route("/api/v2/membership-types/metadata", "POST")
export class GetMembershipTypeMetadataRequest implements IReturn<GetMembershipTypeMetadataResponse>
{
    public model: MembershipType;
    public context: MembershipTypeMetadataContext;

    public constructor(init?: Partial<GetMembershipTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMembershipTypeMetadataResponse(); }
    public getTypeName() { return 'GetMembershipTypeMetadataRequest'; }
}

// @Route("/api/v2/membership-types/lookup-updates", "POST")
export class GetMembershipTypeLookupUpdatesRequest implements IReturn<GetMembershipTypeLookupUpdatesResponse>
{
    public model: MembershipType;
    public changes: FieldChange[];
    public context: MembershipTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetMembershipTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMembershipTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetMembershipTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/membership-types/validate", "POST")
export class ValidateMembershipTypeRequest implements IReturn<ValidateMembershipTypeResponse>
{
    public model: MembershipType;
    public context: MembershipTypeMetadataContext;

    public constructor(init?: Partial<ValidateMembershipTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateMembershipTypeResponse(); }
    public getTypeName() { return 'ValidateMembershipTypeRequest'; }
}

// @Route("/api/v2/membership-types/form", "POST")
export class SubmitMembershipTypeFormRequest implements IReturn<SubmitMembershipTypeFormResponse>
{
    public model: MembershipType;
    public mode: SaveMode;
    public context: MembershipTypeMetadataContext;

    public constructor(init?: Partial<SubmitMembershipTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitMembershipTypeFormResponse(); }
    public getTypeName() { return 'SubmitMembershipTypeFormRequest'; }
}

// @Route("/api/v2/note-types/metadata", "POST")
export class GetNoteTypeMetadataRequest implements IReturn<GetNoteTypeMetadataResponse>
{
    public model: NoteType;
    public context: NoteTypeMetadataContext;

    public constructor(init?: Partial<GetNoteTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetNoteTypeMetadataResponse(); }
    public getTypeName() { return 'GetNoteTypeMetadataRequest'; }
}

// @Route("/api/v2/note-types/lookup-updates", "POST")
export class GetNoteTypeLookupUpdatesRequest implements IReturn<GetNoteTypeLookupUpdatesResponse>
{
    public model: NoteType;
    public changes: FieldChange[];
    public context: NoteTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetNoteTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetNoteTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetNoteTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/note-types/validate", "POST")
export class ValidateNoteTypeRequest implements IReturn<ValidateNoteTypeResponse>
{
    public model: NoteType;
    public context: NoteTypeMetadataContext;

    public constructor(init?: Partial<ValidateNoteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateNoteTypeResponse(); }
    public getTypeName() { return 'ValidateNoteTypeRequest'; }
}

// @Route("/api/v2/note-types/form", "POST")
export class SubmitNoteTypeFormRequest implements IReturn<SubmitNoteTypeFormResponse>
{
    public model: NoteType;
    public mode: SaveMode;
    public context: NoteTypeMetadataContext;

    public constructor(init?: Partial<SubmitNoteTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitNoteTypeFormResponse(); }
    public getTypeName() { return 'SubmitNoteTypeFormRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/metadata", "POST")
export class GetOpenClinicaUserRoleMetadataRequest implements IReturn<GetOpenClinicaUserRoleMetadataResponse>
{
    public model: OpenClinicaUserRole;
    public context: OpenClinicaUserRoleMetadataContext;

    public constructor(init?: Partial<GetOpenClinicaUserRoleMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRoleMetadataResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRoleMetadataRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/lookup-updates", "POST")
export class GetOpenClinicaUserRoleLookupUpdatesRequest implements IReturn<GetOpenClinicaUserRoleLookupUpdatesResponse>
{
    public model: OpenClinicaUserRole;
    public changes: FieldChange[];
    public context: OpenClinicaUserRoleMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetOpenClinicaUserRoleLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRoleLookupUpdatesResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRoleLookupUpdatesRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/validate", "POST")
export class ValidateOpenClinicaUserRoleRequest implements IReturn<ValidateOpenClinicaUserRoleResponse>
{
    public model: OpenClinicaUserRole;
    public context: OpenClinicaUserRoleMetadataContext;

    public constructor(init?: Partial<ValidateOpenClinicaUserRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateOpenClinicaUserRoleResponse(); }
    public getTypeName() { return 'ValidateOpenClinicaUserRoleRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/form", "POST")
export class SubmitOpenClinicaUserRoleFormRequest implements IReturn<SubmitOpenClinicaUserRoleFormResponse>
{
    public model: OpenClinicaUserRole;
    public mode: SaveMode;
    public context: OpenClinicaUserRoleMetadataContext;

    public constructor(init?: Partial<SubmitOpenClinicaUserRoleFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitOpenClinicaUserRoleFormResponse(); }
    public getTypeName() { return 'SubmitOpenClinicaUserRoleFormRequest'; }
}

// @Route("/api/v2/patients/metadata", "POST")
export class GetPatientMetadataRequest implements IReturn<GetPatientMetadataResponse>
{
    public model: Patient;
    public context: PatientMetadataContext;

    public constructor(init?: Partial<GetPatientMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientMetadataResponse(); }
    public getTypeName() { return 'GetPatientMetadataRequest'; }
}

// @Route("/api/v2/patients/lookup-updates", "POST")
export class GetPatientLookupUpdatesRequest implements IReturn<GetPatientLookupUpdatesResponse>
{
    public model: Patient;
    public changes: FieldChange[];
    public context: PatientMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPatientLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPatientLookupUpdatesRequest'; }
}

// @Route("/api/v2/patients/validate", "POST")
export class ValidatePatientRequest implements IReturn<ValidatePatientResponse>
{
    public model: Patient;
    public context: PatientMetadataContext;

    public constructor(init?: Partial<ValidatePatientRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePatientResponse(); }
    public getTypeName() { return 'ValidatePatientRequest'; }
}

// @Route("/api/v2/patients/form", "POST")
export class SubmitPatientFormRequest implements IReturn<SubmitPatientFormResponse>
{
    public model: Patient;
    public mode: SaveMode;
    public context: PatientMetadataContext;

    public constructor(init?: Partial<SubmitPatientFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPatientFormResponse(); }
    public getTypeName() { return 'SubmitPatientFormRequest'; }
}

// @Route("/api/v2/permission-configurations/metadata", "POST")
export class GetPermissionConfigurationMetadataRequest implements IReturn<GetPermissionConfigurationMetadataResponse>
{
    public model: PermissionConfiguration;
    public context: PermissionConfigurationMetadataContext;

    public constructor(init?: Partial<GetPermissionConfigurationMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPermissionConfigurationMetadataResponse(); }
    public getTypeName() { return 'GetPermissionConfigurationMetadataRequest'; }
}

// @Route("/api/v2/permission-configurations/lookup-updates", "POST")
export class GetPermissionConfigurationLookupUpdatesRequest implements IReturn<GetPermissionConfigurationLookupUpdatesResponse>
{
    public model: PermissionConfiguration;
    public changes: FieldChange[];
    public context: PermissionConfigurationMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPermissionConfigurationLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPermissionConfigurationLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPermissionConfigurationLookupUpdatesRequest'; }
}

// @Route("/api/v2/permission-configurations/validate", "POST")
export class ValidatePermissionConfigurationRequest implements IReturn<ValidatePermissionConfigurationResponse>
{
    public model: PermissionConfiguration;
    public context: PermissionConfigurationMetadataContext;

    public constructor(init?: Partial<ValidatePermissionConfigurationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePermissionConfigurationResponse(); }
    public getTypeName() { return 'ValidatePermissionConfigurationRequest'; }
}

// @Route("/api/v2/permission-configurations/form", "POST")
export class SubmitPermissionConfigurationFormRequest implements IReturn<SubmitPermissionConfigurationFormResponse>
{
    public model: PermissionConfiguration;
    public mode: SaveMode;
    public context: PermissionConfigurationMetadataContext;

    public constructor(init?: Partial<SubmitPermissionConfigurationFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPermissionConfigurationFormResponse(); }
    public getTypeName() { return 'SubmitPermissionConfigurationFormRequest'; }
}

// @Route("/api/v2/personnel/metadata", "POST")
export class GetPersonnelMetadataRequest implements IReturn<GetPersonnelMetadataResponse>
{
    public model: Personnel;
    public context: PersonnelMetadataContext;

    public constructor(init?: Partial<GetPersonnelMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelMetadataResponse(); }
    public getTypeName() { return 'GetPersonnelMetadataRequest'; }
}

// @Route("/api/v2/personnel/lookup-updates", "POST")
export class GetPersonnelLookupUpdatesRequest implements IReturn<GetPersonnelLookupUpdatesResponse>
{
    public model: Personnel;
    public changes: FieldChange[];
    public context: PersonnelMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPersonnelLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPersonnelLookupUpdatesRequest'; }
}

// @Route("/api/v2/personnel/validate", "POST")
export class ValidatePersonnelRequest implements IReturn<ValidatePersonnelResponse>
{
    public model: Personnel;
    public context: PersonnelMetadataContext;

    public constructor(init?: Partial<ValidatePersonnelRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePersonnelResponse(); }
    public getTypeName() { return 'ValidatePersonnelRequest'; }
}

// @Route("/api/v2/personnel/form", "POST")
export class SubmitPersonnelFormRequest implements IReturn<SubmitPersonnelFormResponse>
{
    public model: Personnel;
    public mode: SaveMode;
    public context: PersonnelMetadataContext;

    public constructor(init?: Partial<SubmitPersonnelFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPersonnelFormResponse(); }
    public getTypeName() { return 'SubmitPersonnelFormRequest'; }
}

// @Route("/api/v2/personnel-notes/metadata", "POST")
export class GetPersonnelNoteMetadataRequest implements IReturn<GetPersonnelNoteMetadataResponse>
{
    public model: PersonnelNote;
    public context: PersonnelNoteMetadataContext;

    public constructor(init?: Partial<GetPersonnelNoteMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNoteMetadataResponse(); }
    public getTypeName() { return 'GetPersonnelNoteMetadataRequest'; }
}

// @Route("/api/v2/personnel-notes/lookup-updates", "POST")
export class GetPersonnelNoteLookupUpdatesRequest implements IReturn<GetPersonnelNoteLookupUpdatesResponse>
{
    public model: PersonnelNote;
    public changes: FieldChange[];
    public context: PersonnelNoteMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPersonnelNoteLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNoteLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPersonnelNoteLookupUpdatesRequest'; }
}

// @Route("/api/v2/personnel-notes/validate", "POST")
export class ValidatePersonnelNoteRequest implements IReturn<ValidatePersonnelNoteResponse>
{
    public model: PersonnelNote;
    public context: PersonnelNoteMetadataContext;

    public constructor(init?: Partial<ValidatePersonnelNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePersonnelNoteResponse(); }
    public getTypeName() { return 'ValidatePersonnelNoteRequest'; }
}

// @Route("/api/v2/personnel-notes/form", "POST")
export class SubmitPersonnelNoteFormRequest implements IReturn<SubmitPersonnelNoteFormResponse>
{
    public model: PersonnelNote;
    public mode: SaveMode;
    public context: PersonnelNoteMetadataContext;

    public constructor(init?: Partial<SubmitPersonnelNoteFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPersonnelNoteFormResponse(); }
    public getTypeName() { return 'SubmitPersonnelNoteFormRequest'; }
}

// @Route("/api/v2/personnel-roles/metadata", "POST")
export class GetPersonnelRoleMetadataRequest implements IReturn<GetPersonnelRoleMetadataResponse>
{
    public model: PersonnelRole;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<GetPersonnelRoleMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleMetadataResponse(); }
    public getTypeName() { return 'GetPersonnelRoleMetadataRequest'; }
}

// @Route("/api/v2/personnel-roles/lookup-updates", "POST")
export class GetPersonnelRoleLookupUpdatesRequest implements IReturn<GetPersonnelRoleLookupUpdatesResponse>
{
    public model: PersonnelRole;
    public changes: FieldChange[];
    public context: PersonnelRoleMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPersonnelRoleLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleLookupUpdatesRequest'; }
}

// @Route("/api/v2/personnel-roles/validate", "POST")
export class ValidatePersonnelRoleRequest implements IReturn<ValidatePersonnelRoleResponse>
{
    public model: PersonnelRole;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<ValidatePersonnelRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePersonnelRoleResponse(); }
    public getTypeName() { return 'ValidatePersonnelRoleRequest'; }
}

// @Route("/api/v2/personnel-roles/form", "POST")
export class SubmitPersonnelRoleFormRequest implements IReturn<SubmitPersonnelRoleFormResponse>
{
    public model: PersonnelRole;
    public mode: SaveMode;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<SubmitPersonnelRoleFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPersonnelRoleFormResponse(); }
    public getTypeName() { return 'SubmitPersonnelRoleFormRequest'; }
}

// @Route("/api/v2/personnel-role-creates/initialize", "POST")
export class InitializePersonnelRoleCreateRequest implements IReturn<InitializePersonnelRoleCreateResponse>, IPost
{
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<InitializePersonnelRoleCreateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePersonnelRoleCreateResponse(); }
    public getTypeName() { return 'InitializePersonnelRoleCreateRequest'; }
}

// @Route("/api/v2/personnel-role-creates/metadata", "POST")
export class GetPersonnelRoleCreateMetadataRequest implements IReturn<GetPersonnelRoleCreateMetadataResponse>, IPost
{
    public model: PersonnelRoleCreate;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<GetPersonnelRoleCreateMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleCreateMetadataResponse(); }
    public getTypeName() { return 'GetPersonnelRoleCreateMetadataRequest'; }
}

// @Route("/api/v2/personnel-role-creates/lookup-updates", "POST")
export class GetPersonnelRoleCreateLookupUpdatesRequest implements IReturn<GetPersonnelRoleCreateLookupUpdatesResponse>, IPost
{
    public model: PersonnelRoleCreate;
    public changes: FieldChange[];
    public context: PersonnelRoleMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetPersonnelRoleCreateLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleCreateLookupUpdatesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleCreateLookupUpdatesRequest'; }
}

// @Route("/api/v2/personnel-role-creates/validate", "POST")
export class ValidatePersonnelRoleCreateRequest implements IReturn<ValidatePersonnelRoleCreateResponse>, IPost
{
    public model: PersonnelRoleCreate;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<ValidatePersonnelRoleCreateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidatePersonnelRoleCreateResponse(); }
    public getTypeName() { return 'ValidatePersonnelRoleCreateRequest'; }
}

// @Route("/api/v2/personnel-role-creates/submit", "POST")
export class SubmitPersonnelRoleCreateFormRequest implements IReturn<SubmitPersonnelRoleCreateFormResponse>, IPost
{
    public model: PersonnelRoleCreate;
    public mode: SaveMode;
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<SubmitPersonnelRoleCreateFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitPersonnelRoleCreateFormResponse(); }
    public getTypeName() { return 'SubmitPersonnelRoleCreateFormRequest'; }
}

// @Route("/api/v2/professional-disciplines/metadata", "POST")
export class GetProfessionalDisciplineMetadataRequest implements IReturn<GetProfessionalDisciplineMetadataResponse>
{
    public model: ProfessionalDiscipline;
    public context: ProfessionalDisciplineMetadataContext;

    public constructor(init?: Partial<GetProfessionalDisciplineMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetProfessionalDisciplineMetadataResponse(); }
    public getTypeName() { return 'GetProfessionalDisciplineMetadataRequest'; }
}

// @Route("/api/v2/professional-disciplines/lookup-updates", "POST")
export class GetProfessionalDisciplineLookupUpdatesRequest implements IReturn<GetProfessionalDisciplineLookupUpdatesResponse>
{
    public model: ProfessionalDiscipline;
    public changes: FieldChange[];
    public context: ProfessionalDisciplineMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetProfessionalDisciplineLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetProfessionalDisciplineLookupUpdatesResponse(); }
    public getTypeName() { return 'GetProfessionalDisciplineLookupUpdatesRequest'; }
}

// @Route("/api/v2/professional-disciplines/validate", "POST")
export class ValidateProfessionalDisciplineRequest implements IReturn<ValidateProfessionalDisciplineResponse>
{
    public model: ProfessionalDiscipline;
    public context: ProfessionalDisciplineMetadataContext;

    public constructor(init?: Partial<ValidateProfessionalDisciplineRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateProfessionalDisciplineResponse(); }
    public getTypeName() { return 'ValidateProfessionalDisciplineRequest'; }
}

// @Route("/api/v2/professional-disciplines/form", "POST")
export class SubmitProfessionalDisciplineFormRequest implements IReturn<SubmitProfessionalDisciplineFormResponse>
{
    public model: ProfessionalDiscipline;
    public mode: SaveMode;
    public context: ProfessionalDisciplineMetadataContext;

    public constructor(init?: Partial<SubmitProfessionalDisciplineFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitProfessionalDisciplineFormResponse(); }
    public getTypeName() { return 'SubmitProfessionalDisciplineFormRequest'; }
}

// @Route("/api/v2/reporting-tags/metadata", "POST")
export class GetReportingTagMetadataRequest implements IReturn<GetReportingTagMetadataResponse>
{
    public model: ReportingTag;
    public context: ReportingTagMetadataContext;

    public constructor(init?: Partial<GetReportingTagMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagMetadataResponse(); }
    public getTypeName() { return 'GetReportingTagMetadataRequest'; }
}

// @Route("/api/v2/reporting-tags/lookup-updates", "POST")
export class GetReportingTagLookupUpdatesRequest implements IReturn<GetReportingTagLookupUpdatesResponse>
{
    public model: ReportingTag;
    public changes: FieldChange[];
    public context: ReportingTagMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetReportingTagLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagLookupUpdatesResponse(); }
    public getTypeName() { return 'GetReportingTagLookupUpdatesRequest'; }
}

// @Route("/api/v2/reporting-tags/validate", "POST")
export class ValidateReportingTagRequest implements IReturn<ValidateReportingTagResponse>
{
    public model: ReportingTag;
    public context: ReportingTagMetadataContext;

    public constructor(init?: Partial<ValidateReportingTagRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateReportingTagResponse(); }
    public getTypeName() { return 'ValidateReportingTagRequest'; }
}

// @Route("/api/v2/reporting-tags/form", "POST")
export class SubmitReportingTagFormRequest implements IReturn<SubmitReportingTagFormResponse>
{
    public model: ReportingTag;
    public mode: SaveMode;
    public context: ReportingTagMetadataContext;

    public constructor(init?: Partial<SubmitReportingTagFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitReportingTagFormResponse(); }
    public getTypeName() { return 'SubmitReportingTagFormRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/metadata", "POST")
export class GetReportingTagCategoryMetadataRequest implements IReturn<GetReportingTagCategoryMetadataResponse>
{
    public model: ReportingTagCategory;
    public context: ReportingTagCategoryMetadataContext;

    public constructor(init?: Partial<GetReportingTagCategoryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagCategoryMetadataResponse(); }
    public getTypeName() { return 'GetReportingTagCategoryMetadataRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/lookup-updates", "POST")
export class GetReportingTagCategoryLookupUpdatesRequest implements IReturn<GetReportingTagCategoryLookupUpdatesResponse>
{
    public model: ReportingTagCategory;
    public changes: FieldChange[];
    public context: ReportingTagCategoryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetReportingTagCategoryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagCategoryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetReportingTagCategoryLookupUpdatesRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/validate", "POST")
export class ValidateReportingTagCategoryRequest implements IReturn<ValidateReportingTagCategoryResponse>
{
    public model: ReportingTagCategory;
    public context: ReportingTagCategoryMetadataContext;

    public constructor(init?: Partial<ValidateReportingTagCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateReportingTagCategoryResponse(); }
    public getTypeName() { return 'ValidateReportingTagCategoryRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/form", "POST")
export class SubmitReportingTagCategoryFormRequest implements IReturn<SubmitReportingTagCategoryFormResponse>
{
    public model: ReportingTagCategory;
    public mode: SaveMode;
    public context: ReportingTagCategoryMetadataContext;

    public constructor(init?: Partial<SubmitReportingTagCategoryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitReportingTagCategoryFormResponse(); }
    public getTypeName() { return 'SubmitReportingTagCategoryFormRequest'; }
}

// @Route("/api/v2/reporting-tag-types/metadata", "POST")
export class GetReportingTagTypeMetadataRequest implements IReturn<GetReportingTagTypeMetadataResponse>
{
    public model: ReportingTagType;
    public context: ReportingTagTypeMetadataContext;

    public constructor(init?: Partial<GetReportingTagTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagTypeMetadataResponse(); }
    public getTypeName() { return 'GetReportingTagTypeMetadataRequest'; }
}

// @Route("/api/v2/reporting-tag-types/lookup-updates", "POST")
export class GetReportingTagTypeLookupUpdatesRequest implements IReturn<GetReportingTagTypeLookupUpdatesResponse>
{
    public model: ReportingTagType;
    public changes: FieldChange[];
    public context: ReportingTagTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetReportingTagTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetReportingTagTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/reporting-tag-types/validate", "POST")
export class ValidateReportingTagTypeRequest implements IReturn<ValidateReportingTagTypeResponse>
{
    public model: ReportingTagType;
    public context: ReportingTagTypeMetadataContext;

    public constructor(init?: Partial<ValidateReportingTagTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateReportingTagTypeResponse(); }
    public getTypeName() { return 'ValidateReportingTagTypeRequest'; }
}

// @Route("/api/v2/reporting-tag-types/form", "POST")
export class SubmitReportingTagTypeFormRequest implements IReturn<SubmitReportingTagTypeFormResponse>
{
    public model: ReportingTagType;
    public mode: SaveMode;
    public context: ReportingTagTypeMetadataContext;

    public constructor(init?: Partial<SubmitReportingTagTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitReportingTagTypeFormResponse(); }
    public getTypeName() { return 'SubmitReportingTagTypeFormRequest'; }
}

// @Route("/api/v2/roles/metadata", "POST")
export class GetRoleMetadataRequest implements IReturn<GetRoleMetadataResponse>
{
    public model: Role;
    public context: RoleMetadataContext;

    public constructor(init?: Partial<GetRoleMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetRoleMetadataResponse(); }
    public getTypeName() { return 'GetRoleMetadataRequest'; }
}

// @Route("/api/v2/roles/lookup-updates", "POST")
export class GetRoleLookupUpdatesRequest implements IReturn<GetRoleLookupUpdatesResponse>
{
    public model: Role;
    public changes: FieldChange[];
    public context: RoleMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetRoleLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetRoleLookupUpdatesResponse(); }
    public getTypeName() { return 'GetRoleLookupUpdatesRequest'; }
}

// @Route("/api/v2/roles/validate", "POST")
export class ValidateRoleRequest implements IReturn<ValidateRoleResponse>
{
    public model: Role;
    public context: RoleMetadataContext;

    public constructor(init?: Partial<ValidateRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateRoleResponse(); }
    public getTypeName() { return 'ValidateRoleRequest'; }
}

// @Route("/api/v2/roles/form", "POST")
export class SubmitRoleFormRequest implements IReturn<SubmitRoleFormResponse>
{
    public model: Role;
    public mode: SaveMode;
    public context: RoleMetadataContext;

    public constructor(init?: Partial<SubmitRoleFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitRoleFormResponse(); }
    public getTypeName() { return 'SubmitRoleFormRequest'; }
}

// @Route("/api/v2/salutations/metadata", "POST")
export class GetSalutationMetadataRequest implements IReturn<GetSalutationMetadataResponse>
{
    public model: Salutation;
    public context: SalutationMetadataContext;

    public constructor(init?: Partial<GetSalutationMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalutationMetadataResponse(); }
    public getTypeName() { return 'GetSalutationMetadataRequest'; }
}

// @Route("/api/v2/salutations/lookup-updates", "POST")
export class GetSalutationLookupUpdatesRequest implements IReturn<GetSalutationLookupUpdatesResponse>
{
    public model: Salutation;
    public changes: FieldChange[];
    public context: SalutationMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetSalutationLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalutationLookupUpdatesResponse(); }
    public getTypeName() { return 'GetSalutationLookupUpdatesRequest'; }
}

// @Route("/api/v2/salutations/validate", "POST")
export class ValidateSalutationRequest implements IReturn<ValidateSalutationResponse>
{
    public model: Salutation;
    public context: SalutationMetadataContext;

    public constructor(init?: Partial<ValidateSalutationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateSalutationResponse(); }
    public getTypeName() { return 'ValidateSalutationRequest'; }
}

// @Route("/api/v2/salutations/form", "POST")
export class SubmitSalutationFormRequest implements IReturn<SubmitSalutationFormResponse>
{
    public model: Salutation;
    public mode: SaveMode;
    public context: SalutationMetadataContext;

    public constructor(init?: Partial<SubmitSalutationFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitSalutationFormResponse(); }
    public getTypeName() { return 'SubmitSalutationFormRequest'; }
}

// @Route("/api/v2/site-locations/metadata", "POST")
export class GetSiteLocationMetadataRequest implements IReturn<GetSiteLocationMetadataResponse>
{
    public model: SiteLocation;
    public context: SiteLocationMetadataContext;

    public constructor(init?: Partial<GetSiteLocationMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteLocationMetadataResponse(); }
    public getTypeName() { return 'GetSiteLocationMetadataRequest'; }
}

// @Route("/api/v2/site-locations/lookup-updates", "POST")
export class GetSiteLocationLookupUpdatesRequest implements IReturn<GetSiteLocationLookupUpdatesResponse>
{
    public model: SiteLocation;
    public changes: FieldChange[];
    public context: SiteLocationMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetSiteLocationLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteLocationLookupUpdatesResponse(); }
    public getTypeName() { return 'GetSiteLocationLookupUpdatesRequest'; }
}

// @Route("/api/v2/site-locations/validate", "POST")
export class ValidateSiteLocationRequest implements IReturn<ValidateSiteLocationResponse>
{
    public model: SiteLocation;
    public context: SiteLocationMetadataContext;

    public constructor(init?: Partial<ValidateSiteLocationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateSiteLocationResponse(); }
    public getTypeName() { return 'ValidateSiteLocationRequest'; }
}

// @Route("/api/v2/site-locations/form", "POST")
export class SubmitSiteLocationFormRequest implements IReturn<SubmitSiteLocationFormResponse>
{
    public model: SiteLocation;
    public mode: SaveMode;
    public context: SiteLocationMetadataContext;

    public constructor(init?: Partial<SubmitSiteLocationFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitSiteLocationFormResponse(); }
    public getTypeName() { return 'SubmitSiteLocationFormRequest'; }
}

// @Route("/api/v2/site-types/metadata", "POST")
export class GetSiteTypeMetadataRequest implements IReturn<GetSiteTypeMetadataResponse>
{
    public model: SiteType;
    public context: SiteTypeMetadataContext;

    public constructor(init?: Partial<GetSiteTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteTypeMetadataResponse(); }
    public getTypeName() { return 'GetSiteTypeMetadataRequest'; }
}

// @Route("/api/v2/site-types/lookup-updates", "POST")
export class GetSiteTypeLookupUpdatesRequest implements IReturn<GetSiteTypeLookupUpdatesResponse>
{
    public model: SiteType;
    public changes: FieldChange[];
    public context: SiteTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetSiteTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetSiteTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/site-types/validate", "POST")
export class ValidateSiteTypeRequest implements IReturn<ValidateSiteTypeResponse>
{
    public model: SiteType;
    public context: SiteTypeMetadataContext;

    public constructor(init?: Partial<ValidateSiteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateSiteTypeResponse(); }
    public getTypeName() { return 'ValidateSiteTypeRequest'; }
}

// @Route("/api/v2/site-types/form", "POST")
export class SubmitSiteTypeFormRequest implements IReturn<SubmitSiteTypeFormResponse>
{
    public model: SiteType;
    public mode: SaveMode;
    public context: SiteTypeMetadataContext;

    public constructor(init?: Partial<SubmitSiteTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitSiteTypeFormResponse(); }
    public getTypeName() { return 'SubmitSiteTypeFormRequest'; }
}

// @Route("/api/v2/sort-orders/metadata", "POST")
export class GetSortOrderMetadataRequest implements IReturn<GetSortOrderMetadataResponse>
{
    public model: SortOrder;
    public context: SortOrderMetadataContext;

    public constructor(init?: Partial<GetSortOrderMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSortOrderMetadataResponse(); }
    public getTypeName() { return 'GetSortOrderMetadataRequest'; }
}

// @Route("/api/v2/sort-orders/lookup-updates", "POST")
export class GetSortOrderLookupUpdatesRequest implements IReturn<GetSortOrderLookupUpdatesResponse>
{
    public model: SortOrder;
    public changes: FieldChange[];
    public context: SortOrderMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetSortOrderLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSortOrderLookupUpdatesResponse(); }
    public getTypeName() { return 'GetSortOrderLookupUpdatesRequest'; }
}

// @Route("/api/v2/sort-orders/validate", "POST")
export class ValidateSortOrderRequest implements IReturn<ValidateSortOrderResponse>
{
    public model: SortOrder;
    public context: SortOrderMetadataContext;

    public constructor(init?: Partial<ValidateSortOrderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateSortOrderResponse(); }
    public getTypeName() { return 'ValidateSortOrderRequest'; }
}

// @Route("/api/v2/sort-orders/form", "POST")
export class SubmitSortOrderFormRequest implements IReturn<SubmitSortOrderFormResponse>
{
    public model: SortOrder;
    public mode: SaveMode;
    public context: SortOrderMetadataContext;

    public constructor(init?: Partial<SubmitSortOrderFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitSortOrderFormResponse(); }
    public getTypeName() { return 'SubmitSortOrderFormRequest'; }
}

// @Route("/api/v2/standard-email-templates/metadata", "POST")
export class GetStandardEmailTemplateMetadataRequest implements IReturn<GetStandardEmailTemplateMetadataResponse>
{
    public model: StandardEmailTemplate;
    public context: StandardEmailTemplateMetadataContext;

    public constructor(init?: Partial<GetStandardEmailTemplateMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStandardEmailTemplateMetadataResponse(); }
    public getTypeName() { return 'GetStandardEmailTemplateMetadataRequest'; }
}

// @Route("/api/v2/standard-email-templates/lookup-updates", "POST")
export class GetStandardEmailTemplateLookupUpdatesRequest implements IReturn<GetStandardEmailTemplateLookupUpdatesResponse>
{
    public model: StandardEmailTemplate;
    public changes: FieldChange[];
    public context: StandardEmailTemplateMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetStandardEmailTemplateLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStandardEmailTemplateLookupUpdatesResponse(); }
    public getTypeName() { return 'GetStandardEmailTemplateLookupUpdatesRequest'; }
}

// @Route("/api/v2/standard-email-templates/validate", "POST")
export class ValidateStandardEmailTemplateRequest implements IReturn<ValidateStandardEmailTemplateResponse>
{
    public model: StandardEmailTemplate;
    public context: StandardEmailTemplateMetadataContext;

    public constructor(init?: Partial<ValidateStandardEmailTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateStandardEmailTemplateResponse(); }
    public getTypeName() { return 'ValidateStandardEmailTemplateRequest'; }
}

// @Route("/api/v2/standard-email-templates/form", "POST")
export class SubmitStandardEmailTemplateFormRequest implements IReturn<SubmitStandardEmailTemplateFormResponse>
{
    public model: StandardEmailTemplate;
    public mode: SaveMode;
    public context: StandardEmailTemplateMetadataContext;

    public constructor(init?: Partial<SubmitStandardEmailTemplateFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitStandardEmailTemplateFormResponse(); }
    public getTypeName() { return 'SubmitStandardEmailTemplateFormRequest'; }
}

// @Route("/api/v2/states/metadata", "POST")
export class GetStateMetadataRequest implements IReturn<GetStateMetadataResponse>
{
    public model: State;
    public context: StateMetadataContext;

    public constructor(init?: Partial<GetStateMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStateMetadataResponse(); }
    public getTypeName() { return 'GetStateMetadataRequest'; }
}

// @Route("/api/v2/states/lookup-updates", "POST")
export class GetStateLookupUpdatesRequest implements IReturn<GetStateLookupUpdatesResponse>
{
    public model: State;
    public changes: FieldChange[];
    public context: StateMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetStateLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStateLookupUpdatesResponse(); }
    public getTypeName() { return 'GetStateLookupUpdatesRequest'; }
}

// @Route("/api/v2/states/validate", "POST")
export class ValidateStateRequest implements IReturn<ValidateStateResponse>
{
    public model: State;
    public context: StateMetadataContext;

    public constructor(init?: Partial<ValidateStateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateStateResponse(); }
    public getTypeName() { return 'ValidateStateRequest'; }
}

// @Route("/api/v2/states/form", "POST")
export class SubmitStateFormRequest implements IReturn<SubmitStateFormResponse>
{
    public model: State;
    public mode: SaveMode;
    public context: StateMetadataContext;

    public constructor(init?: Partial<SubmitStateFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitStateFormResponse(); }
    public getTypeName() { return 'SubmitStateFormRequest'; }
}

// @Route("/api/v2/task-types/metadata", "POST")
export class GetTaskTypeMetadataRequest implements IReturn<GetTaskTypeMetadataResponse>
{
    public model: TaskType;
    public context: TaskTypeMetadataContext;

    public constructor(init?: Partial<GetTaskTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTaskTypeMetadataResponse(); }
    public getTypeName() { return 'GetTaskTypeMetadataRequest'; }
}

// @Route("/api/v2/task-types/lookup-updates", "POST")
export class GetTaskTypeLookupUpdatesRequest implements IReturn<GetTaskTypeLookupUpdatesResponse>
{
    public model: TaskType;
    public changes: FieldChange[];
    public context: TaskTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTaskTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTaskTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTaskTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/task-types/validate", "POST")
export class ValidateTaskTypeRequest implements IReturn<ValidateTaskTypeResponse>
{
    public model: TaskType;
    public context: TaskTypeMetadataContext;

    public constructor(init?: Partial<ValidateTaskTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTaskTypeResponse(); }
    public getTypeName() { return 'ValidateTaskTypeRequest'; }
}

// @Route("/api/v2/task-types/form", "POST")
export class SubmitTaskTypeFormRequest implements IReturn<SubmitTaskTypeFormResponse>
{
    public model: TaskType;
    public mode: SaveMode;
    public context: TaskTypeMetadataContext;

    public constructor(init?: Partial<SubmitTaskTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTaskTypeFormResponse(); }
    public getTypeName() { return 'SubmitTaskTypeFormRequest'; }
}

// @Route("/api/v2/template-trial-items/metadata", "POST")
export class GetTemplateTrialItemMetadataRequest implements IReturn<GetTemplateTrialItemMetadataResponse>
{
    public model: TemplateTrialItem;
    public context: TemplateTrialItemMetadataContext;

    public constructor(init?: Partial<GetTemplateTrialItemMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemplateTrialItemMetadataResponse(); }
    public getTypeName() { return 'GetTemplateTrialItemMetadataRequest'; }
}

// @Route("/api/v2/template-trial-items/lookup-updates", "POST")
export class GetTemplateTrialItemLookupUpdatesRequest implements IReturn<GetTemplateTrialItemLookupUpdatesResponse>
{
    public model: TemplateTrialItem;
    public changes: FieldChange[];
    public context: TemplateTrialItemMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTemplateTrialItemLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemplateTrialItemLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTemplateTrialItemLookupUpdatesRequest'; }
}

// @Route("/api/v2/template-trial-items/validate", "POST")
export class ValidateTemplateTrialItemRequest implements IReturn<ValidateTemplateTrialItemResponse>
{
    public model: TemplateTrialItem;
    public context: TemplateTrialItemMetadataContext;

    public constructor(init?: Partial<ValidateTemplateTrialItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTemplateTrialItemResponse(); }
    public getTypeName() { return 'ValidateTemplateTrialItemRequest'; }
}

// @Route("/api/v2/template-trial-items/form", "POST")
export class SubmitTemplateTrialItemFormRequest implements IReturn<SubmitTemplateTrialItemFormResponse>
{
    public model: TemplateTrialItem;
    public mode: SaveMode;
    public context: TemplateTrialItemMetadataContext;

    public constructor(init?: Partial<SubmitTemplateTrialItemFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTemplateTrialItemFormResponse(); }
    public getTypeName() { return 'SubmitTemplateTrialItemFormRequest'; }
}

// @Route("/api/v2/tracker-milestones/metadata", "POST")
export class GetTrackerMilestoneMetadataRequest implements IReturn<GetTrackerMilestoneMetadataResponse>
{
    public model: TrackerMilestone;
    public context: TrackerMilestoneMetadataContext;

    public constructor(init?: Partial<GetTrackerMilestoneMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerMilestoneMetadataResponse(); }
    public getTypeName() { return 'GetTrackerMilestoneMetadataRequest'; }
}

// @Route("/api/v2/tracker-milestones/lookup-updates", "POST")
export class GetTrackerMilestoneLookupUpdatesRequest implements IReturn<GetTrackerMilestoneLookupUpdatesResponse>
{
    public model: TrackerMilestone;
    public changes: FieldChange[];
    public context: TrackerMilestoneMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrackerMilestoneLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerMilestoneLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrackerMilestoneLookupUpdatesRequest'; }
}

// @Route("/api/v2/tracker-milestones/validate", "POST")
export class ValidateTrackerMilestoneRequest implements IReturn<ValidateTrackerMilestoneResponse>
{
    public model: TrackerMilestone;
    public context: TrackerMilestoneMetadataContext;

    public constructor(init?: Partial<ValidateTrackerMilestoneRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrackerMilestoneResponse(); }
    public getTypeName() { return 'ValidateTrackerMilestoneRequest'; }
}

// @Route("/api/v2/tracker-milestones/form", "POST")
export class SubmitTrackerMilestoneFormRequest implements IReturn<SubmitTrackerMilestoneFormResponse>
{
    public model: TrackerMilestone;
    public mode: SaveMode;
    public context: TrackerMilestoneMetadataContext;

    public constructor(init?: Partial<SubmitTrackerMilestoneFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrackerMilestoneFormResponse(); }
    public getTypeName() { return 'SubmitTrackerMilestoneFormRequest'; }
}

// @Route("/api/v2/tracker-statuses/metadata", "POST")
export class GetTrackerStatusMetadataRequest implements IReturn<GetTrackerStatusMetadataResponse>
{
    public model: TrackerStatus;
    public context: TrackerStatusMetadataContext;

    public constructor(init?: Partial<GetTrackerStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerStatusMetadataResponse(); }
    public getTypeName() { return 'GetTrackerStatusMetadataRequest'; }
}

// @Route("/api/v2/tracker-statuses/lookup-updates", "POST")
export class GetTrackerStatusLookupUpdatesRequest implements IReturn<GetTrackerStatusLookupUpdatesResponse>
{
    public model: TrackerStatus;
    public changes: FieldChange[];
    public context: TrackerStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrackerStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrackerStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/tracker-statuses/validate", "POST")
export class ValidateTrackerStatusRequest implements IReturn<ValidateTrackerStatusResponse>
{
    public model: TrackerStatus;
    public context: TrackerStatusMetadataContext;

    public constructor(init?: Partial<ValidateTrackerStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrackerStatusResponse(); }
    public getTypeName() { return 'ValidateTrackerStatusRequest'; }
}

// @Route("/api/v2/tracker-statuses/form", "POST")
export class SubmitTrackerStatusFormRequest implements IReturn<SubmitTrackerStatusFormResponse>
{
    public model: TrackerStatus;
    public mode: SaveMode;
    public context: TrackerStatusMetadataContext;

    public constructor(init?: Partial<SubmitTrackerStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrackerStatusFormResponse(); }
    public getTypeName() { return 'SubmitTrackerStatusFormRequest'; }
}

// @Route("/api/v2/tracker-types/metadata", "POST")
export class GetTrackerTypeMetadataRequest implements IReturn<GetTrackerTypeMetadataResponse>
{
    public model: TrackerType;
    public context: TrackerTypeMetadataContext;

    public constructor(init?: Partial<GetTrackerTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerTypeMetadataResponse(); }
    public getTypeName() { return 'GetTrackerTypeMetadataRequest'; }
}

// @Route("/api/v2/tracker-types/lookup-updates", "POST")
export class GetTrackerTypeLookupUpdatesRequest implements IReturn<GetTrackerTypeLookupUpdatesResponse>
{
    public model: TrackerType;
    public changes: FieldChange[];
    public context: TrackerTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrackerTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrackerTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/tracker-types/validate", "POST")
export class ValidateTrackerTypeRequest implements IReturn<ValidateTrackerTypeResponse>
{
    public model: TrackerType;
    public context: TrackerTypeMetadataContext;

    public constructor(init?: Partial<ValidateTrackerTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrackerTypeResponse(); }
    public getTypeName() { return 'ValidateTrackerTypeRequest'; }
}

// @Route("/api/v2/tracker-types/form", "POST")
export class SubmitTrackerTypeFormRequest implements IReturn<SubmitTrackerTypeFormResponse>
{
    public model: TrackerType;
    public mode: SaveMode;
    public context: TrackerTypeMetadataContext;

    public constructor(init?: Partial<SubmitTrackerTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrackerTypeFormResponse(); }
    public getTypeName() { return 'SubmitTrackerTypeFormRequest'; }
}

// @Route("/api/v2/trials/metadata", "POST")
export class GetTrialMetadataRequest implements IReturn<GetTrialMetadataResponse>
{
    public model: Trial;
    public context: TrialMetadataContext;

    public constructor(init?: Partial<GetTrialMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMetadataResponse(); }
    public getTypeName() { return 'GetTrialMetadataRequest'; }
}

// @Route("/api/v2/trials/lookup-updates", "POST")
export class GetTrialLookupUpdatesRequest implements IReturn<GetTrialLookupUpdatesResponse>
{
    public model: Trial;
    public changes: FieldChange[];
    public context: TrialMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialLookupUpdatesRequest'; }
}

// @Route("/api/v2/trials/validate", "POST")
export class ValidateTrialRequest implements IReturn<ValidateTrialResponse>
{
    public model: Trial;
    public context: TrialMetadataContext;

    public constructor(init?: Partial<ValidateTrialRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialResponse(); }
    public getTypeName() { return 'ValidateTrialRequest'; }
}

// @Route("/api/v2/trials/form", "POST")
export class SubmitTrialFormRequest implements IReturn<SubmitTrialFormResponse>
{
    public model: Trial;
    public mode: SaveMode;
    public context: TrialMetadataContext;

    public constructor(init?: Partial<SubmitTrialFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialFormResponse(); }
    public getTypeName() { return 'SubmitTrialFormRequest'; }
}

// @Route("/api/v2/trial-analysis-types/metadata", "POST")
export class GetTrialAnalysisTypeMetadataRequest implements IReturn<GetTrialAnalysisTypeMetadataResponse>
{
    public model: TrialAnalysisType;
    public context: TrialAnalysisTypeMetadataContext;

    public constructor(init?: Partial<GetTrialAnalysisTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialAnalysisTypeMetadataResponse(); }
    public getTypeName() { return 'GetTrialAnalysisTypeMetadataRequest'; }
}

// @Route("/api/v2/trial-analysis-types/lookup-updates", "POST")
export class GetTrialAnalysisTypeLookupUpdatesRequest implements IReturn<GetTrialAnalysisTypeLookupUpdatesResponse>
{
    public model: TrialAnalysisType;
    public changes: FieldChange[];
    public context: TrialAnalysisTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialAnalysisTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialAnalysisTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialAnalysisTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-analysis-types/validate", "POST")
export class ValidateTrialAnalysisTypeRequest implements IReturn<ValidateTrialAnalysisTypeResponse>
{
    public model: TrialAnalysisType;
    public context: TrialAnalysisTypeMetadataContext;

    public constructor(init?: Partial<ValidateTrialAnalysisTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialAnalysisTypeResponse(); }
    public getTypeName() { return 'ValidateTrialAnalysisTypeRequest'; }
}

// @Route("/api/v2/trial-analysis-types/form", "POST")
export class SubmitTrialAnalysisTypeFormRequest implements IReturn<SubmitTrialAnalysisTypeFormResponse>
{
    public model: TrialAnalysisType;
    public mode: SaveMode;
    public context: TrialAnalysisTypeMetadataContext;

    public constructor(init?: Partial<SubmitTrialAnalysisTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialAnalysisTypeFormResponse(); }
    public getTypeName() { return 'SubmitTrialAnalysisTypeFormRequest'; }
}

// @Route("/api/v2/trial-apis/metadata", "POST")
export class GetTrialApiMetadataRequest implements IReturn<GetTrialApiMetadataResponse>
{
    public model: TrialApi;
    public context: TrialApiMetadataContext;

    public constructor(init?: Partial<GetTrialApiMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialApiMetadataResponse(); }
    public getTypeName() { return 'GetTrialApiMetadataRequest'; }
}

// @Route("/api/v2/trial-apis/lookup-updates", "POST")
export class GetTrialApiLookupUpdatesRequest implements IReturn<GetTrialApiLookupUpdatesResponse>
{
    public model: TrialApi;
    public changes: FieldChange[];
    public context: TrialApiMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialApiLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialApiLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialApiLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-apis/validate", "POST")
export class ValidateTrialApiRequest implements IReturn<ValidateTrialApiResponse>
{
    public model: TrialApi;
    public context: TrialApiMetadataContext;

    public constructor(init?: Partial<ValidateTrialApiRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialApiResponse(); }
    public getTypeName() { return 'ValidateTrialApiRequest'; }
}

// @Route("/api/v2/trial-apis/form", "POST")
export class SubmitTrialApiFormRequest implements IReturn<SubmitTrialApiFormResponse>
{
    public model: TrialApi;
    public mode: SaveMode;
    public context: TrialApiMetadataContext;

    public constructor(init?: Partial<SubmitTrialApiFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialApiFormResponse(); }
    public getTypeName() { return 'SubmitTrialApiFormRequest'; }
}

// @Route("/api/v2/trial-categories/metadata", "POST")
export class GetTrialCategoryMetadataRequest implements IReturn<GetTrialCategoryMetadataResponse>
{
    public model: TrialCategory;
    public context: TrialCategoryMetadataContext;

    public constructor(init?: Partial<GetTrialCategoryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialCategoryMetadataResponse(); }
    public getTypeName() { return 'GetTrialCategoryMetadataRequest'; }
}

// @Route("/api/v2/trial-categories/lookup-updates", "POST")
export class GetTrialCategoryLookupUpdatesRequest implements IReturn<GetTrialCategoryLookupUpdatesResponse>
{
    public model: TrialCategory;
    public changes: FieldChange[];
    public context: TrialCategoryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialCategoryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialCategoryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialCategoryLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-categories/validate", "POST")
export class ValidateTrialCategoryRequest implements IReturn<ValidateTrialCategoryResponse>
{
    public model: TrialCategory;
    public context: TrialCategoryMetadataContext;

    public constructor(init?: Partial<ValidateTrialCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialCategoryResponse(); }
    public getTypeName() { return 'ValidateTrialCategoryRequest'; }
}

// @Route("/api/v2/trial-categories/form", "POST")
export class SubmitTrialCategoryFormRequest implements IReturn<SubmitTrialCategoryFormResponse>
{
    public model: TrialCategory;
    public mode: SaveMode;
    public context: TrialCategoryMetadataContext;

    public constructor(init?: Partial<SubmitTrialCategoryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialCategoryFormResponse(); }
    public getTypeName() { return 'SubmitTrialCategoryFormRequest'; }
}

// @Route("/api/v2/trial-forms/metadata", "POST")
export class GetTrialFormMetadataRequest implements IReturn<GetTrialFormMetadataResponse>
{
    public model: TrialForm;
    public context: TrialFormMetadataContext;

    public constructor(init?: Partial<GetTrialFormMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormMetadataResponse(); }
    public getTypeName() { return 'GetTrialFormMetadataRequest'; }
}

// @Route("/api/v2/trial-forms/lookup-updates", "POST")
export class GetTrialFormLookupUpdatesRequest implements IReturn<GetTrialFormLookupUpdatesResponse>
{
    public model: TrialForm;
    public changes: FieldChange[];
    public context: TrialFormMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialFormLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialFormLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-forms/validate", "POST")
export class ValidateTrialFormRequest implements IReturn<ValidateTrialFormResponse>
{
    public model: TrialForm;
    public context: TrialFormMetadataContext;

    public constructor(init?: Partial<ValidateTrialFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialFormResponse(); }
    public getTypeName() { return 'ValidateTrialFormRequest'; }
}

// @Route("/api/v2/trial-forms/form", "POST")
export class SubmitTrialFormFormRequest implements IReturn<SubmitTrialFormFormResponse>
{
    public model: TrialForm;
    public mode: SaveMode;
    public context: TrialFormMetadataContext;

    public constructor(init?: Partial<SubmitTrialFormFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialFormFormResponse(); }
    public getTypeName() { return 'SubmitTrialFormFormRequest'; }
}

// @Route("/api/v2/trial-form-reports/metadata", "POST")
export class GetTrialFormReportMetadataRequest implements IReturn<GetTrialFormReportMetadataResponse>
{
    public model: TrialFormReport;
    public context: TrialFormReportMetadataContext;

    public constructor(init?: Partial<GetTrialFormReportMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormReportMetadataResponse(); }
    public getTypeName() { return 'GetTrialFormReportMetadataRequest'; }
}

// @Route("/api/v2/trial-form-reports/lookup-updates", "POST")
export class GetTrialFormReportLookupUpdatesRequest implements IReturn<GetTrialFormReportLookupUpdatesResponse>
{
    public model: TrialFormReport;
    public changes: FieldChange[];
    public context: TrialFormReportMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialFormReportLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormReportLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialFormReportLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-form-reports/validate", "POST")
export class ValidateTrialFormReportRequest implements IReturn<ValidateTrialFormReportResponse>
{
    public model: TrialFormReport;
    public context: TrialFormReportMetadataContext;

    public constructor(init?: Partial<ValidateTrialFormReportRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialFormReportResponse(); }
    public getTypeName() { return 'ValidateTrialFormReportRequest'; }
}

// @Route("/api/v2/trial-form-reports/form", "POST")
export class SubmitTrialFormReportFormRequest implements IReturn<SubmitTrialFormReportFormResponse>
{
    public model: TrialFormReport;
    public mode: SaveMode;
    public context: TrialFormReportMetadataContext;

    public constructor(init?: Partial<SubmitTrialFormReportFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialFormReportFormResponse(); }
    public getTypeName() { return 'SubmitTrialFormReportFormRequest'; }
}

// @Route("/api/v2/trial-groups/metadata", "POST")
export class GetTrialGroupMetadataRequest implements IReturn<GetTrialGroupMetadataResponse>
{
    public model: TrialGroup;
    public context: TrialGroupMetadataContext;

    public constructor(init?: Partial<GetTrialGroupMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupMetadataResponse(); }
    public getTypeName() { return 'GetTrialGroupMetadataRequest'; }
}

// @Route("/api/v2/trial-groups/lookup-updates", "POST")
export class GetTrialGroupLookupUpdatesRequest implements IReturn<GetTrialGroupLookupUpdatesResponse>
{
    public model: TrialGroup;
    public changes: FieldChange[];
    public context: TrialGroupMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialGroupLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialGroupLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-groups/validate", "POST")
export class ValidateTrialGroupRequest implements IReturn<ValidateTrialGroupResponse>
{
    public model: TrialGroup;
    public context: TrialGroupMetadataContext;

    public constructor(init?: Partial<ValidateTrialGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialGroupResponse(); }
    public getTypeName() { return 'ValidateTrialGroupRequest'; }
}

// @Route("/api/v2/trial-groups/form", "POST")
export class SubmitTrialGroupFormRequest implements IReturn<SubmitTrialGroupFormResponse>
{
    public model: TrialGroup;
    public mode: SaveMode;
    public context: TrialGroupMetadataContext;

    public constructor(init?: Partial<SubmitTrialGroupFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialGroupFormResponse(); }
    public getTypeName() { return 'SubmitTrialGroupFormRequest'; }
}

// @Route("/api/v2/trial-group-items/metadata", "POST")
export class GetTrialGroupItemMetadataRequest implements IReturn<GetTrialGroupItemMetadataResponse>
{
    public model: TrialGroupItem;
    public context: TrialGroupItemMetadataContext;

    public constructor(init?: Partial<GetTrialGroupItemMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupItemMetadataResponse(); }
    public getTypeName() { return 'GetTrialGroupItemMetadataRequest'; }
}

// @Route("/api/v2/trial-group-items/lookup-updates", "POST")
export class GetTrialGroupItemLookupUpdatesRequest implements IReturn<GetTrialGroupItemLookupUpdatesResponse>
{
    public model: TrialGroupItem;
    public changes: FieldChange[];
    public context: TrialGroupItemMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialGroupItemLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupItemLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialGroupItemLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-group-items/validate", "POST")
export class ValidateTrialGroupItemRequest implements IReturn<ValidateTrialGroupItemResponse>
{
    public model: TrialGroupItem;
    public context: TrialGroupItemMetadataContext;

    public constructor(init?: Partial<ValidateTrialGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialGroupItemResponse(); }
    public getTypeName() { return 'ValidateTrialGroupItemRequest'; }
}

// @Route("/api/v2/trial-group-items/form", "POST")
export class SubmitTrialGroupItemFormRequest implements IReturn<SubmitTrialGroupItemFormResponse>
{
    public model: TrialGroupItem;
    public mode: SaveMode;
    public context: TrialGroupItemMetadataContext;

    public constructor(init?: Partial<SubmitTrialGroupItemFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialGroupItemFormResponse(); }
    public getTypeName() { return 'SubmitTrialGroupItemFormRequest'; }
}

// @Route("/api/v2/trial-institutions/metadata", "POST")
export class GetTrialInstitutionMetadataRequest implements IReturn<GetTrialInstitutionMetadataResponse>
{
    public model: TrialInstitution;
    public context: TrialInstitutionMetadataContext;

    public constructor(init?: Partial<GetTrialInstitutionMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionMetadataResponse(); }
    public getTypeName() { return 'GetTrialInstitutionMetadataRequest'; }
}

// @Route("/api/v2/trial-institutions/lookup-updates", "POST")
export class GetTrialInstitutionLookupUpdatesRequest implements IReturn<GetTrialInstitutionLookupUpdatesResponse>
{
    public model: TrialInstitution;
    public changes: FieldChange[];
    public context: TrialInstitutionMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialInstitutionLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-institutions/validate", "POST")
export class ValidateTrialInstitutionRequest implements IReturn<ValidateTrialInstitutionResponse>
{
    public model: TrialInstitution;
    public context: TrialInstitutionMetadataContext;

    public constructor(init?: Partial<ValidateTrialInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialInstitutionResponse(); }
    public getTypeName() { return 'ValidateTrialInstitutionRequest'; }
}

// @Route("/api/v2/trial-institutions/form", "POST")
export class SubmitTrialInstitutionFormRequest implements IReturn<SubmitTrialInstitutionFormResponse>
{
    public model: TrialInstitution;
    public mode: SaveMode;
    public context: TrialInstitutionMetadataContext;

    public constructor(init?: Partial<SubmitTrialInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialInstitutionFormResponse(); }
    public getTypeName() { return 'SubmitTrialInstitutionFormRequest'; }
}

// @Route("/api/v2/trial-institution-items/metadata", "POST")
export class GetTrialInstitutionItemMetadataRequest implements IReturn<GetTrialInstitutionItemMetadataResponse>
{
    public model: TrialInstitutionItem;
    public context: TrialInstitutionItemMetadataContext;

    public constructor(init?: Partial<GetTrialInstitutionItemMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemMetadataResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemMetadataRequest'; }
}

// @Route("/api/v2/trial-institution-items/lookup-updates", "POST")
export class GetTrialInstitutionItemLookupUpdatesRequest implements IReturn<GetTrialInstitutionItemLookupUpdatesResponse>
{
    public model: TrialInstitutionItem;
    public changes: FieldChange[];
    public context: TrialInstitutionItemMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialInstitutionItemLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-institution-items/validate", "POST")
export class ValidateTrialInstitutionItemRequest implements IReturn<ValidateTrialInstitutionItemResponse>
{
    public model: TrialInstitutionItem;
    public context: TrialInstitutionItemMetadataContext;

    public constructor(init?: Partial<ValidateTrialInstitutionItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialInstitutionItemResponse(); }
    public getTypeName() { return 'ValidateTrialInstitutionItemRequest'; }
}

// @Route("/api/v2/trial-institution-items/form", "POST")
export class SubmitTrialInstitutionItemFormRequest implements IReturn<SubmitTrialInstitutionItemFormResponse>
{
    public model: TrialInstitutionItem;
    public mode: SaveMode;
    public context: TrialInstitutionItemMetadataContext;

    public constructor(init?: Partial<SubmitTrialInstitutionItemFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialInstitutionItemFormResponse(); }
    public getTypeName() { return 'SubmitTrialInstitutionItemFormRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/metadata", "POST")
export class GetTrialInstitutionItemTemplateMetadataRequest implements IReturn<GetTrialInstitutionItemTemplateMetadataResponse>
{
    public model: TrialInstitutionItemTemplate;
    public context: TrialInstitutionItemTemplateMetadataContext;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateMetadataResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateMetadataRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/lookup-updates", "POST")
export class GetTrialInstitutionItemTemplateLookupUpdatesRequest implements IReturn<GetTrialInstitutionItemTemplateLookupUpdatesResponse>
{
    public model: TrialInstitutionItemTemplate;
    public changes: FieldChange[];
    public context: TrialInstitutionItemTemplateMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/validate", "POST")
export class ValidateTrialInstitutionItemTemplateRequest implements IReturn<ValidateTrialInstitutionItemTemplateResponse>
{
    public model: TrialInstitutionItemTemplate;
    public context: TrialInstitutionItemTemplateMetadataContext;

    public constructor(init?: Partial<ValidateTrialInstitutionItemTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialInstitutionItemTemplateResponse(); }
    public getTypeName() { return 'ValidateTrialInstitutionItemTemplateRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/form", "POST")
export class SubmitTrialInstitutionItemTemplateFormRequest implements IReturn<SubmitTrialInstitutionItemTemplateFormResponse>
{
    public model: TrialInstitutionItemTemplate;
    public mode: SaveMode;
    public context: TrialInstitutionItemTemplateMetadataContext;

    public constructor(init?: Partial<SubmitTrialInstitutionItemTemplateFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialInstitutionItemTemplateFormResponse(); }
    public getTypeName() { return 'SubmitTrialInstitutionItemTemplateFormRequest'; }
}

// @Route("/api/v2/trial-institution-notes/metadata", "POST")
export class GetTrialInstitutionNoteMetadataRequest implements IReturn<GetTrialInstitutionNoteMetadataResponse>
{
    public model: TrialInstitutionNote;
    public context: TrialInstitutionNoteMetadataContext;

    public constructor(init?: Partial<GetTrialInstitutionNoteMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNoteMetadataResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNoteMetadataRequest'; }
}

// @Route("/api/v2/trial-institution-notes/lookup-updates", "POST")
export class GetTrialInstitutionNoteLookupUpdatesRequest implements IReturn<GetTrialInstitutionNoteLookupUpdatesResponse>
{
    public model: TrialInstitutionNote;
    public changes: FieldChange[];
    public context: TrialInstitutionNoteMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialInstitutionNoteLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNoteLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNoteLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-institution-notes/validate", "POST")
export class ValidateTrialInstitutionNoteRequest implements IReturn<ValidateTrialInstitutionNoteResponse>
{
    public model: TrialInstitutionNote;
    public context: TrialInstitutionNoteMetadataContext;

    public constructor(init?: Partial<ValidateTrialInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialInstitutionNoteResponse(); }
    public getTypeName() { return 'ValidateTrialInstitutionNoteRequest'; }
}

// @Route("/api/v2/trial-institution-notes/form", "POST")
export class SubmitTrialInstitutionNoteFormRequest implements IReturn<SubmitTrialInstitutionNoteFormResponse>
{
    public model: TrialInstitutionNote;
    public mode: SaveMode;
    public context: TrialInstitutionNoteMetadataContext;

    public constructor(init?: Partial<SubmitTrialInstitutionNoteFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialInstitutionNoteFormResponse(); }
    public getTypeName() { return 'SubmitTrialInstitutionNoteFormRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/metadata", "POST")
export class GetTrialInstitutionStatusMetadataRequest implements IReturn<GetTrialInstitutionStatusMetadataResponse>
{
    public model: TrialInstitutionStatus;
    public context: TrialInstitutionStatusMetadataContext;

    public constructor(init?: Partial<GetTrialInstitutionStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionStatusMetadataResponse(); }
    public getTypeName() { return 'GetTrialInstitutionStatusMetadataRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/lookup-updates", "POST")
export class GetTrialInstitutionStatusLookupUpdatesRequest implements IReturn<GetTrialInstitutionStatusLookupUpdatesResponse>
{
    public model: TrialInstitutionStatus;
    public changes: FieldChange[];
    public context: TrialInstitutionStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialInstitutionStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/validate", "POST")
export class ValidateTrialInstitutionStatusRequest implements IReturn<ValidateTrialInstitutionStatusResponse>
{
    public model: TrialInstitutionStatus;
    public context: TrialInstitutionStatusMetadataContext;

    public constructor(init?: Partial<ValidateTrialInstitutionStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialInstitutionStatusResponse(); }
    public getTypeName() { return 'ValidateTrialInstitutionStatusRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/form", "POST")
export class SubmitTrialInstitutionStatusFormRequest implements IReturn<SubmitTrialInstitutionStatusFormResponse>
{
    public model: TrialInstitutionStatus;
    public mode: SaveMode;
    public context: TrialInstitutionStatusMetadataContext;

    public constructor(init?: Partial<SubmitTrialInstitutionStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialInstitutionStatusFormResponse(); }
    public getTypeName() { return 'SubmitTrialInstitutionStatusFormRequest'; }
}

// @Route("/api/v2/trial-item-instances/metadata", "POST")
export class GetTrialItemInstanceMetadataRequest implements IReturn<GetTrialItemInstanceMetadataResponse>
{
    public model: TrialItemInstance;
    public context: TrialItemInstanceMetadataContext;

    public constructor(init?: Partial<GetTrialItemInstanceMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceMetadataResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceMetadataRequest'; }
}

// @Route("/api/v2/trial-item-instances/lookup-updates", "POST")
export class GetTrialItemInstanceLookupUpdatesRequest implements IReturn<GetTrialItemInstanceLookupUpdatesResponse>
{
    public model: TrialItemInstance;
    public changes: FieldChange[];
    public context: TrialItemInstanceMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialItemInstanceLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-item-instances/validate", "POST")
export class ValidateTrialItemInstanceRequest implements IReturn<ValidateTrialItemInstanceResponse>
{
    public model: TrialItemInstance;
    public context: TrialItemInstanceMetadataContext;

    public constructor(init?: Partial<ValidateTrialItemInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialItemInstanceResponse(); }
    public getTypeName() { return 'ValidateTrialItemInstanceRequest'; }
}

// @Route("/api/v2/trial-item-instances/form", "POST")
export class SubmitTrialItemInstanceFormRequest implements IReturn<SubmitTrialItemInstanceFormResponse>
{
    public model: TrialItemInstance;
    public mode: SaveMode;
    public context: TrialItemInstanceMetadataContext;

    public constructor(init?: Partial<SubmitTrialItemInstanceFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialItemInstanceFormResponse(); }
    public getTypeName() { return 'SubmitTrialItemInstanceFormRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/metadata", "POST")
export class GetTrialItemInstanceStatusMetadataRequest implements IReturn<GetTrialItemInstanceStatusMetadataResponse>
{
    public model: TrialItemInstanceStatus;
    public context: TrialItemInstanceStatusMetadataContext;

    public constructor(init?: Partial<GetTrialItemInstanceStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceStatusMetadataResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceStatusMetadataRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/lookup-updates", "POST")
export class GetTrialItemInstanceStatusLookupUpdatesRequest implements IReturn<GetTrialItemInstanceStatusLookupUpdatesResponse>
{
    public model: TrialItemInstanceStatus;
    public changes: FieldChange[];
    public context: TrialItemInstanceStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialItemInstanceStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/validate", "POST")
export class ValidateTrialItemInstanceStatusRequest implements IReturn<ValidateTrialItemInstanceStatusResponse>
{
    public model: TrialItemInstanceStatus;
    public context: TrialItemInstanceStatusMetadataContext;

    public constructor(init?: Partial<ValidateTrialItemInstanceStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialItemInstanceStatusResponse(); }
    public getTypeName() { return 'ValidateTrialItemInstanceStatusRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/form", "POST")
export class SubmitTrialItemInstanceStatusFormRequest implements IReturn<SubmitTrialItemInstanceStatusFormResponse>
{
    public model: TrialItemInstanceStatus;
    public mode: SaveMode;
    public context: TrialItemInstanceStatusMetadataContext;

    public constructor(init?: Partial<SubmitTrialItemInstanceStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialItemInstanceStatusFormResponse(); }
    public getTypeName() { return 'SubmitTrialItemInstanceStatusFormRequest'; }
}

// @Route("/api/v2/trial-milestones/metadata", "POST")
export class GetTrialMilestonesMetadataRequest implements IReturn<GetTrialMilestonesMetadataResponse>
{
    public model: TrialMilestones;
    public context: TrialMilestonesMetadataContext;

    public constructor(init?: Partial<GetTrialMilestonesMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMilestonesMetadataResponse(); }
    public getTypeName() { return 'GetTrialMilestonesMetadataRequest'; }
}

// @Route("/api/v2/trial-milestones/lookup-updates", "POST")
export class GetTrialMilestonesLookupUpdatesRequest implements IReturn<GetTrialMilestonesLookupUpdatesResponse>
{
    public model: TrialMilestones;
    public changes: FieldChange[];
    public context: TrialMilestonesMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialMilestonesLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMilestonesLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialMilestonesLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-milestones/validate", "POST")
export class ValidateTrialMilestonesRequest implements IReturn<ValidateTrialMilestonesResponse>
{
    public model: TrialMilestones;
    public context: TrialMilestonesMetadataContext;

    public constructor(init?: Partial<ValidateTrialMilestonesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialMilestonesResponse(); }
    public getTypeName() { return 'ValidateTrialMilestonesRequest'; }
}

// @Route("/api/v2/trial-milestones/form", "POST")
export class SubmitTrialMilestonesFormRequest implements IReturn<SubmitTrialMilestonesFormResponse>
{
    public model: TrialMilestones;
    public mode: SaveMode;
    public context: TrialMilestonesMetadataContext;

    public constructor(init?: Partial<SubmitTrialMilestonesFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialMilestonesFormResponse(); }
    public getTypeName() { return 'SubmitTrialMilestonesFormRequest'; }
}

// @Route("/api/v2/trial-notes/metadata", "POST")
export class GetTrialNoteMetadataRequest implements IReturn<GetTrialNoteMetadataResponse>
{
    public model: TrialNote;
    public context: TrialNoteMetadataContext;

    public constructor(init?: Partial<GetTrialNoteMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNoteMetadataResponse(); }
    public getTypeName() { return 'GetTrialNoteMetadataRequest'; }
}

// @Route("/api/v2/trial-notes/lookup-updates", "POST")
export class GetTrialNoteLookupUpdatesRequest implements IReturn<GetTrialNoteLookupUpdatesResponse>
{
    public model: TrialNote;
    public changes: FieldChange[];
    public context: TrialNoteMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialNoteLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNoteLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialNoteLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-notes/validate", "POST")
export class ValidateTrialNoteRequest implements IReturn<ValidateTrialNoteResponse>
{
    public model: TrialNote;
    public context: TrialNoteMetadataContext;

    public constructor(init?: Partial<ValidateTrialNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialNoteResponse(); }
    public getTypeName() { return 'ValidateTrialNoteRequest'; }
}

// @Route("/api/v2/trial-notes/form", "POST")
export class SubmitTrialNoteFormRequest implements IReturn<SubmitTrialNoteFormResponse>
{
    public model: TrialNote;
    public mode: SaveMode;
    public context: TrialNoteMetadataContext;

    public constructor(init?: Partial<SubmitTrialNoteFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialNoteFormResponse(); }
    public getTypeName() { return 'SubmitTrialNoteFormRequest'; }
}

// @Route("/api/v2/trial-phases/metadata", "POST")
export class GetTrialPhaseMetadataRequest implements IReturn<GetTrialPhaseMetadataResponse>
{
    public model: TrialPhase;
    public context: TrialPhaseMetadataContext;

    public constructor(init?: Partial<GetTrialPhaseMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPhaseMetadataResponse(); }
    public getTypeName() { return 'GetTrialPhaseMetadataRequest'; }
}

// @Route("/api/v2/trial-phases/lookup-updates", "POST")
export class GetTrialPhaseLookupUpdatesRequest implements IReturn<GetTrialPhaseLookupUpdatesResponse>
{
    public model: TrialPhase;
    public changes: FieldChange[];
    public context: TrialPhaseMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialPhaseLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPhaseLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialPhaseLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-phases/validate", "POST")
export class ValidateTrialPhaseRequest implements IReturn<ValidateTrialPhaseResponse>
{
    public model: TrialPhase;
    public context: TrialPhaseMetadataContext;

    public constructor(init?: Partial<ValidateTrialPhaseRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialPhaseResponse(); }
    public getTypeName() { return 'ValidateTrialPhaseRequest'; }
}

// @Route("/api/v2/trial-phases/form", "POST")
export class SubmitTrialPhaseFormRequest implements IReturn<SubmitTrialPhaseFormResponse>
{
    public model: TrialPhase;
    public mode: SaveMode;
    public context: TrialPhaseMetadataContext;

    public constructor(init?: Partial<SubmitTrialPhaseFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialPhaseFormResponse(); }
    public getTypeName() { return 'SubmitTrialPhaseFormRequest'; }
}

// @Route("/api/v2/trial-presentation-types/metadata", "POST")
export class GetTrialPresentationTypeMetadataRequest implements IReturn<GetTrialPresentationTypeMetadataResponse>
{
    public model: TrialPresentationType;
    public context: TrialPresentationTypeMetadataContext;

    public constructor(init?: Partial<GetTrialPresentationTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPresentationTypeMetadataResponse(); }
    public getTypeName() { return 'GetTrialPresentationTypeMetadataRequest'; }
}

// @Route("/api/v2/trial-presentation-types/lookup-updates", "POST")
export class GetTrialPresentationTypeLookupUpdatesRequest implements IReturn<GetTrialPresentationTypeLookupUpdatesResponse>
{
    public model: TrialPresentationType;
    public changes: FieldChange[];
    public context: TrialPresentationTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialPresentationTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPresentationTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialPresentationTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-presentation-types/validate", "POST")
export class ValidateTrialPresentationTypeRequest implements IReturn<ValidateTrialPresentationTypeResponse>
{
    public model: TrialPresentationType;
    public context: TrialPresentationTypeMetadataContext;

    public constructor(init?: Partial<ValidateTrialPresentationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialPresentationTypeResponse(); }
    public getTypeName() { return 'ValidateTrialPresentationTypeRequest'; }
}

// @Route("/api/v2/trial-presentation-types/form", "POST")
export class SubmitTrialPresentationTypeFormRequest implements IReturn<SubmitTrialPresentationTypeFormResponse>
{
    public model: TrialPresentationType;
    public mode: SaveMode;
    public context: TrialPresentationTypeMetadataContext;

    public constructor(init?: Partial<SubmitTrialPresentationTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialPresentationTypeFormResponse(); }
    public getTypeName() { return 'SubmitTrialPresentationTypeFormRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/metadata", "POST")
export class GetTrialPublicationStatusMetadataRequest implements IReturn<GetTrialPublicationStatusMetadataResponse>
{
    public model: TrialPublicationStatus;
    public context: TrialPublicationStatusMetadataContext;

    public constructor(init?: Partial<GetTrialPublicationStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationStatusMetadataResponse(); }
    public getTypeName() { return 'GetTrialPublicationStatusMetadataRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/lookup-updates", "POST")
export class GetTrialPublicationStatusLookupUpdatesRequest implements IReturn<GetTrialPublicationStatusLookupUpdatesResponse>
{
    public model: TrialPublicationStatus;
    public changes: FieldChange[];
    public context: TrialPublicationStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialPublicationStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialPublicationStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/validate", "POST")
export class ValidateTrialPublicationStatusRequest implements IReturn<ValidateTrialPublicationStatusResponse>
{
    public model: TrialPublicationStatus;
    public context: TrialPublicationStatusMetadataContext;

    public constructor(init?: Partial<ValidateTrialPublicationStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialPublicationStatusResponse(); }
    public getTypeName() { return 'ValidateTrialPublicationStatusRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/form", "POST")
export class SubmitTrialPublicationStatusFormRequest implements IReturn<SubmitTrialPublicationStatusFormResponse>
{
    public model: TrialPublicationStatus;
    public mode: SaveMode;
    public context: TrialPublicationStatusMetadataContext;

    public constructor(init?: Partial<SubmitTrialPublicationStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialPublicationStatusFormResponse(); }
    public getTypeName() { return 'SubmitTrialPublicationStatusFormRequest'; }
}

// @Route("/api/v2/trial-publication-types/metadata", "POST")
export class GetTrialPublicationTypeMetadataRequest implements IReturn<GetTrialPublicationTypeMetadataResponse>
{
    public model: TrialPublicationType;
    public context: TrialPublicationTypeMetadataContext;

    public constructor(init?: Partial<GetTrialPublicationTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationTypeMetadataResponse(); }
    public getTypeName() { return 'GetTrialPublicationTypeMetadataRequest'; }
}

// @Route("/api/v2/trial-publication-types/lookup-updates", "POST")
export class GetTrialPublicationTypeLookupUpdatesRequest implements IReturn<GetTrialPublicationTypeLookupUpdatesResponse>
{
    public model: TrialPublicationType;
    public changes: FieldChange[];
    public context: TrialPublicationTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialPublicationTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialPublicationTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-publication-types/validate", "POST")
export class ValidateTrialPublicationTypeRequest implements IReturn<ValidateTrialPublicationTypeResponse>
{
    public model: TrialPublicationType;
    public context: TrialPublicationTypeMetadataContext;

    public constructor(init?: Partial<ValidateTrialPublicationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialPublicationTypeResponse(); }
    public getTypeName() { return 'ValidateTrialPublicationTypeRequest'; }
}

// @Route("/api/v2/trial-publication-types/form", "POST")
export class SubmitTrialPublicationTypeFormRequest implements IReturn<SubmitTrialPublicationTypeFormResponse>
{
    public model: TrialPublicationType;
    public mode: SaveMode;
    public context: TrialPublicationTypeMetadataContext;

    public constructor(init?: Partial<SubmitTrialPublicationTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialPublicationTypeFormResponse(); }
    public getTypeName() { return 'SubmitTrialPublicationTypeFormRequest'; }
}

// @Route("/api/v2/trial-registries/metadata", "POST")
export class GetTrialRegistryMetadataRequest implements IReturn<GetTrialRegistryMetadataResponse>
{
    public model: TrialRegistry;
    public context: TrialRegistryMetadataContext;

    public constructor(init?: Partial<GetTrialRegistryMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialRegistryMetadataResponse(); }
    public getTypeName() { return 'GetTrialRegistryMetadataRequest'; }
}

// @Route("/api/v2/trial-registries/lookup-updates", "POST")
export class GetTrialRegistryLookupUpdatesRequest implements IReturn<GetTrialRegistryLookupUpdatesResponse>
{
    public model: TrialRegistry;
    public changes: FieldChange[];
    public context: TrialRegistryMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialRegistryLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialRegistryLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialRegistryLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-registries/validate", "POST")
export class ValidateTrialRegistryRequest implements IReturn<ValidateTrialRegistryResponse>
{
    public model: TrialRegistry;
    public context: TrialRegistryMetadataContext;

    public constructor(init?: Partial<ValidateTrialRegistryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialRegistryResponse(); }
    public getTypeName() { return 'ValidateTrialRegistryRequest'; }
}

// @Route("/api/v2/trial-registries/form", "POST")
export class SubmitTrialRegistryFormRequest implements IReturn<SubmitTrialRegistryFormResponse>
{
    public model: TrialRegistry;
    public mode: SaveMode;
    public context: TrialRegistryMetadataContext;

    public constructor(init?: Partial<SubmitTrialRegistryFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialRegistryFormResponse(); }
    public getTypeName() { return 'SubmitTrialRegistryFormRequest'; }
}

// @Route("/api/v2/trial-statuses/metadata", "POST")
export class GetTrialStatusMetadataRequest implements IReturn<GetTrialStatusMetadataResponse>
{
    public model: TrialStatus;
    public context: TrialStatusMetadataContext;

    public constructor(init?: Partial<GetTrialStatusMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialStatusMetadataResponse(); }
    public getTypeName() { return 'GetTrialStatusMetadataRequest'; }
}

// @Route("/api/v2/trial-statuses/lookup-updates", "POST")
export class GetTrialStatusLookupUpdatesRequest implements IReturn<GetTrialStatusLookupUpdatesResponse>
{
    public model: TrialStatus;
    public changes: FieldChange[];
    public context: TrialStatusMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialStatusLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialStatusLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialStatusLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-statuses/validate", "POST")
export class ValidateTrialStatusRequest implements IReturn<ValidateTrialStatusResponse>
{
    public model: TrialStatus;
    public context: TrialStatusMetadataContext;

    public constructor(init?: Partial<ValidateTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialStatusResponse(); }
    public getTypeName() { return 'ValidateTrialStatusRequest'; }
}

// @Route("/api/v2/trial-statuses/form", "POST")
export class SubmitTrialStatusFormRequest implements IReturn<SubmitTrialStatusFormResponse>
{
    public model: TrialStatus;
    public mode: SaveMode;
    public context: TrialStatusMetadataContext;

    public constructor(init?: Partial<SubmitTrialStatusFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialStatusFormResponse(); }
    public getTypeName() { return 'SubmitTrialStatusFormRequest'; }
}

// @Route("/api/v2/trial-trackers/metadata", "POST")
export class GetTrialTrackerMetadataRequest implements IReturn<GetTrialTrackerMetadataResponse>
{
    public model: TrialTracker;
    public context: TrialTrackerMetadataContext;

    public constructor(init?: Partial<GetTrialTrackerMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackerMetadataResponse(); }
    public getTypeName() { return 'GetTrialTrackerMetadataRequest'; }
}

// @Route("/api/v2/trial-trackers/lookup-updates", "POST")
export class GetTrialTrackerLookupUpdatesRequest implements IReturn<GetTrialTrackerLookupUpdatesResponse>
{
    public model: TrialTracker;
    public changes: FieldChange[];
    public context: TrialTrackerMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialTrackerLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackerLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialTrackerLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-trackers/validate", "POST")
export class ValidateTrialTrackerRequest implements IReturn<ValidateTrialTrackerResponse>
{
    public model: TrialTracker;
    public context: TrialTrackerMetadataContext;

    public constructor(init?: Partial<ValidateTrialTrackerRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialTrackerResponse(); }
    public getTypeName() { return 'ValidateTrialTrackerRequest'; }
}

// @Route("/api/v2/trial-trackers/form", "POST")
export class SubmitTrialTrackerFormRequest implements IReturn<SubmitTrialTrackerFormResponse>
{
    public model: TrialTracker;
    public mode: SaveMode;
    public context: TrialTrackerMetadataContext;

    public constructor(init?: Partial<SubmitTrialTrackerFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialTrackerFormResponse(); }
    public getTypeName() { return 'SubmitTrialTrackerFormRequest'; }
}

// @Route("/api/v2/trial-treatments/metadata", "POST")
export class GetTrialTreatmentMetadataRequest implements IReturn<GetTrialTreatmentMetadataResponse>
{
    public model: TrialTreatment;
    public context: TrialTreatmentMetadataContext;

    public constructor(init?: Partial<GetTrialTreatmentMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentMetadataResponse(); }
    public getTypeName() { return 'GetTrialTreatmentMetadataRequest'; }
}

// @Route("/api/v2/trial-treatments/lookup-updates", "POST")
export class GetTrialTreatmentLookupUpdatesRequest implements IReturn<GetTrialTreatmentLookupUpdatesResponse>
{
    public model: TrialTreatment;
    public changes: FieldChange[];
    public context: TrialTreatmentMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialTreatmentLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialTreatmentLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-treatments/validate", "POST")
export class ValidateTrialTreatmentRequest implements IReturn<ValidateTrialTreatmentResponse>
{
    public model: TrialTreatment;
    public context: TrialTreatmentMetadataContext;

    public constructor(init?: Partial<ValidateTrialTreatmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialTreatmentResponse(); }
    public getTypeName() { return 'ValidateTrialTreatmentRequest'; }
}

// @Route("/api/v2/trial-treatments/form", "POST")
export class SubmitTrialTreatmentFormRequest implements IReturn<SubmitTrialTreatmentFormResponse>
{
    public model: TrialTreatment;
    public mode: SaveMode;
    public context: TrialTreatmentMetadataContext;

    public constructor(init?: Partial<SubmitTrialTreatmentFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialTreatmentFormResponse(); }
    public getTypeName() { return 'SubmitTrialTreatmentFormRequest'; }
}

// @Route("/api/v2/trial-types/metadata", "POST")
export class GetTrialTypeMetadataRequest implements IReturn<GetTrialTypeMetadataResponse>
{
    public model: TrialType;
    public context: TrialTypeMetadataContext;

    public constructor(init?: Partial<GetTrialTypeMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTypeMetadataResponse(); }
    public getTypeName() { return 'GetTrialTypeMetadataRequest'; }
}

// @Route("/api/v2/trial-types/lookup-updates", "POST")
export class GetTrialTypeLookupUpdatesRequest implements IReturn<GetTrialTypeLookupUpdatesResponse>
{
    public model: TrialType;
    public changes: FieldChange[];
    public context: TrialTypeMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTrialTypeLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTypeLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTrialTypeLookupUpdatesRequest'; }
}

// @Route("/api/v2/trial-types/validate", "POST")
export class ValidateTrialTypeRequest implements IReturn<ValidateTrialTypeResponse>
{
    public model: TrialType;
    public context: TrialTypeMetadataContext;

    public constructor(init?: Partial<ValidateTrialTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTrialTypeResponse(); }
    public getTypeName() { return 'ValidateTrialTypeRequest'; }
}

// @Route("/api/v2/trial-types/form", "POST")
export class SubmitTrialTypeFormRequest implements IReturn<SubmitTrialTypeFormResponse>
{
    public model: TrialType;
    public mode: SaveMode;
    public context: TrialTypeMetadataContext;

    public constructor(init?: Partial<SubmitTrialTypeFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTrialTypeFormResponse(); }
    public getTypeName() { return 'SubmitTrialTypeFormRequest'; }
}

// @Route("/api/v2/tumour-groups/metadata", "POST")
export class GetTumourGroupMetadataRequest implements IReturn<GetTumourGroupMetadataResponse>
{
    public model: TumourGroup;
    public context: TumourGroupMetadataContext;

    public constructor(init?: Partial<GetTumourGroupMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTumourGroupMetadataResponse(); }
    public getTypeName() { return 'GetTumourGroupMetadataRequest'; }
}

// @Route("/api/v2/tumour-groups/lookup-updates", "POST")
export class GetTumourGroupLookupUpdatesRequest implements IReturn<GetTumourGroupLookupUpdatesResponse>
{
    public model: TumourGroup;
    public changes: FieldChange[];
    public context: TumourGroupMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetTumourGroupLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTumourGroupLookupUpdatesResponse(); }
    public getTypeName() { return 'GetTumourGroupLookupUpdatesRequest'; }
}

// @Route("/api/v2/tumour-groups/validate", "POST")
export class ValidateTumourGroupRequest implements IReturn<ValidateTumourGroupResponse>
{
    public model: TumourGroup;
    public context: TumourGroupMetadataContext;

    public constructor(init?: Partial<ValidateTumourGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateTumourGroupResponse(); }
    public getTypeName() { return 'ValidateTumourGroupRequest'; }
}

// @Route("/api/v2/tumour-groups/form", "POST")
export class SubmitTumourGroupFormRequest implements IReturn<SubmitTumourGroupFormResponse>
{
    public model: TumourGroup;
    public mode: SaveMode;
    public context: TumourGroupMetadataContext;

    public constructor(init?: Partial<SubmitTumourGroupFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitTumourGroupFormResponse(); }
    public getTypeName() { return 'SubmitTumourGroupFormRequest'; }
}

// @Route("/api/v2/yes-nos/metadata", "POST")
export class GetYesNoMetadataRequest implements IReturn<GetYesNoMetadataResponse>
{
    public model: YesNo;
    public context: YesNoMetadataContext;

    public constructor(init?: Partial<GetYesNoMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoMetadataResponse(); }
    public getTypeName() { return 'GetYesNoMetadataRequest'; }
}

// @Route("/api/v2/yes-nos/lookup-updates", "POST")
export class GetYesNoLookupUpdatesRequest implements IReturn<GetYesNoLookupUpdatesResponse>
{
    public model: YesNo;
    public changes: FieldChange[];
    public context: YesNoMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetYesNoLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoLookupUpdatesResponse(); }
    public getTypeName() { return 'GetYesNoLookupUpdatesRequest'; }
}

// @Route("/api/v2/yes-nos/validate", "POST")
export class ValidateYesNoRequest implements IReturn<ValidateYesNoResponse>
{
    public model: YesNo;
    public context: YesNoMetadataContext;

    public constructor(init?: Partial<ValidateYesNoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateYesNoResponse(); }
    public getTypeName() { return 'ValidateYesNoRequest'; }
}

// @Route("/api/v2/yes-nos/form", "POST")
export class SubmitYesNoFormRequest implements IReturn<SubmitYesNoFormResponse>
{
    public model: YesNo;
    public mode: SaveMode;
    public context: YesNoMetadataContext;

    public constructor(init?: Partial<SubmitYesNoFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitYesNoFormResponse(); }
    public getTypeName() { return 'SubmitYesNoFormRequest'; }
}

// @Route("/api/v2/yes-no-pendings/metadata", "POST")
export class GetYesNoPendingMetadataRequest implements IReturn<GetYesNoPendingMetadataResponse>
{
    public model: YesNoPending;
    public context: YesNoPendingMetadataContext;

    public constructor(init?: Partial<GetYesNoPendingMetadataRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoPendingMetadataResponse(); }
    public getTypeName() { return 'GetYesNoPendingMetadataRequest'; }
}

// @Route("/api/v2/yes-no-pendings/lookup-updates", "POST")
export class GetYesNoPendingLookupUpdatesRequest implements IReturn<GetYesNoPendingLookupUpdatesResponse>
{
    public model: YesNoPending;
    public changes: FieldChange[];
    public context: YesNoPendingMetadataContext;
    public propertyPath: string;
    public dependentValues: { [index: string]: Object; };

    public constructor(init?: Partial<GetYesNoPendingLookupUpdatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoPendingLookupUpdatesResponse(); }
    public getTypeName() { return 'GetYesNoPendingLookupUpdatesRequest'; }
}

// @Route("/api/v2/yes-no-pendings/validate", "POST")
export class ValidateYesNoPendingRequest implements IReturn<ValidateYesNoPendingResponse>
{
    public model: YesNoPending;
    public context: YesNoPendingMetadataContext;

    public constructor(init?: Partial<ValidateYesNoPendingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateYesNoPendingResponse(); }
    public getTypeName() { return 'ValidateYesNoPendingRequest'; }
}

// @Route("/api/v2/yes-no-pendings/form", "POST")
export class SubmitYesNoPendingFormRequest implements IReturn<SubmitYesNoPendingFormResponse>
{
    public model: YesNoPending;
    public mode: SaveMode;
    public context: YesNoPendingMetadataContext;

    public constructor(init?: Partial<SubmitYesNoPendingFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitYesNoPendingFormResponse(); }
    public getTypeName() { return 'SubmitYesNoPendingFormRequest'; }
}

// @Route("/api/v2/group-summaries", "GET")
export class GetGroupSummariesRequest implements IReturn<GetGroupSummariesResponse>
{

    public constructor(init?: Partial<GetGroupSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupSummariesResponse(); }
    public getTypeName() { return 'GetGroupSummariesRequest'; }
}

// @Route("/api/v2/group-item-summaries", "GET")
export class GetGroupItemSummariesRequest implements IReturn<GetGroupItemSummariesResponse>
{

    public constructor(init?: Partial<GetGroupItemSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemSummariesResponse(); }
    public getTypeName() { return 'GetGroupItemSummariesRequest'; }
}

// @Route("/api/v2/groups/{GroupId}/group-item-summaries", "GET")
export class GetGroupItemSummariesByGroupIdRequest implements IReturn<GetGroupItemSummariesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupItemSummariesByGroupIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemSummariesResponse(); }
    public getTypeName() { return 'GetGroupItemSummariesByGroupIdRequest'; }
}

// @Route("/api/v2/group-note-summaries", "GET")
export class GetGroupNoteSummariesRequest implements IReturn<GetGroupNoteSummariesResponse>
{

    public constructor(init?: Partial<GetGroupNoteSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNoteSummariesResponse(); }
    public getTypeName() { return 'GetGroupNoteSummariesRequest'; }
}

// @Route("/api/v2/groups/{GroupId}/group-note-summaries", "GET")
export class GetGroupNoteSummariesByGroupIdRequest implements IReturn<GetGroupNoteSummariesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetGroupNoteSummariesByGroupIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNoteSummariesResponse(); }
    public getTypeName() { return 'GetGroupNoteSummariesByGroupIdRequest'; }
}

// @Route("/api/v2/personnel-summaries", "GET")
export class GetPersonnelSummariesRequest implements IReturn<GetPersonnelSummariesResponse>
{

    public constructor(init?: Partial<GetPersonnelSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelSummariesRequest'; }
}

// @Route("/api/v2/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{

    public constructor(init?: Partial<GetPersonnelRoleSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesRequest'; }
}

// @Route("/api/v2/personnel/{PersonnelId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByPersonnelIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public personnelId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByPersonnelIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByPersonnelIdRequest'; }
}

// @Route("/api/v2/roles/{RoleId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByRoleIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public roleId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByRoleIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByRoleIdRequest'; }
}

// @Route("/api/v2/groups/{GroupId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByGroupIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByGroupIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByGroupIdRequest'; }
}

// @Route("/api/v2/institutions/{InstitutionId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByInstitutionIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByInstitutionIdRequest'; }
}

// @Route("/api/v2/departments/{DepartmentId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByDepartmentIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public departmentId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByDepartmentIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByDepartmentIdRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByTrialIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/personnel-role-summaries", "GET")
export class GetPersonnelRoleSummariesByTrialInstitutionIdRequest implements IReturn<GetPersonnelRoleSummariesResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetPersonnelRoleSummariesByTrialInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelRoleSummariesByTrialInstitutionIdRequest'; }
}

// @Route("/api/v2/personnel-note-summaries", "GET")
export class GetPersonnelNoteSummariesRequest implements IReturn<GetPersonnelNoteSummariesResponse>
{

    public constructor(init?: Partial<GetPersonnelNoteSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNoteSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelNoteSummariesRequest'; }
}

// @Route("/api/v2/personnel/{PersonnelId}/personnel-note-summaries", "GET")
export class GetPersonnelNoteSummariesByPersonnelIdRequest implements IReturn<GetPersonnelNoteSummariesResponse>
{
    public personnelId: number;

    public constructor(init?: Partial<GetPersonnelNoteSummariesByPersonnelIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNoteSummariesResponse(); }
    public getTypeName() { return 'GetPersonnelNoteSummariesByPersonnelIdRequest'; }
}

// @Route("/api/v2/institution-summaries", "GET")
export class GetInstitutionSummariesRequest implements IReturn<GetInstitutionSummariesResponse>
{

    public constructor(init?: Partial<GetInstitutionSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionSummariesResponse(); }
    public getTypeName() { return 'GetInstitutionSummariesRequest'; }
}

// @Route("/api/v2/department-summaries", "GET")
export class GetDepartmentSummariesRequest implements IReturn<GetDepartmentSummariesResponse>
{

    public constructor(init?: Partial<GetDepartmentSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentSummariesResponse(); }
    public getTypeName() { return 'GetDepartmentSummariesRequest'; }
}

// @Route("/api/v2/institutions/{InstitutionId}/department-summaries", "GET")
export class GetDepartmentSummariesByInstitutionIdRequest implements IReturn<GetDepartmentSummariesResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetDepartmentSummariesByInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentSummariesResponse(); }
    public getTypeName() { return 'GetDepartmentSummariesByInstitutionIdRequest'; }
}

// @Route("/api/v2/institution-forms/{InstitutionFormId}/summary", "GET")
export class GetInstitutionFormSummaryByInstitutionFormIdRequest implements IReturn<GetInstitutionFormSummaryByInstitutionFormIdResponse>, IGet
{
    public institutionFormId?: number;

    public constructor(init?: Partial<GetInstitutionFormSummaryByInstitutionFormIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormSummaryByInstitutionFormIdResponse(); }
    public getTypeName() { return 'GetInstitutionFormSummaryByInstitutionFormIdRequest'; }
}

// @Route("/api/v2/institution-form-summaries", "GET")
export class GetInstitutionFormSummariesRequest implements IReturn<GetInstitutionFormSummariesResponse>
{

    public constructor(init?: Partial<GetInstitutionFormSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormSummariesResponse(); }
    public getTypeName() { return 'GetInstitutionFormSummariesRequest'; }
}

// @Route("/api/v2/institutions/{InstitutionId}/institution-form-summaries", "GET")
export class GetInstitutionFormSummariesByInstitutionIdRequest implements IReturn<GetInstitutionFormSummariesResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionFormSummariesByInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormSummariesResponse(); }
    public getTypeName() { return 'GetInstitutionFormSummariesByInstitutionIdRequest'; }
}

// @Route("/api/v2/institution-note-summaries", "GET")
export class GetInstitutionNoteSummariesRequest implements IReturn<GetInstitutionNoteSummariesResponse>
{

    public constructor(init?: Partial<GetInstitutionNoteSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNoteSummariesResponse(); }
    public getTypeName() { return 'GetInstitutionNoteSummariesRequest'; }
}

// @Route("/api/v2/institutions/{InstitutionId}/institution-note-summaries", "GET")
export class GetInstitutionNoteSummariesByInstitutionIdRequest implements IReturn<GetInstitutionNoteSummariesResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetInstitutionNoteSummariesByInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNoteSummariesResponse(); }
    public getTypeName() { return 'GetInstitutionNoteSummariesByInstitutionIdRequest'; }
}

// @Route("/api/v2/trial-forms/{TrialFormId}/summary", "GET")
export class GetTrialFormSummaryByTrialFormIdRequest implements IReturn<GetTrialFormSummaryByTrialFormIdResponse>, IGet
{
    public trialFormId?: number;

    public constructor(init?: Partial<GetTrialFormSummaryByTrialFormIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormSummaryByTrialFormIdResponse(); }
    public getTypeName() { return 'GetTrialFormSummaryByTrialFormIdRequest'; }
}

// @Route("/api/v2/trial-form-summaries", "GET")
export class GetTrialFormSummariesRequest implements IReturn<GetTrialFormSummariesResponse>
{

    public constructor(init?: Partial<GetTrialFormSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormSummariesResponse(); }
    public getTypeName() { return 'GetTrialFormSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-form-summaries", "GET")
export class GetTrialFormSummariesByTrialIdRequest implements IReturn<GetTrialFormSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialFormSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormSummariesResponse(); }
    public getTypeName() { return 'GetTrialFormSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-form-administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-form-administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsByTrialIdRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsByTrialIdRequest'; }
}

// @Route("/api/v2/institutions/{InstitutionId}/trial-form-administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsByInstitutionIdRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{
    public institutionId: number;

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsByInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsByInstitutionIdRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/trial-form-administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsByTrialInstitutionIdRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsByTrialInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsByTrialInstitutionIdRequest'; }
}

// @Route("/api/v2/trial-forms/{TrialFormId}/administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsByTrialFormIdRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{
    public trialFormId: number;

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsByTrialFormIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsByTrialFormIdRequest'; }
}

// @Route("/api/v2/patients/{PatientId}/trial-form-administration-case-reports", "GET")
export class GetTrialFormAdministrationCaseReportsByPatientIdRequest implements IReturn<GetTrialFormAdministrationCaseReportsResponse>
{
    public patientId: number;

    public constructor(init?: Partial<GetTrialFormAdministrationCaseReportsByPatientIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormAdministrationCaseReportsResponse(); }
    public getTypeName() { return 'GetTrialFormAdministrationCaseReportsByPatientIdRequest'; }
}

// @Route("/api/v2/trial-group-summaries", "GET")
export class GetTrialGroupSummariesRequest implements IReturn<GetTrialGroupSummariesResponse>
{

    public constructor(init?: Partial<GetTrialGroupSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupSummariesResponse(); }
    public getTypeName() { return 'GetTrialGroupSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-group-summaries", "GET")
export class GetTrialGroupSummariesByTrialIdRequest implements IReturn<GetTrialGroupSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialGroupSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupSummariesResponse(); }
    public getTypeName() { return 'GetTrialGroupSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/groups/{GroupId}/trial-group-summaries", "GET")
export class GetTrialGroupSummariesByGroupIdRequest implements IReturn<GetTrialGroupSummariesResponse>
{
    public groupId: number;

    public constructor(init?: Partial<GetTrialGroupSummariesByGroupIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupSummariesResponse(); }
    public getTypeName() { return 'GetTrialGroupSummariesByGroupIdRequest'; }
}

// @Route("/api/v2/trial-note-summaries", "GET")
export class GetTrialNoteSummariesRequest implements IReturn<GetTrialNoteSummariesResponse>
{

    public constructor(init?: Partial<GetTrialNoteSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNoteSummariesResponse(); }
    public getTypeName() { return 'GetTrialNoteSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-note-summaries", "GET")
export class GetTrialNoteSummariesByTrialIdRequest implements IReturn<GetTrialNoteSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialNoteSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNoteSummariesResponse(); }
    public getTypeName() { return 'GetTrialNoteSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/patient-summaries", "GET")
export class GetPatientSummariesRequest implements IReturn<GetPatientSummariesResponse>
{

    public constructor(init?: Partial<GetPatientSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientSummariesResponse(); }
    public getTypeName() { return 'GetPatientSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/patient-summaries", "GET")
export class GetPatientSummariesByTrialIdRequest implements IReturn<GetPatientSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetPatientSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientSummariesResponse(); }
    public getTypeName() { return 'GetPatientSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/patient-summaries", "GET")
export class GetPatientSummariesByTrialInstitutionIdRequest implements IReturn<GetPatientSummariesResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetPatientSummariesByTrialInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientSummariesResponse(); }
    public getTypeName() { return 'GetPatientSummariesByTrialInstitutionIdRequest'; }
}

// @Route("/api/v2/trial-tracker-summaries", "GET")
export class GetTrialTrackerSummariesRequest implements IReturn<GetTrialTrackerSummariesResponse>
{

    public constructor(init?: Partial<GetTrialTrackerSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackerSummariesResponse(); }
    public getTypeName() { return 'GetTrialTrackerSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-tracker-summaries", "GET")
export class GetTrialTrackerSummariesByTrialIdRequest implements IReturn<GetTrialTrackerSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialTrackerSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackerSummariesResponse(); }
    public getTypeName() { return 'GetTrialTrackerSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-treatment-summaries", "GET")
export class GetTrialTreatmentSummariesRequest implements IReturn<GetTrialTreatmentSummariesResponse>
{

    public constructor(init?: Partial<GetTrialTreatmentSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentSummariesResponse(); }
    public getTypeName() { return 'GetTrialTreatmentSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-treatment-summaries", "GET")
export class GetTrialTreatmentSummariesByTrialIdRequest implements IReturn<GetTrialTreatmentSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialTreatmentSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentSummariesResponse(); }
    public getTypeName() { return 'GetTrialTreatmentSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-item-instance-summaries", "GET")
export class GetTrialItemInstanceSummariesRequest implements IReturn<GetTrialItemInstanceSummariesResponse>
{

    public constructor(init?: Partial<GetTrialItemInstanceSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceSummariesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-item-instance-summaries", "GET")
export class GetTrialItemInstanceSummariesByTrialIdRequest implements IReturn<GetTrialItemInstanceSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialItemInstanceSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceSummariesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/trial-item-instances/{TrialItemInstanceId}/summaries", "GET")
export class GetTrialItemInstanceSummariesByTrialItemInstanceIdRequest implements IReturn<GetTrialItemInstanceSummariesResponse>
{
    public trialItemInstanceId: number;

    public constructor(init?: Partial<GetTrialItemInstanceSummariesByTrialItemInstanceIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceSummariesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceSummariesByTrialItemInstanceIdRequest'; }
}

// @Route("/api/v2/trial-institution-item-summaries", "GET")
export class GetTrialInstitutionItemSummariesRequest implements IReturn<GetTrialInstitutionItemSummariesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionItemSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemSummariesRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/trial-institution-item-summaries", "GET")
export class GetTrialInstitutionItemSummariesByTrialInstitutionIdRequest implements IReturn<GetTrialInstitutionItemSummariesResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemSummariesByTrialInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemSummariesByTrialInstitutionIdRequest'; }
}

// @Route("/api/v2/trial-institution-items/{TrialInstitutionItemId}/summaries", "GET")
export class GetTrialInstitutionItemSummariesByTrialInstitutionItemIdRequest implements IReturn<GetTrialInstitutionItemSummariesResponse>
{
    public trialInstitutionItemId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemSummariesByTrialInstitutionItemIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemSummariesByTrialInstitutionItemIdRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{TrialInstitutionItemTemplateId}/trial-institution-item-summaries", "GET")
export class GetTrialInstitutionItemSummariesByTrialInstitutionItemTemplateIdRequest implements IReturn<GetTrialInstitutionItemSummariesResponse>
{
    public trialInstitutionItemTemplateId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemSummariesByTrialInstitutionItemTemplateIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemSummariesByTrialInstitutionItemTemplateIdRequest'; }
}

// @Route("/api/v2/trial-institution-note-summaries", "GET")
export class GetTrialInstitutionNoteSummariesRequest implements IReturn<GetTrialInstitutionNoteSummariesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionNoteSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNoteSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNoteSummariesRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/trial-institution-note-summaries", "GET")
export class GetTrialInstitutionNoteSummariesByTrialInstitutionIdRequest implements IReturn<GetTrialInstitutionNoteSummariesResponse>
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionNoteSummariesByTrialInstitutionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNoteSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNoteSummariesByTrialInstitutionIdRequest'; }
}

// @Route("/api/v2/item-component-summaries", "GET")
export class GetItemComponentSummariesRequest implements IReturn<GetItemComponentSummariesResponse>
{

    public constructor(init?: Partial<GetItemComponentSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentSummariesResponse(); }
    public getTypeName() { return 'GetItemComponentSummariesRequest'; }
}

// @Route("/api/v2/template-trial-item-summaries", "GET")
export class GetTemplateTrialItemSummariesRequest implements IReturn<GetTemplateTrialItemSummariesResponse>
{

    public constructor(init?: Partial<GetTemplateTrialItemSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemplateTrialItemSummariesResponse(); }
    public getTypeName() { return 'GetTemplateTrialItemSummariesRequest'; }
}

// @Route("/api/v2/trial-institution-item-template-summaries", "GET")
export class GetTrialInstitutionItemTemplateSummariesRequest implements IReturn<GetTrialInstitutionItemTemplateSummariesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-institution-item-template-summaries", "GET")
export class GetTrialInstitutionItemTemplateSummariesByTrialIdRequest implements IReturn<GetTrialInstitutionItemTemplateSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/global-trial-institution-item-template-summaries", "GET")
export class GetGlobalTrialInstitutionItemTemplateSummariesRequest implements IReturn<GetTrialInstitutionItemTemplateSummariesResponse>
{

    public constructor(init?: Partial<GetGlobalTrialInstitutionItemTemplateSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateSummariesResponse(); }
    public getTypeName() { return 'GetGlobalTrialInstitutionItemTemplateSummariesRequest'; }
}

// @Route("/api/v2/open-clinica-user-role-summaries", "GET")
export class GetOpenClinicaUserRoleSummariesRequest implements IReturn<GetOpenClinicaUserRoleSummariesResponse>
{

    public constructor(init?: Partial<GetOpenClinicaUserRoleSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRoleSummariesResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRoleSummariesRequest'; }
}

// @Route("/api/v2/personnel/{PersonnelId}/open-clinica-user-role-summaries", "GET")
export class GetOpenClinicaUserRoleSummariesByPersonnelIdRequest implements IReturn<GetOpenClinicaUserRoleSummariesResponse>
{
    public personnelId: number;

    public constructor(init?: Partial<GetOpenClinicaUserRoleSummariesByPersonnelIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRoleSummariesResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRoleSummariesByPersonnelIdRequest'; }
}

// @Route("/api/v2/authentication/user", "GET")
export class GetUserRequest implements IReturn<GetUserResponse>
{

    public constructor(init?: Partial<GetUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetUserResponse(); }
    public getTypeName() { return 'GetUserRequest'; }
}

// @Route("/api/v2/settings/app", "GET")
export class GetAppSettingsRequest implements IReturn<GetAppSettingsResponse>
{

    public constructor(init?: Partial<GetAppSettingsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAppSettingsResponse(); }
    public getTypeName() { return 'GetAppSettingsRequest'; }
}

// @Route("/api/v2/dashboard/summary/trial-forms/current-user", "GET")
export class GetDashboardSummaryTrialFormsByCurrentUserRequest implements IReturn<GetDashboardSummaryTrialFormsByCurrentUserResponse>
{
    public itemComponentTypeId?: number;

    public constructor(init?: Partial<GetDashboardSummaryTrialFormsByCurrentUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDashboardSummaryTrialFormsByCurrentUserResponse(); }
    public getTypeName() { return 'GetDashboardSummaryTrialFormsByCurrentUserRequest'; }
}

// @Route("/api/v2/dashboard/summary/institution-forms/current-user", "GET")
export class GetDashboardSummaryInstitutionFormsByCurrentUserRequest implements IReturn<GetDashboardSummaryInstitutionFormsByCurrentUserResponse>
{
    public itemComponentTypeId?: number;

    public constructor(init?: Partial<GetDashboardSummaryInstitutionFormsByCurrentUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDashboardSummaryInstitutionFormsByCurrentUserResponse(); }
    public getTypeName() { return 'GetDashboardSummaryInstitutionFormsByCurrentUserRequest'; }
}

// @Route("/api/v2/dashboard/summary/trial-item-instances/current-user", "GET")
export class GetDashboardSummaryTrialItemInstancesByCurrentUserRequest implements IReturn<GetDashboardSummaryTrialItemInstancesByCurrentUserResponse>
{
    public formTemplateCategoryId?: number;

    public constructor(init?: Partial<GetDashboardSummaryTrialItemInstancesByCurrentUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDashboardSummaryTrialItemInstancesByCurrentUserResponse(); }
    public getTypeName() { return 'GetDashboardSummaryTrialItemInstancesByCurrentUserRequest'; }
}

// @Route("/api/v2/dashboard/summary/trial-institutions/current-user", "GET")
export class GetDashboardSummaryTrialInstitutionsByCurrentUserRequest implements IReturn<GetDashboardSummaryTrialInstitutionsByCurrentUserResponse>
{

    public constructor(init?: Partial<GetDashboardSummaryTrialInstitutionsByCurrentUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDashboardSummaryTrialInstitutionsByCurrentUserResponse(); }
    public getTypeName() { return 'GetDashboardSummaryTrialInstitutionsByCurrentUserRequest'; }
}

// @Route("/api/v2/dashboard/summary/trials/current-user", "GET")
export class GetDashboardSummaryTrialsByCurrentUserRequest implements IReturn<GetDashboardSummaryTrialsByCurrentUserResponse>
{

    public constructor(init?: Partial<GetDashboardSummaryTrialsByCurrentUserRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDashboardSummaryTrialsByCurrentUserResponse(); }
    public getTypeName() { return 'GetDashboardSummaryTrialsByCurrentUserRequest'; }
}

// @Route("/api/v2/search", "GET")
export class GetSearchResultsRequest implements IReturn<GetSearchResultsResponse>
{
    public searchFor: string;

    public constructor(init?: Partial<GetSearchResultsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSearchResultsResponse(); }
    public getTypeName() { return 'GetSearchResultsRequest'; }
}

// @Route("/api/v2/temporary-file/upload", "POST")
export class UploadTemporaryFileRequest implements IReturn<UploadTemporaryFileResponse>
{
    public json: boolean;

    public constructor(init?: Partial<UploadTemporaryFileRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new UploadTemporaryFileResponse(); }
    public getTypeName() { return 'UploadTemporaryFileRequest'; }
}

// @Route("/api/v2/temporary-file/upload-chunk", "POST")
export class UploadTemporaryFileChunkRequest implements IReturn<UploadTemporaryFileChunkResponse>
{
    public uploadId: string;
    public chunkIndex: number;
    public totalChunks: number;
    public fileName: string;
    public uploadAttempt: number;
    public json: boolean;

    public constructor(init?: Partial<UploadTemporaryFileChunkRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new UploadTemporaryFileChunkResponse(); }
    public getTypeName() { return 'UploadTemporaryFileChunkRequest'; }
}

// @Route("/api/v2/temporary-file/info/{Guid}", "GET")
export class GetTemporaryFileInfoRequest implements IReturn<GetTemporaryFileInfoResponse>
{
    public guid: string;

    public constructor(init?: Partial<GetTemporaryFileInfoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemporaryFileInfoResponse(); }
    public getTypeName() { return 'GetTemporaryFileInfoRequest'; }
}

// @Route("/api/v2/temporary-file/remove", "POST")
export class RemoveTemporaryFileRequest implements IReturn<RemoveTemporaryFileResponse>
{
    public guid: string;

    public constructor(init?: Partial<RemoveTemporaryFileRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new RemoveTemporaryFileResponse(); }
    public getTypeName() { return 'RemoveTemporaryFileRequest'; }
}

// @Route("/api/v2/temporary-file/{Guid}", "GET")
export class GetTemporaryFileRequest
{
    public guid: string;

    public constructor(init?: Partial<GetTemporaryFileRequest>) { (Object as any).assign(this, init); }
}

// @Route("/api/v2/temporary-file/download/{Guid}", "GET")
export class DownloadTemporaryFileRequest
{
    public guid: string;

    public constructor(init?: Partial<DownloadTemporaryFileRequest>) { (Object as any).assign(this, init); }
}

// @Route("/api/v2/source-document/{Id}", "GET")
export class GetSourceDocumentFileRequest
{
    public id: number;

    public constructor(init?: Partial<GetSourceDocumentFileRequest>) { (Object as any).assign(this, init); }
}

// @Route("/api/v2/source-document/download/{Id}", "GET")
export class DownloadSourceDocumentFileRequest
{
    public id: number;

    public constructor(init?: Partial<DownloadSourceDocumentFileRequest>) { (Object as any).assign(this, init); }
}

// @Route("/api/v2/temporary-file/begin-parallel-chunk", "POST")
export class BeginTemporaryFileParallelChunkRequest implements IReturn<BeginTemporaryFileParallelChunkResponse>
{
    public totalChunks?: number;
    public chunkSize?: number;
    public fileName: string;

    public constructor(init?: Partial<BeginTemporaryFileParallelChunkRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new BeginTemporaryFileParallelChunkResponse(); }
    public getTypeName() { return 'BeginTemporaryFileParallelChunkRequest'; }
}

// @Route("/api/v2/temporary-file/resume-parallel-chunk", "GET")
export class GetTemporaryFileParallelChunkStatusRequest implements IReturn<GetTemporaryFileParallelChunkStatusResponse>
{
    public uploadId: string;

    public constructor(init?: Partial<GetTemporaryFileParallelChunkStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemporaryFileParallelChunkStatusResponse(); }
    public getTypeName() { return 'GetTemporaryFileParallelChunkStatusRequest'; }
}

// @Route("/api/v2/temporary-file/remove-parallel-chunk", "POST")
export class RemoveTemporaryFileParallelChunkRequest implements IReturn<RemoveTemporaryFileParallelChunkResponse>
{
    public uploadId: string;

    public constructor(init?: Partial<RemoveTemporaryFileParallelChunkRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new RemoveTemporaryFileParallelChunkResponse(); }
    public getTypeName() { return 'RemoveTemporaryFileParallelChunkRequest'; }
}

// @Route("/api/v2/temporary-file/upload-parallel-chunk", "POST")
export class UploadTemporaryFileParallelChunkRequest implements IReturn<UploadTemporaryFileParallelChunkResponse>
{

    public constructor(init?: Partial<UploadTemporaryFileParallelChunkRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new UploadTemporaryFileParallelChunkResponse(); }
    public getTypeName() { return 'UploadTemporaryFileParallelChunkRequest'; }
}

// @Route("/api/v2/collection-instance-entries/{Id}", "GET")
export class GetCollectionInstanceEntryRequest implements IReturn<GetCollectionInstanceEntryResponse>, IGet
{
    public id: number;

    public constructor(init?: Partial<GetCollectionInstanceEntryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstanceEntryResponse(); }
    public getTypeName() { return 'GetCollectionInstanceEntryRequest'; }
}

// @Route("/api/v2/collection-instance-entries/by-ids", "POST")
export class GetCollectionInstanceEntriesByIdsRequest implements IReturn<GetCollectionInstanceEntriesResponse>, IPost
{
    public ids: number[];

    public constructor(init?: Partial<GetCollectionInstanceEntriesByIdsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstanceEntriesResponse(); }
    public getTypeName() { return 'GetCollectionInstanceEntriesByIdsRequest'; }
}

// @Route("/api/v2/collection-instance-entries/submit-batch", "POST")
export class SubmitCollectionInstanceEntriesRequest implements IReturn<SubmitCollectionInstanceEntriesResponse>, IPost
{
    public submissions: CollectionInstanceEntrySubmission[];
    public mode: SaveMode;

    public constructor(init?: Partial<SubmitCollectionInstanceEntriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCollectionInstanceEntriesResponse(); }
    public getTypeName() { return 'SubmitCollectionInstanceEntriesRequest'; }
}

// @Route("/api/v2/collection-instance-entries/submit", "POST")
export class SubmitCollectionInstanceEntryRequest implements IReturn<SubmitCollectionInstanceEntryResponse>, IPost
{
    public model: CollectionInstanceEntry;
    public context: CollectionInstanceMetadataContext;
    public mode: SaveMode;

    public constructor(init?: Partial<SubmitCollectionInstanceEntryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SubmitCollectionInstanceEntryResponse(); }
    public getTypeName() { return 'SubmitCollectionInstanceEntryRequest'; }
}

// @Route("/api/v2/collection-instance-entries/validate", "POST")
export class ValidateCollectionInstanceEntryRequest implements IReturn<ValidateCollectionInstanceEntryResponse>, IPost
{
    public model: CollectionInstanceEntry;
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<ValidateCollectionInstanceEntryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ValidateCollectionInstanceEntryResponse(); }
    public getTypeName() { return 'ValidateCollectionInstanceEntryRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{TrialInstitutionItemTemplateId}/out-of-scope-active-items", "GET")
export class GetTrialInstitutionItemTemplateOutOfScopeItemsRequest implements IReturn<GetTrialInstitutionItemTemplateOutOfScopeItemsResponse>, IGet
{
    public trialInstitutionItemTemplateId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateOutOfScopeItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateOutOfScopeItemsResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateOutOfScopeItemsRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{TrialInstitutionItemTemplateId}/deactivation-policy", "POST")
export class ApplyTrialInstitutionItemTemplateDeactivationPolicyRequest implements IReturn<ApplyTrialInstitutionItemTemplateDeactivationPolicyResponse>, IPost
{
    public trialInstitutionItemTemplateId: number;
    public policy: TrialInstitutionItemDeactivationPolicy;

    public constructor(init?: Partial<ApplyTrialInstitutionItemTemplateDeactivationPolicyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ApplyTrialInstitutionItemTemplateDeactivationPolicyResponse(); }
    public getTypeName() { return 'ApplyTrialInstitutionItemTemplateDeactivationPolicyRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/out-of-scope-active-items", "GET")
export class GetTrialInstitutionOutOfScopeItemsRequest implements IReturn<GetTrialInstitutionOutOfScopeItemsResponse>, IGet
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionOutOfScopeItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionOutOfScopeItemsResponse(); }
    public getTypeName() { return 'GetTrialInstitutionOutOfScopeItemsRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/deactivation-policy", "POST")
export class ApplyTrialInstitutionDeactivationPolicyRequest implements IReturn<ApplyTrialInstitutionDeactivationPolicyResponse>, IPost
{
    public trialInstitutionId: number;
    public policy: TrialInstitutionItemDeactivationPolicy;

    public constructor(init?: Partial<ApplyTrialInstitutionDeactivationPolicyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ApplyTrialInstitutionDeactivationPolicyResponse(); }
    public getTypeName() { return 'ApplyTrialInstitutionDeactivationPolicyRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{TrialInstitutionItemTemplateId}/reactivation-candidates", "GET")
export class GetTrialInstitutionItemTemplateReactivationCandidatesRequest implements IReturn<GetTrialInstitutionItemTemplateReactivationCandidatesResponse>, IGet
{
    public trialInstitutionItemTemplateId: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateReactivationCandidatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateReactivationCandidatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateReactivationCandidatesRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{TrialInstitutionItemTemplateId}/reactivation-policy", "POST")
export class ApplyTrialInstitutionItemTemplateReactivationPolicyRequest implements IReturn<ApplyTrialInstitutionItemTemplateReactivationPolicyResponse>, IPost
{
    public trialInstitutionItemTemplateId: number;
    public policy: TrialInstitutionItemReactivationPolicy;

    public constructor(init?: Partial<ApplyTrialInstitutionItemTemplateReactivationPolicyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ApplyTrialInstitutionItemTemplateReactivationPolicyResponse(); }
    public getTypeName() { return 'ApplyTrialInstitutionItemTemplateReactivationPolicyRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/reactivation-candidates", "GET")
export class GetTrialInstitutionReactivationCandidatesRequest implements IReturn<GetTrialInstitutionReactivationCandidatesResponse>, IGet
{
    public trialInstitutionId: number;

    public constructor(init?: Partial<GetTrialInstitutionReactivationCandidatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionReactivationCandidatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionReactivationCandidatesRequest'; }
}

// @Route("/api/v2/trial-institutions/{TrialInstitutionId}/reactivation-policy", "POST")
export class ApplyTrialInstitutionReactivationPolicyRequest implements IReturn<ApplyTrialInstitutionReactivationPolicyResponse>, IPost
{
    public trialInstitutionId: number;
    public policy: TrialInstitutionItemReactivationPolicy;

    public constructor(init?: Partial<ApplyTrialInstitutionReactivationPolicyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ApplyTrialInstitutionReactivationPolicyResponse(); }
    public getTypeName() { return 'ApplyTrialInstitutionReactivationPolicyRequest'; }
}

// @Route("/api/v2/trial-identities", "GET")
export class GetTrialIdentitiesRequest implements IReturn<GetTrialIdentitiesResponse>
{

    public constructor(init?: Partial<GetTrialIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialIdentitiesResponse(); }
    public getTypeName() { return 'GetTrialIdentitiesRequest'; }
}

// @Route("/api/v2/trial-identities/{Id}", "GET")
export class GetTrialIdentityByIdRequest implements IReturn<GetTrialIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetTrialIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialIdentityByIdResponse(); }
    public getTypeName() { return 'GetTrialIdentityByIdRequest'; }
}

// @Route("/api/v2/trial-summaries", "GET")
export class GetTrialSummariesRequest implements IReturn<GetTrialSummariesResponse>
{

    public constructor(init?: Partial<GetTrialSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialSummariesResponse(); }
    public getTypeName() { return 'GetTrialSummariesRequest'; }
}

// @Route("/api/v2/trial-institution-identities", "GET")
export class GetTrialInstitutionIdentitiesRequest implements IReturn<GetTrialInstitutionIdentitiesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionIdentitiesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionIdentitiesRequest'; }
}

// @Route("/api/v2/trial-institution-identities/{Id}", "GET")
export class GetTrialInstitutionIdentityByIdRequest implements IReturn<GetTrialInstitutionIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionIdentityByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionIdentityByIdRequest'; }
}

// @Route("/api/v2/trial-institution-summaries", "GET")
export class GetTrialInstitutionSummariesRequest implements IReturn<GetTrialInstitutionSummariesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionSummariesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionSummariesRequest'; }
}

// @Route("/api/v2/trials/{TrialId}/trial-institution-summaries", "GET")
export class GetTrialInstitutionSummariesByTrialIdRequest implements IReturn<GetTrialInstitutionSummariesResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialInstitutionSummariesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionSummariesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionSummariesByTrialIdRequest'; }
}

// @Route("/api/v2/institution-identities", "GET")
export class GetInstitutionIdentitiesRequest implements IReturn<GetInstitutionIdentitiesResponse>
{

    public constructor(init?: Partial<GetInstitutionIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionIdentitiesResponse(); }
    public getTypeName() { return 'GetInstitutionIdentitiesRequest'; }
}

// @Route("/api/v2/institution-identities/{Id}", "GET")
export class GetInstitutionIdentityByIdRequest implements IReturn<GetInstitutionIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionIdentityByIdResponse(); }
    public getTypeName() { return 'GetInstitutionIdentityByIdRequest'; }
}

// @Route("/api/v2/department-identities", "GET")
export class GetDepartmentIdentitiesRequest implements IReturn<GetDepartmentIdentitiesResponse>
{

    public constructor(init?: Partial<GetDepartmentIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentIdentitiesResponse(); }
    public getTypeName() { return 'GetDepartmentIdentitiesRequest'; }
}

// @Route("/api/v2/department-identities/{Id}", "GET")
export class GetDepartmentIdentityByIdRequest implements IReturn<GetDepartmentIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetDepartmentIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentIdentityByIdResponse(); }
    public getTypeName() { return 'GetDepartmentIdentityByIdRequest'; }
}

// @Route("/api/v2/patient-identities", "GET")
export class GetPatientIdentitiesRequest implements IReturn<GetPatientIdentitiesResponse>
{

    public constructor(init?: Partial<GetPatientIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientIdentitiesResponse(); }
    public getTypeName() { return 'GetPatientIdentitiesRequest'; }
}

// @Route("/api/v2/patient-identities/{Id}", "GET")
export class GetPatientIdentityByIdRequest implements IReturn<GetPatientIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetPatientIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientIdentityByIdResponse(); }
    public getTypeName() { return 'GetPatientIdentityByIdRequest'; }
}

// @Route("/api/v2/group-identities", "GET")
export class GetGroupIdentitiesRequest implements IReturn<GetGroupIdentitiesResponse>
{

    public constructor(init?: Partial<GetGroupIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupIdentitiesResponse(); }
    public getTypeName() { return 'GetGroupIdentitiesRequest'; }
}

// @Route("/api/v2/group-identities/{Id}", "GET")
export class GetGroupIdentityByIdRequest implements IReturn<GetGroupIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetGroupIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupIdentityByIdResponse(); }
    public getTypeName() { return 'GetGroupIdentityByIdRequest'; }
}

// @Route("/api/v2/personnel-identities", "GET")
export class GetPersonnelIdentitiesRequest implements IReturn<GetPersonnelIdentitiesResponse>
{

    public constructor(init?: Partial<GetPersonnelIdentitiesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelIdentitiesResponse(); }
    public getTypeName() { return 'GetPersonnelIdentitiesRequest'; }
}

// @Route("/api/v2/personnel-identities/{Id}", "GET")
export class GetPersonnelIdentityByIdRequest implements IReturn<GetPersonnelIdentityByIdResponse>, IGet
{
    public id?: number;

    public constructor(init?: Partial<GetPersonnelIdentityByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelIdentityByIdResponse(); }
    public getTypeName() { return 'GetPersonnelIdentityByIdRequest'; }
}

// @Route("/api/v2/trial-forms/{TrialFormId}/measurement-report", "GET")
export class GetMeasurementReportByTrialFormIdRequest implements IReturn<GetMeasurementReportByTrialFormIdResponse>
{
    public trialFormId: number;

    public constructor(init?: Partial<GetMeasurementReportByTrialFormIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMeasurementReportByTrialFormIdResponse(); }
    public getTypeName() { return 'GetMeasurementReportByTrialFormIdRequest'; }
}

// @Route("/api/v2/trial-forms/{TrialFormId}/measurement-report/justified", "POST")
export class SetMeasurementReportClassificationJustifiedRequest implements IReturn<SetMeasurementReportClassificationJustifiedResponse>
{
    public trialFormId: number;
    public collectionInstanceDataId: number;
    public justified: boolean;

    public constructor(init?: Partial<SetMeasurementReportClassificationJustifiedRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SetMeasurementReportClassificationJustifiedResponse(); }
    public getTypeName() { return 'SetMeasurementReportClassificationJustifiedRequest'; }
}

// @Route("/api/v2/trial-form-reports/by-trial-form/{TrialFormId}", "GET")
export class GetTrialFormReportByTrialFormIdRequest implements IReturn<GetTrialFormReportByTrialFormIdResponse>
{
    public trialFormId: number;

    public constructor(init?: Partial<GetTrialFormReportByTrialFormIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormReportByTrialFormIdResponse(); }
    public getTypeName() { return 'GetTrialFormReportByTrialFormIdRequest'; }
}

// @Route("/api/v2/trial-apis/by-trial/{TrialId}", "GET")
export class GetTrialApiByTrialIdRequest implements IReturn<GetTrialApiByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialApiByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialApiByTrialIdResponse(); }
    public getTypeName() { return 'GetTrialApiByTrialIdRequest'; }
}

// @Route("/api/v2/trial-milestones/by-trial/{TrialId}", "GET")
export class GetTrialMilestonesByTrialIdRequest implements IReturn<GetTrialMilestonesByTrialIdResponse>
{
    public trialId: number;

    public constructor(init?: Partial<GetTrialMilestonesByTrialIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMilestonesByTrialIdResponse(); }
    public getTypeName() { return 'GetTrialMilestonesByTrialIdRequest'; }
}

// @Route("/trogapi/institution", "GET")
// @Route("/trogapi/institution/{Id}", "GET")
export class TrogApiGetInstitutionRequest implements IReturn<TrogApiGetInstitutionResponse>, IGet
{
    public id?: number;
    public code: string;

    public constructor(init?: Partial<TrogApiGetInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetInstitutionResponse(); }
    public getTypeName() { return 'TrogApiGetInstitutionRequest'; }
}

// @Route("/trogapi/trial/institutions", "GET")
// @Route("/trogapi/trial/institutions/{Code}", "GET")
export class TrogApiGetTrialInstitutionsRequest implements IReturn<TrogApiGetTrialInstitutionsResponse>, IGet
{
    public id?: number;
    public code: string;

    public constructor(init?: Partial<TrogApiGetTrialInstitutionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetTrialInstitutionsResponse(); }
    public getTypeName() { return 'TrogApiGetTrialInstitutionsRequest'; }
}

// @Route("/trogapi/users", "GET")
export class TrogApiGetUsersRequest implements IReturn<TrogApiGetUsersResponse>, IGet
{
    public trialId?: number;
    public instId?: number;
    public groupIds: number[];

    public constructor(init?: Partial<TrogApiGetUsersRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetUsersResponse(); }
    public getTypeName() { return 'TrogApiGetUsersRequest'; }
}

// @Route("/trogapi/usersapikey", "GET")
export class TrogApiGetUserApiKeyRequest implements IReturn<TrogApiGetUserApiKeyResponse>, IGet
{
    public username: string;
    public apiKey: string;

    public constructor(init?: Partial<TrogApiGetUserApiKeyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetUserApiKeyResponse(); }
    public getTypeName() { return 'TrogApiGetUserApiKeyRequest'; }
}

// @Route("/trogapi/permissions/get-api-user", "GET")
export class TrogApiGetUserByUserNameRequest implements IReturn<TrogApiGetUserByUserNameResponse>, IGet
{
    public userName: string;

    public constructor(init?: Partial<TrogApiGetUserByUserNameRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetUserByUserNameResponse(); }
    public getTypeName() { return 'TrogApiGetUserByUserNameRequest'; }
}

// @Route("/trogapi/permission/single", "POST")
export class TrogApiHasPermissionRequest implements IReturn<TrogApiHasPermissionResponse>, IPost
{
    public username: string;
    public permissionQuery: TrogApiPermissionQuery;

    public constructor(init?: Partial<TrogApiHasPermissionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiHasPermissionResponse(); }
    public getTypeName() { return 'TrogApiHasPermissionRequest'; }
}

// @Route("/trogapi/permission/multi", "POST")
export class TrogApiHasPermissionsRequest implements IReturn<TrogApiHasPermissionsResponse>, IPost
{
    public username: string;
    public permissionQueries: TrogApiPermissionQuery[];

    public constructor(init?: Partial<TrogApiHasPermissionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiHasPermissionsResponse(); }
    public getTypeName() { return 'TrogApiHasPermissionsRequest'; }
}

// @Route("/trogapi/permission/any", "POST")
export class TrogApiHasPermissionsAnyRequest implements IReturn<TrogApiHasPermissionsAnyResponse>, IPost
{
    public username: string;
    public permissionQueries: TrogApiPermissionQuery[];

    public constructor(init?: Partial<TrogApiHasPermissionsAnyRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiHasPermissionsAnyResponse(); }
    public getTypeName() { return 'TrogApiHasPermissionsAnyRequest'; }
}

// @Route("/trogapi/permission/all", "POST")
export class TrogApiHasPermissionsAllRequest implements IReturn<TrogApiHasPermissionsAllResponse>, IPost
{
    public username: string;
    public permissionQueries: TrogApiPermissionQuery[];

    public constructor(init?: Partial<TrogApiHasPermissionsAllRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiHasPermissionsAllResponse(); }
    public getTypeName() { return 'TrogApiHasPermissionsAllRequest'; }
}

// @Route("/trogapi/permission/evaluate-all", "POST")
export class TrogApiEvaluateAllPermissionsRequest implements IReturn<TrogApiEvaluateAllPermissionsResponse>, IPost
{
    public username: string;
    public permissionQueries: TrogApiPermissionQuery[];

    public constructor(init?: Partial<TrogApiEvaluateAllPermissionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiEvaluateAllPermissionsResponse(); }
    public getTypeName() { return 'TrogApiEvaluateAllPermissionsRequest'; }
}

// @Route("/trogapi/permission-configurations", "GET")
export class TrogApiGetPermissionConfigurationsRequest implements IReturn<TrogApiGetPermissionConfigurationsResponse>, IGet
{

    public constructor(init?: Partial<TrogApiGetPermissionConfigurationsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetPermissionConfigurationsResponse(); }
    public getTypeName() { return 'TrogApiGetPermissionConfigurationsRequest'; }
}

// @Route("/trogapi/permission-configuration", "GET")
export class TrogApiGetPermissionConfigurationByPermissionIdRequest implements IReturn<TrogApiGetPermissionConfigurationByPermissionIdResponse>, IGet
{
    public permission: Permission;

    public constructor(init?: Partial<TrogApiGetPermissionConfigurationByPermissionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetPermissionConfigurationByPermissionIdResponse(); }
    public getTypeName() { return 'TrogApiGetPermissionConfigurationByPermissionIdRequest'; }
}

// @Route("/trogapi/permissions/by-user-and-context", "POST")
export class TrogApiGetPermissionsForUserAndContextRequest implements IReturn<TrogApiGetPermissionsForUserAndContextResponse>, IPost
{
    public userName: string;
    public permissionResolutionType?: PermissionResolutionType;
    public permissionContext: TrogApiPermissionContext;
    public userType: string;
    public trialId?: number;
    public institutionCode: string;
    public email: string;

    public constructor(init?: Partial<TrogApiGetPermissionsForUserAndContextRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new TrogApiGetPermissionsForUserAndContextResponse(); }
    public getTypeName() { return 'TrogApiGetPermissionsForUserAndContextRequest'; }
}

// @Route("/api/v2/activities-undertaken/{Id}", "GET")
export class GetActivitiesUndertakenByIdRequest implements IReturn<GetActivitiesUndertakenByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetActivitiesUndertakenByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetActivitiesUndertakenByIdResponse(); }
    public getTypeName() { return 'GetActivitiesUndertakenByIdRequest'; }
}

// @Route("/api/v2/activities-undertaken", "GET")
export class GetActivitiesUndertakenListRequest implements IReturn<GetActivitiesUndertakenListResponse>
{

    public constructor(init?: Partial<GetActivitiesUndertakenListRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetActivitiesUndertakenListResponse(); }
    public getTypeName() { return 'GetActivitiesUndertakenListRequest'; }
}

// @Route("/api/v2/activities-undertaken/initial", "POST")
export class InitializeActivitiesUndertakenRequest implements IReturn<InitializeActivitiesUndertakenResponse>
{
    public context: ActivitiesUndertakenMetadataContext;

    public constructor(init?: Partial<InitializeActivitiesUndertakenRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeActivitiesUndertakenResponse(); }
    public getTypeName() { return 'InitializeActivitiesUndertakenRequest'; }
}

// @Route("/api/v2/activities-undertaken", "POST")
export class SaveActivitiesUndertakenRequest implements IReturn<SaveActivitiesUndertakenResponse>
{
    public model: ActivitiesUndertaken;

    public constructor(init?: Partial<SaveActivitiesUndertakenRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveActivitiesUndertakenResponse(); }
    public getTypeName() { return 'SaveActivitiesUndertakenRequest'; }
}

// @Route("/api/v2/activities-undertaken/{Id}", "DELETE")
export class DeleteActivitiesUndertakenRequest implements IReturn<DeleteActivitiesUndertakenResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteActivitiesUndertakenRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteActivitiesUndertakenResponse(); }
    public getTypeName() { return 'DeleteActivitiesUndertakenRequest'; }
}

// @Route("/api/v2/address-options/{Id}", "GET")
export class GetAddressOptionByIdRequest implements IReturn<GetAddressOptionByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetAddressOptionByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAddressOptionByIdResponse(); }
    public getTypeName() { return 'GetAddressOptionByIdRequest'; }
}

// @Route("/api/v2/address-options", "GET")
export class GetAddressOptionsRequest implements IReturn<GetAddressOptionsResponse>
{

    public constructor(init?: Partial<GetAddressOptionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAddressOptionsResponse(); }
    public getTypeName() { return 'GetAddressOptionsRequest'; }
}

// @Route("/api/v2/address-options/initial", "POST")
export class InitializeAddressOptionRequest implements IReturn<InitializeAddressOptionResponse>
{
    public context: AddressOptionMetadataContext;

    public constructor(init?: Partial<InitializeAddressOptionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeAddressOptionResponse(); }
    public getTypeName() { return 'InitializeAddressOptionRequest'; }
}

// @Route("/api/v2/address-options", "POST")
export class SaveAddressOptionRequest implements IReturn<SaveAddressOptionResponse>
{
    public model: AddressOption;

    public constructor(init?: Partial<SaveAddressOptionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveAddressOptionResponse(); }
    public getTypeName() { return 'SaveAddressOptionRequest'; }
}

// @Route("/api/v2/address-options/{Id}", "DELETE")
export class DeleteAddressOptionRequest implements IReturn<DeleteAddressOptionResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteAddressOptionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteAddressOptionResponse(); }
    public getTypeName() { return 'DeleteAddressOptionRequest'; }
}

// @Route("/api/v2/allocated-wps/{Id}", "GET")
export class GetAllocatedWPByIdRequest implements IReturn<GetAllocatedWPByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetAllocatedWPByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAllocatedWPByIdResponse(); }
    public getTypeName() { return 'GetAllocatedWPByIdRequest'; }
}

// @Route("/api/v2/allocated-wps", "GET")
export class GetAllocatedWPsRequest implements IReturn<GetAllocatedWPsResponse>
{

    public constructor(init?: Partial<GetAllocatedWPsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAllocatedWPsResponse(); }
    public getTypeName() { return 'GetAllocatedWPsRequest'; }
}

// @Route("/api/v2/allocated-wps/initial", "POST")
export class InitializeAllocatedWPRequest implements IReturn<InitializeAllocatedWPResponse>
{
    public context: AllocatedWPMetadataContext;

    public constructor(init?: Partial<InitializeAllocatedWPRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeAllocatedWPResponse(); }
    public getTypeName() { return 'InitializeAllocatedWPRequest'; }
}

// @Route("/api/v2/allocated-wps", "POST")
export class SaveAllocatedWPRequest implements IReturn<SaveAllocatedWPResponse>
{
    public model: AllocatedWP;

    public constructor(init?: Partial<SaveAllocatedWPRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveAllocatedWPResponse(); }
    public getTypeName() { return 'SaveAllocatedWPRequest'; }
}

// @Route("/api/v2/allocated-wps/{Id}", "DELETE")
export class DeleteAllocatedWPRequest implements IReturn<DeleteAllocatedWPResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteAllocatedWPRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteAllocatedWPResponse(); }
    public getTypeName() { return 'DeleteAllocatedWPRequest'; }
}

// @Route("/api/v2/assignment-types/{Id}", "GET")
export class GetAssignmentTypeByIdRequest implements IReturn<GetAssignmentTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetAssignmentTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAssignmentTypeByIdResponse(); }
    public getTypeName() { return 'GetAssignmentTypeByIdRequest'; }
}

// @Route("/api/v2/assignment-types", "GET")
export class GetAssignmentTypesRequest implements IReturn<GetAssignmentTypesResponse>
{

    public constructor(init?: Partial<GetAssignmentTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetAssignmentTypesResponse(); }
    public getTypeName() { return 'GetAssignmentTypesRequest'; }
}

// @Route("/api/v2/assignment-types/initial", "POST")
export class InitializeAssignmentTypeRequest implements IReturn<InitializeAssignmentTypeResponse>
{
    public context: AssignmentTypeMetadataContext;

    public constructor(init?: Partial<InitializeAssignmentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeAssignmentTypeResponse(); }
    public getTypeName() { return 'InitializeAssignmentTypeRequest'; }
}

// @Route("/api/v2/assignment-types", "POST")
export class SaveAssignmentTypeRequest implements IReturn<SaveAssignmentTypeResponse>
{
    public model: AssignmentType;

    public constructor(init?: Partial<SaveAssignmentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveAssignmentTypeResponse(); }
    public getTypeName() { return 'SaveAssignmentTypeRequest'; }
}

// @Route("/api/v2/assignment-types/{Id}", "DELETE")
export class DeleteAssignmentTypeRequest implements IReturn<DeleteAssignmentTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteAssignmentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteAssignmentTypeResponse(); }
    public getTypeName() { return 'DeleteAssignmentTypeRequest'; }
}

// @Route("/api/v2/case-types/{Id}", "GET")
export class GetCaseTypeByIdRequest implements IReturn<GetCaseTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetCaseTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCaseTypeByIdResponse(); }
    public getTypeName() { return 'GetCaseTypeByIdRequest'; }
}

// @Route("/api/v2/case-types", "GET")
export class GetCaseTypesRequest implements IReturn<GetCaseTypesResponse>
{

    public constructor(init?: Partial<GetCaseTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCaseTypesResponse(); }
    public getTypeName() { return 'GetCaseTypesRequest'; }
}

// @Route("/api/v2/case-types/initial", "POST")
export class InitializeCaseTypeRequest implements IReturn<InitializeCaseTypeResponse>
{
    public context: CaseTypeMetadataContext;

    public constructor(init?: Partial<InitializeCaseTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeCaseTypeResponse(); }
    public getTypeName() { return 'InitializeCaseTypeRequest'; }
}

// @Route("/api/v2/case-types", "POST")
export class SaveCaseTypeRequest implements IReturn<SaveCaseTypeResponse>
{
    public model: CaseType;

    public constructor(init?: Partial<SaveCaseTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveCaseTypeResponse(); }
    public getTypeName() { return 'SaveCaseTypeRequest'; }
}

// @Route("/api/v2/case-types/{Id}", "DELETE")
export class DeleteCaseTypeRequest implements IReturn<DeleteCaseTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteCaseTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteCaseTypeResponse(); }
    public getTypeName() { return 'DeleteCaseTypeRequest'; }
}

// @Route("/api/v2/categories/{Id}", "GET")
export class GetCategoryByIdRequest implements IReturn<GetCategoryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetCategoryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCategoryByIdResponse(); }
    public getTypeName() { return 'GetCategoryByIdRequest'; }
}

// @Route("/api/v2/categories", "GET")
export class GetCategoriesRequest implements IReturn<GetCategoriesResponse>
{

    public constructor(init?: Partial<GetCategoriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCategoriesResponse(); }
    public getTypeName() { return 'GetCategoriesRequest'; }
}

// @Route("/api/v2/categories/initial", "POST")
export class InitializeCategoryRequest implements IReturn<InitializeCategoryResponse>
{
    public context: CategoryMetadataContext;

    public constructor(init?: Partial<InitializeCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeCategoryResponse(); }
    public getTypeName() { return 'InitializeCategoryRequest'; }
}

// @Route("/api/v2/categories", "POST")
export class SaveCategoryRequest implements IReturn<SaveCategoryResponse>
{
    public model: Category;

    public constructor(init?: Partial<SaveCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveCategoryResponse(); }
    public getTypeName() { return 'SaveCategoryRequest'; }
}

// @Route("/api/v2/categories/{Id}", "DELETE")
export class DeleteCategoryRequest implements IReturn<DeleteCategoryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteCategoryResponse(); }
    public getTypeName() { return 'DeleteCategoryRequest'; }
}

// @Route("/api/v2/collection-instances/{Id}", "GET")
export class GetCollectionInstanceByIdRequest implements IReturn<GetCollectionInstanceByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetCollectionInstanceByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstanceByIdResponse(); }
    public getTypeName() { return 'GetCollectionInstanceByIdRequest'; }
}

// @Route("/api/v2/collection-instances", "GET")
export class GetCollectionInstancesRequest implements IReturn<GetCollectionInstancesResponse>
{

    public constructor(init?: Partial<GetCollectionInstancesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionInstancesResponse(); }
    public getTypeName() { return 'GetCollectionInstancesRequest'; }
}

// @Route("/api/v2/collection-instances/initial", "POST")
export class InitializeCollectionInstanceRequest implements IReturn<InitializeCollectionInstanceResponse>
{
    public context: CollectionInstanceMetadataContext;

    public constructor(init?: Partial<InitializeCollectionInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeCollectionInstanceResponse(); }
    public getTypeName() { return 'InitializeCollectionInstanceRequest'; }
}

// @Route("/api/v2/collection-instances", "POST")
export class SaveCollectionInstanceRequest implements IReturn<SaveCollectionInstanceResponse>
{
    public model: CollectionInstance;

    public constructor(init?: Partial<SaveCollectionInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveCollectionInstanceResponse(); }
    public getTypeName() { return 'SaveCollectionInstanceRequest'; }
}

// @Route("/api/v2/collection-instances/{Id}", "DELETE")
export class DeleteCollectionInstanceRequest implements IReturn<DeleteCollectionInstanceResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteCollectionInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteCollectionInstanceResponse(); }
    public getTypeName() { return 'DeleteCollectionInstanceRequest'; }
}

// @Route("/api/v2/collections/{Id}", "GET")
export class GetCollectionByIdRequest implements IReturn<GetCollectionByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetCollectionByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionByIdResponse(); }
    public getTypeName() { return 'GetCollectionByIdRequest'; }
}

// @Route("/api/v2/collections", "GET")
export class GetCollectionsRequest implements IReturn<GetCollectionsResponse>
{

    public constructor(init?: Partial<GetCollectionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCollectionsResponse(); }
    public getTypeName() { return 'GetCollectionsRequest'; }
}

// @Route("/api/v2/collections/initial", "POST")
export class InitializeCollectionRequest implements IReturn<InitializeCollectionResponse>
{
    public context: CollectionMetadataContext;

    public constructor(init?: Partial<InitializeCollectionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeCollectionResponse(); }
    public getTypeName() { return 'InitializeCollectionRequest'; }
}

// @Route("/api/v2/collections", "POST")
export class SaveCollectionRequest implements IReturn<SaveCollectionResponse>
{
    public model: Collection;

    public constructor(init?: Partial<SaveCollectionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveCollectionResponse(); }
    public getTypeName() { return 'SaveCollectionRequest'; }
}

// @Route("/api/v2/collections/{Id}", "DELETE")
export class DeleteCollectionRequest implements IReturn<DeleteCollectionResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteCollectionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteCollectionResponse(); }
    public getTypeName() { return 'DeleteCollectionRequest'; }
}

// @Route("/api/v2/countries/{Id}", "GET")
export class GetCountryByIdRequest implements IReturn<GetCountryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetCountryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountryByIdResponse(); }
    public getTypeName() { return 'GetCountryByIdRequest'; }
}

// @Route("/api/v2/countries", "GET")
export class GetCountriesRequest implements IReturn<GetCountriesResponse>
{

    public constructor(init?: Partial<GetCountriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetCountriesResponse(); }
    public getTypeName() { return 'GetCountriesRequest'; }
}

// @Route("/api/v2/countries/initial", "POST")
export class InitializeCountryRequest implements IReturn<InitializeCountryResponse>
{
    public context: CountryMetadataContext;

    public constructor(init?: Partial<InitializeCountryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeCountryResponse(); }
    public getTypeName() { return 'InitializeCountryRequest'; }
}

// @Route("/api/v2/countries", "POST")
export class SaveCountryRequest implements IReturn<SaveCountryResponse>
{
    public model: Country;

    public constructor(init?: Partial<SaveCountryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveCountryResponse(); }
    public getTypeName() { return 'SaveCountryRequest'; }
}

// @Route("/api/v2/countries/{Id}", "DELETE")
export class DeleteCountryRequest implements IReturn<DeleteCountryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteCountryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteCountryResponse(); }
    public getTypeName() { return 'DeleteCountryRequest'; }
}

// @Route("/api/v2/departments/{Id}", "GET")
export class GetDepartmentByIdRequest implements IReturn<GetDepartmentByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetDepartmentByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentByIdResponse(); }
    public getTypeName() { return 'GetDepartmentByIdRequest'; }
}

// @Route("/api/v2/departments", "GET")
export class GetDepartmentsRequest implements IReturn<GetDepartmentsResponse>
{

    public constructor(init?: Partial<GetDepartmentsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetDepartmentsResponse(); }
    public getTypeName() { return 'GetDepartmentsRequest'; }
}

// @Route("/api/v2/departments/initial", "POST")
export class InitializeDepartmentRequest implements IReturn<InitializeDepartmentResponse>
{
    public context: DepartmentMetadataContext;

    public constructor(init?: Partial<InitializeDepartmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeDepartmentResponse(); }
    public getTypeName() { return 'InitializeDepartmentRequest'; }
}

// @Route("/api/v2/departments", "POST")
export class SaveDepartmentRequest implements IReturn<SaveDepartmentResponse>
{
    public model: Department;

    public constructor(init?: Partial<SaveDepartmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveDepartmentResponse(); }
    public getTypeName() { return 'SaveDepartmentRequest'; }
}

// @Route("/api/v2/departments/{Id}", "DELETE")
export class DeleteDepartmentRequest implements IReturn<DeleteDepartmentResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteDepartmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteDepartmentResponse(); }
    public getTypeName() { return 'DeleteDepartmentRequest'; }
}

// @Route("/api/v2/errors/{Id}", "GET")
export class GetErrorByIdRequest implements IReturn<GetErrorByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetErrorByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetErrorByIdResponse(); }
    public getTypeName() { return 'GetErrorByIdRequest'; }
}

// @Route("/api/v2/errors", "GET")
export class GetErrorsRequest implements IReturn<GetErrorsResponse>
{

    public constructor(init?: Partial<GetErrorsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetErrorsResponse(); }
    public getTypeName() { return 'GetErrorsRequest'; }
}

// @Route("/api/v2/errors/initial", "POST")
export class InitializeErrorRequest implements IReturn<InitializeErrorResponse>
{
    public context: ErrorMetadataContext;

    public constructor(init?: Partial<InitializeErrorRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeErrorResponse(); }
    public getTypeName() { return 'InitializeErrorRequest'; }
}

// @Route("/api/v2/errors", "POST")
export class SaveErrorRequest implements IReturn<SaveErrorResponse>
{
    public model: Error;

    public constructor(init?: Partial<SaveErrorRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveErrorResponse(); }
    public getTypeName() { return 'SaveErrorRequest'; }
}

// @Route("/api/v2/errors/{Id}", "DELETE")
export class DeleteErrorRequest implements IReturn<DeleteErrorResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteErrorRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteErrorResponse(); }
    public getTypeName() { return 'DeleteErrorRequest'; }
}

// @Route("/api/v2/facility-alliance-members/{Id}", "GET")
export class GetFacilityAllianceMemberByIdRequest implements IReturn<GetFacilityAllianceMemberByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFacilityAllianceMemberByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFacilityAllianceMemberByIdResponse(); }
    public getTypeName() { return 'GetFacilityAllianceMemberByIdRequest'; }
}

// @Route("/api/v2/facility-alliance-members", "GET")
export class GetFacilityAllianceMembersRequest implements IReturn<GetFacilityAllianceMembersResponse>
{

    public constructor(init?: Partial<GetFacilityAllianceMembersRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFacilityAllianceMembersResponse(); }
    public getTypeName() { return 'GetFacilityAllianceMembersRequest'; }
}

// @Route("/api/v2/facility-alliance-members/initial", "POST")
export class InitializeFacilityAllianceMemberRequest implements IReturn<InitializeFacilityAllianceMemberResponse>
{
    public context: FacilityAllianceMemberMetadataContext;

    public constructor(init?: Partial<InitializeFacilityAllianceMemberRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFacilityAllianceMemberResponse(); }
    public getTypeName() { return 'InitializeFacilityAllianceMemberRequest'; }
}

// @Route("/api/v2/facility-alliance-members", "POST")
export class SaveFacilityAllianceMemberRequest implements IReturn<SaveFacilityAllianceMemberResponse>
{
    public model: FacilityAllianceMember;

    public constructor(init?: Partial<SaveFacilityAllianceMemberRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFacilityAllianceMemberResponse(); }
    public getTypeName() { return 'SaveFacilityAllianceMemberRequest'; }
}

// @Route("/api/v2/facility-alliance-members/{Id}", "DELETE")
export class DeleteFacilityAllianceMemberRequest implements IReturn<DeleteFacilityAllianceMemberResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFacilityAllianceMemberRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFacilityAllianceMemberResponse(); }
    public getTypeName() { return 'DeleteFacilityAllianceMemberRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/{Id}", "GET")
export class GetFormNextAutoVersionByIdRequest implements IReturn<GetFormNextAutoVersionByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFormNextAutoVersionByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormNextAutoVersionByIdResponse(); }
    public getTypeName() { return 'GetFormNextAutoVersionByIdRequest'; }
}

// @Route("/api/v2/form-next-auto-versions", "GET")
export class GetFormNextAutoVersionsRequest implements IReturn<GetFormNextAutoVersionsResponse>
{

    public constructor(init?: Partial<GetFormNextAutoVersionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormNextAutoVersionsResponse(); }
    public getTypeName() { return 'GetFormNextAutoVersionsRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/initial", "POST")
export class InitializeFormNextAutoVersionRequest implements IReturn<InitializeFormNextAutoVersionResponse>
{
    public context: FormNextAutoVersionMetadataContext;

    public constructor(init?: Partial<InitializeFormNextAutoVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFormNextAutoVersionResponse(); }
    public getTypeName() { return 'InitializeFormNextAutoVersionRequest'; }
}

// @Route("/api/v2/form-next-auto-versions", "POST")
export class SaveFormNextAutoVersionRequest implements IReturn<SaveFormNextAutoVersionResponse>
{
    public model: FormNextAutoVersion;

    public constructor(init?: Partial<SaveFormNextAutoVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFormNextAutoVersionResponse(); }
    public getTypeName() { return 'SaveFormNextAutoVersionRequest'; }
}

// @Route("/api/v2/form-next-auto-versions/{Id}", "DELETE")
export class DeleteFormNextAutoVersionRequest implements IReturn<DeleteFormNextAutoVersionResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFormNextAutoVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFormNextAutoVersionResponse(); }
    public getTypeName() { return 'DeleteFormNextAutoVersionRequest'; }
}

// @Route("/api/v2/form-template-categories/{Id}", "GET")
export class GetFormTemplateCategoryByIdRequest implements IReturn<GetFormTemplateCategoryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFormTemplateCategoryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateCategoryByIdResponse(); }
    public getTypeName() { return 'GetFormTemplateCategoryByIdRequest'; }
}

// @Route("/api/v2/form-template-categories", "GET")
export class GetFormTemplateCategoriesRequest implements IReturn<GetFormTemplateCategoriesResponse>
{

    public constructor(init?: Partial<GetFormTemplateCategoriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateCategoriesResponse(); }
    public getTypeName() { return 'GetFormTemplateCategoriesRequest'; }
}

// @Route("/api/v2/form-template-categories/initial", "POST")
export class InitializeFormTemplateCategoryRequest implements IReturn<InitializeFormTemplateCategoryResponse>
{
    public context: FormTemplateCategoryMetadataContext;

    public constructor(init?: Partial<InitializeFormTemplateCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFormTemplateCategoryResponse(); }
    public getTypeName() { return 'InitializeFormTemplateCategoryRequest'; }
}

// @Route("/api/v2/form-template-categories", "POST")
export class SaveFormTemplateCategoryRequest implements IReturn<SaveFormTemplateCategoryResponse>
{
    public model: FormTemplateCategory;

    public constructor(init?: Partial<SaveFormTemplateCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFormTemplateCategoryResponse(); }
    public getTypeName() { return 'SaveFormTemplateCategoryRequest'; }
}

// @Route("/api/v2/form-template-categories/{Id}", "DELETE")
export class DeleteFormTemplateCategoryRequest implements IReturn<DeleteFormTemplateCategoryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFormTemplateCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFormTemplateCategoryResponse(); }
    public getTypeName() { return 'DeleteFormTemplateCategoryRequest'; }
}

// @Route("/api/v2/form-template-file-types/{Id}", "GET")
export class GetFormTemplateFileTypeByIdRequest implements IReturn<GetFormTemplateFileTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFormTemplateFileTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateFileTypeByIdResponse(); }
    public getTypeName() { return 'GetFormTemplateFileTypeByIdRequest'; }
}

// @Route("/api/v2/form-template-file-types", "GET")
export class GetFormTemplateFileTypesRequest implements IReturn<GetFormTemplateFileTypesResponse>
{

    public constructor(init?: Partial<GetFormTemplateFileTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateFileTypesResponse(); }
    public getTypeName() { return 'GetFormTemplateFileTypesRequest'; }
}

// @Route("/api/v2/form-template-file-types/initial", "POST")
export class InitializeFormTemplateFileTypeRequest implements IReturn<InitializeFormTemplateFileTypeResponse>
{
    public context: FormTemplateFileTypeMetadataContext;

    public constructor(init?: Partial<InitializeFormTemplateFileTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFormTemplateFileTypeResponse(); }
    public getTypeName() { return 'InitializeFormTemplateFileTypeRequest'; }
}

// @Route("/api/v2/form-template-file-types", "POST")
export class SaveFormTemplateFileTypeRequest implements IReturn<SaveFormTemplateFileTypeResponse>
{
    public model: FormTemplateFileType;

    public constructor(init?: Partial<SaveFormTemplateFileTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFormTemplateFileTypeResponse(); }
    public getTypeName() { return 'SaveFormTemplateFileTypeRequest'; }
}

// @Route("/api/v2/form-template-file-types/{Id}", "DELETE")
export class DeleteFormTemplateFileTypeRequest implements IReturn<DeleteFormTemplateFileTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFormTemplateFileTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFormTemplateFileTypeResponse(); }
    public getTypeName() { return 'DeleteFormTemplateFileTypeRequest'; }
}

// @Route("/api/v2/form-template-statuses/{Id}", "GET")
export class GetFormTemplateStatusByIdRequest implements IReturn<GetFormTemplateStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFormTemplateStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateStatusByIdResponse(); }
    public getTypeName() { return 'GetFormTemplateStatusByIdRequest'; }
}

// @Route("/api/v2/form-template-statuses", "GET")
export class GetFormTemplateStatusesRequest implements IReturn<GetFormTemplateStatusesResponse>
{

    public constructor(init?: Partial<GetFormTemplateStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateStatusesResponse(); }
    public getTypeName() { return 'GetFormTemplateStatusesRequest'; }
}

// @Route("/api/v2/form-template-statuses/initial", "POST")
export class InitializeFormTemplateStatusRequest implements IReturn<InitializeFormTemplateStatusResponse>
{
    public context: FormTemplateStatusMetadataContext;

    public constructor(init?: Partial<InitializeFormTemplateStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFormTemplateStatusResponse(); }
    public getTypeName() { return 'InitializeFormTemplateStatusRequest'; }
}

// @Route("/api/v2/form-template-statuses", "POST")
export class SaveFormTemplateStatusRequest implements IReturn<SaveFormTemplateStatusResponse>
{
    public model: FormTemplateStatus;

    public constructor(init?: Partial<SaveFormTemplateStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFormTemplateStatusResponse(); }
    public getTypeName() { return 'SaveFormTemplateStatusRequest'; }
}

// @Route("/api/v2/form-template-statuses/{Id}", "DELETE")
export class DeleteFormTemplateStatusRequest implements IReturn<DeleteFormTemplateStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFormTemplateStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFormTemplateStatusResponse(); }
    public getTypeName() { return 'DeleteFormTemplateStatusRequest'; }
}

// @Route("/api/v2/form-templates/{Id}", "GET")
export class GetFormTemplateByIdRequest implements IReturn<GetFormTemplateByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFormTemplateByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplateByIdResponse(); }
    public getTypeName() { return 'GetFormTemplateByIdRequest'; }
}

// @Route("/api/v2/form-templates", "GET")
export class GetFormTemplatesRequest implements IReturn<GetFormTemplatesResponse>
{

    public constructor(init?: Partial<GetFormTemplatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFormTemplatesResponse(); }
    public getTypeName() { return 'GetFormTemplatesRequest'; }
}

// @Route("/api/v2/form-templates/initial", "POST")
export class InitializeFormTemplateRequest implements IReturn<InitializeFormTemplateResponse>
{
    public context: FormTemplateMetadataContext;

    public constructor(init?: Partial<InitializeFormTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFormTemplateResponse(); }
    public getTypeName() { return 'InitializeFormTemplateRequest'; }
}

// @Route("/api/v2/form-templates", "POST")
export class SaveFormTemplateRequest implements IReturn<SaveFormTemplateResponse>
{
    public model: FormTemplate;

    public constructor(init?: Partial<SaveFormTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFormTemplateResponse(); }
    public getTypeName() { return 'SaveFormTemplateRequest'; }
}

// @Route("/api/v2/form-templates/{Id}", "DELETE")
export class DeleteFormTemplateRequest implements IReturn<DeleteFormTemplateResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFormTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFormTemplateResponse(); }
    public getTypeName() { return 'DeleteFormTemplateRequest'; }
}

// @Route("/api/v2/funding-statuses/{Id}", "GET")
export class GetFundingStatusByIdRequest implements IReturn<GetFundingStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetFundingStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFundingStatusByIdResponse(); }
    public getTypeName() { return 'GetFundingStatusByIdRequest'; }
}

// @Route("/api/v2/funding-statuses", "GET")
export class GetFundingStatusesRequest implements IReturn<GetFundingStatusesResponse>
{

    public constructor(init?: Partial<GetFundingStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetFundingStatusesResponse(); }
    public getTypeName() { return 'GetFundingStatusesRequest'; }
}

// @Route("/api/v2/funding-statuses/initial", "POST")
export class InitializeFundingStatusRequest implements IReturn<InitializeFundingStatusResponse>
{
    public context: FundingStatusMetadataContext;

    public constructor(init?: Partial<InitializeFundingStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeFundingStatusResponse(); }
    public getTypeName() { return 'InitializeFundingStatusRequest'; }
}

// @Route("/api/v2/funding-statuses", "POST")
export class SaveFundingStatusRequest implements IReturn<SaveFundingStatusResponse>
{
    public model: FundingStatus;

    public constructor(init?: Partial<SaveFundingStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveFundingStatusResponse(); }
    public getTypeName() { return 'SaveFundingStatusRequest'; }
}

// @Route("/api/v2/funding-statuses/{Id}", "DELETE")
export class DeleteFundingStatusRequest implements IReturn<DeleteFundingStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteFundingStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteFundingStatusResponse(); }
    public getTypeName() { return 'DeleteFundingStatusRequest'; }
}

// @Route("/api/v2/genders/{Id}", "GET")
export class GetGenderByIdRequest implements IReturn<GetGenderByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetGenderByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGenderByIdResponse(); }
    public getTypeName() { return 'GetGenderByIdRequest'; }
}

// @Route("/api/v2/genders", "GET")
export class GetGendersRequest implements IReturn<GetGendersResponse>
{

    public constructor(init?: Partial<GetGendersRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGendersResponse(); }
    public getTypeName() { return 'GetGendersRequest'; }
}

// @Route("/api/v2/genders/initial", "POST")
export class InitializeGenderRequest implements IReturn<InitializeGenderResponse>
{
    public context: GenderMetadataContext;

    public constructor(init?: Partial<InitializeGenderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeGenderResponse(); }
    public getTypeName() { return 'InitializeGenderRequest'; }
}

// @Route("/api/v2/genders", "POST")
export class SaveGenderRequest implements IReturn<SaveGenderResponse>
{
    public model: Gender;

    public constructor(init?: Partial<SaveGenderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveGenderResponse(); }
    public getTypeName() { return 'SaveGenderRequest'; }
}

// @Route("/api/v2/genders/{Id}", "DELETE")
export class DeleteGenderRequest implements IReturn<DeleteGenderResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteGenderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteGenderResponse(); }
    public getTypeName() { return 'DeleteGenderRequest'; }
}

// @Route("/api/v2/group-items/{Id}", "GET")
export class GetGroupItemByIdRequest implements IReturn<GetGroupItemByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetGroupItemByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemByIdResponse(); }
    public getTypeName() { return 'GetGroupItemByIdRequest'; }
}

// @Route("/api/v2/group-items", "GET")
export class GetGroupItemsRequest implements IReturn<GetGroupItemsResponse>
{

    public constructor(init?: Partial<GetGroupItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupItemsResponse(); }
    public getTypeName() { return 'GetGroupItemsRequest'; }
}

// @Route("/api/v2/group-items/initial", "POST")
export class InitializeGroupItemRequest implements IReturn<InitializeGroupItemResponse>
{
    public context: GroupItemMetadataContext;

    public constructor(init?: Partial<InitializeGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeGroupItemResponse(); }
    public getTypeName() { return 'InitializeGroupItemRequest'; }
}

// @Route("/api/v2/group-items", "POST")
export class SaveGroupItemRequest implements IReturn<SaveGroupItemResponse>
{
    public model: GroupItem;

    public constructor(init?: Partial<SaveGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveGroupItemResponse(); }
    public getTypeName() { return 'SaveGroupItemRequest'; }
}

// @Route("/api/v2/group-items/{Id}", "DELETE")
export class DeleteGroupItemRequest implements IReturn<DeleteGroupItemResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteGroupItemResponse(); }
    public getTypeName() { return 'DeleteGroupItemRequest'; }
}

// @Route("/api/v2/group-notes/{Id}", "GET")
export class GetGroupNoteByIdRequest implements IReturn<GetGroupNoteByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetGroupNoteByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNoteByIdResponse(); }
    public getTypeName() { return 'GetGroupNoteByIdRequest'; }
}

// @Route("/api/v2/group-notes", "GET")
export class GetGroupNotesRequest implements IReturn<GetGroupNotesResponse>
{

    public constructor(init?: Partial<GetGroupNotesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupNotesResponse(); }
    public getTypeName() { return 'GetGroupNotesRequest'; }
}

// @Route("/api/v2/group-notes/initial", "POST")
export class InitializeGroupNoteRequest implements IReturn<InitializeGroupNoteResponse>
{
    public context: GroupNoteMetadataContext;

    public constructor(init?: Partial<InitializeGroupNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeGroupNoteResponse(); }
    public getTypeName() { return 'InitializeGroupNoteRequest'; }
}

// @Route("/api/v2/group-notes", "POST")
export class SaveGroupNoteRequest implements IReturn<SaveGroupNoteResponse>
{
    public model: GroupNote;

    public constructor(init?: Partial<SaveGroupNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveGroupNoteResponse(); }
    public getTypeName() { return 'SaveGroupNoteRequest'; }
}

// @Route("/api/v2/group-notes/{Id}", "DELETE")
export class DeleteGroupNoteRequest implements IReturn<DeleteGroupNoteResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteGroupNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteGroupNoteResponse(); }
    public getTypeName() { return 'DeleteGroupNoteRequest'; }
}

// @Route("/api/v2/group-types/{Id}", "GET")
export class GetGroupTypeByIdRequest implements IReturn<GetGroupTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetGroupTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupTypeByIdResponse(); }
    public getTypeName() { return 'GetGroupTypeByIdRequest'; }
}

// @Route("/api/v2/group-types", "GET")
export class GetGroupTypesRequest implements IReturn<GetGroupTypesResponse>
{

    public constructor(init?: Partial<GetGroupTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupTypesResponse(); }
    public getTypeName() { return 'GetGroupTypesRequest'; }
}

// @Route("/api/v2/group-types/initial", "POST")
export class InitializeGroupTypeRequest implements IReturn<InitializeGroupTypeResponse>
{
    public context: GroupTypeMetadataContext;

    public constructor(init?: Partial<InitializeGroupTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeGroupTypeResponse(); }
    public getTypeName() { return 'InitializeGroupTypeRequest'; }
}

// @Route("/api/v2/group-types", "POST")
export class SaveGroupTypeRequest implements IReturn<SaveGroupTypeResponse>
{
    public model: GroupType;

    public constructor(init?: Partial<SaveGroupTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveGroupTypeResponse(); }
    public getTypeName() { return 'SaveGroupTypeRequest'; }
}

// @Route("/api/v2/group-types/{Id}", "DELETE")
export class DeleteGroupTypeRequest implements IReturn<DeleteGroupTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteGroupTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteGroupTypeResponse(); }
    public getTypeName() { return 'DeleteGroupTypeRequest'; }
}

// @Route("/api/v2/groups/{Id}", "GET")
export class GetGroupByIdRequest implements IReturn<GetGroupByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetGroupByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupByIdResponse(); }
    public getTypeName() { return 'GetGroupByIdRequest'; }
}

// @Route("/api/v2/groups", "GET")
export class GetGroupsRequest implements IReturn<GetGroupsResponse>
{

    public constructor(init?: Partial<GetGroupsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetGroupsResponse(); }
    public getTypeName() { return 'GetGroupsRequest'; }
}

// @Route("/api/v2/groups/initial", "POST")
export class InitializeGroupRequest implements IReturn<InitializeGroupResponse>
{
    public context: GroupMetadataContext;

    public constructor(init?: Partial<InitializeGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeGroupResponse(); }
    public getTypeName() { return 'InitializeGroupRequest'; }
}

// @Route("/api/v2/groups", "POST")
export class SaveGroupRequest implements IReturn<SaveGroupResponse>
{
    public model: Group;

    public constructor(init?: Partial<SaveGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveGroupResponse(); }
    public getTypeName() { return 'SaveGroupRequest'; }
}

// @Route("/api/v2/groups/{Id}", "DELETE")
export class DeleteGroupRequest implements IReturn<DeleteGroupResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteGroupResponse(); }
    public getTypeName() { return 'DeleteGroupRequest'; }
}

// @Route("/api/v2/institution-codings/{Id}", "GET")
export class GetInstitutionCodingByIdRequest implements IReturn<GetInstitutionCodingByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionCodingByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionCodingByIdResponse(); }
    public getTypeName() { return 'GetInstitutionCodingByIdRequest'; }
}

// @Route("/api/v2/institution-codings", "GET")
export class GetInstitutionCodingsRequest implements IReturn<GetInstitutionCodingsResponse>
{

    public constructor(init?: Partial<GetInstitutionCodingsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionCodingsResponse(); }
    public getTypeName() { return 'GetInstitutionCodingsRequest'; }
}

// @Route("/api/v2/institution-codings/initial", "POST")
export class InitializeInstitutionCodingRequest implements IReturn<InitializeInstitutionCodingResponse>
{
    public context: InstitutionCodingMetadataContext;

    public constructor(init?: Partial<InitializeInstitutionCodingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInstitutionCodingResponse(); }
    public getTypeName() { return 'InitializeInstitutionCodingRequest'; }
}

// @Route("/api/v2/institution-codings", "POST")
export class SaveInstitutionCodingRequest implements IReturn<SaveInstitutionCodingResponse>
{
    public model: InstitutionCoding;

    public constructor(init?: Partial<SaveInstitutionCodingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInstitutionCodingResponse(); }
    public getTypeName() { return 'SaveInstitutionCodingRequest'; }
}

// @Route("/api/v2/institution-codings/{Id}", "DELETE")
export class DeleteInstitutionCodingRequest implements IReturn<DeleteInstitutionCodingResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInstitutionCodingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInstitutionCodingResponse(); }
    public getTypeName() { return 'DeleteInstitutionCodingRequest'; }
}

// @Route("/api/v2/institution-forms/{InstitutionFormId}/versions", "POST")
export class CreateInstitutionFormVersionRequest implements IReturn<CreateInstitutionFormVersionResponse>
{
    public institutionFormId: number;
    public expectedCurrentVersionId?: number;
    public version: string;
    public copyData: boolean;

    public constructor(init?: Partial<CreateInstitutionFormVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateInstitutionFormVersionResponse(); }
    public getTypeName() { return 'CreateInstitutionFormVersionRequest'; }
}

// @Route("/api/v2/institution-forms/{Id}", "GET")
export class GetInstitutionFormByIdRequest implements IReturn<GetInstitutionFormByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionFormByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormByIdResponse(); }
    public getTypeName() { return 'GetInstitutionFormByIdRequest'; }
}

// @Route("/api/v2/institution-forms", "GET")
export class GetInstitutionFormsRequest implements IReturn<GetInstitutionFormsResponse>
{

    public constructor(init?: Partial<GetInstitutionFormsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionFormsResponse(); }
    public getTypeName() { return 'GetInstitutionFormsRequest'; }
}

// @Route("/api/v2/institution-forms/initial", "POST")
export class InitializeInstitutionFormRequest implements IReturn<InitializeInstitutionFormResponse>
{
    public context: InstitutionFormMetadataContext;

    public constructor(init?: Partial<InitializeInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInstitutionFormResponse(); }
    public getTypeName() { return 'InitializeInstitutionFormRequest'; }
}

// @Route("/api/v2/institution-forms", "POST")
export class SaveInstitutionFormRequest implements IReturn<SaveInstitutionFormResponse>
{
    public model: InstitutionForm;

    public constructor(init?: Partial<SaveInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInstitutionFormResponse(); }
    public getTypeName() { return 'SaveInstitutionFormRequest'; }
}

// @Route("/api/v2/institution-forms/{Id}", "DELETE")
export class DeleteInstitutionFormRequest implements IReturn<DeleteInstitutionFormResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInstitutionFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInstitutionFormResponse(); }
    public getTypeName() { return 'DeleteInstitutionFormRequest'; }
}

// @Route("/api/v2/institution-notes/{Id}", "GET")
export class GetInstitutionNoteByIdRequest implements IReturn<GetInstitutionNoteByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionNoteByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNoteByIdResponse(); }
    public getTypeName() { return 'GetInstitutionNoteByIdRequest'; }
}

// @Route("/api/v2/institution-notes", "GET")
export class GetInstitutionNotesRequest implements IReturn<GetInstitutionNotesResponse>
{

    public constructor(init?: Partial<GetInstitutionNotesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionNotesResponse(); }
    public getTypeName() { return 'GetInstitutionNotesRequest'; }
}

// @Route("/api/v2/institution-notes/initial", "POST")
export class InitializeInstitutionNoteRequest implements IReturn<InitializeInstitutionNoteResponse>
{
    public context: InstitutionNoteMetadataContext;

    public constructor(init?: Partial<InitializeInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInstitutionNoteResponse(); }
    public getTypeName() { return 'InitializeInstitutionNoteRequest'; }
}

// @Route("/api/v2/institution-notes", "POST")
export class SaveInstitutionNoteRequest implements IReturn<SaveInstitutionNoteResponse>
{
    public model: InstitutionNote;

    public constructor(init?: Partial<SaveInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInstitutionNoteResponse(); }
    public getTypeName() { return 'SaveInstitutionNoteRequest'; }
}

// @Route("/api/v2/institution-notes/{Id}", "DELETE")
export class DeleteInstitutionNoteRequest implements IReturn<DeleteInstitutionNoteResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInstitutionNoteResponse(); }
    public getTypeName() { return 'DeleteInstitutionNoteRequest'; }
}

// @Route("/api/v2/institution-types/{Id}", "GET")
export class GetInstitutionTypeByIdRequest implements IReturn<GetInstitutionTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionTypeByIdResponse(); }
    public getTypeName() { return 'GetInstitutionTypeByIdRequest'; }
}

// @Route("/api/v2/institution-types", "GET")
export class GetInstitutionTypesRequest implements IReturn<GetInstitutionTypesResponse>
{

    public constructor(init?: Partial<GetInstitutionTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionTypesResponse(); }
    public getTypeName() { return 'GetInstitutionTypesRequest'; }
}

// @Route("/api/v2/institution-types/initial", "POST")
export class InitializeInstitutionTypeRequest implements IReturn<InitializeInstitutionTypeResponse>
{
    public context: InstitutionTypeMetadataContext;

    public constructor(init?: Partial<InitializeInstitutionTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInstitutionTypeResponse(); }
    public getTypeName() { return 'InitializeInstitutionTypeRequest'; }
}

// @Route("/api/v2/institution-types", "POST")
export class SaveInstitutionTypeRequest implements IReturn<SaveInstitutionTypeResponse>
{
    public model: InstitutionType;

    public constructor(init?: Partial<SaveInstitutionTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInstitutionTypeResponse(); }
    public getTypeName() { return 'SaveInstitutionTypeRequest'; }
}

// @Route("/api/v2/institution-types/{Id}", "DELETE")
export class DeleteInstitutionTypeRequest implements IReturn<DeleteInstitutionTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInstitutionTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInstitutionTypeResponse(); }
    public getTypeName() { return 'DeleteInstitutionTypeRequest'; }
}

// @Route("/api/v2/institutions/{Id}", "GET")
export class GetInstitutionByIdRequest implements IReturn<GetInstitutionByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInstitutionByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionByIdResponse(); }
    public getTypeName() { return 'GetInstitutionByIdRequest'; }
}

// @Route("/api/v2/institutions", "GET")
export class GetInstitutionsRequest implements IReturn<GetInstitutionsResponse>
{

    public constructor(init?: Partial<GetInstitutionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInstitutionsResponse(); }
    public getTypeName() { return 'GetInstitutionsRequest'; }
}

// @Route("/api/v2/institutions/initial", "POST")
export class InitializeInstitutionRequest implements IReturn<InitializeInstitutionResponse>
{
    public context: InstitutionMetadataContext;

    public constructor(init?: Partial<InitializeInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInstitutionResponse(); }
    public getTypeName() { return 'InitializeInstitutionRequest'; }
}

// @Route("/api/v2/institutions", "POST")
export class SaveInstitutionRequest implements IReturn<SaveInstitutionResponse>
{
    public model: Institution;

    public constructor(init?: Partial<SaveInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInstitutionResponse(); }
    public getTypeName() { return 'SaveInstitutionRequest'; }
}

// @Route("/api/v2/institutions/{Id}", "DELETE")
export class DeleteInstitutionRequest implements IReturn<DeleteInstitutionResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInstitutionResponse(); }
    public getTypeName() { return 'DeleteInstitutionRequest'; }
}

// @Route("/api/v2/interests/{Id}", "GET")
export class GetInterestByIdRequest implements IReturn<GetInterestByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInterestByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInterestByIdResponse(); }
    public getTypeName() { return 'GetInterestByIdRequest'; }
}

// @Route("/api/v2/interests", "GET")
export class GetInterestsRequest implements IReturn<GetInterestsResponse>
{

    public constructor(init?: Partial<GetInterestsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInterestsResponse(); }
    public getTypeName() { return 'GetInterestsRequest'; }
}

// @Route("/api/v2/interests/initial", "POST")
export class InitializeInterestRequest implements IReturn<InitializeInterestResponse>
{
    public context: InterestMetadataContext;

    public constructor(init?: Partial<InitializeInterestRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInterestResponse(); }
    public getTypeName() { return 'InitializeInterestRequest'; }
}

// @Route("/api/v2/interests", "POST")
export class SaveInterestRequest implements IReturn<SaveInterestResponse>
{
    public model: Interest;

    public constructor(init?: Partial<SaveInterestRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInterestResponse(); }
    public getTypeName() { return 'SaveInterestRequest'; }
}

// @Route("/api/v2/interests/{Id}", "DELETE")
export class DeleteInterestRequest implements IReturn<DeleteInterestResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInterestRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInterestResponse(); }
    public getTypeName() { return 'DeleteInterestRequest'; }
}

// @Route("/api/v2/international-trial-statuses/{Id}", "GET")
export class GetInternationalTrialStatusByIdRequest implements IReturn<GetInternationalTrialStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInternationalTrialStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInternationalTrialStatusByIdResponse(); }
    public getTypeName() { return 'GetInternationalTrialStatusByIdRequest'; }
}

// @Route("/api/v2/international-trial-statuses", "GET")
export class GetInternationalTrialStatusesRequest implements IReturn<GetInternationalTrialStatusesResponse>
{

    public constructor(init?: Partial<GetInternationalTrialStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInternationalTrialStatusesResponse(); }
    public getTypeName() { return 'GetInternationalTrialStatusesRequest'; }
}

// @Route("/api/v2/international-trial-statuses/initial", "POST")
export class InitializeInternationalTrialStatusRequest implements IReturn<InitializeInternationalTrialStatusResponse>
{
    public context: InternationalTrialStatusMetadataContext;

    public constructor(init?: Partial<InitializeInternationalTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInternationalTrialStatusResponse(); }
    public getTypeName() { return 'InitializeInternationalTrialStatusRequest'; }
}

// @Route("/api/v2/international-trial-statuses", "POST")
export class SaveInternationalTrialStatusRequest implements IReturn<SaveInternationalTrialStatusResponse>
{
    public model: InternationalTrialStatus;

    public constructor(init?: Partial<SaveInternationalTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInternationalTrialStatusResponse(); }
    public getTypeName() { return 'SaveInternationalTrialStatusRequest'; }
}

// @Route("/api/v2/international-trial-statuses/{Id}", "DELETE")
export class DeleteInternationalTrialStatusRequest implements IReturn<DeleteInternationalTrialStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInternationalTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInternationalTrialStatusResponse(); }
    public getTypeName() { return 'DeleteInternationalTrialStatusRequest'; }
}

// @Route("/api/v2/involvements/{Id}", "GET")
export class GetInvolvementByIdRequest implements IReturn<GetInvolvementByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetInvolvementByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInvolvementByIdResponse(); }
    public getTypeName() { return 'GetInvolvementByIdRequest'; }
}

// @Route("/api/v2/involvements", "GET")
export class GetInvolvementsRequest implements IReturn<GetInvolvementsResponse>
{

    public constructor(init?: Partial<GetInvolvementsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetInvolvementsResponse(); }
    public getTypeName() { return 'GetInvolvementsRequest'; }
}

// @Route("/api/v2/involvements/initial", "POST")
export class InitializeInvolvementRequest implements IReturn<InitializeInvolvementResponse>
{
    public context: InvolvementMetadataContext;

    public constructor(init?: Partial<InitializeInvolvementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeInvolvementResponse(); }
    public getTypeName() { return 'InitializeInvolvementRequest'; }
}

// @Route("/api/v2/involvements", "POST")
export class SaveInvolvementRequest implements IReturn<SaveInvolvementResponse>
{
    public model: Involvement;

    public constructor(init?: Partial<SaveInvolvementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveInvolvementResponse(); }
    public getTypeName() { return 'SaveInvolvementRequest'; }
}

// @Route("/api/v2/involvements/{Id}", "DELETE")
export class DeleteInvolvementRequest implements IReturn<DeleteInvolvementResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteInvolvementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteInvolvementResponse(); }
    public getTypeName() { return 'DeleteInvolvementRequest'; }
}

// @Route("/api/v2/item-component-types/{Id}", "GET")
export class GetItemComponentTypeByIdRequest implements IReturn<GetItemComponentTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetItemComponentTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentTypeByIdResponse(); }
    public getTypeName() { return 'GetItemComponentTypeByIdRequest'; }
}

// @Route("/api/v2/item-component-types", "GET")
export class GetItemComponentTypesRequest implements IReturn<GetItemComponentTypesResponse>
{

    public constructor(init?: Partial<GetItemComponentTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentTypesResponse(); }
    public getTypeName() { return 'GetItemComponentTypesRequest'; }
}

// @Route("/api/v2/item-component-types/initial", "POST")
export class InitializeItemComponentTypeRequest implements IReturn<InitializeItemComponentTypeResponse>
{
    public context: ItemComponentTypeMetadataContext;

    public constructor(init?: Partial<InitializeItemComponentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeItemComponentTypeResponse(); }
    public getTypeName() { return 'InitializeItemComponentTypeRequest'; }
}

// @Route("/api/v2/item-component-types", "POST")
export class SaveItemComponentTypeRequest implements IReturn<SaveItemComponentTypeResponse>
{
    public model: ItemComponentType;

    public constructor(init?: Partial<SaveItemComponentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveItemComponentTypeResponse(); }
    public getTypeName() { return 'SaveItemComponentTypeRequest'; }
}

// @Route("/api/v2/item-component-types/{Id}", "DELETE")
export class DeleteItemComponentTypeRequest implements IReturn<DeleteItemComponentTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteItemComponentTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteItemComponentTypeResponse(); }
    public getTypeName() { return 'DeleteItemComponentTypeRequest'; }
}

// @Route("/api/v2/collections/{CollectionId}/item-components", "GET")
export class GetItemComponentsByCollectionIdRequest implements IReturn<GetItemComponentsByCollectionIdResponse>
{
    public collectionId: number;

    public constructor(init?: Partial<GetItemComponentsByCollectionIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentsByCollectionIdResponse(); }
    public getTypeName() { return 'GetItemComponentsByCollectionIdRequest'; }
}

// @Route("/api/v2/item-components/{Id}", "GET")
export class GetItemComponentByIdRequest implements IReturn<GetItemComponentByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetItemComponentByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentByIdResponse(); }
    public getTypeName() { return 'GetItemComponentByIdRequest'; }
}

// @Route("/api/v2/item-components", "GET")
export class GetItemComponentsRequest implements IReturn<GetItemComponentsResponse>
{

    public constructor(init?: Partial<GetItemComponentsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetItemComponentsResponse(); }
    public getTypeName() { return 'GetItemComponentsRequest'; }
}

// @Route("/api/v2/item-components/initial", "POST")
export class InitializeItemComponentRequest implements IReturn<InitializeItemComponentResponse>
{
    public context: ItemComponentMetadataContext;

    public constructor(init?: Partial<InitializeItemComponentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeItemComponentResponse(); }
    public getTypeName() { return 'InitializeItemComponentRequest'; }
}

// @Route("/api/v2/item-components", "POST")
export class SaveItemComponentRequest implements IReturn<SaveItemComponentResponse>
{
    public model: ItemComponent;

    public constructor(init?: Partial<SaveItemComponentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveItemComponentResponse(); }
    public getTypeName() { return 'SaveItemComponentRequest'; }
}

// @Route("/api/v2/item-components/{Id}", "DELETE")
export class DeleteItemComponentRequest implements IReturn<DeleteItemComponentResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteItemComponentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteItemComponentResponse(); }
    public getTypeName() { return 'DeleteItemComponentRequest'; }
}

// @Route("/api/v2/measurements/{Id}", "GET")
export class GetMeasurementByIdRequest implements IReturn<GetMeasurementByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetMeasurementByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMeasurementByIdResponse(); }
    public getTypeName() { return 'GetMeasurementByIdRequest'; }
}

// @Route("/api/v2/measurements", "GET")
export class GetMeasurementsRequest implements IReturn<GetMeasurementsResponse>
{

    public constructor(init?: Partial<GetMeasurementsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMeasurementsResponse(); }
    public getTypeName() { return 'GetMeasurementsRequest'; }
}

// @Route("/api/v2/measurements/initial", "POST")
export class InitializeMeasurementRequest implements IReturn<InitializeMeasurementResponse>
{
    public context: MeasurementMetadataContext;

    public constructor(init?: Partial<InitializeMeasurementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeMeasurementResponse(); }
    public getTypeName() { return 'InitializeMeasurementRequest'; }
}

// @Route("/api/v2/measurements", "POST")
export class SaveMeasurementRequest implements IReturn<SaveMeasurementResponse>
{
    public model: Measurement;

    public constructor(init?: Partial<SaveMeasurementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveMeasurementResponse(); }
    public getTypeName() { return 'SaveMeasurementRequest'; }
}

// @Route("/api/v2/measurements/{Id}", "DELETE")
export class DeleteMeasurementRequest implements IReturn<DeleteMeasurementResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteMeasurementRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteMeasurementResponse(); }
    public getTypeName() { return 'DeleteMeasurementRequest'; }
}

// @Route("/api/v2/membership-types/{Id}", "GET")
export class GetMembershipTypeByIdRequest implements IReturn<GetMembershipTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetMembershipTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMembershipTypeByIdResponse(); }
    public getTypeName() { return 'GetMembershipTypeByIdRequest'; }
}

// @Route("/api/v2/membership-types", "GET")
export class GetMembershipTypesRequest implements IReturn<GetMembershipTypesResponse>
{

    public constructor(init?: Partial<GetMembershipTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetMembershipTypesResponse(); }
    public getTypeName() { return 'GetMembershipTypesRequest'; }
}

// @Route("/api/v2/membership-types/initial", "POST")
export class InitializeMembershipTypeRequest implements IReturn<InitializeMembershipTypeResponse>
{
    public context: MembershipTypeMetadataContext;

    public constructor(init?: Partial<InitializeMembershipTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeMembershipTypeResponse(); }
    public getTypeName() { return 'InitializeMembershipTypeRequest'; }
}

// @Route("/api/v2/membership-types", "POST")
export class SaveMembershipTypeRequest implements IReturn<SaveMembershipTypeResponse>
{
    public model: MembershipType;

    public constructor(init?: Partial<SaveMembershipTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveMembershipTypeResponse(); }
    public getTypeName() { return 'SaveMembershipTypeRequest'; }
}

// @Route("/api/v2/membership-types/{Id}", "DELETE")
export class DeleteMembershipTypeRequest implements IReturn<DeleteMembershipTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteMembershipTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteMembershipTypeResponse(); }
    public getTypeName() { return 'DeleteMembershipTypeRequest'; }
}

// @Route("/api/v2/note-types/{Id}", "GET")
export class GetNoteTypeByIdRequest implements IReturn<GetNoteTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetNoteTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetNoteTypeByIdResponse(); }
    public getTypeName() { return 'GetNoteTypeByIdRequest'; }
}

// @Route("/api/v2/note-types", "GET")
export class GetNoteTypesRequest implements IReturn<GetNoteTypesResponse>
{

    public constructor(init?: Partial<GetNoteTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetNoteTypesResponse(); }
    public getTypeName() { return 'GetNoteTypesRequest'; }
}

// @Route("/api/v2/note-types/initial", "POST")
export class InitializeNoteTypeRequest implements IReturn<InitializeNoteTypeResponse>
{
    public context: NoteTypeMetadataContext;

    public constructor(init?: Partial<InitializeNoteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeNoteTypeResponse(); }
    public getTypeName() { return 'InitializeNoteTypeRequest'; }
}

// @Route("/api/v2/note-types", "POST")
export class SaveNoteTypeRequest implements IReturn<SaveNoteTypeResponse>
{
    public model: NoteType;

    public constructor(init?: Partial<SaveNoteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveNoteTypeResponse(); }
    public getTypeName() { return 'SaveNoteTypeRequest'; }
}

// @Route("/api/v2/note-types/{Id}", "DELETE")
export class DeleteNoteTypeRequest implements IReturn<DeleteNoteTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteNoteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteNoteTypeResponse(); }
    public getTypeName() { return 'DeleteNoteTypeRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/{Id}", "GET")
export class GetOpenClinicaUserRoleByIdRequest implements IReturn<GetOpenClinicaUserRoleByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetOpenClinicaUserRoleByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRoleByIdResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRoleByIdRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles", "GET")
export class GetOpenClinicaUserRolesRequest implements IReturn<GetOpenClinicaUserRolesResponse>
{

    public constructor(init?: Partial<GetOpenClinicaUserRolesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetOpenClinicaUserRolesResponse(); }
    public getTypeName() { return 'GetOpenClinicaUserRolesRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/initial", "POST")
export class InitializeOpenClinicaUserRoleRequest implements IReturn<InitializeOpenClinicaUserRoleResponse>
{
    public context: OpenClinicaUserRoleMetadataContext;

    public constructor(init?: Partial<InitializeOpenClinicaUserRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeOpenClinicaUserRoleResponse(); }
    public getTypeName() { return 'InitializeOpenClinicaUserRoleRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles", "POST")
export class SaveOpenClinicaUserRoleRequest implements IReturn<SaveOpenClinicaUserRoleResponse>
{
    public model: OpenClinicaUserRole;

    public constructor(init?: Partial<SaveOpenClinicaUserRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveOpenClinicaUserRoleResponse(); }
    public getTypeName() { return 'SaveOpenClinicaUserRoleRequest'; }
}

// @Route("/api/v2/open-clinica-user-roles/{Id}", "DELETE")
export class DeleteOpenClinicaUserRoleRequest implements IReturn<DeleteOpenClinicaUserRoleResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteOpenClinicaUserRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteOpenClinicaUserRoleResponse(); }
    public getTypeName() { return 'DeleteOpenClinicaUserRoleRequest'; }
}

// @Route("/api/v2/patients/{Id}", "GET")
export class GetPatientByIdRequest implements IReturn<GetPatientByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetPatientByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientByIdResponse(); }
    public getTypeName() { return 'GetPatientByIdRequest'; }
}

// @Route("/api/v2/patients", "GET")
export class GetPatientsRequest implements IReturn<GetPatientsResponse>
{

    public constructor(init?: Partial<GetPatientsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPatientsResponse(); }
    public getTypeName() { return 'GetPatientsRequest'; }
}

// @Route("/api/v2/patients/initial", "POST")
export class InitializePatientRequest implements IReturn<InitializePatientResponse>
{
    public context: PatientMetadataContext;

    public constructor(init?: Partial<InitializePatientRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePatientResponse(); }
    public getTypeName() { return 'InitializePatientRequest'; }
}

// @Route("/api/v2/patients", "POST")
export class SavePatientRequest implements IReturn<SavePatientResponse>
{
    public model: Patient;

    public constructor(init?: Partial<SavePatientRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SavePatientResponse(); }
    public getTypeName() { return 'SavePatientRequest'; }
}

// @Route("/api/v2/patients/{Id}", "DELETE")
export class DeletePatientRequest implements IReturn<DeletePatientResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeletePatientRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeletePatientResponse(); }
    public getTypeName() { return 'DeletePatientRequest'; }
}

// @Route("/api/v2/permission-configurations/{Id}", "GET")
export class GetPermissionConfigurationByIdRequest implements IReturn<GetPermissionConfigurationByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetPermissionConfigurationByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPermissionConfigurationByIdResponse(); }
    public getTypeName() { return 'GetPermissionConfigurationByIdRequest'; }
}

// @Route("/api/v2/permission-configurations", "GET")
export class GetPermissionConfigurationsRequest implements IReturn<GetPermissionConfigurationsResponse>
{

    public constructor(init?: Partial<GetPermissionConfigurationsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPermissionConfigurationsResponse(); }
    public getTypeName() { return 'GetPermissionConfigurationsRequest'; }
}

// @Route("/api/v2/permission-configurations/initial", "POST")
export class InitializePermissionConfigurationRequest implements IReturn<InitializePermissionConfigurationResponse>
{
    public context: PermissionConfigurationMetadataContext;

    public constructor(init?: Partial<InitializePermissionConfigurationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePermissionConfigurationResponse(); }
    public getTypeName() { return 'InitializePermissionConfigurationRequest'; }
}

// @Route("/api/v2/permission-configurations", "POST")
export class SavePermissionConfigurationRequest implements IReturn<SavePermissionConfigurationResponse>
{
    public model: PermissionConfiguration;

    public constructor(init?: Partial<SavePermissionConfigurationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SavePermissionConfigurationResponse(); }
    public getTypeName() { return 'SavePermissionConfigurationRequest'; }
}

// @Route("/api/v2/permission-configurations/{Id}", "DELETE")
export class DeletePermissionConfigurationRequest implements IReturn<DeletePermissionConfigurationResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeletePermissionConfigurationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeletePermissionConfigurationResponse(); }
    public getTypeName() { return 'DeletePermissionConfigurationRequest'; }
}

// @Route("/api/v2/personnel-notes/{Id}", "GET")
export class GetPersonnelNoteByIdRequest implements IReturn<GetPersonnelNoteByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetPersonnelNoteByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNoteByIdResponse(); }
    public getTypeName() { return 'GetPersonnelNoteByIdRequest'; }
}

// @Route("/api/v2/personnel-notes", "GET")
export class GetPersonnelNotesRequest implements IReturn<GetPersonnelNotesResponse>
{

    public constructor(init?: Partial<GetPersonnelNotesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelNotesResponse(); }
    public getTypeName() { return 'GetPersonnelNotesRequest'; }
}

// @Route("/api/v2/personnel-notes/initial", "POST")
export class InitializePersonnelNoteRequest implements IReturn<InitializePersonnelNoteResponse>
{
    public context: PersonnelNoteMetadataContext;

    public constructor(init?: Partial<InitializePersonnelNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePersonnelNoteResponse(); }
    public getTypeName() { return 'InitializePersonnelNoteRequest'; }
}

// @Route("/api/v2/personnel-notes", "POST")
export class SavePersonnelNoteRequest implements IReturn<SavePersonnelNoteResponse>
{
    public model: PersonnelNote;

    public constructor(init?: Partial<SavePersonnelNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SavePersonnelNoteResponse(); }
    public getTypeName() { return 'SavePersonnelNoteRequest'; }
}

// @Route("/api/v2/personnel-notes/{Id}", "DELETE")
export class DeletePersonnelNoteRequest implements IReturn<DeletePersonnelNoteResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeletePersonnelNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeletePersonnelNoteResponse(); }
    public getTypeName() { return 'DeletePersonnelNoteRequest'; }
}

// @Route("/api/v2/personnel-roles/{Id}", "GET")
export class GetPersonnelRoleByIdRequest implements IReturn<GetPersonnelRoleByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetPersonnelRoleByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRoleByIdResponse(); }
    public getTypeName() { return 'GetPersonnelRoleByIdRequest'; }
}

// @Route("/api/v2/personnel-roles", "GET")
export class GetPersonnelRolesRequest implements IReturn<GetPersonnelRolesResponse>
{

    public constructor(init?: Partial<GetPersonnelRolesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelRolesResponse(); }
    public getTypeName() { return 'GetPersonnelRolesRequest'; }
}

// @Route("/api/v2/personnel-roles/initial", "POST")
export class InitializePersonnelRoleRequest implements IReturn<InitializePersonnelRoleResponse>
{
    public context: PersonnelRoleMetadataContext;

    public constructor(init?: Partial<InitializePersonnelRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePersonnelRoleResponse(); }
    public getTypeName() { return 'InitializePersonnelRoleRequest'; }
}

// @Route("/api/v2/personnel-roles", "POST")
export class SavePersonnelRoleRequest implements IReturn<SavePersonnelRoleResponse>
{
    public model: PersonnelRole;

    public constructor(init?: Partial<SavePersonnelRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SavePersonnelRoleResponse(); }
    public getTypeName() { return 'SavePersonnelRoleRequest'; }
}

// @Route("/api/v2/personnel-roles/{Id}", "DELETE")
export class DeletePersonnelRoleRequest implements IReturn<DeletePersonnelRoleResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeletePersonnelRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeletePersonnelRoleResponse(); }
    public getTypeName() { return 'DeletePersonnelRoleRequest'; }
}

// @Route("/api/v2/personnel/{Id}", "GET")
export class GetPersonnelByIdRequest implements IReturn<GetPersonnelByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetPersonnelByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelByIdResponse(); }
    public getTypeName() { return 'GetPersonnelByIdRequest'; }
}

// @Route("/api/v2/personnel", "GET")
export class GetPersonnelsRequest implements IReturn<GetPersonnelsResponse>
{

    public constructor(init?: Partial<GetPersonnelsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetPersonnelsResponse(); }
    public getTypeName() { return 'GetPersonnelsRequest'; }
}

// @Route("/api/v2/personnel/initial", "POST")
export class InitializePersonnelRequest implements IReturn<InitializePersonnelResponse>
{
    public context: PersonnelMetadataContext;

    public constructor(init?: Partial<InitializePersonnelRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializePersonnelResponse(); }
    public getTypeName() { return 'InitializePersonnelRequest'; }
}

// @Route("/api/v2/personnel", "POST")
export class SavePersonnelRequest implements IReturn<SavePersonnelResponse>
{
    public model: Personnel;

    public constructor(init?: Partial<SavePersonnelRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SavePersonnelResponse(); }
    public getTypeName() { return 'SavePersonnelRequest'; }
}

// @Route("/api/v2/personnel/{Id}", "DELETE")
export class DeletePersonnelRequest implements IReturn<DeletePersonnelResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeletePersonnelRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeletePersonnelResponse(); }
    public getTypeName() { return 'DeletePersonnelRequest'; }
}

// @Route("/api/v2/professional-disciplines/{Id}", "GET")
export class GetProfessionalDisciplineByIdRequest implements IReturn<GetProfessionalDisciplineByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetProfessionalDisciplineByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetProfessionalDisciplineByIdResponse(); }
    public getTypeName() { return 'GetProfessionalDisciplineByIdRequest'; }
}

// @Route("/api/v2/professional-disciplines", "GET")
export class GetProfessionalDisciplinesRequest implements IReturn<GetProfessionalDisciplinesResponse>
{

    public constructor(init?: Partial<GetProfessionalDisciplinesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetProfessionalDisciplinesResponse(); }
    public getTypeName() { return 'GetProfessionalDisciplinesRequest'; }
}

// @Route("/api/v2/professional-disciplines/initial", "POST")
export class InitializeProfessionalDisciplineRequest implements IReturn<InitializeProfessionalDisciplineResponse>
{
    public context: ProfessionalDisciplineMetadataContext;

    public constructor(init?: Partial<InitializeProfessionalDisciplineRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeProfessionalDisciplineResponse(); }
    public getTypeName() { return 'InitializeProfessionalDisciplineRequest'; }
}

// @Route("/api/v2/professional-disciplines", "POST")
export class SaveProfessionalDisciplineRequest implements IReturn<SaveProfessionalDisciplineResponse>
{
    public model: ProfessionalDiscipline;

    public constructor(init?: Partial<SaveProfessionalDisciplineRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveProfessionalDisciplineResponse(); }
    public getTypeName() { return 'SaveProfessionalDisciplineRequest'; }
}

// @Route("/api/v2/professional-disciplines/{Id}", "DELETE")
export class DeleteProfessionalDisciplineRequest implements IReturn<DeleteProfessionalDisciplineResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteProfessionalDisciplineRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteProfessionalDisciplineResponse(); }
    public getTypeName() { return 'DeleteProfessionalDisciplineRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/{Id}", "GET")
export class GetReportingTagCategoryByIdRequest implements IReturn<GetReportingTagCategoryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetReportingTagCategoryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagCategoryByIdResponse(); }
    public getTypeName() { return 'GetReportingTagCategoryByIdRequest'; }
}

// @Route("/api/v2/reporting-tag-categories", "GET")
export class GetReportingTagCategoriesRequest implements IReturn<GetReportingTagCategoriesResponse>
{

    public constructor(init?: Partial<GetReportingTagCategoriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagCategoriesResponse(); }
    public getTypeName() { return 'GetReportingTagCategoriesRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/initial", "POST")
export class InitializeReportingTagCategoryRequest implements IReturn<InitializeReportingTagCategoryResponse>
{
    public context: ReportingTagCategoryMetadataContext;

    public constructor(init?: Partial<InitializeReportingTagCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeReportingTagCategoryResponse(); }
    public getTypeName() { return 'InitializeReportingTagCategoryRequest'; }
}

// @Route("/api/v2/reporting-tag-categories", "POST")
export class SaveReportingTagCategoryRequest implements IReturn<SaveReportingTagCategoryResponse>
{
    public model: ReportingTagCategory;

    public constructor(init?: Partial<SaveReportingTagCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveReportingTagCategoryResponse(); }
    public getTypeName() { return 'SaveReportingTagCategoryRequest'; }
}

// @Route("/api/v2/reporting-tag-categories/{Id}", "DELETE")
export class DeleteReportingTagCategoryRequest implements IReturn<DeleteReportingTagCategoryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteReportingTagCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteReportingTagCategoryResponse(); }
    public getTypeName() { return 'DeleteReportingTagCategoryRequest'; }
}

// @Route("/api/v2/reporting-tag-types/{Id}", "GET")
export class GetReportingTagTypeByIdRequest implements IReturn<GetReportingTagTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetReportingTagTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagTypeByIdResponse(); }
    public getTypeName() { return 'GetReportingTagTypeByIdRequest'; }
}

// @Route("/api/v2/reporting-tag-types", "GET")
export class GetReportingTagTypesRequest implements IReturn<GetReportingTagTypesResponse>
{

    public constructor(init?: Partial<GetReportingTagTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagTypesResponse(); }
    public getTypeName() { return 'GetReportingTagTypesRequest'; }
}

// @Route("/api/v2/reporting-tag-types/initial", "POST")
export class InitializeReportingTagTypeRequest implements IReturn<InitializeReportingTagTypeResponse>
{
    public context: ReportingTagTypeMetadataContext;

    public constructor(init?: Partial<InitializeReportingTagTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeReportingTagTypeResponse(); }
    public getTypeName() { return 'InitializeReportingTagTypeRequest'; }
}

// @Route("/api/v2/reporting-tag-types", "POST")
export class SaveReportingTagTypeRequest implements IReturn<SaveReportingTagTypeResponse>
{
    public model: ReportingTagType;

    public constructor(init?: Partial<SaveReportingTagTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveReportingTagTypeResponse(); }
    public getTypeName() { return 'SaveReportingTagTypeRequest'; }
}

// @Route("/api/v2/reporting-tag-types/{Id}", "DELETE")
export class DeleteReportingTagTypeRequest implements IReturn<DeleteReportingTagTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteReportingTagTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteReportingTagTypeResponse(); }
    public getTypeName() { return 'DeleteReportingTagTypeRequest'; }
}

// @Route("/api/v2/reporting-tags/{Id}", "GET")
export class GetReportingTagByIdRequest implements IReturn<GetReportingTagByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetReportingTagByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagByIdResponse(); }
    public getTypeName() { return 'GetReportingTagByIdRequest'; }
}

// @Route("/api/v2/reporting-tags", "GET")
export class GetReportingTagsRequest implements IReturn<GetReportingTagsResponse>
{

    public constructor(init?: Partial<GetReportingTagsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetReportingTagsResponse(); }
    public getTypeName() { return 'GetReportingTagsRequest'; }
}

// @Route("/api/v2/reporting-tags/initial", "POST")
export class InitializeReportingTagRequest implements IReturn<InitializeReportingTagResponse>
{
    public context: ReportingTagMetadataContext;

    public constructor(init?: Partial<InitializeReportingTagRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeReportingTagResponse(); }
    public getTypeName() { return 'InitializeReportingTagRequest'; }
}

// @Route("/api/v2/reporting-tags", "POST")
export class SaveReportingTagRequest implements IReturn<SaveReportingTagResponse>
{
    public model: ReportingTag;

    public constructor(init?: Partial<SaveReportingTagRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveReportingTagResponse(); }
    public getTypeName() { return 'SaveReportingTagRequest'; }
}

// @Route("/api/v2/reporting-tags/{Id}", "DELETE")
export class DeleteReportingTagRequest implements IReturn<DeleteReportingTagResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteReportingTagRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteReportingTagResponse(); }
    public getTypeName() { return 'DeleteReportingTagRequest'; }
}

// @Route("/api/v2/roles/{Id}", "GET")
export class GetRoleByIdRequest implements IReturn<GetRoleByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetRoleByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetRoleByIdResponse(); }
    public getTypeName() { return 'GetRoleByIdRequest'; }
}

// @Route("/api/v2/roles", "GET")
export class GetRolesRequest implements IReturn<GetRolesResponse>
{

    public constructor(init?: Partial<GetRolesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetRolesResponse(); }
    public getTypeName() { return 'GetRolesRequest'; }
}

// @Route("/api/v2/roles/initial", "POST")
export class InitializeRoleRequest implements IReturn<InitializeRoleResponse>
{
    public context: RoleMetadataContext;

    public constructor(init?: Partial<InitializeRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeRoleResponse(); }
    public getTypeName() { return 'InitializeRoleRequest'; }
}

// @Route("/api/v2/roles", "POST")
export class SaveRoleRequest implements IReturn<SaveRoleResponse>
{
    public model: Role;

    public constructor(init?: Partial<SaveRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveRoleResponse(); }
    public getTypeName() { return 'SaveRoleRequest'; }
}

// @Route("/api/v2/roles/{Id}", "DELETE")
export class DeleteRoleRequest implements IReturn<DeleteRoleResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteRoleRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteRoleResponse(); }
    public getTypeName() { return 'DeleteRoleRequest'; }
}

// @Route("/api/v2/salutations/{Id}", "GET")
export class GetSalutationByIdRequest implements IReturn<GetSalutationByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetSalutationByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalutationByIdResponse(); }
    public getTypeName() { return 'GetSalutationByIdRequest'; }
}

// @Route("/api/v2/salutations", "GET")
export class GetSalutationsRequest implements IReturn<GetSalutationsResponse>
{

    public constructor(init?: Partial<GetSalutationsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSalutationsResponse(); }
    public getTypeName() { return 'GetSalutationsRequest'; }
}

// @Route("/api/v2/salutations/initial", "POST")
export class InitializeSalutationRequest implements IReturn<InitializeSalutationResponse>
{
    public context: SalutationMetadataContext;

    public constructor(init?: Partial<InitializeSalutationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeSalutationResponse(); }
    public getTypeName() { return 'InitializeSalutationRequest'; }
}

// @Route("/api/v2/salutations", "POST")
export class SaveSalutationRequest implements IReturn<SaveSalutationResponse>
{
    public model: Salutation;

    public constructor(init?: Partial<SaveSalutationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveSalutationResponse(); }
    public getTypeName() { return 'SaveSalutationRequest'; }
}

// @Route("/api/v2/salutations/{Id}", "DELETE")
export class DeleteSalutationRequest implements IReturn<DeleteSalutationResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteSalutationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteSalutationResponse(); }
    public getTypeName() { return 'DeleteSalutationRequest'; }
}

// @Route("/api/v2/site-locations/{Id}", "GET")
export class GetSiteLocationByIdRequest implements IReturn<GetSiteLocationByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetSiteLocationByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteLocationByIdResponse(); }
    public getTypeName() { return 'GetSiteLocationByIdRequest'; }
}

// @Route("/api/v2/site-locations", "GET")
export class GetSiteLocationsRequest implements IReturn<GetSiteLocationsResponse>
{

    public constructor(init?: Partial<GetSiteLocationsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteLocationsResponse(); }
    public getTypeName() { return 'GetSiteLocationsRequest'; }
}

// @Route("/api/v2/site-locations/initial", "POST")
export class InitializeSiteLocationRequest implements IReturn<InitializeSiteLocationResponse>
{
    public context: SiteLocationMetadataContext;

    public constructor(init?: Partial<InitializeSiteLocationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeSiteLocationResponse(); }
    public getTypeName() { return 'InitializeSiteLocationRequest'; }
}

// @Route("/api/v2/site-locations", "POST")
export class SaveSiteLocationRequest implements IReturn<SaveSiteLocationResponse>
{
    public model: SiteLocation;

    public constructor(init?: Partial<SaveSiteLocationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveSiteLocationResponse(); }
    public getTypeName() { return 'SaveSiteLocationRequest'; }
}

// @Route("/api/v2/site-locations/{Id}", "DELETE")
export class DeleteSiteLocationRequest implements IReturn<DeleteSiteLocationResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteSiteLocationRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteSiteLocationResponse(); }
    public getTypeName() { return 'DeleteSiteLocationRequest'; }
}

// @Route("/api/v2/site-types/{Id}", "GET")
export class GetSiteTypeByIdRequest implements IReturn<GetSiteTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetSiteTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteTypeByIdResponse(); }
    public getTypeName() { return 'GetSiteTypeByIdRequest'; }
}

// @Route("/api/v2/site-types", "GET")
export class GetSiteTypesRequest implements IReturn<GetSiteTypesResponse>
{

    public constructor(init?: Partial<GetSiteTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSiteTypesResponse(); }
    public getTypeName() { return 'GetSiteTypesRequest'; }
}

// @Route("/api/v2/site-types/initial", "POST")
export class InitializeSiteTypeRequest implements IReturn<InitializeSiteTypeResponse>
{
    public context: SiteTypeMetadataContext;

    public constructor(init?: Partial<InitializeSiteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeSiteTypeResponse(); }
    public getTypeName() { return 'InitializeSiteTypeRequest'; }
}

// @Route("/api/v2/site-types", "POST")
export class SaveSiteTypeRequest implements IReturn<SaveSiteTypeResponse>
{
    public model: SiteType;

    public constructor(init?: Partial<SaveSiteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveSiteTypeResponse(); }
    public getTypeName() { return 'SaveSiteTypeRequest'; }
}

// @Route("/api/v2/site-types/{Id}", "DELETE")
export class DeleteSiteTypeRequest implements IReturn<DeleteSiteTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteSiteTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteSiteTypeResponse(); }
    public getTypeName() { return 'DeleteSiteTypeRequest'; }
}

// @Route("/api/v2/sort-orders/{Id}", "GET")
export class GetSortOrderByIdRequest implements IReturn<GetSortOrderByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetSortOrderByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSortOrderByIdResponse(); }
    public getTypeName() { return 'GetSortOrderByIdRequest'; }
}

// @Route("/api/v2/sort-orders", "GET")
export class GetSortOrdersRequest implements IReturn<GetSortOrdersResponse>
{

    public constructor(init?: Partial<GetSortOrdersRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetSortOrdersResponse(); }
    public getTypeName() { return 'GetSortOrdersRequest'; }
}

// @Route("/api/v2/sort-orders/initial", "POST")
export class InitializeSortOrderRequest implements IReturn<InitializeSortOrderResponse>
{
    public context: SortOrderMetadataContext;

    public constructor(init?: Partial<InitializeSortOrderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeSortOrderResponse(); }
    public getTypeName() { return 'InitializeSortOrderRequest'; }
}

// @Route("/api/v2/sort-orders", "POST")
export class SaveSortOrderRequest implements IReturn<SaveSortOrderResponse>
{
    public model: SortOrder;

    public constructor(init?: Partial<SaveSortOrderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveSortOrderResponse(); }
    public getTypeName() { return 'SaveSortOrderRequest'; }
}

// @Route("/api/v2/sort-orders/{Id}", "DELETE")
export class DeleteSortOrderRequest implements IReturn<DeleteSortOrderResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteSortOrderRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteSortOrderResponse(); }
    public getTypeName() { return 'DeleteSortOrderRequest'; }
}

// @Route("/api/v2/standard-email-templates/{Id}", "GET")
export class GetStandardEmailTemplateByIdRequest implements IReturn<GetStandardEmailTemplateByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetStandardEmailTemplateByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStandardEmailTemplateByIdResponse(); }
    public getTypeName() { return 'GetStandardEmailTemplateByIdRequest'; }
}

// @Route("/api/v2/standard-email-templates", "GET")
export class GetStandardEmailTemplatesRequest implements IReturn<GetStandardEmailTemplatesResponse>
{

    public constructor(init?: Partial<GetStandardEmailTemplatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStandardEmailTemplatesResponse(); }
    public getTypeName() { return 'GetStandardEmailTemplatesRequest'; }
}

// @Route("/api/v2/standard-email-templates/initial", "POST")
export class InitializeStandardEmailTemplateRequest implements IReturn<InitializeStandardEmailTemplateResponse>
{
    public context: StandardEmailTemplateMetadataContext;

    public constructor(init?: Partial<InitializeStandardEmailTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeStandardEmailTemplateResponse(); }
    public getTypeName() { return 'InitializeStandardEmailTemplateRequest'; }
}

// @Route("/api/v2/standard-email-templates", "POST")
export class SaveStandardEmailTemplateRequest implements IReturn<SaveStandardEmailTemplateResponse>
{
    public model: StandardEmailTemplate;

    public constructor(init?: Partial<SaveStandardEmailTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveStandardEmailTemplateResponse(); }
    public getTypeName() { return 'SaveStandardEmailTemplateRequest'; }
}

// @Route("/api/v2/standard-email-templates/{Id}", "DELETE")
export class DeleteStandardEmailTemplateRequest implements IReturn<DeleteStandardEmailTemplateResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteStandardEmailTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteStandardEmailTemplateResponse(); }
    public getTypeName() { return 'DeleteStandardEmailTemplateRequest'; }
}

// @Route("/api/v2/states/{Id}", "GET")
export class GetStateByIdRequest implements IReturn<GetStateByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetStateByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStateByIdResponse(); }
    public getTypeName() { return 'GetStateByIdRequest'; }
}

// @Route("/api/v2/states", "GET")
export class GetStatesRequest implements IReturn<GetStatesResponse>
{

    public constructor(init?: Partial<GetStatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetStatesResponse(); }
    public getTypeName() { return 'GetStatesRequest'; }
}

// @Route("/api/v2/states/initial", "POST")
export class InitializeStateRequest implements IReturn<InitializeStateResponse>
{
    public context: StateMetadataContext;

    public constructor(init?: Partial<InitializeStateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeStateResponse(); }
    public getTypeName() { return 'InitializeStateRequest'; }
}

// @Route("/api/v2/states", "POST")
export class SaveStateRequest implements IReturn<SaveStateResponse>
{
    public model: State;

    public constructor(init?: Partial<SaveStateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveStateResponse(); }
    public getTypeName() { return 'SaveStateRequest'; }
}

// @Route("/api/v2/states/{Id}", "DELETE")
export class DeleteStateRequest implements IReturn<DeleteStateResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteStateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteStateResponse(); }
    public getTypeName() { return 'DeleteStateRequest'; }
}

// @Route("/api/v2/task-types/{Id}", "GET")
export class GetTaskTypeByIdRequest implements IReturn<GetTaskTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTaskTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTaskTypeByIdResponse(); }
    public getTypeName() { return 'GetTaskTypeByIdRequest'; }
}

// @Route("/api/v2/task-types", "GET")
export class GetTaskTypesRequest implements IReturn<GetTaskTypesResponse>
{

    public constructor(init?: Partial<GetTaskTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTaskTypesResponse(); }
    public getTypeName() { return 'GetTaskTypesRequest'; }
}

// @Route("/api/v2/task-types/initial", "POST")
export class InitializeTaskTypeRequest implements IReturn<InitializeTaskTypeResponse>
{
    public context: TaskTypeMetadataContext;

    public constructor(init?: Partial<InitializeTaskTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTaskTypeResponse(); }
    public getTypeName() { return 'InitializeTaskTypeRequest'; }
}

// @Route("/api/v2/task-types", "POST")
export class SaveTaskTypeRequest implements IReturn<SaveTaskTypeResponse>
{
    public model: TaskType;

    public constructor(init?: Partial<SaveTaskTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTaskTypeResponse(); }
    public getTypeName() { return 'SaveTaskTypeRequest'; }
}

// @Route("/api/v2/task-types/{Id}", "DELETE")
export class DeleteTaskTypeRequest implements IReturn<DeleteTaskTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTaskTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTaskTypeResponse(); }
    public getTypeName() { return 'DeleteTaskTypeRequest'; }
}

// @Route("/api/v2/template-trial-items/{Id}", "GET")
export class GetTemplateTrialItemByIdRequest implements IReturn<GetTemplateTrialItemByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTemplateTrialItemByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemplateTrialItemByIdResponse(); }
    public getTypeName() { return 'GetTemplateTrialItemByIdRequest'; }
}

// @Route("/api/v2/template-trial-items", "GET")
export class GetTemplateTrialItemsRequest implements IReturn<GetTemplateTrialItemsResponse>
{

    public constructor(init?: Partial<GetTemplateTrialItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTemplateTrialItemsResponse(); }
    public getTypeName() { return 'GetTemplateTrialItemsRequest'; }
}

// @Route("/api/v2/template-trial-items/initial", "POST")
export class InitializeTemplateTrialItemRequest implements IReturn<InitializeTemplateTrialItemResponse>
{
    public context: TemplateTrialItemMetadataContext;

    public constructor(init?: Partial<InitializeTemplateTrialItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTemplateTrialItemResponse(); }
    public getTypeName() { return 'InitializeTemplateTrialItemRequest'; }
}

// @Route("/api/v2/template-trial-items", "POST")
export class SaveTemplateTrialItemRequest implements IReturn<SaveTemplateTrialItemResponse>
{
    public model: TemplateTrialItem;

    public constructor(init?: Partial<SaveTemplateTrialItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTemplateTrialItemResponse(); }
    public getTypeName() { return 'SaveTemplateTrialItemRequest'; }
}

// @Route("/api/v2/template-trial-items/{Id}", "DELETE")
export class DeleteTemplateTrialItemRequest implements IReturn<DeleteTemplateTrialItemResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTemplateTrialItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTemplateTrialItemResponse(); }
    public getTypeName() { return 'DeleteTemplateTrialItemRequest'; }
}

// @Route("/api/v2/tracker-milestones/{Id}", "GET")
export class GetTrackerMilestoneByIdRequest implements IReturn<GetTrackerMilestoneByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrackerMilestoneByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerMilestoneByIdResponse(); }
    public getTypeName() { return 'GetTrackerMilestoneByIdRequest'; }
}

// @Route("/api/v2/tracker-milestones", "GET")
export class GetTrackerMilestonesRequest implements IReturn<GetTrackerMilestonesResponse>
{

    public constructor(init?: Partial<GetTrackerMilestonesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerMilestonesResponse(); }
    public getTypeName() { return 'GetTrackerMilestonesRequest'; }
}

// @Route("/api/v2/tracker-milestones/initial", "POST")
export class InitializeTrackerMilestoneRequest implements IReturn<InitializeTrackerMilestoneResponse>
{
    public context: TrackerMilestoneMetadataContext;

    public constructor(init?: Partial<InitializeTrackerMilestoneRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrackerMilestoneResponse(); }
    public getTypeName() { return 'InitializeTrackerMilestoneRequest'; }
}

// @Route("/api/v2/tracker-milestones", "POST")
export class SaveTrackerMilestoneRequest implements IReturn<SaveTrackerMilestoneResponse>
{
    public model: TrackerMilestone;

    public constructor(init?: Partial<SaveTrackerMilestoneRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrackerMilestoneResponse(); }
    public getTypeName() { return 'SaveTrackerMilestoneRequest'; }
}

// @Route("/api/v2/tracker-milestones/{Id}", "DELETE")
export class DeleteTrackerMilestoneRequest implements IReturn<DeleteTrackerMilestoneResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrackerMilestoneRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrackerMilestoneResponse(); }
    public getTypeName() { return 'DeleteTrackerMilestoneRequest'; }
}

// @Route("/api/v2/tracker-statuses/{Id}", "GET")
export class GetTrackerStatusByIdRequest implements IReturn<GetTrackerStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrackerStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerStatusByIdResponse(); }
    public getTypeName() { return 'GetTrackerStatusByIdRequest'; }
}

// @Route("/api/v2/tracker-statuses", "GET")
export class GetTrackerStatusesRequest implements IReturn<GetTrackerStatusesResponse>
{

    public constructor(init?: Partial<GetTrackerStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerStatusesResponse(); }
    public getTypeName() { return 'GetTrackerStatusesRequest'; }
}

// @Route("/api/v2/tracker-statuses/initial", "POST")
export class InitializeTrackerStatusRequest implements IReturn<InitializeTrackerStatusResponse>
{
    public context: TrackerStatusMetadataContext;

    public constructor(init?: Partial<InitializeTrackerStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrackerStatusResponse(); }
    public getTypeName() { return 'InitializeTrackerStatusRequest'; }
}

// @Route("/api/v2/tracker-statuses", "POST")
export class SaveTrackerStatusRequest implements IReturn<SaveTrackerStatusResponse>
{
    public model: TrackerStatus;

    public constructor(init?: Partial<SaveTrackerStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrackerStatusResponse(); }
    public getTypeName() { return 'SaveTrackerStatusRequest'; }
}

// @Route("/api/v2/tracker-statuses/{Id}", "DELETE")
export class DeleteTrackerStatusRequest implements IReturn<DeleteTrackerStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrackerStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrackerStatusResponse(); }
    public getTypeName() { return 'DeleteTrackerStatusRequest'; }
}

// @Route("/api/v2/tracker-types/{Id}", "GET")
export class GetTrackerTypeByIdRequest implements IReturn<GetTrackerTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrackerTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerTypeByIdResponse(); }
    public getTypeName() { return 'GetTrackerTypeByIdRequest'; }
}

// @Route("/api/v2/tracker-types", "GET")
export class GetTrackerTypesRequest implements IReturn<GetTrackerTypesResponse>
{

    public constructor(init?: Partial<GetTrackerTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrackerTypesResponse(); }
    public getTypeName() { return 'GetTrackerTypesRequest'; }
}

// @Route("/api/v2/tracker-types/initial", "POST")
export class InitializeTrackerTypeRequest implements IReturn<InitializeTrackerTypeResponse>
{
    public context: TrackerTypeMetadataContext;

    public constructor(init?: Partial<InitializeTrackerTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrackerTypeResponse(); }
    public getTypeName() { return 'InitializeTrackerTypeRequest'; }
}

// @Route("/api/v2/tracker-types", "POST")
export class SaveTrackerTypeRequest implements IReturn<SaveTrackerTypeResponse>
{
    public model: TrackerType;

    public constructor(init?: Partial<SaveTrackerTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrackerTypeResponse(); }
    public getTypeName() { return 'SaveTrackerTypeRequest'; }
}

// @Route("/api/v2/tracker-types/{Id}", "DELETE")
export class DeleteTrackerTypeRequest implements IReturn<DeleteTrackerTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrackerTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrackerTypeResponse(); }
    public getTypeName() { return 'DeleteTrackerTypeRequest'; }
}

// @Route("/api/v2/trial-analysis-types/{Id}", "GET")
export class GetTrialAnalysisTypeByIdRequest implements IReturn<GetTrialAnalysisTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialAnalysisTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialAnalysisTypeByIdResponse(); }
    public getTypeName() { return 'GetTrialAnalysisTypeByIdRequest'; }
}

// @Route("/api/v2/trial-analysis-types", "GET")
export class GetTrialAnalysisTypesRequest implements IReturn<GetTrialAnalysisTypesResponse>
{

    public constructor(init?: Partial<GetTrialAnalysisTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialAnalysisTypesResponse(); }
    public getTypeName() { return 'GetTrialAnalysisTypesRequest'; }
}

// @Route("/api/v2/trial-analysis-types/initial", "POST")
export class InitializeTrialAnalysisTypeRequest implements IReturn<InitializeTrialAnalysisTypeResponse>
{
    public context: TrialAnalysisTypeMetadataContext;

    public constructor(init?: Partial<InitializeTrialAnalysisTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialAnalysisTypeResponse(); }
    public getTypeName() { return 'InitializeTrialAnalysisTypeRequest'; }
}

// @Route("/api/v2/trial-analysis-types", "POST")
export class SaveTrialAnalysisTypeRequest implements IReturn<SaveTrialAnalysisTypeResponse>
{
    public model: TrialAnalysisType;

    public constructor(init?: Partial<SaveTrialAnalysisTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialAnalysisTypeResponse(); }
    public getTypeName() { return 'SaveTrialAnalysisTypeRequest'; }
}

// @Route("/api/v2/trial-analysis-types/{Id}", "DELETE")
export class DeleteTrialAnalysisTypeRequest implements IReturn<DeleteTrialAnalysisTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialAnalysisTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialAnalysisTypeResponse(); }
    public getTypeName() { return 'DeleteTrialAnalysisTypeRequest'; }
}

// @Route("/api/v2/trial-apis/{Id}", "GET")
export class GetTrialApiByIdRequest implements IReturn<GetTrialApiByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialApiByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialApiByIdResponse(); }
    public getTypeName() { return 'GetTrialApiByIdRequest'; }
}

// @Route("/api/v2/trial-apis", "GET")
export class GetTrialApisRequest implements IReturn<GetTrialApisResponse>
{

    public constructor(init?: Partial<GetTrialApisRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialApisResponse(); }
    public getTypeName() { return 'GetTrialApisRequest'; }
}

// @Route("/api/v2/trial-apis/initial", "POST")
export class InitializeTrialApiRequest implements IReturn<InitializeTrialApiResponse>
{
    public context: TrialApiMetadataContext;

    public constructor(init?: Partial<InitializeTrialApiRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialApiResponse(); }
    public getTypeName() { return 'InitializeTrialApiRequest'; }
}

// @Route("/api/v2/trial-apis", "POST")
export class SaveTrialApiRequest implements IReturn<SaveTrialApiResponse>
{
    public model: TrialApi;

    public constructor(init?: Partial<SaveTrialApiRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialApiResponse(); }
    public getTypeName() { return 'SaveTrialApiRequest'; }
}

// @Route("/api/v2/trial-apis/{Id}", "DELETE")
export class DeleteTrialApiRequest implements IReturn<DeleteTrialApiResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialApiRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialApiResponse(); }
    public getTypeName() { return 'DeleteTrialApiRequest'; }
}

// @Route("/api/v2/trial-categories/{Id}", "GET")
export class GetTrialCategoryByIdRequest implements IReturn<GetTrialCategoryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialCategoryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialCategoryByIdResponse(); }
    public getTypeName() { return 'GetTrialCategoryByIdRequest'; }
}

// @Route("/api/v2/trial-categories", "GET")
export class GetTrialCategoriesRequest implements IReturn<GetTrialCategoriesResponse>
{

    public constructor(init?: Partial<GetTrialCategoriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialCategoriesResponse(); }
    public getTypeName() { return 'GetTrialCategoriesRequest'; }
}

// @Route("/api/v2/trial-categories/initial", "POST")
export class InitializeTrialCategoryRequest implements IReturn<InitializeTrialCategoryResponse>
{
    public context: TrialCategoryMetadataContext;

    public constructor(init?: Partial<InitializeTrialCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialCategoryResponse(); }
    public getTypeName() { return 'InitializeTrialCategoryRequest'; }
}

// @Route("/api/v2/trial-categories", "POST")
export class SaveTrialCategoryRequest implements IReturn<SaveTrialCategoryResponse>
{
    public model: TrialCategory;

    public constructor(init?: Partial<SaveTrialCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialCategoryResponse(); }
    public getTypeName() { return 'SaveTrialCategoryRequest'; }
}

// @Route("/api/v2/trial-categories/{Id}", "DELETE")
export class DeleteTrialCategoryRequest implements IReturn<DeleteTrialCategoryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialCategoryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialCategoryResponse(); }
    public getTypeName() { return 'DeleteTrialCategoryRequest'; }
}

// @Route("/api/v2/trial-form-reports/{Id}", "GET")
export class GetTrialFormReportByIdRequest implements IReturn<GetTrialFormReportByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialFormReportByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormReportByIdResponse(); }
    public getTypeName() { return 'GetTrialFormReportByIdRequest'; }
}

// @Route("/api/v2/trial-form-reports", "GET")
export class GetTrialFormReportsRequest implements IReturn<GetTrialFormReportsResponse>
{

    public constructor(init?: Partial<GetTrialFormReportsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormReportsResponse(); }
    public getTypeName() { return 'GetTrialFormReportsRequest'; }
}

// @Route("/api/v2/trial-form-reports/initial", "POST")
export class InitializeTrialFormReportRequest implements IReturn<InitializeTrialFormReportResponse>
{
    public context: TrialFormReportMetadataContext;

    public constructor(init?: Partial<InitializeTrialFormReportRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialFormReportResponse(); }
    public getTypeName() { return 'InitializeTrialFormReportRequest'; }
}

// @Route("/api/v2/trial-form-reports", "POST")
export class SaveTrialFormReportRequest implements IReturn<SaveTrialFormReportResponse>
{
    public model: TrialFormReport;

    public constructor(init?: Partial<SaveTrialFormReportRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialFormReportResponse(); }
    public getTypeName() { return 'SaveTrialFormReportRequest'; }
}

// @Route("/api/v2/trial-form-reports/{Id}", "DELETE")
export class DeleteTrialFormReportRequest implements IReturn<DeleteTrialFormReportResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialFormReportRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialFormReportResponse(); }
    public getTypeName() { return 'DeleteTrialFormReportRequest'; }
}

// @Route("/api/v2/trial-forms/{TrialFormId}/versions", "POST")
export class CreateTrialFormVersionRequest implements IReturn<CreateTrialFormVersionResponse>
{
    public trialFormId: number;
    public expectedCurrentVersionId?: number;
    public version: string;
    public copyData: boolean;

    public constructor(init?: Partial<CreateTrialFormVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateTrialFormVersionResponse(); }
    public getTypeName() { return 'CreateTrialFormVersionRequest'; }
}

// @Route("/api/v2/trial-forms/{Id}", "GET")
export class GetTrialFormByIdRequest implements IReturn<GetTrialFormByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialFormByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormByIdResponse(); }
    public getTypeName() { return 'GetTrialFormByIdRequest'; }
}

// @Route("/api/v2/trial-forms", "GET")
export class GetTrialFormsRequest implements IReturn<GetTrialFormsResponse>
{

    public constructor(init?: Partial<GetTrialFormsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialFormsResponse(); }
    public getTypeName() { return 'GetTrialFormsRequest'; }
}

// @Route("/api/v2/trial-forms/initial", "POST")
export class InitializeTrialFormRequest implements IReturn<InitializeTrialFormResponse>
{
    public context: TrialFormMetadataContext;

    public constructor(init?: Partial<InitializeTrialFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialFormResponse(); }
    public getTypeName() { return 'InitializeTrialFormRequest'; }
}

// @Route("/api/v2/trial-forms", "POST")
export class SaveTrialFormRequest implements IReturn<SaveTrialFormResponse>
{
    public model: TrialForm;

    public constructor(init?: Partial<SaveTrialFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialFormResponse(); }
    public getTypeName() { return 'SaveTrialFormRequest'; }
}

// @Route("/api/v2/trial-forms/{Id}", "DELETE")
export class DeleteTrialFormRequest implements IReturn<DeleteTrialFormResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialFormRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialFormResponse(); }
    public getTypeName() { return 'DeleteTrialFormRequest'; }
}

// @Route("/api/v2/trial-group-items/{TrialGroupItemId}/versions", "POST")
export class CreateTrialGroupItemVersionRequest implements IReturn<CreateTrialGroupItemVersionResponse>
{
    public trialGroupItemId: number;
    public expectedCurrentVersionId?: number;
    public version: string;

    public constructor(init?: Partial<CreateTrialGroupItemVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateTrialGroupItemVersionResponse(); }
    public getTypeName() { return 'CreateTrialGroupItemVersionRequest'; }
}

// @Route("/api/v2/trial-group-items/{Id}", "GET")
export class GetTrialGroupItemByIdRequest implements IReturn<GetTrialGroupItemByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialGroupItemByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupItemByIdResponse(); }
    public getTypeName() { return 'GetTrialGroupItemByIdRequest'; }
}

// @Route("/api/v2/trial-group-items", "GET")
export class GetTrialGroupItemsRequest implements IReturn<GetTrialGroupItemsResponse>
{

    public constructor(init?: Partial<GetTrialGroupItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupItemsResponse(); }
    public getTypeName() { return 'GetTrialGroupItemsRequest'; }
}

// @Route("/api/v2/trial-group-items/initial", "POST")
export class InitializeTrialGroupItemRequest implements IReturn<InitializeTrialGroupItemResponse>
{
    public context: TrialGroupItemMetadataContext;

    public constructor(init?: Partial<InitializeTrialGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialGroupItemResponse(); }
    public getTypeName() { return 'InitializeTrialGroupItemRequest'; }
}

// @Route("/api/v2/trial-group-items", "POST")
export class SaveTrialGroupItemRequest implements IReturn<SaveTrialGroupItemResponse>
{
    public model: TrialGroupItem;

    public constructor(init?: Partial<SaveTrialGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialGroupItemResponse(); }
    public getTypeName() { return 'SaveTrialGroupItemRequest'; }
}

// @Route("/api/v2/trial-group-items/{Id}", "DELETE")
export class DeleteTrialGroupItemRequest implements IReturn<DeleteTrialGroupItemResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialGroupItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialGroupItemResponse(); }
    public getTypeName() { return 'DeleteTrialGroupItemRequest'; }
}

// @Route("/api/v2/trial-groups/{Id}", "GET")
export class GetTrialGroupByIdRequest implements IReturn<GetTrialGroupByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialGroupByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupByIdResponse(); }
    public getTypeName() { return 'GetTrialGroupByIdRequest'; }
}

// @Route("/api/v2/trial-groups", "GET")
export class GetTrialGroupsRequest implements IReturn<GetTrialGroupsResponse>
{

    public constructor(init?: Partial<GetTrialGroupsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialGroupsResponse(); }
    public getTypeName() { return 'GetTrialGroupsRequest'; }
}

// @Route("/api/v2/trial-groups/initial", "POST")
export class InitializeTrialGroupRequest implements IReturn<InitializeTrialGroupResponse>
{
    public context: TrialGroupMetadataContext;

    public constructor(init?: Partial<InitializeTrialGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialGroupResponse(); }
    public getTypeName() { return 'InitializeTrialGroupRequest'; }
}

// @Route("/api/v2/trial-groups", "POST")
export class SaveTrialGroupRequest implements IReturn<SaveTrialGroupResponse>
{
    public model: TrialGroup;

    public constructor(init?: Partial<SaveTrialGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialGroupResponse(); }
    public getTypeName() { return 'SaveTrialGroupRequest'; }
}

// @Route("/api/v2/trial-groups/{Id}", "DELETE")
export class DeleteTrialGroupRequest implements IReturn<DeleteTrialGroupResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialGroupResponse(); }
    public getTypeName() { return 'DeleteTrialGroupRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/import", "POST")
export class ImportTrialInstitutionItemTemplatesRequest implements IReturn<ImportTrialInstitutionItemTemplatesResponse>
{
    public destinationTrialId: number;
    public sourceTrialId?: number;
    public selectedIds: number[];
    public addGroups: boolean;

    public constructor(init?: Partial<ImportTrialInstitutionItemTemplatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ImportTrialInstitutionItemTemplatesResponse(); }
    public getTypeName() { return 'ImportTrialInstitutionItemTemplatesRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{Id}", "GET")
export class GetTrialInstitutionItemTemplateByIdRequest implements IReturn<GetTrialInstitutionItemTemplateByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionItemTemplateByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplateByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplateByIdRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates", "GET")
export class GetTrialInstitutionItemTemplatesRequest implements IReturn<GetTrialInstitutionItemTemplatesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionItemTemplatesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemTemplatesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemTemplatesRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/initial", "POST")
export class InitializeTrialInstitutionItemTemplateRequest implements IReturn<InitializeTrialInstitutionItemTemplateResponse>
{
    public context: TrialInstitutionItemTemplateMetadataContext;

    public constructor(init?: Partial<InitializeTrialInstitutionItemTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialInstitutionItemTemplateResponse(); }
    public getTypeName() { return 'InitializeTrialInstitutionItemTemplateRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates", "POST")
export class SaveTrialInstitutionItemTemplateRequest implements IReturn<SaveTrialInstitutionItemTemplateResponse>
{
    public model: TrialInstitutionItemTemplate;

    public constructor(init?: Partial<SaveTrialInstitutionItemTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialInstitutionItemTemplateResponse(); }
    public getTypeName() { return 'SaveTrialInstitutionItemTemplateRequest'; }
}

// @Route("/api/v2/trial-institution-item-templates/{Id}", "DELETE")
export class DeleteTrialInstitutionItemTemplateRequest implements IReturn<DeleteTrialInstitutionItemTemplateResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialInstitutionItemTemplateRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialInstitutionItemTemplateResponse(); }
    public getTypeName() { return 'DeleteTrialInstitutionItemTemplateRequest'; }
}

// @Route("/api/v2/trial-institution-items/{TrialInstitutionItemId}/versions", "POST")
export class CreateTrialInstitutionItemVersionRequest implements IReturn<CreateTrialInstitutionItemVersionResponse>
{
    public trialInstitutionItemId: number;
    public expectedCurrentVersionId?: number;
    public version: string;
    public versionDate?: string;
    public comments: string;

    public constructor(init?: Partial<CreateTrialInstitutionItemVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateTrialInstitutionItemVersionResponse(); }
    public getTypeName() { return 'CreateTrialInstitutionItemVersionRequest'; }
}

// @Route("/api/v2/trial-institution-items/{Id}", "GET")
export class GetTrialInstitutionItemByIdRequest implements IReturn<GetTrialInstitutionItemByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionItemByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemByIdRequest'; }
}

// @Route("/api/v2/trial-institution-items", "GET")
export class GetTrialInstitutionItemsRequest implements IReturn<GetTrialInstitutionItemsResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionItemsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionItemsResponse(); }
    public getTypeName() { return 'GetTrialInstitutionItemsRequest'; }
}

// @Route("/api/v2/trial-institution-items/initial", "POST")
export class InitializeTrialInstitutionItemRequest implements IReturn<InitializeTrialInstitutionItemResponse>
{
    public context: TrialInstitutionItemMetadataContext;

    public constructor(init?: Partial<InitializeTrialInstitutionItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialInstitutionItemResponse(); }
    public getTypeName() { return 'InitializeTrialInstitutionItemRequest'; }
}

// @Route("/api/v2/trial-institution-items", "POST")
export class SaveTrialInstitutionItemRequest implements IReturn<SaveTrialInstitutionItemResponse>
{
    public model: TrialInstitutionItem;

    public constructor(init?: Partial<SaveTrialInstitutionItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialInstitutionItemResponse(); }
    public getTypeName() { return 'SaveTrialInstitutionItemRequest'; }
}

// @Route("/api/v2/trial-institution-items/{Id}", "DELETE")
export class DeleteTrialInstitutionItemRequest implements IReturn<DeleteTrialInstitutionItemResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialInstitutionItemRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialInstitutionItemResponse(); }
    public getTypeName() { return 'DeleteTrialInstitutionItemRequest'; }
}

// @Route("/api/v2/trial-institution-notes/{Id}", "GET")
export class GetTrialInstitutionNoteByIdRequest implements IReturn<GetTrialInstitutionNoteByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionNoteByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNoteByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNoteByIdRequest'; }
}

// @Route("/api/v2/trial-institution-notes", "GET")
export class GetTrialInstitutionNotesRequest implements IReturn<GetTrialInstitutionNotesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionNotesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionNotesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionNotesRequest'; }
}

// @Route("/api/v2/trial-institution-notes/initial", "POST")
export class InitializeTrialInstitutionNoteRequest implements IReturn<InitializeTrialInstitutionNoteResponse>
{
    public context: TrialInstitutionNoteMetadataContext;

    public constructor(init?: Partial<InitializeTrialInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialInstitutionNoteResponse(); }
    public getTypeName() { return 'InitializeTrialInstitutionNoteRequest'; }
}

// @Route("/api/v2/trial-institution-notes", "POST")
export class SaveTrialInstitutionNoteRequest implements IReturn<SaveTrialInstitutionNoteResponse>
{
    public model: TrialInstitutionNote;

    public constructor(init?: Partial<SaveTrialInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialInstitutionNoteResponse(); }
    public getTypeName() { return 'SaveTrialInstitutionNoteRequest'; }
}

// @Route("/api/v2/trial-institution-notes/{Id}", "DELETE")
export class DeleteTrialInstitutionNoteRequest implements IReturn<DeleteTrialInstitutionNoteResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialInstitutionNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialInstitutionNoteResponse(); }
    public getTypeName() { return 'DeleteTrialInstitutionNoteRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/{Id}", "GET")
export class GetTrialInstitutionStatusByIdRequest implements IReturn<GetTrialInstitutionStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionStatusByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionStatusByIdRequest'; }
}

// @Route("/api/v2/trial-institution-statuses", "GET")
export class GetTrialInstitutionStatusesRequest implements IReturn<GetTrialInstitutionStatusesResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionStatusesResponse(); }
    public getTypeName() { return 'GetTrialInstitutionStatusesRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/initial", "POST")
export class InitializeTrialInstitutionStatusRequest implements IReturn<InitializeTrialInstitutionStatusResponse>
{
    public context: TrialInstitutionStatusMetadataContext;

    public constructor(init?: Partial<InitializeTrialInstitutionStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialInstitutionStatusResponse(); }
    public getTypeName() { return 'InitializeTrialInstitutionStatusRequest'; }
}

// @Route("/api/v2/trial-institution-statuses", "POST")
export class SaveTrialInstitutionStatusRequest implements IReturn<SaveTrialInstitutionStatusResponse>
{
    public model: TrialInstitutionStatus;

    public constructor(init?: Partial<SaveTrialInstitutionStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialInstitutionStatusResponse(); }
    public getTypeName() { return 'SaveTrialInstitutionStatusRequest'; }
}

// @Route("/api/v2/trial-institution-statuses/{Id}", "DELETE")
export class DeleteTrialInstitutionStatusRequest implements IReturn<DeleteTrialInstitutionStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialInstitutionStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialInstitutionStatusResponse(); }
    public getTypeName() { return 'DeleteTrialInstitutionStatusRequest'; }
}

// @Route("/api/v2/trial-institutions/{Id}", "GET")
export class GetTrialInstitutionByIdRequest implements IReturn<GetTrialInstitutionByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialInstitutionByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionByIdResponse(); }
    public getTypeName() { return 'GetTrialInstitutionByIdRequest'; }
}

// @Route("/api/v2/trial-institutions", "GET")
export class GetTrialInstitutionsRequest implements IReturn<GetTrialInstitutionsResponse>
{

    public constructor(init?: Partial<GetTrialInstitutionsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialInstitutionsResponse(); }
    public getTypeName() { return 'GetTrialInstitutionsRequest'; }
}

// @Route("/api/v2/trial-institutions/initial", "POST")
export class InitializeTrialInstitutionRequest implements IReturn<InitializeTrialInstitutionResponse>
{
    public context: TrialInstitutionMetadataContext;

    public constructor(init?: Partial<InitializeTrialInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialInstitutionResponse(); }
    public getTypeName() { return 'InitializeTrialInstitutionRequest'; }
}

// @Route("/api/v2/trial-institutions", "POST")
export class SaveTrialInstitutionRequest implements IReturn<SaveTrialInstitutionResponse>
{
    public model: TrialInstitution;

    public constructor(init?: Partial<SaveTrialInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialInstitutionResponse(); }
    public getTypeName() { return 'SaveTrialInstitutionRequest'; }
}

// @Route("/api/v2/trial-institutions/{Id}", "DELETE")
export class DeleteTrialInstitutionRequest implements IReturn<DeleteTrialInstitutionResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialInstitutionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialInstitutionResponse(); }
    public getTypeName() { return 'DeleteTrialInstitutionRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/{Id}", "GET")
export class GetTrialItemInstanceStatusByIdRequest implements IReturn<GetTrialItemInstanceStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialItemInstanceStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceStatusByIdResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceStatusByIdRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses", "GET")
export class GetTrialItemInstanceStatusesRequest implements IReturn<GetTrialItemInstanceStatusesResponse>
{

    public constructor(init?: Partial<GetTrialItemInstanceStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceStatusesResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceStatusesRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/initial", "POST")
export class InitializeTrialItemInstanceStatusRequest implements IReturn<InitializeTrialItemInstanceStatusResponse>
{
    public context: TrialItemInstanceStatusMetadataContext;

    public constructor(init?: Partial<InitializeTrialItemInstanceStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialItemInstanceStatusResponse(); }
    public getTypeName() { return 'InitializeTrialItemInstanceStatusRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses", "POST")
export class SaveTrialItemInstanceStatusRequest implements IReturn<SaveTrialItemInstanceStatusResponse>
{
    public model: TrialItemInstanceStatus;

    public constructor(init?: Partial<SaveTrialItemInstanceStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialItemInstanceStatusResponse(); }
    public getTypeName() { return 'SaveTrialItemInstanceStatusRequest'; }
}

// @Route("/api/v2/trial-item-instance-statuses/{Id}", "DELETE")
export class DeleteTrialItemInstanceStatusRequest implements IReturn<DeleteTrialItemInstanceStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialItemInstanceStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialItemInstanceStatusResponse(); }
    public getTypeName() { return 'DeleteTrialItemInstanceStatusRequest'; }
}

// @Route("/api/v2/trial-item-instances/import", "POST")
export class ImportTrialItemInstancesRequest implements IReturn<ImportTrialItemInstancesResponse>
{
    public destinationTrialId: number;
    public sourceTrialId?: number;
    public selectedIds: number[];

    public constructor(init?: Partial<ImportTrialItemInstancesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new ImportTrialItemInstancesResponse(); }
    public getTypeName() { return 'ImportTrialItemInstancesRequest'; }
}

// @Route("/api/v2/trial-item-instances/{TrialItemInstanceId}/versions", "POST")
export class CreateTrialItemInstanceVersionRequest implements IReturn<CreateTrialItemInstanceVersionResponse>
{
    public trialItemInstanceId: number;
    public expectedCurrentVersionId?: number;
    public version: string;
    public versionDate?: string;
    public comments: string;

    public constructor(init?: Partial<CreateTrialItemInstanceVersionRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new CreateTrialItemInstanceVersionResponse(); }
    public getTypeName() { return 'CreateTrialItemInstanceVersionRequest'; }
}

// @Route("/api/v2/trial-item-instances/{Id}", "GET")
export class GetTrialItemInstanceByIdRequest implements IReturn<GetTrialItemInstanceByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialItemInstanceByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstanceByIdResponse(); }
    public getTypeName() { return 'GetTrialItemInstanceByIdRequest'; }
}

// @Route("/api/v2/trial-item-instances", "GET")
export class GetTrialItemInstancesRequest implements IReturn<GetTrialItemInstancesResponse>
{

    public constructor(init?: Partial<GetTrialItemInstancesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialItemInstancesResponse(); }
    public getTypeName() { return 'GetTrialItemInstancesRequest'; }
}

// @Route("/api/v2/trial-item-instances/initial", "POST")
export class InitializeTrialItemInstanceRequest implements IReturn<InitializeTrialItemInstanceResponse>
{
    public context: TrialItemInstanceMetadataContext;

    public constructor(init?: Partial<InitializeTrialItemInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialItemInstanceResponse(); }
    public getTypeName() { return 'InitializeTrialItemInstanceRequest'; }
}

// @Route("/api/v2/trial-item-instances", "POST")
export class SaveTrialItemInstanceRequest implements IReturn<SaveTrialItemInstanceResponse>
{
    public model: TrialItemInstance;

    public constructor(init?: Partial<SaveTrialItemInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialItemInstanceResponse(); }
    public getTypeName() { return 'SaveTrialItemInstanceRequest'; }
}

// @Route("/api/v2/trial-item-instances/{Id}", "DELETE")
export class DeleteTrialItemInstanceRequest implements IReturn<DeleteTrialItemInstanceResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialItemInstanceRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialItemInstanceResponse(); }
    public getTypeName() { return 'DeleteTrialItemInstanceRequest'; }
}

// @Route("/api/v2/trial-milestones/{Id}", "GET")
export class GetTrialMilestonesByIdRequest implements IReturn<GetTrialMilestonesByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialMilestonesByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMilestonesByIdResponse(); }
    public getTypeName() { return 'GetTrialMilestonesByIdRequest'; }
}

// @Route("/api/v2/trial-milestones", "GET")
export class GetTrialMilestonesListRequest implements IReturn<GetTrialMilestonesListResponse>
{

    public constructor(init?: Partial<GetTrialMilestonesListRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialMilestonesListResponse(); }
    public getTypeName() { return 'GetTrialMilestonesListRequest'; }
}

// @Route("/api/v2/trial-milestones/initial", "POST")
export class InitializeTrialMilestonesRequest implements IReturn<InitializeTrialMilestonesResponse>
{
    public context: TrialMilestonesMetadataContext;

    public constructor(init?: Partial<InitializeTrialMilestonesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialMilestonesResponse(); }
    public getTypeName() { return 'InitializeTrialMilestonesRequest'; }
}

// @Route("/api/v2/trial-milestones", "POST")
export class SaveTrialMilestonesRequest implements IReturn<SaveTrialMilestonesResponse>
{
    public model: TrialMilestones;

    public constructor(init?: Partial<SaveTrialMilestonesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialMilestonesResponse(); }
    public getTypeName() { return 'SaveTrialMilestonesRequest'; }
}

// @Route("/api/v2/trial-milestones/{Id}", "DELETE")
export class DeleteTrialMilestonesRequest implements IReturn<DeleteTrialMilestonesResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialMilestonesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialMilestonesResponse(); }
    public getTypeName() { return 'DeleteTrialMilestonesRequest'; }
}

// @Route("/api/v2/trial-notes/{Id}", "GET")
export class GetTrialNoteByIdRequest implements IReturn<GetTrialNoteByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialNoteByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNoteByIdResponse(); }
    public getTypeName() { return 'GetTrialNoteByIdRequest'; }
}

// @Route("/api/v2/trial-notes", "GET")
export class GetTrialNotesRequest implements IReturn<GetTrialNotesResponse>
{

    public constructor(init?: Partial<GetTrialNotesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialNotesResponse(); }
    public getTypeName() { return 'GetTrialNotesRequest'; }
}

// @Route("/api/v2/trial-notes/initial", "POST")
export class InitializeTrialNoteRequest implements IReturn<InitializeTrialNoteResponse>
{
    public context: TrialNoteMetadataContext;

    public constructor(init?: Partial<InitializeTrialNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialNoteResponse(); }
    public getTypeName() { return 'InitializeTrialNoteRequest'; }
}

// @Route("/api/v2/trial-notes", "POST")
export class SaveTrialNoteRequest implements IReturn<SaveTrialNoteResponse>
{
    public model: TrialNote;

    public constructor(init?: Partial<SaveTrialNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialNoteResponse(); }
    public getTypeName() { return 'SaveTrialNoteRequest'; }
}

// @Route("/api/v2/trial-notes/{Id}", "DELETE")
export class DeleteTrialNoteRequest implements IReturn<DeleteTrialNoteResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialNoteRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialNoteResponse(); }
    public getTypeName() { return 'DeleteTrialNoteRequest'; }
}

// @Route("/api/v2/trial-phases/{Id}", "GET")
export class GetTrialPhaseByIdRequest implements IReturn<GetTrialPhaseByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialPhaseByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPhaseByIdResponse(); }
    public getTypeName() { return 'GetTrialPhaseByIdRequest'; }
}

// @Route("/api/v2/trial-phases", "GET")
export class GetTrialPhasesRequest implements IReturn<GetTrialPhasesResponse>
{

    public constructor(init?: Partial<GetTrialPhasesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPhasesResponse(); }
    public getTypeName() { return 'GetTrialPhasesRequest'; }
}

// @Route("/api/v2/trial-phases/initial", "POST")
export class InitializeTrialPhaseRequest implements IReturn<InitializeTrialPhaseResponse>
{
    public context: TrialPhaseMetadataContext;

    public constructor(init?: Partial<InitializeTrialPhaseRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialPhaseResponse(); }
    public getTypeName() { return 'InitializeTrialPhaseRequest'; }
}

// @Route("/api/v2/trial-phases", "POST")
export class SaveTrialPhaseRequest implements IReturn<SaveTrialPhaseResponse>
{
    public model: TrialPhase;

    public constructor(init?: Partial<SaveTrialPhaseRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialPhaseResponse(); }
    public getTypeName() { return 'SaveTrialPhaseRequest'; }
}

// @Route("/api/v2/trial-phases/{Id}", "DELETE")
export class DeleteTrialPhaseRequest implements IReturn<DeleteTrialPhaseResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialPhaseRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialPhaseResponse(); }
    public getTypeName() { return 'DeleteTrialPhaseRequest'; }
}

// @Route("/api/v2/trial-presentation-types/{Id}", "GET")
export class GetTrialPresentationTypeByIdRequest implements IReturn<GetTrialPresentationTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialPresentationTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPresentationTypeByIdResponse(); }
    public getTypeName() { return 'GetTrialPresentationTypeByIdRequest'; }
}

// @Route("/api/v2/trial-presentation-types", "GET")
export class GetTrialPresentationTypesRequest implements IReturn<GetTrialPresentationTypesResponse>
{

    public constructor(init?: Partial<GetTrialPresentationTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPresentationTypesResponse(); }
    public getTypeName() { return 'GetTrialPresentationTypesRequest'; }
}

// @Route("/api/v2/trial-presentation-types/initial", "POST")
export class InitializeTrialPresentationTypeRequest implements IReturn<InitializeTrialPresentationTypeResponse>
{
    public context: TrialPresentationTypeMetadataContext;

    public constructor(init?: Partial<InitializeTrialPresentationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialPresentationTypeResponse(); }
    public getTypeName() { return 'InitializeTrialPresentationTypeRequest'; }
}

// @Route("/api/v2/trial-presentation-types", "POST")
export class SaveTrialPresentationTypeRequest implements IReturn<SaveTrialPresentationTypeResponse>
{
    public model: TrialPresentationType;

    public constructor(init?: Partial<SaveTrialPresentationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialPresentationTypeResponse(); }
    public getTypeName() { return 'SaveTrialPresentationTypeRequest'; }
}

// @Route("/api/v2/trial-presentation-types/{Id}", "DELETE")
export class DeleteTrialPresentationTypeRequest implements IReturn<DeleteTrialPresentationTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialPresentationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialPresentationTypeResponse(); }
    public getTypeName() { return 'DeleteTrialPresentationTypeRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/{Id}", "GET")
export class GetTrialPublicationStatusByIdRequest implements IReturn<GetTrialPublicationStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialPublicationStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationStatusByIdResponse(); }
    public getTypeName() { return 'GetTrialPublicationStatusByIdRequest'; }
}

// @Route("/api/v2/trial-publication-statuses", "GET")
export class GetTrialPublicationStatusesRequest implements IReturn<GetTrialPublicationStatusesResponse>
{

    public constructor(init?: Partial<GetTrialPublicationStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationStatusesResponse(); }
    public getTypeName() { return 'GetTrialPublicationStatusesRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/initial", "POST")
export class InitializeTrialPublicationStatusRequest implements IReturn<InitializeTrialPublicationStatusResponse>
{
    public context: TrialPublicationStatusMetadataContext;

    public constructor(init?: Partial<InitializeTrialPublicationStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialPublicationStatusResponse(); }
    public getTypeName() { return 'InitializeTrialPublicationStatusRequest'; }
}

// @Route("/api/v2/trial-publication-statuses", "POST")
export class SaveTrialPublicationStatusRequest implements IReturn<SaveTrialPublicationStatusResponse>
{
    public model: TrialPublicationStatus;

    public constructor(init?: Partial<SaveTrialPublicationStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialPublicationStatusResponse(); }
    public getTypeName() { return 'SaveTrialPublicationStatusRequest'; }
}

// @Route("/api/v2/trial-publication-statuses/{Id}", "DELETE")
export class DeleteTrialPublicationStatusRequest implements IReturn<DeleteTrialPublicationStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialPublicationStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialPublicationStatusResponse(); }
    public getTypeName() { return 'DeleteTrialPublicationStatusRequest'; }
}

// @Route("/api/v2/trial-publication-types/{Id}", "GET")
export class GetTrialPublicationTypeByIdRequest implements IReturn<GetTrialPublicationTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialPublicationTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationTypeByIdResponse(); }
    public getTypeName() { return 'GetTrialPublicationTypeByIdRequest'; }
}

// @Route("/api/v2/trial-publication-types", "GET")
export class GetTrialPublicationTypesRequest implements IReturn<GetTrialPublicationTypesResponse>
{

    public constructor(init?: Partial<GetTrialPublicationTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialPublicationTypesResponse(); }
    public getTypeName() { return 'GetTrialPublicationTypesRequest'; }
}

// @Route("/api/v2/trial-publication-types/initial", "POST")
export class InitializeTrialPublicationTypeRequest implements IReturn<InitializeTrialPublicationTypeResponse>
{
    public context: TrialPublicationTypeMetadataContext;

    public constructor(init?: Partial<InitializeTrialPublicationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialPublicationTypeResponse(); }
    public getTypeName() { return 'InitializeTrialPublicationTypeRequest'; }
}

// @Route("/api/v2/trial-publication-types", "POST")
export class SaveTrialPublicationTypeRequest implements IReturn<SaveTrialPublicationTypeResponse>
{
    public model: TrialPublicationType;

    public constructor(init?: Partial<SaveTrialPublicationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialPublicationTypeResponse(); }
    public getTypeName() { return 'SaveTrialPublicationTypeRequest'; }
}

// @Route("/api/v2/trial-publication-types/{Id}", "DELETE")
export class DeleteTrialPublicationTypeRequest implements IReturn<DeleteTrialPublicationTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialPublicationTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialPublicationTypeResponse(); }
    public getTypeName() { return 'DeleteTrialPublicationTypeRequest'; }
}

// @Route("/api/v2/trial-registries/{Id}", "GET")
export class GetTrialRegistryByIdRequest implements IReturn<GetTrialRegistryByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialRegistryByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialRegistryByIdResponse(); }
    public getTypeName() { return 'GetTrialRegistryByIdRequest'; }
}

// @Route("/api/v2/trial-registries", "GET")
export class GetTrialRegistriesRequest implements IReturn<GetTrialRegistriesResponse>
{

    public constructor(init?: Partial<GetTrialRegistriesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialRegistriesResponse(); }
    public getTypeName() { return 'GetTrialRegistriesRequest'; }
}

// @Route("/api/v2/trial-registries/initial", "POST")
export class InitializeTrialRegistryRequest implements IReturn<InitializeTrialRegistryResponse>
{
    public context: TrialRegistryMetadataContext;

    public constructor(init?: Partial<InitializeTrialRegistryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialRegistryResponse(); }
    public getTypeName() { return 'InitializeTrialRegistryRequest'; }
}

// @Route("/api/v2/trial-registries", "POST")
export class SaveTrialRegistryRequest implements IReturn<SaveTrialRegistryResponse>
{
    public model: TrialRegistry;

    public constructor(init?: Partial<SaveTrialRegistryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialRegistryResponse(); }
    public getTypeName() { return 'SaveTrialRegistryRequest'; }
}

// @Route("/api/v2/trial-registries/{Id}", "DELETE")
export class DeleteTrialRegistryRequest implements IReturn<DeleteTrialRegistryResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialRegistryRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialRegistryResponse(); }
    public getTypeName() { return 'DeleteTrialRegistryRequest'; }
}

// @Route("/api/v2/trial-statuses/{Id}", "GET")
export class GetTrialStatusByIdRequest implements IReturn<GetTrialStatusByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialStatusByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialStatusByIdResponse(); }
    public getTypeName() { return 'GetTrialStatusByIdRequest'; }
}

// @Route("/api/v2/trial-statuses", "GET")
export class GetTrialStatusesRequest implements IReturn<GetTrialStatusesResponse>
{

    public constructor(init?: Partial<GetTrialStatusesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialStatusesResponse(); }
    public getTypeName() { return 'GetTrialStatusesRequest'; }
}

// @Route("/api/v2/trial-statuses/initial", "POST")
export class InitializeTrialStatusRequest implements IReturn<InitializeTrialStatusResponse>
{
    public context: TrialStatusMetadataContext;

    public constructor(init?: Partial<InitializeTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialStatusResponse(); }
    public getTypeName() { return 'InitializeTrialStatusRequest'; }
}

// @Route("/api/v2/trial-statuses", "POST")
export class SaveTrialStatusRequest implements IReturn<SaveTrialStatusResponse>
{
    public model: TrialStatus;

    public constructor(init?: Partial<SaveTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialStatusResponse(); }
    public getTypeName() { return 'SaveTrialStatusRequest'; }
}

// @Route("/api/v2/trial-statuses/{Id}", "DELETE")
export class DeleteTrialStatusRequest implements IReturn<DeleteTrialStatusResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialStatusRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialStatusResponse(); }
    public getTypeName() { return 'DeleteTrialStatusRequest'; }
}

// @Route("/api/v2/trial-trackers/{Id}", "GET")
export class GetTrialTrackerByIdRequest implements IReturn<GetTrialTrackerByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialTrackerByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackerByIdResponse(); }
    public getTypeName() { return 'GetTrialTrackerByIdRequest'; }
}

// @Route("/api/v2/trial-trackers", "GET")
export class GetTrialTrackersRequest implements IReturn<GetTrialTrackersResponse>
{

    public constructor(init?: Partial<GetTrialTrackersRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTrackersResponse(); }
    public getTypeName() { return 'GetTrialTrackersRequest'; }
}

// @Route("/api/v2/trial-trackers/initial", "POST")
export class InitializeTrialTrackerRequest implements IReturn<InitializeTrialTrackerResponse>
{
    public context: TrialTrackerMetadataContext;

    public constructor(init?: Partial<InitializeTrialTrackerRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialTrackerResponse(); }
    public getTypeName() { return 'InitializeTrialTrackerRequest'; }
}

// @Route("/api/v2/trial-trackers", "POST")
export class SaveTrialTrackerRequest implements IReturn<SaveTrialTrackerResponse>
{
    public model: TrialTracker;

    public constructor(init?: Partial<SaveTrialTrackerRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialTrackerResponse(); }
    public getTypeName() { return 'SaveTrialTrackerRequest'; }
}

// @Route("/api/v2/trial-trackers/{Id}", "DELETE")
export class DeleteTrialTrackerRequest implements IReturn<DeleteTrialTrackerResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialTrackerRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialTrackerResponse(); }
    public getTypeName() { return 'DeleteTrialTrackerRequest'; }
}

// @Route("/api/v2/trial-treatments/{Id}", "GET")
export class GetTrialTreatmentByIdRequest implements IReturn<GetTrialTreatmentByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialTreatmentByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentByIdResponse(); }
    public getTypeName() { return 'GetTrialTreatmentByIdRequest'; }
}

// @Route("/api/v2/trial-treatments", "GET")
export class GetTrialTreatmentsRequest implements IReturn<GetTrialTreatmentsResponse>
{

    public constructor(init?: Partial<GetTrialTreatmentsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTreatmentsResponse(); }
    public getTypeName() { return 'GetTrialTreatmentsRequest'; }
}

// @Route("/api/v2/trial-treatments/initial", "POST")
export class InitializeTrialTreatmentRequest implements IReturn<InitializeTrialTreatmentResponse>
{
    public context: TrialTreatmentMetadataContext;

    public constructor(init?: Partial<InitializeTrialTreatmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialTreatmentResponse(); }
    public getTypeName() { return 'InitializeTrialTreatmentRequest'; }
}

// @Route("/api/v2/trial-treatments", "POST")
export class SaveTrialTreatmentRequest implements IReturn<SaveTrialTreatmentResponse>
{
    public model: TrialTreatment;

    public constructor(init?: Partial<SaveTrialTreatmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialTreatmentResponse(); }
    public getTypeName() { return 'SaveTrialTreatmentRequest'; }
}

// @Route("/api/v2/trial-treatments/{Id}", "DELETE")
export class DeleteTrialTreatmentRequest implements IReturn<DeleteTrialTreatmentResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialTreatmentRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialTreatmentResponse(); }
    public getTypeName() { return 'DeleteTrialTreatmentRequest'; }
}

// @Route("/api/v2/trial-types/{Id}", "GET")
export class GetTrialTypeByIdRequest implements IReturn<GetTrialTypeByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialTypeByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTypeByIdResponse(); }
    public getTypeName() { return 'GetTrialTypeByIdRequest'; }
}

// @Route("/api/v2/trial-types", "GET")
export class GetTrialTypesRequest implements IReturn<GetTrialTypesResponse>
{

    public constructor(init?: Partial<GetTrialTypesRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialTypesResponse(); }
    public getTypeName() { return 'GetTrialTypesRequest'; }
}

// @Route("/api/v2/trial-types/initial", "POST")
export class InitializeTrialTypeRequest implements IReturn<InitializeTrialTypeResponse>
{
    public context: TrialTypeMetadataContext;

    public constructor(init?: Partial<InitializeTrialTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialTypeResponse(); }
    public getTypeName() { return 'InitializeTrialTypeRequest'; }
}

// @Route("/api/v2/trial-types", "POST")
export class SaveTrialTypeRequest implements IReturn<SaveTrialTypeResponse>
{
    public model: TrialType;

    public constructor(init?: Partial<SaveTrialTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialTypeResponse(); }
    public getTypeName() { return 'SaveTrialTypeRequest'; }
}

// @Route("/api/v2/trial-types/{Id}", "DELETE")
export class DeleteTrialTypeRequest implements IReturn<DeleteTrialTypeResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialTypeRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialTypeResponse(); }
    public getTypeName() { return 'DeleteTrialTypeRequest'; }
}

// @Route("/api/v2/trials/{Id}", "GET")
export class GetTrialByIdRequest implements IReturn<GetTrialByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTrialByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialByIdResponse(); }
    public getTypeName() { return 'GetTrialByIdRequest'; }
}

// @Route("/api/v2/trials", "GET")
export class GetTrialsRequest implements IReturn<GetTrialsResponse>
{

    public constructor(init?: Partial<GetTrialsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTrialsResponse(); }
    public getTypeName() { return 'GetTrialsRequest'; }
}

// @Route("/api/v2/trials/initial", "POST")
export class InitializeTrialRequest implements IReturn<InitializeTrialResponse>
{
    public context: TrialMetadataContext;

    public constructor(init?: Partial<InitializeTrialRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTrialResponse(); }
    public getTypeName() { return 'InitializeTrialRequest'; }
}

// @Route("/api/v2/trials", "POST")
export class SaveTrialRequest implements IReturn<SaveTrialResponse>
{
    public model: Trial;

    public constructor(init?: Partial<SaveTrialRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTrialResponse(); }
    public getTypeName() { return 'SaveTrialRequest'; }
}

// @Route("/api/v2/trials/{Id}", "DELETE")
export class DeleteTrialRequest implements IReturn<DeleteTrialResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTrialRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTrialResponse(); }
    public getTypeName() { return 'DeleteTrialRequest'; }
}

// @Route("/api/v2/tumour-groups/{Id}", "GET")
export class GetTumourGroupByIdRequest implements IReturn<GetTumourGroupByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetTumourGroupByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTumourGroupByIdResponse(); }
    public getTypeName() { return 'GetTumourGroupByIdRequest'; }
}

// @Route("/api/v2/tumour-groups", "GET")
export class GetTumourGroupsRequest implements IReturn<GetTumourGroupsResponse>
{

    public constructor(init?: Partial<GetTumourGroupsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetTumourGroupsResponse(); }
    public getTypeName() { return 'GetTumourGroupsRequest'; }
}

// @Route("/api/v2/tumour-groups/initial", "POST")
export class InitializeTumourGroupRequest implements IReturn<InitializeTumourGroupResponse>
{
    public context: TumourGroupMetadataContext;

    public constructor(init?: Partial<InitializeTumourGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeTumourGroupResponse(); }
    public getTypeName() { return 'InitializeTumourGroupRequest'; }
}

// @Route("/api/v2/tumour-groups", "POST")
export class SaveTumourGroupRequest implements IReturn<SaveTumourGroupResponse>
{
    public model: TumourGroup;

    public constructor(init?: Partial<SaveTumourGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveTumourGroupResponse(); }
    public getTypeName() { return 'SaveTumourGroupRequest'; }
}

// @Route("/api/v2/tumour-groups/{Id}", "DELETE")
export class DeleteTumourGroupRequest implements IReturn<DeleteTumourGroupResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteTumourGroupRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteTumourGroupResponse(); }
    public getTypeName() { return 'DeleteTumourGroupRequest'; }
}

// @Route("/api/v2/yes-no-pendings/{Id}", "GET")
export class GetYesNoPendingByIdRequest implements IReturn<GetYesNoPendingByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetYesNoPendingByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoPendingByIdResponse(); }
    public getTypeName() { return 'GetYesNoPendingByIdRequest'; }
}

// @Route("/api/v2/yes-no-pendings", "GET")
export class GetYesNoPendingsRequest implements IReturn<GetYesNoPendingsResponse>
{

    public constructor(init?: Partial<GetYesNoPendingsRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoPendingsResponse(); }
    public getTypeName() { return 'GetYesNoPendingsRequest'; }
}

// @Route("/api/v2/yes-no-pendings/initial", "POST")
export class InitializeYesNoPendingRequest implements IReturn<InitializeYesNoPendingResponse>
{
    public context: YesNoPendingMetadataContext;

    public constructor(init?: Partial<InitializeYesNoPendingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeYesNoPendingResponse(); }
    public getTypeName() { return 'InitializeYesNoPendingRequest'; }
}

// @Route("/api/v2/yes-no-pendings", "POST")
export class SaveYesNoPendingRequest implements IReturn<SaveYesNoPendingResponse>
{
    public model: YesNoPending;

    public constructor(init?: Partial<SaveYesNoPendingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveYesNoPendingResponse(); }
    public getTypeName() { return 'SaveYesNoPendingRequest'; }
}

// @Route("/api/v2/yes-no-pendings/{Id}", "DELETE")
export class DeleteYesNoPendingRequest implements IReturn<DeleteYesNoPendingResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteYesNoPendingRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteYesNoPendingResponse(); }
    public getTypeName() { return 'DeleteYesNoPendingRequest'; }
}

// @Route("/api/v2/yes-nos/{Id}", "GET")
export class GetYesNoByIdRequest implements IReturn<GetYesNoByIdResponse>
{
    public id?: number;

    public constructor(init?: Partial<GetYesNoByIdRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNoByIdResponse(); }
    public getTypeName() { return 'GetYesNoByIdRequest'; }
}

// @Route("/api/v2/yes-nos", "GET")
export class GetYesNosRequest implements IReturn<GetYesNosResponse>
{

    public constructor(init?: Partial<GetYesNosRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetYesNosResponse(); }
    public getTypeName() { return 'GetYesNosRequest'; }
}

// @Route("/api/v2/yes-nos/initial", "POST")
export class InitializeYesNoRequest implements IReturn<InitializeYesNoResponse>
{
    public context: YesNoMetadataContext;

    public constructor(init?: Partial<InitializeYesNoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new InitializeYesNoResponse(); }
    public getTypeName() { return 'InitializeYesNoRequest'; }
}

// @Route("/api/v2/yes-nos", "POST")
export class SaveYesNoRequest implements IReturn<SaveYesNoResponse>
{
    public model: YesNo;

    public constructor(init?: Partial<SaveYesNoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new SaveYesNoResponse(); }
    public getTypeName() { return 'SaveYesNoRequest'; }
}

// @Route("/api/v2/yes-nos/{Id}", "DELETE")
export class DeleteYesNoRequest implements IReturn<DeleteYesNoResponse>
{
    public id?: number;

    public constructor(init?: Partial<DeleteYesNoRequest>) { (Object as any).assign(this, init); }
    public createResponse() { return new DeleteYesNoResponse(); }
    public getTypeName() { return 'DeleteYesNoRequest'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie?: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new AssignRolesResponse(); }
    public getTypeName() { return 'AssignRoles'; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public createResponse() { return new UnAssignRolesResponse(); }
    public getTypeName() { return 'UnAssignRoles'; }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new GetApiKeysResponse(); }
    public getTypeName() { return 'GetApiKeys'; }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public createResponse() { return new RegenerateApiKeysResponse(); }
    public getTypeName() { return 'RegenerateApiKeys'; }
}

